<template>
<v-card tile class="compose-shell">
  <v-toolbar flat dark color="#212121">
    <v-btn icon dark @click="closeDialog">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-toolbar-title>{{ $t('components.ekrm.CreateModelCompose.title') }}</v-toolbar-title>
  </v-toolbar>

  <!-- WHAT IS WRONG WITH THE WHOLE THING, held out of the steps and above them. A step shows one
       question at a time, so an error raised by an answer given two steps back would otherwise be
       off the screen at the moment it matters; this strip is the one place the wizard speaks about
       itself. The notes that merely REPORT a figure the wizard moved stay at the foot of the page,
       with the decomposition they are read against.

       The validator's own errors keep the gate they have always had — see moneyReady. Until a
       revenue is typed there is no size to check anything against, and half a form's worth of
       complaints about an unfinished form is noise. -->
  <div v-if="hasTopAlerts" class="compose-alerts">
    <div class="compose-alerts__inner">
      <v-alert v-if="reportError" type="error" text dense border="left" class="mb-4">{{ reportError }}</v-alert>
      <v-alert v-if="catalogueError" type="warning" text dense border="left" class="mb-4">{{ catalogueError }}</v-alert>
      <template v-if="moneyReady">
        <!-- Two things the user can now do are refused by the validator, and both are answered here
             rather than at the save: emptying a channel, and driving revenue under the spend it is
             supposed to have produced. -->
        <v-alert v-for="(entry, index) in liveErrors" :key="`live_error_${index}`"
          type="error" text dense border="left" class="mb-4">
          {{ entry.text }}
        </v-alert>
        <v-alert v-for="(entry, index) in liveWarnings" :key="`live_warning_${index}`"
          type="warning" text dense border="left" class="mb-4">
          {{ entry.text }}
        </v-alert>
        <v-alert v-if="baseWarning" type="warning" text dense border="left" class="mb-4">
          {{ baseWarning }}
        </v-alert>
        <!-- The same floor, against the base the decomposition below is left with once the
             seasonality has taken its share too. Both can stand at once: they are two claims. -->
        <v-alert v-if="decompositionBaseWarning" type="warning" text dense border="left" class="mb-4">
          {{ decompositionBaseWarning }}
        </v-alert>
      </template>
    </div>
  </div>

  <v-card-text class="clone-page">
    <div class="clone-page__inner">
      <!-- WHAT HAS BEEN ANSWERED SO FAR, over the bar that says where the user is. A step shows one
           question and hides the four around it, so the figures the current question is decided
           against — the media the spend is a statement about, the spend the revenue has to clear —
           would otherwise be a step away at the moment they matter. Only steps already left are in
           it: a line reporting an answer the user is still typing is the wizard reading over their
           shoulder. -->
      <div v-if="stepRecap.length > 0" class="compose-recap">
        <div v-for="item in stepRecap" :key="item.key" class="compose-recap__item">
          <span class="compose-recap__label">{{ item.label }}</span>
          <span class="compose-recap__value">{{ item.value }}</span>
        </div>
      </div>

      <!-- THE WIZARD, ONE QUESTION AT A TIME. What the page used to show all at once is asked in the
           order it is decided in: who the model is, what its media are, what is spent on them, and
           what that spend produced — and then, asking nothing, what all of it amounts to. Each step
           is gated on the one before it — see stepValid — so nothing is asked against figures that
           are not there yet, which is the same gate `ready` and `moneyReady` used to draw as
           greyed-out cards down a single page. -->
      <v-stepper v-model="step" flat class="compose-stepper">
        <v-stepper-header class="compose-stepper__header">
          <v-stepper-step :class="{ 'compose-stepper__step--done': step > 1 && stepValid[1] }" :editable="maxReachableStep >= 1" :step="1">
            {{ $t('components.ekrm.CreateModelCompose.stepDetails') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :class="{ 'compose-stepper__step--done': step > 2 && stepValid[2] }" :editable="maxReachableStep >= 2" :step="2">
            {{ $t('components.ekrm.CreateModelCompose.stepChannels') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :class="{ 'compose-stepper__step--done': step > 3 && stepValid[3] }" :editable="maxReachableStep >= 3" :step="3">
            {{ $t('components.ekrm.CreateModelCompose.stepSpend') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :class="{ 'compose-stepper__step--done': step > 4 && stepValid[4] }" :editable="maxReachableStep >= 4" :step="4">
            {{ $t('components.ekrm.CreateModelCompose.stepRevenue') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :class="{ 'compose-stepper__step--done': step > 5 && stepValid[5] }" :editable="maxReachableStep >= 5" :step="5">
            {{ $t('components.ekrm.CreateModelCompose.stepOtherInputs') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :class="{ 'compose-stepper__step--done': step > 6 && stepValid[6] }" :editable="maxReachableStep >= 6" :step="6">
            {{ $t('components.ekrm.CreateModelCompose.stepFutureTrends') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :editable="maxReachableStep >= 7" :step="7">
            {{ $t('components.ekrm.CreateModelCompose.stepPreview') }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content :step="1">
            <!-- WHERE THIS MODEL COMES FROM, asked before anything else on the page — before the name
                 and before the market — because the answer decides what those two fields even start
                 with. Nothing is shown under it until it has been answered: a wizard that opened on a
                 form with a choice hidden among it invited the reader to fill the form and never make
                 the choice, and the choice is the one thing here that cannot be corrected later
                 without throwing the rest away.

                 Two tiles rather than a radio pair: what separates them is not a setting but two ways
                 of using the wizard, and the difference is a sentence each rather than a word. The one
                 on the left is what this wizard has always been — an empty page, channels arriving a
                 picker at a time. The one on the right takes ONE model and answers as much of the four
                 steps as that model can answer, and then gets out of the way: everything it wrote is on
                 the step that owns it and can be retyped there, so a copy is a starting position and
                 not a mode. -->
            <div class="compose-ask">{{ $t('components.ekrm.CreateModelCompose.sourceQuestion') }}</div>
            <div class="compose-source">
              <button
                v-for="tile in sourceTiles"
                :key="tile.mode"
                type="button"
                class="compose-source__tile"
                :class="{ 'compose-source__tile--on': sourceMode === tile.mode }"
                :aria-pressed="String(sourceMode === tile.mode)"
                @click="onSourceMode(tile.mode)">
                <span class="compose-source__icon">
                  <v-icon :color="sourceMode === tile.mode ? 'primary' : 'grey darken-1'">{{ tile.icon }}</v-icon>
                </span>
                <span class="compose-source__body">
                  <span class="compose-source__name">{{ tile.title }}</span>
                  <span class="compose-source__note">{{ tile.note }}</span>
                </span>
                <!-- The tick, and not only the ring: a border in the tenant's own colour is the whole
                     of the difference between the two tiles otherwise, and on a pale theme that is a
                     hairline. -->
                <v-icon v-if="sourceMode === tile.mode" class="compose-source__check" color="primary" small>mdi-check-circle</v-icon>
              </button>
            </div>

            <!-- The model being copied, and everything the copy has to say for itself. It stands above
                 the name and the market because it WRITES them: a reader who picks a model here finds
                 the two boxes below already carrying that model's name, marked as a copy, and its
                 country. -->
            <v-expand-transition>
              <div v-if="sourceMode === 'copy'" class="compose-copy mt-4">
<!-- The model is chosen in the importer, where it can be found by its name or by what it
                     is about; here it is only named, with the way to change it. -->
                <div class="compose-copy__model">
                  <v-icon :color="copyModel ? 'primary' : 'grey'" class="compose-copy__model-icon">mdi-database</v-icon>
                  <div class="compose-copy__model-body">
                    <span v-if="copyModel" class="compose-copy__model-name text-truncate">{{ copyModel.name || copyModel.id }}</span>
                    <span v-else class="compose-copy__model-name compose-copy__model-name--empty">
                      {{ $t('components.ekrm.CreateModelCompose.copyModel') }}
                    </span>
                    <span v-if="copyModelMeta" class="compose-copy__note text-truncate">{{ copyModelMeta }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    depressed
                    :outlined="!!copyModel"
                    color="primary"
                    :loading="catalogueLoading && !copyModel"
                    @click="openCopyImporter">
                    <v-icon small left>mdi-database-search</v-icon>
                    {{ copyModel
                      ? $t('components.ekrm.CreateModelCompose.changeModel')
                      : $t('components.ekrm.CreateModelCompose.chooseModel') }}
                  </v-btn>
                </div>

                <!-- The wait is a report fetched and then a Levenberg-Marquardt fit per channel, which
                     is long enough to be wondered about. -->
                <div v-if="copyLoading" class="compose-copy__wait">
                  <v-progress-circular indeterminate color="primary" size="20" width="2"></v-progress-circular>
                  <span class="compose-copy__note">{{ $t('components.ekrm.CreateModelCompose.pickerLoadingNote') }}</span>
                </div>

                <v-alert v-if="copyError" type="error" text dense border="left" class="mt-3 mb-0">
                  {{ copyError }}
                </v-alert>

                <!-- WHAT THE COPY CAME TO, and what it could not carry. The second half is the point of
                     the first: a copy that quietly dropped three channels and flattened a season would
                     be a model the reader believes is the one they picked. -->
                <template v-if="copySummary">
                  <v-alert type="success" text dense border="left" class="mt-3 mb-0">{{ copySummary }}</v-alert>
                  <v-alert v-if="copySkipped.length > 0" type="warning" text dense border="left" class="mt-3 mb-0">
                    <div class="font-weight-medium">{{ $t('components.ekrm.CreateModelCompose.copySkippedTitle') }}</div>
                    <ul class="mt-1">
                      <li v-for="entry in copySkipped" :key="entry.raw">{{ skippedLabel(entry) }}</li>
                    </ul>
                  </v-alert>
                  <v-alert v-if="copyHeldText" type="warning" text dense border="left" class="mt-3 mb-0">
                    {{ copyHeldText }}
                  </v-alert>
                </template>
              </div>
            </v-expand-transition>

            <!-- What the wizard asks for before anything can be built: the two fields the payload cannot
                 be built without. They arrive with the answer above them and not before it — from
                 scratch they are the first thing to type, from a copy they are already written and are
                 there to be corrected — and the channels come next, from their own dialog, with
                 everything under them read off what they carry.

                 Two boxes on one row, in the dress every other box on this page wears — a white card on
                 the page's grey, a small uppercase label, the value on a hairline under it — and laid out
                 on the same .clone-metrics flex, so they fall to one per row on a narrow screen exactly
                 as the metric boxes do. What stood here was a v-card of stock dense fields with floating
                 labels, which is the app's form language and not this page's: it read as a form the
                 wizard had been dropped into rather than as the wizard's first row. -->
            <v-expand-transition>
              <div v-if="setupDetailsShown" class="clone-metrics mt-4">
                <div class="clone-metric clone-field">
                  <!-- A real <label for>, not the div the metric boxes use: those name a figure the box
                       itself prints, where these name a field that is typed into, and the name has to reach
                       it — an id ties the two, and clicking the word then puts the caret in the box. -->
                  <label class="clone-metric__label" for="ekrm_compose_name">
                    {{ $t('components.ekrm.CreateModelCompose.name') }}
                  </label>
                  <v-text-field
                    id="ekrm_compose_name"
                    ref="nameField"
                    v-model="name"
                    class="clone-field__input"
                    :rules="nameRules"
                    hide-details="auto"
                    single-line
                  ></v-text-field>
                </div>
                <div class="clone-metric clone-field">
                  <label class="clone-metric__label" for="ekrm_compose_market">
                    {{ $t('components.ekrm.CreateModelCompose.market') }}
                  </label>
                  <!-- A LIST WITH A SEARCH IN IT, and not a plain select: the countries run to a
                       couple of hundred and a list that long is reached by typing rather than by
                       scrolling. And it OPENS ON ARRIVAL — tabbing out of the name lands here and the
                       options are already down, so the first keystroke filters them instead of
                       hunting for the control that would have shown them. -->
                  <v-autocomplete
                    id="ekrm_compose_market"
                    ref="marketField"
                    v-model="market"
                    class="clone-field__input"
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    :rules="marketRules"
                    hide-details="auto"
                    single-line
                    auto-select-first
                    @focus="openMarketMenu"
                  ></v-autocomplete>
                </div>
                <!-- THE MONEY THE MODEL IS MEASURED IN, asked and not yet obeyed: every model this
                     wizard builds is in USD whatever is picked, and a copy of a model in another
                     currency arrives converted at the rate that model carries. The list is the
                     currencies of the markets in Admin > Countries — see currencyItems. -->
                <div class="clone-metric clone-field">
                  <label class="clone-metric__label" for="ekrm_compose_currency">
                    {{ $t('components.ekrm.CreateModelCompose.currency') }}
                    <v-chip x-small outlined class="ml-1">{{ $t('components.ekrm.CreateModelCompose.comingSoon') }}</v-chip>
                  </label>
                  <v-autocomplete
                    id="ekrm_compose_currency"
                    v-model="currencyChoice"
                    class="clone-field__input"
                    :items="currencyItems"
                    hide-details
                    single-line
                    auto-select-first
                  ></v-autocomplete>
                </div>
                <!-- THE MODEL'S FREQUENCY, asked and not yet obeyed: every model this wizard builds
                     is monthly whatever is picked. -->
                <div class="clone-metric clone-field">
                  <label class="clone-metric__label" for="ekrm_compose_frequency">
                    {{ $t('components.ekrm.CreateModelCompose.frequency') }}
                    <v-chip x-small outlined class="ml-1">{{ $t('components.ekrm.CreateModelCompose.comingSoon') }}</v-chip>
                  </label>
                  <v-select
                    id="ekrm_compose_frequency"
                    v-model="frequencyChoice"
                    class="clone-field__input"
                    :items="frequencyItems"
                    hide-details
                    single-line
                  ></v-select>
                </div>
                <!-- THE YEARS OF HISTORY THE MODEL IS BUILT ON, asked and not yet obeyed: every
                     model this wizard builds reads one year whatever is picked. -->
                <div class="clone-metric clone-field">
                  <label class="clone-metric__label" for="ekrm_compose_history">
                    {{ $t('components.ekrm.CreateModelCompose.history') }}
                    <v-chip x-small outlined class="ml-1">{{ $t('components.ekrm.CreateModelCompose.comingSoon') }}</v-chip>
                  </label>
                  <v-select
                    id="ekrm_compose_history"
                    v-model="historyChoice"
                    class="clone-field__input"
                    :items="historyItems"
                    hide-details
                    single-line
                  ></v-select>
                </div>
              </div>
            </v-expand-transition>
          </v-stepper-content>

          <v-stepper-content :step="2">
            <!-- The channels, and the one section that is always visible: everything below is a reading
                 of them, so there is nothing to read until one has been added. It sits outside the block
                 below for a sharper reason too — validateEkrmForm files "the model must have media" under
                 the reference step, which liveErrors filters out, so an empty composer would otherwise say
                 nothing at all. -->
            <div class="d-flex align-center mb-3">
              <h3 class="subtitle-1 font-weight-medium">
                {{ $t('components.ekrm.CreateModelCompose.channels') }}
              </h3>
              <v-chip x-small class="ml-2" outlined>{{ channels.length }}</v-chip>
              <v-spacer></v-spacer>
              <span class="caption grey--text text--darken-1">{{ channelsInfo }}</span>
            </div>

            <!-- Six to a row where the clone puts three. The clone copies one model and shows what that
                 model has, which is typically three or four media; this one is assembled a channel at a
                 time out of as many models as the user cares to open, so the list is longer by
                 construction and the cards are the whole of the section. At three across a dozen channels
                 is four rows and the two boxes under them are off the screen — and the cards are read
                 BEFORE those boxes on purpose, every figure in them being a reading of these curves. So
                 the column halves at each breakpoint and the card is measured for it. -->
            <v-row dense class="mb-4">
              <!-- The cell carries an id and, for a moment after it arrives, a ring. The picker closes on
                   the add now, so what the user is returned to is this grid — and a card added at the end
                   of twelve is off the bottom of a page whose own scroller belongs to the fullscreen
                   dialog. The id is what showArrived scrolls to and the ring is what says which of the cards
                   is the one that just arrived; both are gone a second and a half later, the card being an
                   ordinary card from then on. -->
              <v-col
                v-for="card in cards"
                :id="`clone_card_${card.uid}`"
                :key="card.uid"
                cols="6" md="3" lg="2"
                :class="{ 'clone-card-cell--new': !!justAddedMap[card.uid] }">
                <ekrm-channel-card
                  :card="card"
                  :removable="true"
                  :compact="true"
                  :color="card.color"
                  :plot-view-box="plotViewBox"
                  :plot-height="plotHeight"
                  :labels="cardLabels"
                  @remove="askRemove($event.uid)"
                  @edit="openEditor($event.uid)" />
              </v-col>
              <!-- The way in, standing in the cell the channel it adds will stand in. What was here was a
                   chip on the counter's shoulder: a control two words wide on a row the eye leaves as soon
                   as it has read the count, pointing at a grid below it. This one IS the grid's next cell,
                   so where it stands and how big it is say what pressing it does, and the card that
                   arrives takes exactly the space that was being held open for it.

                   Dashed and grey because the cell is empty: it holds a place rather than reporting
                   anything, and beside a dozen cards that each carry two curves and two figures it must
                   not read as one of them. It stretches to the row's own height — the cards are already
                   flex items stretched to the tallest of them — and carries a floor for the one case where
                   there is no card beside it to take the height from, which is the empty composer.

                   A real <button> for the same reason the chip was one: it lands in the tab order and
                   answers Enter and Space without being told to. -->
              <v-col cols="6" md="3" lg="2">
                <!-- AND THE TILE ASKS WHICH KIND OF CHANNEL, because there are two now and they are
                     not a setting inside one dialog. Taking a medium out of a model that measured one
                     is a search through a catalogue; writing one down is a name and two figures. The
                     first opens the picker it always did; the second makes the card there and then
                     and opens it, the editor being where every one of its answers is typed anyway.

                     A menu rather than two tiles side by side: the second tile would sit in the grid
                     of channels claiming a cell, and the cell is what says "a card arrives here" —
                     two of them would say a card arrives in each. -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <button
                      type="button"
                      class="clone-add-card"
                      v-bind="attrs"
                      :title="$t('components.ekrm.CreateModelCompose.addChannels')"
                      v-on="on">
                      <v-icon>mdi-plus</v-icon>
                      <span class="clone-add-card__label">{{ $t('components.ekrm.CreateModelCompose.addChannels') }}</span>
                    </button>
                  </template>
                  <v-list dense>
                    <v-list-item @click="openChannelImporter">
                      <v-list-item-icon class="mr-3">
                        <v-icon small>mdi-database-search</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('components.ekrm.CreateModelCompose.importFromModels') }}</v-list-item-title>
                        <v-list-item-subtitle class="clone-add-menu__note">
                          {{ $t('components.ekrm.CreateModelCompose.importFromModelsNote') }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="addScratch">
                      <v-list-item-icon class="mr-3">
                        <v-icon small>mdi-pencil-plus-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('components.ekrm.CreateModelCompose.addFromScratch') }}</v-list-item-title>
                        <v-list-item-subtitle class="clone-add-menu__note">
                          {{ $t('components.ekrm.CreateModelCompose.addFromScratchNote') }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>

            <!-- A CHANNEL ON THE GRID THAT IS NOBODY'S MEDIUM YET, said once for the page and directly
                 under the cards it is about. Each such card already wears the word on itself, which is
                 where the answer is typed — but a single unanswered card among six answered ones is a
                 thin border in a grid, and everything below this line is a reading of the curves that a
                 pending channel is simply not in: the spend, the ROAS, the attribution and both charts
                 are true of the media that HAVE been placed and silent about the rest.

                 It stands until the last one is answered. Before the first one is, there is no summary to
                 put it over and the same sentence is what the empty block below says instead — see
                 emptyStateText, which is this text and not the invitation to add a channel once there is
                 a channel on the page. -->
            <v-alert v-if="ready && pendingChannels.length > 0"
              type="warning" text dense border="left" class="mb-4">
              {{ channelsPendingText }}
            </v-alert>

            <!-- EVERY PLACED CURVE ON ONE PAIR OF AXES, under the cards that each draw one in a box of
                 its own. A card frames its curve to its own saturation, so two cards side by side say
                 nothing about which channel absorbs more money; this chart does, drawing them all to
                 the same edge. A pending channel is not on it, having no curve in dollars yet.

                 In the wizard's own dress and not the report's: a white box under a small uppercase
                 name with its unit beside it, the chart inside without the black title bar. -->
            <div v-if="channelsCompareData" class="clone-field compose-compare mb-4">
              <div class="clone-metric__label">
                <span>{{ $t('components.ekrm.CreateModelCompose.channelsCompare') }}</span>
                <span class="clone-metric__unit">{{ ekrmUnit }}</span>
              </div>
              <channel-curves-chart-multi
                :data="channelsCompareData"
                titleString=""
                :hide-title="true"
                elevation="elevation-0"
                :x-name="$t('components.ekrm.CreateModelCompose.spend')"
                :y-name="$t('components.ekrm.CreateModelCompose.revenue')"
                :colors="previewChannelColors"
                :x-axis-type-is-category="false"
                :x-axis-type-is-date="false"
                :x-axis-rotate="60"
                :show-negatives="false"
                :smooth-lines="false"
                :show-tooltips="true"
                :export="false" />
            </div>

            <!-- Nothing has been added yet, said where the cards would be. It is the step's own
                 empty state now rather than the page's: everything that used to stand under it
                 is a step of its own and is not reached until a channel is on the grid. -->
            <div v-if="!ready" class="clone-empty">
              <v-icon size="56" color="grey lighten-1">mdi-chart-bell-curve-cumulative</v-icon>
              <p class="mt-4 mb-0 subtitle-1 grey--text text--darken-2">
                {{ emptyStateText }}
              </p>
            </div>
          </v-stepper-content>

          <v-stepper-content :step="3">
            <!-- WHAT IS SPENT ON THE MEDIA, and it is asked the moment they are placed because it
                 needs nothing else: the curves are placed in dollars on the cards of the step
                 before, the plan is the sum of the saturation points typed on them, and the
                 corridor it is held in names no revenue at all — see cloneSpendFloorLimits, a floor
                 and no ceiling, because nothing about the media bounds a spend from above. -->
            <div class="clone-metrics clone-metrics--stacked mb-4">
              <!-- THE FIRST LEVEL, and the curve it is read on beside it rather than under it. The card
                   is Media Spend and the two boxes inside it are Total Spend and Total ROAS — one
                   figure seen twice, each named where it is typed, under a card that names itself once,
                   the same way the revenue card below names its year and the twelfth of it standing
                   beside it.

                   IT OPENS LIVE, on the plan the cards themselves describe: every channel at the
                   saturation point typed on it, unmoved. There is no revenue yet and it needs none —
                   the ROAS is what the curves return over what they are given, the corridor it is held
                   in is the two floors that mention no revenue, and both are statements about the media
                   the user has just finished making. A card that asked for the money first and then
                   greyed out the answer would be asking the wizard's own question in reverse.

                   Split, and the two figures on the LEFT with the curve beside them on the right: the
                   boxes are what the card asks for and the chart is what explains them, which is the
                   order this wizard reads in everywhere else. Stacked, the curve arrived a plot's height
                   below the pair and explained them after the fact.

                   AND THE SLIDER IS GONE. It was a control that moved both figures by a fraction of a
                   percent a pixel, which is not how either of them is decided — a spend is a figure
                   somebody has, and a return is one they are aiming at, and both of those are typed. What
                   is left on the chart is the three levels worth taking without one: where these curves
                   return the most, and the two ends of what this plan can spend. Each is a button, and
                   they are the only three clicks the plot takes. Everything between them is read rather
                   than pressed — hovering the curve names the spend and the return at that level, which
                   is the question a line of every level answers and no label on it does.

                   It carries no footer. What was in one was an average per month — a twelfth of the box
                   above it, which is a division the revenue card now offers as a field and this one
                   never took — and the marketing attribution band, which is a reading of the curves at
                   this spend AGAINST a revenue, and is stated where the model states it: in the
                   decomposition below, whose Media row IS that band's centre. Two figures at the foot of
                   a card, neither of them askable and one of them repeated further down, is a card
                   explaining itself. -->
              <ekrm-trade-card
                ref="tradeCard"
                :label="$t('components.ekrm.CreateModelCompose.metricSpend')"
                :unit="ekrmUnit"
                split
                :spend="spendBox"
                :now="roasNow"
                :plot-label="$t('components.ekrm.CreateModelCompose.tradePlotLabel')"
                :plot="tradePlot"
                :dots="tradeDots"
                :view-box="tradeViewBox"
                :height="tradeHeight"
                :ticks-height="tradeTicksHeight"
                @spend-input="onSpendTotalChange"
                @roas-input="onRoasChange"
                @jump="onTradeJump">
                <!-- THE SECOND ROW OF THE SAME CARD: the year's spend, month by month, split between the
                     media. The figure above is what is spent and the curve beside it is what that buys;
                     this is WHEN it is spent and ON WHAT, which is the one thing neither of them can
                     say, and it belongs under the number it is a reading of rather than a page below it.

                     It is the revenue card's own row asked about the other figure — same columns, same
                     figures over them, same card under the pointer, and a thirteenth column for the year
                     at its own scale — so the two rows are one picture read twice. The bands are the
                     channels themselves, each in the colour its card wears, which is what ties a card to
                     a band with media from several models on the page. -->
                <template #beneath>
                  <ekrm-spend-months
                    v-if="spendMonths"
                    :label="$t('components.ekrm.CreateModelCompose.spendMonthsLabel')"
                    :keys-hint="$t('components.ekrm.CreateModelCompose.spendMonthsKeys')"
                    :bars="spendMonths.bars"
                    :total="spendMonths.total"
                    :bar-gap="barGap"
                    :dense="monthCount > 18"
                    :months-editable="ready"
                    @month="onSpendMonthChange" />

                  <!-- THE SAME TWELVE MONTHS AS A GRID, and the one way of stating this spend that the
                       chart above cannot be: every channel and every month at once, in a table that can
                       be pasted into. The columns open a card and the card takes a month at a time,
                       which is the right gesture for correcting a figure and the wrong one for writing
                       a year out — a plan brought in from a sheet is twelve columns times N media, and
                       asking for it a column at a time is asking for twelve cards.

                       SHUT BY DEFAULT. It is the same statement the bands above already make, so the
                       card opens on the picture and the grid is what you ask for when the picture is
                       not where you want to type. It is the control CreateEkrm gives this data on its
                       own step, brought here under the figure it is a reading of.

                       BOTH WAYS AT ONCE. The rows are read off the form the wizard is actually
                       carrying — the same cells the bands are drawn from — so anything that moves the
                       spend moves them: the total typed above, a Total ROAS solved for, a level taken
                       off the chart, a month typed into a column, a channel's curve edited. And a cell
                       typed here goes back the way a typed column does, as a MULTIPLIER on the
                       channel's own flat month, so the level and the mix above it go on moving it
                       afterwards. The total, the return and the bands are all readings of that same
                       form and follow within the keystroke. -->
                  <div class="compose-sheet">
                    <button
                      type="button"
                      class="compose-sheet__toggle"
                      :aria-expanded="String(spendSheetOpen)"
                      @click="spendSheetOpen = !spendSheetOpen">
                      <v-icon x-small>{{ spendSheetOpen ? 'mdi-chevron-up' : 'mdi-table-edit' }}</v-icon>
                      <span>{{ $t(spendSheetOpen
                        ? 'components.ekrm.CreateModelCompose.sheetHide'
                        : 'components.ekrm.CreateModelCompose.spendSheetShow') }}</span>
                    </button>
                    <spreadsheet
                      v-if="spendSheetOpen && spendSheetRows.length"
                      :key="`spend_sheet_${spendSheetKey}`"
                      :value="spendSheetRows"
                      :columns="spendSheetColumns"
                      width="100%"
                      class="compose-sheet__grid"
                      @input="onSpendSheetInput" />
                  </div>
                </template>
              </ekrm-trade-card>
            </div>

            <!-- What the wizard moved on this step, said on this step. The preview repeats it with
                 the rest of the model's notes. -->
            <v-alert v-if="roasNote" type="info" text dense border="left" class="mb-4">
              {{ roasNote }}
            </v-alert>
            <v-alert v-if="spendNote" type="info" text dense border="left" icon="mdi-arrow-collapse-horizontal" class="mb-4">
              {{ spendNote }}
            </v-alert>
            <v-alert v-if="mixMoved" type="info" text dense border="left" icon="mdi-shuffle-variant" class="mb-4">
              {{ $t('components.ekrm.CreateModelCompose.mixMoved') }}
            </v-alert>
          </v-stepper-content>

          <v-stepper-content :step="4">
            <!-- THE SIZE OF THE BUSINESS, and the DEPENDENT figure of the two. Both of its walls are
                 read against the media and the spend settled in the steps before —
                 composeRevenueCeiling off what the curves are credited with, composeRevenueFloor off
                 the row the year is written into — which is why it is asked last and not first. It
                 sizes nothing but the KPI row; no curve and no spend cell is a function of it.

                 The year's shape comes with it: the seasonality and the spot events are how this
                 same twelve months is spent unevenly, so they are the card's own section rather
                 than a step of their own. -->
            <!-- ANOTHER SALES KPI, shown and not yet offered: every model this wizard builds has one
                 KPI, though multi-KPI models exist elsewhere. A placeholder for the second KPI to come. -->
            <div class="d-flex align-center justify-end mb-2">
              <v-chip x-small outlined class="mr-2">{{ $t('components.ekrm.CreateModelCompose.comingSoon') }}</v-chip>
              <v-btn small outlined disabled>
                <v-icon small left>mdi-plus</v-icon>
                {{ $t('components.ekrm.CreateModelCompose.addKpi') }}
              </v-btn>
            </div>
            <div class="clone-metrics clone-metrics--stacked mb-4">
              <!-- THE YEAR, in one card: how big it is, how it falls across the twelve months, what
                   each of those months is made of, how much of that is the season and how much of it
                   happened once.

                   LAST OF THE THREE, and under the spend rather than over it. The media are drawn, then
                   what is spent on them is settled, and this is the revenue that spend produced — which
                   is the order the sentence is said in and now the order it is asked in. Both of this
                   figure's walls are read off the media above: raising it drives the marketing
                   attribution down and under leastAttributionCentre the band rounds away to nothing,
                   and a year small enough rounds its own twelve cells away. See revenueWithin, and
                   seatRevenue for what happens to a typed figure when the spend above it moves.

                   The columns are the waterfall below said twelve times — the same components in the
                   same colours and the same order, base then season then spot then media — so a reader
                   who has understood one has understood the other, and the columns say WHEN each of them
                   happens, which is the only thing the waterfall cannot. Where the season or a spot
                   event takes revenue OUT of a month the row grows a line and that part hangs under it:
                   see revenueBars.

                   The size is typed and the shape is pressed, and they are one card because they are one
                   statement made twice: this is the year. Asking the size somewhere else, above the
                   channels and in a section of its own, made a reading of it — the columns — stand a
                   page away from the figure they are a reading of, and gave the wizard two places to
                   look for one fact. The columns move under the field the moment it is typed, which is
                   the whole argument for putting them together.

                   The row is twelve equal months because a model built from scratch has no history to
                   copy, and flat is the honest opening: it claims nothing. From there the two buttons
                   over the columns move it a press at a time — see onRevenueRandomize — which is what
                   lets the seasonality editor below mean something: declaring that January runs above
                   the year, against a row where January equals December, asks the model to explain
                   shape that is not in the data. The two remain separate statements — this says what
                   each month sold, that says how much of it was seasonal — and they are meant to agree
                   rather than to be each other.

                   Neither button resizes the year. The row is renormalised to a mean of one on the way
                   in, so the total stays the figure typed above them and the stated attribution stays
                   exactly true — cloneAttribution being the marketing over that sum. -->
              <ekrm-revenue-card
                ref="revenueCard"
                :label="$t('components.ekrm.CreateModelCompose.metricRevenueShape')"
                :unit="ekrmUnit"
                :title="$t('components.ekrm.CreateModelCompose.metricRevenueShapeInfo')"
                :value="revenueValue"
                :value-label="$t('components.ekrm.CreateModelCompose.metricTotalKpi')"
                :value-title="$t('components.ekrm.CreateModelCompose.metricTotalKpiInfo')"
                :value-hint="revenueFloorHint"
                :input-key="`revenue_${formKey}`"
                :actions="revenueActions"
                :bars="revenueBars"
                :zero-line="revenueZeroLine"
                :total="revenuePlotTotal"
                :bar-gap="barGap"
                :dense="monthCount > 18"
                :months-editable="ready"
                :max-length="13"
                :aside="revenueAside"
                @input="onTotalRevenueChange"
                @aside-input="onAvgMonthChange"
                @action="onRevenueAction"
                @month="onRevenueMonthChange">
                <!-- EVERYTHING ELSE THIS CARD ASKS ABOUT THE SAME TWELVE MONTHS, under the columns
                     that draw them: the revenue's own table, and the section that asks what of each
                     month was not the business selling — which carries its own rule, its own plot and
                     its own table. They were cards of their own a page below this one, which put each
                     question a row away from the row it is about and left the order they have to be
                     answered in to the reader.

                     It is answered in order now. None of it exists until the revenue does — see
                     moneyReady — because what is drawn below is a percentage of each month's own BASE,
                     and until a revenue is typed there is no base for it to be a percentage of. Type the total, shape the year on
                     the columns above, then say how much of each of those months came back and how much
                     of it happened once.

                     The rows are twelve columns apiece over the same year and are read together, which
                     is the whole argument for the move: what a month sold, and what of it was not the
                     business selling, one under the other in one card. The bars below run a little short
                     of the columns above them — the year's own total stands beside December — so the
                     rows are read month for month rather than measured against each other, which is
                     right: they are separate statements and nothing derives one from another. A year
                     that sells unevenly need not sell unevenly for seasonal reasons, and a wizard that
                     filled those rows in off the row above would be answering the question instead of
                     asking it. -->
                <template v-if="moneyReady" #beneath>
                  <!-- THE REVENUE ROW AS A TABLE, and the one way of stating it the columns above
                       cannot be: twelve months at once, in a grid that can be pasted into. Pressing a
                       column opens one month, which is the right gesture for correcting a figure and the
                       wrong one for writing a year out — a year brought in from a sheet is twelve
                       numbers, and asking for them a column at a time is asking for twelve cards.

                       ONE ROW, AND ITS OWN. It was three — the revenue and the two drawn years under it
                       — in one table under the whole card, on the argument that they are one statement
                       about the same twelve months said three ways. They are, and that is exactly why
                       the table belonged nowhere: it stood under a section it was only a third about,
                       and the two rows it carried were a page away from the picture that draws them. A
                       table goes with the thing it is a second way of typing. This one is the revenue's
                       and stands under the revenue's own columns; the other two have their own, inside
                       the section that asks for them.

                       SHUT BY DEFAULT, for the reason the spend's own grid is: everything in it is
                       already drawn above, and the table is what you ask for when the picture is not
                       where you want to type.

                       A cell says what a pressed column says — this month sold that — so the other
                       eleven stand still and the year is resized by the difference, through
                       composeRevenueMonthAt and its two walls. -->
                  <div class="compose-sheet">
                    <button
                      type="button"
                      class="compose-sheet__toggle"
                      :aria-expanded="String(revenueSheetOpen)"
                      @click="revenueSheetOpen = !revenueSheetOpen">
                      <v-icon x-small>{{ revenueSheetOpen ? 'mdi-chevron-up' : 'mdi-table-edit' }}</v-icon>
                      <span>{{ $t(revenueSheetOpen
                        ? 'components.ekrm.CreateModelCompose.sheetHide'
                        : 'components.ekrm.CreateModelCompose.revenueSheetShow') }}</span>
                    </button>
                    <spreadsheet
                      v-if="revenueSheetOpen && revenueSheetRows.length"
                      :key="`revenue_sheet_${revenueSheetKey}`"
                      :value="revenueSheetRows"
                      :columns="revenueSheetColumns"
                      width="100%"
                      class="compose-sheet__grid"
                      @input="onRevenueSheetInput" />
                  </div>

                  <!-- THE OTHER TWO STATEMENTS ABOUT THE SAME TWELVE MONTHS, IN ONE SECTION AND ONE
                       PLOT: how much of what each month sold comes back every year, and how much of it
                       happened once.

                       THEY WERE TWO FOLDS, one under the other, each with its own heading, its own info
                       button, its own chart in its own colour and its own table. Two sections because
                       they are two claims answered at two different moments — a business has a shape
                       long before anybody remembers a launch. That is still true and it is not what the
                       page was costing the reader. Everything else on this page treats the two as one
                       thing: the waterfall credits them to one bar, the revenue columns stack them into
                       one band, and the cap a month is held under counts them together. A month claimed
                       by both was the one reading neither fold could give, each drawing its own year on
                       its own axis a screen apart — which is exactly the reading the cap is about.

                       So: one section, one cap, one plot, one zero line, one axis, one colour. A month
                       is a STACK and not two bars: what the two of them come to together is what the
                       base has to survive, and stacked, that is the height of the column. They are told
                       apart by the FILL — solid for the season, hatched for the events — which is a
                       distinction of exactly the weight the rest of the page gives them, and by their
                       two totals beside December, which is the one place the difference between them
                       actually has to be read: a year of seasonality nets to nearly nothing and a year
                       of spot events does not. Nothing derives one from the other, and a year that sells
                       unevenly need not sell unevenly for seasonal reasons.

                       A MONTH IS SAID THE WAY A MONTH OF SPEND IS SAID. Press the column and the card
                       that was reading it becomes a form with both rows in it — Tab through the two,
                       Tab again for the next month, Enter to apply, Esc to drop it — which is the
                       gesture the Media Spend row above already answers to and, once the two years are
                       stacked, the only one left: a band two pixels tall is not a target, and the two
                       rows hold each other still, so they have to be committed together or the second
                       is held against a year the first has already moved. Each keeps its own walls, and
                       what those walls refuse is said in words under the card — see shareNote, which
                       the table below this answers to as well.

                       AND IT IS FOLDED AWAY UNTIL IT IS ASKED FOR. Everything above this line has to be
                       answered — a model has a size and its year has a shape — and this does not: the
                       year opens flat, a flat year is the wizard saying it does not know when this
                       business sells, and that is a complete answer. A section standing open with
                       twelve empty months in it asks a question the user does not owe an answer to,
                       and does it directly under the row that is the wizard's actual work. Closed it is
                       one line saying what could be said here, and the word beside it says it is
                       optional rather than unfinished.

                       The block does not exist until the revenue does — see moneyReady — because what is
                       drawn here is a percentage of each month's own revenue and there is no revenue to
                       take a percentage of. Type the total, shape the year on the columns above, then
                       say how much of each of those months is the season and how much of it happened
                       once.

                       ONE year, whatever the window covers. Seasonality is what comes back every year,
                       so the row the payload carries is this year spread across all of them, and the
                       spot events are spread the same way.

                       The card above carries a title on its own root, which a native tooltip inherits
                       all the way down; the empty one here stops the revenue's explanation from
                       following the pointer over a control that is not about the revenue.

                       The heading IS the control, which is what a whole section folding away wants; the
                       info button is its sibling and not its child, a button inside a button being no
                       button at all. -->
                  <div class="clone-season" title="">
                    <div class="clone-metric__label clone-season__head">
                      <button
                        type="button"
                        class="clone-season__toggle"
                        :aria-expanded="String(shapesOpen)"
                        @click="shapesOpen = !shapesOpen">
                        <span class="clone-metric__dot" :style="{ backgroundColor: seasonalityColor }"></span>
                        <span>{{ $t('components.ekrm.CreateModelCompose.shapesSection') }}</span>
                        <!-- The unit the readings inside are in, beside the name and not inside the
                             figures: the same place the decomposition below names its own. It is what is
                             TYPED here and not what the section comes to — every column, every cell of
                             the table and every field the pressed month opens is a share of that month's
                             own BASE, which is what the month sold less what the curves are credited
                             with returning in it. The base and not the revenue, and the unit says so
                             rather than leaving a bare percent sign to be read as the obvious one: it
                             is the difference between a rule the reader meets in the column they are
                             dragging in and a pot they have to ration across a year. The two totals
                             beside December are money, and they are the readings; the unit on a
                             heading names what the section is answered in. -->
                        <span class="clone-metric__unit">{{ $t('components.ekrm.CreateModelCompose.shapeUnit') }}</span>
                        <v-icon class="clone-season__caret" small>{{ shapesOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </button>
                      <v-btn icon x-small class="clone-season__info" @click="shapesDialog = true">
                        <v-icon small>mdi-information-outline</v-icon>
                      </v-btn>
                      <!-- What is behind the fold, on the line that opens it. Two different things, and
                           which one is said is the whole point: a section carrying nothing says it is
                           optional, and one carrying a stated year says what that year comes to. A fold
                           that hid a claim behind the same word as an empty one would be the wizard
                           keeping a statement out of sight — see shapesTotal, which is null and not zero
                           for a section nobody has said anything to. One figure and not two, and it is
                           the one the waterfall's own bar carries: what the section comes to is what it
                           took out of the base, and which half of it came from where is read inside. -->
                      <span v-if="!shapesOpen" class="clone-season__closed">
                        <template v-if="shapesTotal === null">
                          {{ $t('components.ekrm.CreateModelCompose.shapesOptional') }}
                        </template>
                        <template v-else>
                          {{ $t('components.ekrm.CreateModelCompose.metricShapesNet') }}: {{ formatMoney(shapesTotal) }} · {{ shapesShareLabel }}
                        </template>
                      </span>
                    </div>

                    <template v-if="shapesOpen">
                      <!-- WHAT MAY BE TYPED HERE, SAID ONCE AND NOT DRAWN AS A POT. Both rows are
                           percentages of each month's own BASE — what the month sold that the
                           saturation curves are not credited with — and every month is capped at
                           the same share of it, the two rows counted together.

                           There was a meter here, and it was the whole cost of the other unit. When
                           a row was a percentage of the month's REVENUE, the rule that stopped a
                           cell was annual: the base of the whole year had to survive both years at
                           once, so the twelve months of two rows drew from one pot, a March could be
                           refused by what August already claimed, and the section had to draw that
                           pot, name it, warn when it was overdrawn and re-seat both years whenever
                           the revenue was reshaped underneath them.

                           None of it survives the change of unit. A month capped at a share of its
                           OWN base leaves the rest of that base standing whatever the other eleven
                           do, so the wall is in the column the user is dragging in — greyed ground,
                           where every other wall in this wizard is — and the annual rule is held by
                           the revenue box alone, which is a figure answered a step earlier and
                           cannot be moved by anything drawn here. See SHAPE_MONTH_CAP. -->
                      <p class="clone-season__rule">
                        {{ $t('components.ekrm.CreateModelCompose.shapeCapNote', { cap: shapeCap }) }}
                      </p>

                      <!-- THE SAME THREE VERBS THE SALES ROW HAS, over the two rows they are about.
                           A season is a fact about a business too, and the models on this platform
                           have measured theirs — so it can be borrowed rather than drawn a month at
                           a time, and once here it can be put on the right months: a year lifted off
                           a business in the other hemisphere is the right shape standing six months
                           out of place.

                           THE ARROWS MOVE BOTH ROWS TOGETHER, which is the difference between this
                           row of verbs and the one over the Sales columns. There the two drawn years
                           are held still because the reader was moving something else and the season
                           this business has is not a consequence of when it sells; here they ARE
                           what is being moved, and moving one of a pair drawn on one axis against
                           one cap would let a month be claimed twice. A rotation cannot take either
                           row out of range: the cap is a share of each month's own base and the two
                           rows travel together, so every month's pair only changes which month it
                           is. -->
                      <!-- THE SIX VERBS EVERY ROW ON THESE TWO STEPS HAS, in the same order: see
                           shapesActions for what each one does to this pair. -->
                      <div class="clone-season__tools">
                        <v-btn
                          v-for="action in shapesActions"
                          :key="action.key"
                          icon x-small
                          :title="action.title"
                          @click="onShapesAction(action.key)">
                          <v-icon small>{{ action.icon }}</v-icon>
                        </v-btn>
                      </div>

                      <ekrm-shape-months
                        v-if="shapeMonths"
                        :bars="shapeMonths"
                        :total="shapeTotalColumn"
                        :legend="shapeLegend"
                        :keys-hint="$t('components.ekrm.CreateModelCompose.shapeMonthsKeys')"
                        :bar-gap="barGap"
                        :months-editable="ready"
                        @month="onShapeMonthInput" />

                      <!-- AND THE SAME TWO ROWS TYPED, under the plot that draws them. The revenue has
                           its own table under its own columns and this is the pair's, in the section
                           that asks for them: a year pasted out of a sheet is twelve numbers a row, and
                           these two are pasted together because they are answered together — what came
                           back and what did not, over the same twelve months.

                           Shut by default, for the reason every other grid on this page is: everything
                           in it is drawn just above, and the table is what you ask for when the picture
                           is not where you want to type.

                           Each row goes back the way the plot does: a cell is held inside the walls a
                           drawn month is held inside, so nothing can be pasted in here that could not
                           have been drawn. -->
                      <div class="compose-sheet">
                        <button
                          type="button"
                          class="compose-sheet__toggle"
                          :aria-expanded="String(sharesSheetOpen)"
                          @click="sharesSheetOpen = !sharesSheetOpen">
                          <v-icon x-small>{{ sharesSheetOpen ? 'mdi-chevron-up' : 'mdi-table-edit' }}</v-icon>
                          <span>{{ $t(sharesSheetOpen
                            ? 'components.ekrm.CreateModelCompose.sheetHide'
                            : 'components.ekrm.CreateModelCompose.sharesSheetShow') }}</span>
                        </button>
                        <spreadsheet
                          v-if="sharesSheetOpen && sharesSheetRows.length"
                          :key="`shares_sheet_${sharesSheetKey}`"
                          :value="sharesSheetRows"
                          :columns="sharesSheetColumns"
                          width="100%"
                          class="compose-sheet__grid"
                          @input="onSharesSheetInput" />
                      </div>
                    </template>
                  </div>
                </template>
              </ekrm-revenue-card>
            </div>

            <!-- What the wizard moved on this step, said on this step. The preview repeats it with
                 the rest of the model's notes. -->
            <v-alert v-if="revenueNote" type="info" text dense border="left" icon="mdi-arrow-collapse-horizontal" class="mb-4">
              {{ revenueNote }}
            </v-alert>
            <v-alert v-if="shareNote" type="info" text dense border="left" icon="mdi-arrow-collapse-horizontal" class="mb-4">
              {{ shareNote }}
            </v-alert>
          </v-stepper-content>

          <v-stepper-content :step="5">
            <!-- WHAT ELSE WAS SPENT AROUND THE MODEL'S OWN MEDIA, and all of it optional: the brand's
                 spend outside the category and the competition's, each a year of dollars the model
                 is told about and left to weigh — no attribution is asked for either, so the model
                 chooses one inside the range CreateEkrm names for it. Blank is what the composer has
                 always sent, and a series left blank is still that. See writeOtherSpend.

                 Asked the way the sales are, with the same card: a total, a twelfth of it, the twelve
                 columns it falls in and the table under them. -->
            <div class="d-flex align-center mb-2">
              <span class="caption grey--text text--darken-1">{{ $t('components.ekrm.CreateModelCompose.otherInputsIntro') }}</span>
              <v-spacer></v-spacer>
              <!-- ANOTHER INPUT, shown and not yet offered: these two series are the only other
                   inputs the EKRM carries. A placeholder for the ones to come. -->
              <v-chip x-small outlined class="mr-2">{{ $t('components.ekrm.CreateModelCompose.comingSoon') }}</v-chip>
              <v-btn small outlined disabled>
                <v-icon small left>mdi-plus</v-icon>
                {{ $t('components.ekrm.CreateModelCompose.addInput') }}
              </v-btn>
            </div>
            <div class="clone-metrics clone-metrics--stacked mb-4">
              <ekrm-revenue-card
                v-for="card in otherCards"
                :key="card.key"
                :ref="`otherCard_${card.key}`"
                :label="card.label"
                :unit="ekrmUnit"
                :title="card.title"
                :color="card.color"
                :value="card.value"
                :value-label="$t('components.ekrm.CreateModelCompose.otherTotal')"
                :input-key="`other_${card.key}_${formKey}`"
                :actions="otherActions"
                :bars="card.bars"
                :zero-line="0"
                :total="card.total"
                :bar-gap="barGap"
                :dense="monthCount > 18"
                :months-editable="true"
                :max-length="13"
                :aside="card.aside"
                @input="onOtherTotalChange(card.key, $event)"
                @aside-input="onOtherAsideInput(card.key, $event)"
                @action="onOtherAction(card.key, $event)"
                @month="onOtherMonthChange(card.key, $event)">
                <template #beneath>
                  <div class="compose-sheet">
                    <button
                      type="button"
                      class="compose-sheet__toggle"
                      :aria-expanded="String(card.sheetOpen)"
                      @click="toggleOtherSheet(card.key)">
                      <v-icon x-small>{{ card.sheetOpen ? 'mdi-chevron-up' : 'mdi-table-edit' }}</v-icon>
                      <span>{{ $t(card.sheetOpen
                        ? 'components.ekrm.CreateModelCompose.sheetHide'
                        : 'components.ekrm.CreateModelCompose.otherSheetShow') }}</span>
                    </button>
                    <spreadsheet
                      v-if="card.sheetOpen && card.sheetRows.length"
                      :key="`${card.key}_sheet_${card.sheetKey}`"
                      :value="card.sheetRows"
                      :columns="otherSheetColumns"
                      width="100%"
                      class="compose-sheet__grid"
                      @input="onOtherSheetInput(card.key, $event)" />
                  </div>
                </template>
              </ekrm-revenue-card>
            </div>
          </v-stepper-content>

          <v-stepper-content :step="6">
            <!-- WHAT THE NEXT TWELVE MONTHS ARE EXPECTED TO DO, and optional: every series opens at
                 0% to 0%, the next year the same as the one stated, and a band typed or dragged here
                 is the growth the EKRM is told to expect of it. One card per series the payload carries
                 a year of — the sales and the media spend always, co-marketing and competition only
                 where Other Inputs gave them a spend. See writeFutureTrends. -->
            <!-- ASKED AND NOT YET OBEYED: the cards can be answered, still marked Coming soon, and
                 nothing here reaches the payload while FUTURE_TRENDS_ENABLED is off. -->
            <div class="d-flex align-center mb-2">
              <span class="caption grey--text text--darken-1">{{ $t('components.ekrm.CreateModelCompose.futureTrendsIntro') }}</span>
              <v-spacer></v-spacer>
              <v-chip x-small outlined>{{ $t('components.ekrm.CreateModelCompose.comingSoon') }}</v-chip>
            </div>
            <div class="clone-metrics clone-metrics--stacked mb-4">
              <ekrm-growth-card
                v-for="card in growthCards"
                :key="card.key"
                :ref="`growthCard_${card.key}`"
                :label="card.label"
                :title="card.title"
                :unit="ekrmUnit"
                :color="card.color"
                :past="card.past"
                :min="card.min"
                :max="card.max"
                :months="monthNames"
                :format="formatAmount"
                :input-key="`growth_${card.key}_${formKey}`"
                :texts="growthTexts"
                @input="onGrowthChange(card.key, $event)" />
            </div>
          </v-stepper-content>

          <v-stepper-content :step="7">
            <!-- REVENUE DECOMPOSITION, and a step rather than a question: nothing here is typed. It
                 is what the four answers above amount to — where the revenue comes from on the
                 curves the cards draw, and the notes saying which figures the wizard had to move to
                 keep them inside their walls — so it is read last, with the Create button under it,
                 and it is the one screen that is about the whole model rather than one part of it.

                 Held behind moneyReady all the same. The step cannot be opened without a revenue —
                 see stepValid — but the guard is cheap and the readings below are all taken against
                 that figure. -->
            <template v-if="moneyReady">
              <v-alert v-if="roasNote" type="info" text dense border="left" class="mb-4">
                {{ roasNote }}
              </v-alert>
              <!-- The spend is the dependent figure of the two, and a figure that moves without being
                   touched has to say so — the badge on its own box is thin evidence for a number the user
                   did not type. -->
              <v-alert v-if="spendNote" type="info" text dense border="left" icon="mdi-arrow-collapse-horizontal" class="mb-4">
                {{ spendNote }}
              </v-alert>
              <!-- The lead figure, held: a typed revenue the payload cannot carry lands on the wall
                   instead, and a box that quietly showed a figure other than the one just typed into it
                   would be the wizard answering without saying so. -->
              <v-alert v-if="revenueNote" type="info" text dense border="left" icon="mdi-arrow-collapse-horizontal" class="mb-4">
                {{ revenueNote }}
              </v-alert>
              <!-- The same line for the two drawn years, wherever they were typed: a cell of the table
                   shows nothing when it is refused, and neither does a field of the card over a stacked
                   month — the column it belongs to simply does not move. Both go through one arithmetic
                   and are answered in one sentence. -->
              <v-alert v-if="shareNote" type="info" text dense border="left" icon="mdi-arrow-collapse-horizontal" class="mb-4">
                {{ shareNote }}
              </v-alert>
              <!-- Stands for as long as the mix is not the model's, because everything it is read
                   against — the monthly stack in the spend card, the shares, the per-channel figures —
                   is then this wizard's arithmetic rather than the model's own history. -->
              <v-alert v-if="mixMoved" type="info" text dense border="left" icon="mdi-shuffle-variant" class="mb-4">
                {{ $t('components.ekrm.CreateModelCompose.mixMoved') }}
              </v-alert>

              <!-- THE REPORT'S OWN TWO SECTIONS, IN ITS OWN ORDER AND UNDER ITS OWN NAMES. The step
                   used to be three charts in a column; it is now the screen the reader will open
                   after the model is built, which is what makes it a preview rather than a summary
                   of the form. The tab strip and both labels are the Model Report's own strings, so
                   the reader arrives at the real thing already knowing where to look.
                   Segments Detail and Admin are not here: neither exists until the model does. -->
              <v-tabs v-model="previewTab" class="mb-4">
                <v-tab>{{ $t('components.ModelReportComponent.summary') }}</v-tab>
                <v-tab>{{ $t('components.ModelReportComponent.driversPerformance') }}</v-tab>
              </v-tabs>

              <!-- AND IN THE REPORT'S OWN BOXES. Every chart under these tabs is the same component
                   the Model Report draws, and it used to be drawn stripped: hideTitle on, the black
                   header off, and a small grey label of this wizard's own over each plot with a
                   coloured dot beside it. That was the right call while the step was three charts
                   summarising the form and the wrong one the moment it became the report — a reader
                   who is being shown the screen they will open after the model is built should meet
                   it as it will be, in the same boxes, under the same headings, in the same order
                   and at the same widths. So the headers are back, with the units in the titles
                   where the report puts them and the info button where the report puts it, and each
                   chart sits in the row and column the report gives it.

                   Export is the one thing still off. A picture saved off this step is a picture of a
                   model that does not exist yet, and it would leave the building with a filename
                   naming a client the payload has not been sent to. -->
              <template v-if="previewTab === 0 && previewReady">
                <!-- THE ROW THE REPORT OPENS ITS SUMMARY WITH IS NOT HERE AT ALL. It holds the Model
                     Fit and, beside it, the ranked ROAS per channel; the fit is a statement about a
                     model that has been run against a history and this one has not been built, so
                     the ranking stood alone in a third of a row with two thirds of nothing next to
                     it — which is not the report's row, it is a fragment of it. The note above the
                     tabs says why the row is missing, and what a reader would have read off the
                     ranking is in the Media Spend and Return chart below: the same channels, the
                     same money, the cost beside the return rather than divided into it.

                     So the tab opens on the waterfall. -->

                <!-- What the boxes above say about the revenue, drawn: the waterfall's two ends are the
                     two figures themselves, so it is read WITH them rather than as a report standing apart
                     from the form. Under the report's own heading, in the report's own words: the heading
                     is the string the component names ITSELF with when it is given no title, handed back
                     to it with this wizard's word for the KPI in it, and the component appends the unit —
                     so the box reads "Revenue Decomposition (USD)" here exactly as it will there. It is
                     handed rather than left to default because customKpiName is not that word: it is what
                     the chart calls the total bar, and it is "Total". The account of the three components
                     sits behind the info button in the header, which is where the report keeps the same
                     explanation.

                     IT HAS THE ROW TO ITSELF. The spend's own stack stood here beside it and now stands in
                     the Media Spend card, under the figure it is a reading of — the same twelve months in
                     the same palette, drawn in the wizard's own hand rather than the app's. See
                     spendMonths. A chart of the spend a page below the box that states it was the page
                     asking the reader to carry a number down to it. -->
                <v-row v-if="decompositionData">
                  <v-col cols="12">
                    <!-- Where the revenue beside it comes from, on the same curves the cards above draw: what
                         the model would have made with no media at all, when in the year it sells, and what
                         the curves return on the whole of the spend the card above states, landing on the
                         total. It leads for the reason the Total Revenue box does — it is the figure the
                         other two are read against — and one bar for the media and not one per channel, the
                         per-channel split being what the cards above are, each drawn against its own curve.
                         Nothing is drawn at all when a medium has no curve, the same silence the reading
                         itself keeps: a waterfall claiming the whole revenue is base would be a statement,
                         not a gap, and the row is then empty rather than wrong. -->
                    <sales-decomposition
                      :data="decompositionData"
                      :title="$t('components.simulationDetails.SalesDecomposition.salesDecomposition', { kpi: spendReturnKpiName })"
                      :dictionary="decompositionDictionary"
                      :unit="ekrmUnit"
                      :custom-kpi-name="decompositionKpiName"
                      :show-percentages="true"
                      :export="false">
                      <template v-slot:info-dialog>
                        {{ $t('components.ekrm.CreateModelCompose.decompositionIntro') }}
                        <ul>
                          <li><b>{{ $t('components.simulationDetails.SalesDecomposition.base') }}</b>: {{ $t('components.ekrm.CreateModelCompose.decompositionBase') }}</li>
                          <!-- One entry for the one bar the two drawn years are credited to, and it says
                               both things: what a season is and what a spot event is, in that order, under
                               the name the bar carries. Two entries would be the list naming components
                               this chart does not draw. -->
                          <li v-if="shapesTotal !== null">
                            <b>{{ seasonalityLabel }}</b>: {{ $t('components.ekrm.CreateModelCompose.decompositionSeasonality') }}
                            {{ $t('components.ekrm.CreateModelCompose.decompositionSpot') }}
                          </li>
                          <li><b>{{ marketingLabel }}</b>: {{ $t('components.ekrm.CreateModelCompose.decompositionMarketing') }}</li>
                          <!-- The two other inputs, each where the payload carries its spend: what its
                               bar is, or — with no share stated — why it has none. -->
                          <li v-for="other in previewOthers" :key="`decomposition_${other.key}`">
                            <b>{{ other.label }}</b>:
                            <template v-if="other.share !== null">
                              {{ $t(`components.ekrm.CreateModelCompose.${other.key === 'competition' ? 'decompositionCompetition' : 'decompositionComarketing'}`, { share: roundShare(other.share) }) }}
                            </template>
                            <template v-else>
                              {{ $t('components.ekrm.CreateModelCompose.decompositionOtherChosenByModel') }}
                            </template>
                          </li>
                        </ul>
                      </template>
                    </sales-decomposition>
                  </v-col>
                </v-row>

                <!-- WHAT EACH CHANNEL COST AND WHAT EACH ONE RETURNED, against each other. The
                     waterfall above credits the media with one bar, which is the right reading of where
                     the revenue came from and says nothing about which of these channels earned it; the
                     cards on the media step say it one channel at a time, which is the right shape for
                     placing a curve and the wrong one for comparing four. This is the comparison, and
                     it is the Model Report's own chart rather than a picture drawn for this wizard: the
                     reader who builds an EKRM is going to read its report, and the two should be the
                     same object — which is why it keeps the header the report gives it, unit and
                     all. -->
                <v-row v-if="spendReturnData">
                  <v-col cols="12">
                    <media-spend-and-return
                      :data="spendReturnData"
                      :spend-unit="ekrmUnit"
                      :sales-unit="ekrmUnit"
                      :custom-kpi-name="spendReturnKpiName"
                      :export="false" />
                  </v-col>
                </v-row>

                <!-- AND THE SAME RATIO ACROSS THE YEAR. The chart above ranks the channels against
                     each other over the whole twelve months and says nothing about WHEN the money came
                     back; this is the Model Report's Quarterly Average Total ROAS, drawn off the same
                     two traversals — four bars, one per quarter, each what that quarter's spend
                     returned on the curves as they stand. Its own chart under its own heading, for the
                     reason the one above it is: a figure the reader will meet again should be the same
                     object here. The y axis carries the ratio's name because both axes of an EKRM are
                     USD and the figure itself is dimensionless. -->
                <v-row v-if="quarterlyRoasData">
                  <v-col cols="12">
                    <bar-chart
                      :data="quarterlyRoasData"
                      :title="$t('components.ModelReportComponent.quarterlyAverageRoas')"
                      :y-name="$t('components.ekrm.CreateModelCompose.roasAxis')"
                      :full-precision-labels="true"
                      :export="false" />
                  </v-col>
                </v-row>
              </template>

              <!-- DRIVERS PERFORMANCE. The summary above says what the year came to; this says how
                   it got there — the same attribution opened up along the twelve months and along
                   the channels, which is exactly the division the Model Report makes between its
                   two tabs. Every reading here is a margin of one matrix — see
                   previewReturnByChannel — so the columns, the river and the quarterly lines cannot
                   disagree about one channel in one month.

                   FIVE SECTIONS, IN THE REPORT'S OWN ORDER: what the year came to month by month,
                   what was put in, what came back per unit put in, and the two curves that say why —
                   the response and the carry-over. Seasonality Effects, Media Mix and Media
                   Attribution by Period are drawn nowhere here, and neither is Media Spend under its
                   own name: the mix and the attribution are the same river as the input divided or
                   re-credited, and the seasonality is the card on the step before this one read a
                   second way. A preview that showed every margin of one matrix would be longer than
                   the report and would say the same thing four times.

                   Monthly throughout, and no granularity toggles or variable pickers. The report
                   offers weekly against monthly wherever it holds both, and Input Over Time lets a
                   reader choose which input; an EKRM is twelve months and its only input is the
                   media spend, so either control would have one position and do nothing.

                   Pricing and Distribution effects are not here for the reason the Model Fit is not:
                   an EKRM carries no such variables, so there is nothing to draw rather than
                   something to draw empty. -->
              <template v-if="previewTab === 1 && previewReady">
                <!-- THE WATERFALL ALONG THE YEAR. The summary's decomposition is these twelve columns
                     summed, and the three components are the same three, in the same colours: what
                     the business sells on its own, what the two drawn years move, and what the
                     curves return. A month where the season takes sales out shows it below the
                     line, which is the one thing the annual bar can only say as a net. -->
                <v-row v-if="decompositionByPeriodData">
                  <v-col cols="12">
                    <stacked-bar-chart
                      :data="decompositionByPeriodData"
                      :title="`${$t('components.ModelReportComponent.salesDecompositionByPeriod', { kpi: spendReturnKpiName })} (${ekrmUnit})`"
                      :colors="decompositionByPeriodColors"
                      x-name=""
                      :y-name="spendReturnKpiName"
                      :export="false"
                      :scale="true" />
                    <!-- The one column here that is not the payload's own arithmetic, said under the
                         chart: an other input's year is spread by its spend, where the model will put
                         saturation and carry-over between the two. -->
                    <p v-if="previewOtherBars.length > 0" class="caption grey--text text--darken-1 mt-2 mb-0">
                      {{ $t('components.ekrm.CreateModelCompose.decompositionOtherByPeriodNote') }}
                    </p>
                  </v-col>
                </v-row>

                <!-- WHAT WAS PUT IN, one band per channel per month. The report calls this Input Over
                     Time and lets the reader pick which input; an EKRM has exactly one — the media
                     spend — so the picker is absent and the section is that input. Stacked, because
                     the bands are money and their sum is the month's budget: it is the same twelve
                     columns the Media Spend card stacks under the figure that states them, drawn here
                     in the app's own hand. -->
                <!-- With the report's own selector in its title: the media, and each other input the
                     payload carries a spend for, one at a time. -->
                <v-row v-if="previewInputData">
                  <v-col cols="12">
                    <river-chart
                      :key="`preview_input_${previewInputSelected}`"
                      :data="previewInputData"
                      :titleString="$t('components.ModelReportComponent.inputOverTime')"
                      icon="chart-bell-curve"
                      x-name=""
                      :y-name="`${$t('components.ekrm.CreateModelCompose.spend')} (${ekrmUnit})`"
                      :colors="previewInputColors"
                      :x-axis-type-is-category="true"
                      :sum-one-hundred="false"
                      :export="false">
                      <template v-if="previewInputItems.length > 1" v-slot:info>
                        <v-select
                          :value="previewInputSelected"
                          :items="previewInputItems"
                          dense hide-details dark solo flat
                          background-color="grey darken-4"
                          class="mr-2"
                          style="max-width: 240px"
                          @change="previewInputVariable = $event"></v-select>
                      </template>
                    </river-chart>
                  </v-col>
                </v-row>

                <!-- AND WHAT EACH CHANNEL BROUGHT BACK PER UNIT OF IT, quarter by quarter. It is the
                     input above divided into the attribution the decomposition credits the media
                     with, so the three sections close on each other by construction. A quarter a
                     channel bought nothing in is a gap in its line rather than a zero: a ratio over
                     no spend is not a ROAS of nought. -->
                <v-row v-if="quarterlyRoasByMediaData">
                  <v-col cols="12">
                    <channel-curves-chart-multi
                      :data="quarterlyRoasByMediaData"
                      :titleString="$t('components.ModelReportComponent.averageRoasByMedia')"
                      icon="chart-bell-curve"
                      x-name=""
                      :y-name="$t('components.ekrm.CreateModelCompose.roasAxis')"
                      :colors="previewChannelColors"
                      :x-axis-type-is-category="true"
                      :smooth-lines="false"
                      :show-tooltips="true"
                      :detailed-tooltip="true"
                      :tooltip-value-mantissa="2"
                      :tooltip-significant-decimals="true"
                      :export="false" />
                  </v-col>
                </v-row>

                <!-- THE LAST ROW OF THE REPORT'S DRIVERS TAB, and it is one row holding both for the
                     same reason it is there: the response curves and the carry-overs are the two
                     halves of what a channel does with a month's money — how much of it works, and
                     for how long. -->
                <v-row>
                  <!-- EVERY CHANNEL'S RESPONSE ON ONE PAIR OF AXES, in the report's own section: the
                       curve, the five optimal zones and the marginal ROAS, per channel and against
                       each other. The media step draws each of these on its own card and again in its
                       own editor, which is where a curve is PLACED; this is where they are compared,
                       and it is the screen the reader will compare them on afterwards.

                       The dots on it are the plan, not the fit: twelve months of spend against what
                       the attribution credits that month with, off the same matrix the sections above
                       are drawn from — so a point sits where those charts say it does. -->
                  <v-col v-if="saturationCurvesData" cols="12">
                    <saturation-curves
                      :saturation-data="saturationCurvesData"
                      :channel-colors="saturationChannelColors"
                      :client="previewClient"
                      :custom-kpi-name="spendReturnKpiName"
                      :output-unit-name="ekrmUnit"
                      :spend-unit-name="ekrmUnit"
                      :enable-group-selector="false"
                      :can-export-curves="false" />
                  </v-col>

                  <!-- AND EVERY CHANNEL'S CARRY-OVER on one pair of axes: what share of a month's
                       spend is still working a month later, two months later, and so on. Each card on
                       the media step draws its own as bars; this is the comparison between them, and
                       it is the last thing the report says about the drivers. -->
                  <v-col v-if="decayCurvesData" cols="12">
                    <channel-curves-chart-multi
                      :data="decayCurvesData"
                      :titleString="$t('components.ModelReportComponent.decayCurves')"
                      icon="chart-bell-curve"
                      :x-name="$t('components.ekrm.CreateModelCompose.decayAxis')"
                      :y-name="$t('views.ModelReport.impactPercent')"
                      :colors="previewChannelColors"
                      :show-tooltips="true"
                      :scale="true"
                      :filter-mode="null"
                      :export="false" />
                  </v-col>
                </v-row>
              </template>
            </template>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </v-card-text>

  <!-- THE WAY THROUGH, on a bar of its own at the foot of the dialog rather than up on the black
       toolbar. Create is the last step's button and nothing else: a wizard that offers to finish
       from its first screen is not asking its questions in an order. Next is refused until the step
       on screen is answered — stepValid — and Back is free, every step behind the current one
       having been answered already. -->
  <v-divider class="flex-shrink-0"></v-divider>
  <v-card-actions class="compose-actions">
    <v-btn v-if="step > 1" text @click="goBack">
      <v-icon left>mdi-chevron-left</v-icon>{{ $t('views.App.previous') }}
    </v-btn>
    <v-spacer></v-spacer>
    <span v-if="stepHint" class="caption grey--text text--darken-1 mr-4">{{ stepHint }}</span>
    <v-btn v-if="step < 7" color="primary" depressed :disabled="!canLeaveStep" @click="goNext">
      {{ $t('views.App.next') }}<v-icon right>mdi-chevron-right</v-icon>
    </v-btn>
    <v-btn v-else color="primary" depressed :disabled="!canCreate" :loading="creating" @click="createReferenceModel">
      <v-icon left>mdi-check-bold</v-icon>{{ $t('components.ekrm.CreateModelCompose.create') }}
    </v-btn>
  </v-card-actions>

  <!-- WHERE EVERYTHING BORROWED COMES FROM. One importer, three questions asked of it: which model
       to copy, which channels to take (out of as many models as needed), and which model's year or
       season to borrow. Each is found the same way — by the model's name, by what it is about, and
       for channels by what each one is in the taxonomy. See EkrmModelImporter.

       The channels close the dialog on the add, the cards just made being behind it and each of
       them waiting to be answered; the filters are remembered, so a second visit opens on the same
       list. -->
  <ekrm-model-importer
    v-model="copyImporterDialog"
    mode="model"
    icon="mdi-content-duplicate"
    :title="$t('components.ekrm.CreateModelCompose.copyImporterTitle')"
    :subtitle="$t('components.ekrm.CreateModelCompose.copyImporterSubtitle')"
    :models="copyModels"
    :loading="catalogueLoading"
    :empty-text="$t('components.ekrm.CreateModelCompose.noCopyModels')"
    :country-name="countryName"
    :country-key="countryKey"
    :model-note="modelNote"
    :active-model-id="copyModelId"
    @pick="onCopyImporterPick"
  ></ekrm-model-importer>

  <ekrm-model-importer
    v-model="channelImporterDialog"
    mode="channels"
    icon="mdi-plus-box-multiple-outline"
    :title="$t('components.ekrm.CreateModelCompose.channelImporterTitle')"
    :subtitle="$t('components.ekrm.CreateModelCompose.channelImporterSubtitle')"
    :models="sourceModels"
    :loading="catalogueLoading"
    :country-name="countryName"
    :country-key="countryKey"
    :added="taxonomyAdded"
    :reads="taxonomyReads"
    :status="taxonomyStatus"
    :plot-view-box="plotViewBox"
    :card-labels="cardLabels"
    @need-models="onTaxonomyNeed"
    @add="onTaxonomyAdd"
  ></ekrm-model-importer>

  <!-- THE YEAR THE SALES FALL OVER, TAKEN OFF A MODEL THAT MEASURED ONE.

       The step above asks for one figure and one shape: what the business sold, and how that year
       fell across twelve months. The figure is nobody's but the user's. The shape is a fact about a
       business, and there are models on this platform that have measured one — so it can be
       borrowed, and the two buttons beside this one are what you reach for when it cannot.

       BORROWING IT NEEDS NONE OF WHAT A COPY NEEDS. What travels is twelve multipliers of mean one:
       the row is renormalised on the way in, so the total typed above stands untouched and only the
       columns move. A multiplier is dimensionless, so there is no unit to convert and no exchange
       rate to ask for — which is why this list is every model with a finished report, where step
       one's copy has to drop each model whose spend and sales are counted in different money.

       THREE THINGS ARE ASKED AND THE THIRD IS THE ONE WORTH HAVING. Which model; which of its KPIs,
       where it reports more than one; and which year — the average of every complete year it has, or
       one named year. Only COMPLETE calendar years are offered either way: a January that is really
       three weeks of January is a January that sold less, and a dent the data put in a shape is not
       a dent in the business.

       And nothing is applied until it is accepted. The twelve columns under the selectors are the
       shape that will land, drawn in the money it will land in wherever a total has already been
       typed — a shape chosen off a model's name alone is a shape chosen unseen. -->
  <ekrm-model-importer
    v-model="shapeImportDialog"
    mode="model"
    icon="mdi-chart-timeline-variant"
    :title="importText('Title')"
    :subtitle="importText('Subtitle')"
    :models="sourceModels"
    :loading="catalogueLoading"
    :country-name="countryName"
    :country-key="countryKey"
    :model-note="modelNote"
    :active-model-id="activeShapeModelId"
    :picked-model-id="shapeImportModelId"
    @pick="onShapeImportModel"
    @back="onShapeImportBack"
  >
    <template #details>
      <!-- WHICH KPI, and only for a model that has more than one. A single-output model has one
           answer and a selector with one row in it is a question that is not being asked. -->
      <!-- For an other input the question is WHICH INPUT instead: a medium, all of them, or one of
           the external series the model was fed — the KPI does not come into it. -->
      <div
        v-if="!shapeImportLoading && (shapeImportOther
          ? shapeImportSeriesItems.length > 0 || shapeImportYearItems.length > 0
          : shapeImportKpiItems.length > 1 || shapeImportYearItems.length > 0)"
        class="shape-pick__asks">
        <v-select
          v-if="shapeImportOther && shapeImportSeriesItems.length > 0"
          :label="$t('components.ekrm.CreateModelCompose.shapeImportOtherSeries')"
          :value="shapeImportSeries"
          :items="shapeImportSeriesItems"
          prepend-inner-icon="mdi-chart-line"
          hide-details="auto"
          outlined
          dense
          @change="onShapeImportSeries"
        ></v-select>
        <v-select
          v-if="!shapeImportOther && shapeImportKpiItems.length > 1"
          :label="$t('components.ekrm.CreateModelCompose.shapeImportKpi')"
          :value="shapeImportKpi"
          :items="shapeImportKpiItems"
          prepend-inner-icon="mdi-target"
          hide-details="auto"
          outlined
          dense
          @change="onShapeImportKpi"
        ></v-select>
        <v-select
          v-if="shapeImportYearItems.length > 0"
          :label="$t('components.ekrm.CreateModelCompose.shapeImportYear')"
          :value="shapeImportYear"
          :items="shapeImportYearItems"
          prepend-inner-icon="mdi-calendar-range"
          hide-details="auto"
          outlined
          dense
          @change="onShapeImportYear"
        ></v-select>
      </div>

      <v-alert v-if="shapeImportError" type="error" text dense border="left" class="mt-3 mb-0">
        {{ shapeImportError }}
      </v-alert>
      <div v-if="shapeImportLoading" class="clone-pick-empty">
        <v-progress-circular indeterminate color="primary" size="28" width="2"></v-progress-circular>
        <span class="clone-pick-empty__text">
          {{ $t('components.ekrm.CreateModelCompose.shapeImportLoadingNote') }}
        </span>
      </div>
      <!-- A model with no complete calendar year has nothing to lend, and the reason is a fact
           about its history rather than a failure of this dialog. -->
      <v-alert v-else-if="shapeImportYears.length === 0" type="warning" text dense border="left" class="mb-0">
        {{ $t('components.ekrm.CreateModelCompose.shapeImportNoYears') }}
      </v-alert>
      <v-alert v-else-if="shapeImportOther && shapeImportSeriesChoices.length === 0" type="warning" text dense border="left" class="mb-0">
        {{ $t('components.ekrm.CreateModelCompose.shapeImportOtherNoSeries') }}
      </v-alert>
      <v-alert v-else-if="!shapeImportShape" type="warning" text dense border="left" class="mb-0">
        {{ importText('NoShape') }}
      </v-alert>

      <template v-else>
        <!-- THE SHAPE ITSELF, at the size it will arrive: in money wherever a total has been typed
             above, and as multipliers of one where it has not — which is what it IS, and the only
             honest reading of it before there is a total for it to be a share of. -->
        <!-- THE SAME YEAR, LATER OR EARLIER, before it is accepted. A borrowed year is borrowed
             from a business with its own calendar, and the commonest thing wrong with one that is
             otherwise the right shape is that it belongs to the other hemisphere: its December
             sells in July. So the two arrows move all twelve values along together — the shape
             survives a press exactly and twelve presses are the identity — and they are HERE, over
             the picture, because this is where the reader can see whether it now lands where their
             business sells. The same verb stands on the card behind for a year already accepted;
             having it in both places is what stops the correction being a reason to import, look,
             undo and import again. -->
        <div class="shape-pick__tools">
          <span v-if="shapeImportShiftLabel" class="shape-pick__shift">{{ shapeImportShiftLabel }}</span>
          <v-btn
            icon small
            :title="$t('components.ekrm.CreateModelCompose.shapeImportShiftLeft')"
            @click="onShapeImportShift(-1)">
            <v-icon small>mdi-arrow-left-bold-outline</v-icon>
          </v-btn>
          <v-btn
            icon small
            :title="$t('components.ekrm.CreateModelCompose.shapeImportShiftRight')"
            @click="onShapeImportShift(1)">
            <v-icon small>mdi-arrow-right-bold-outline</v-icon>
          </v-btn>
        </div>
        <div class="shape-pick__plot">
          <div v-for="bar in shapeImportBars" :key="bar.key" class="shape-pick__col" :title="bar.title">
            <!-- A sales year is twelve positive months and stands on the floor of the box; a
                 season goes both ways and stands on a line through the middle of it, which is the
                 same reading the section's own plot gives it. The lower half exists only for the
                 row that can reach it. -->
            <div class="shape-pick__track" :style="{ backgroundColor: shapeImportTrack }">
              <div class="shape-pick__bar" :style="{ height: bar.height, backgroundColor: shapeImportColor }"></div>
            </div>
            <template v-if="shapeImportSigned">
              <div class="shape-pick__line"></div>
              <div class="shape-pick__track shape-pick__track--down" :style="{ backgroundColor: shapeImportTrack }">
                <div class="shape-pick__bar shape-pick__bar--down"
                  :style="{ height: bar.down, backgroundColor: shapeImportColor }"></div>
              </div>
            </template>
            <span class="shape-pick__month">{{ bar.label }}</span>
          </div>
        </div>
        <p class="shape-pick__note">{{ importText('Note') }}</p>
        <!-- An other input keeps the total on its card and takes only the shape, so a card with no
             total has nothing for the shape to spread: said here, beside the refused button. -->
        <v-alert v-if="shapeImportOther && !(shapeImportOtherTotal > 0)" type="info" text dense border="left" class="mt-2 mb-0">
          {{ $t('components.ekrm.CreateModelCompose.shapeImportOtherNeedsTotal') }}
        </v-alert>
        <!-- What the cap would not let through, said before the year is accepted rather than
             after: a month the composer cannot draw at the share the source model measured is a
             month that will arrive flatter than the picture the reader is looking at. -->
        <p v-if="shapeImportHeldText" class="shape-pick__note shape-pick__note--held">
          {{ shapeImportHeldText }}
        </p>
      </template>
    </template>
    <template #actions>
      <span v-if="shapeImportSummary" class="clone-picker__summary text-truncate">
        {{ shapeImportSummary }}
      </span>
      <v-spacer></v-spacer>
      <v-btn text @click="shapeImportDialog = false">{{ $t('components.TextBox.close') }}</v-btn>
      <v-btn color="primary" depressed :disabled="!shapeImportCanApply" @click="applyShapeImport">
        {{ importText('Apply') }}
      </v-btn>
    </template>
  </ekrm-model-importer>

  <!-- THE CHANNEL EDITOR: everything about one channel, on one screen, and the only place any of it
       is edited.

       It replaces two dialogs and three controls that lived on the card. The card is a hundred and
       fifty pixels wide and used to carry an input for the name, an input for each of the two
       figures and a press for the curve — four gestures, four scrims, three of them typing into a
       field the width of the value it held, and the one thing none of them had room for was what any
       of it MEANS. A channel is one object: what it is called, where it stops paying, what it makes
       there, and the shape of the response between. It is edited as one.

       WHAT IS ON THE LEFT is the response, and it is drawn from whatever there is to draw it with: a
       placed channel gets the chart and the three levers under it, an unanswered one gets the shape
       it was imported with and the sentence saying what the two figures on the right will do to it.
       The levers move a curve the PAYLOAD carries, so there is nothing for them to point at until
       the figures have put one there.

       THE ARROWS WALK EVERY CHANNEL and they loop. Not the unanswered ones — that was a queue, and a
       queue is a thing you are put through; this is a way around a model, and the channel you want
       next after correcting Search is as likely to be the one you have already answered. Everything
       commits as it is typed, so an arrow pressed mid-edit takes the figure with it: the field
       commits on blur, and a press moves the focus before it moves the channel. -->
  <v-dialog :value="editorCard !== null" width="960" scrollable @input="onEditorDialog">
    <v-card v-if="editorCard" class="clone-editor">
      <v-card-title class="clone-editor__title">
        <!-- THE NAME IS THE TITLE. It was a field on the right of the chart, labelled "Channel
             name", under a heading already saying the name — the same word twice, one of them
             editable and neither of them saying which. The heading itself takes the typing now: it
             is the title until a pointer is over it, and it commits on blur and on Enter like every
             other field on this screen. What the name cannot be is said where the source line is,
             so the bar does not change height while a name is being refused.

             AND IT SAYS SO WITHOUT BEING TOUCHED. A title that only turns into a field on hover is
             a field nobody finds: the line carries a dashed rule under it and a pencil at its end
             at all times, which is the one convention for "this text is the field" that needs no
             explaining, and both darken as the pointer crosses and go blue while it is being typed.
             The pencil is not a button — the input beside it already takes the focus, from a
             pointer and from the tab order, and a second control on to the same field would be one
             more stop on the way round the bar. It is the rule's own end mark, so the whole line
             answers a click by putting the caret in the field. -->
        <div class="clone-editor__heading">
          <div
            class="clone-editor__name-wrap"
            :class="{ 'clone-editor__name-wrap--error': editorNameError !== '' }"
            @click="focusName">
            <input
              ref="editorNameField"
              v-model="editorName"
              class="clone-editor__name subtitle-1 font-weight-medium"
              :maxlength="nameMaxLength"
              :aria-label="$t('components.ekrm.CreateModelCompose.channelName')"
              :title="$t('components.ekrm.CreateModelCompose.channelName')"
              @keydown.enter.exact.prevent="commitName"
              @keydown.tab.exact.prevent="editorTab('name', false)"
              @keydown.tab.shift.exact.prevent="editorTab('name', true)"
              @blur="commitName">
            <v-icon class="clone-editor__name-pen" x-small>mdi-pencil-outline</v-icon>
          </div>
          <span v-if="editorNameError !== ''" class="clone-editor__error text-truncate">
            {{ editorNameError }}
          </span>
          <span v-else class="clone-editor__origin text-truncate" :title="editorCard.originTitle">
            {{ editorCard.originTitle }}
          </span>
        </div>
        <v-spacer></v-spacer>
        <!-- The way around the model. Disabled at one channel rather than hidden: a control that
             comes and goes with the number of cards is a control that has to be found again. -->
        <div class="clone-editor__walk">
          <v-btn
            icon
            small
            :disabled="channels.length < 2"
            :title="$t('components.ekrm.CreateModelCompose.editorPrev')"
            @click="requestStep(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="clone-editor__count">
            {{ $t('components.ekrm.CreateModelCompose.statedOf', editorPosition) }}
          </span>
          <v-btn
            icon
            small
            :disabled="channels.length < 2"
            :title="$t('components.ekrm.CreateModelCompose.editorNext')"
            @click="requestStep(1)">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <v-btn
          icon
          small
          :title="$t('components.ekrm.CreateModelCompose.curveAboutTitle')"
          @click="curveDialog = true">
          <v-icon small>mdi-information-outline</v-icon>
        </v-btn>
        <v-btn
          icon
          small
          :title="$t('components.ekrm.CreateModelCompose.editorCancel')"
          @click="requestClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="clone-editor__body">
        <v-row dense>
          <v-col cols="12" md="7" class="clone-editor__col">
            <!-- THE FOUR CARDS. One screen with four statements on it — the response, the point
                 that places it, where its zones fall and the shape between them — and each of them
                 now stands in a frame of its own under its own name, which is the dress the pair
                 beside the chart put on first. It is one rule and not four: a heading in small
                 capitals, a hairline round what it heads, and the same inset inside every one, so
                 the eye can tell what belongs to what without reading a word of it. -->
            <div class="clone-editor__card">
              <span class="clone-editor__card-title">
                {{ $t('components.ekrm.CreateModelCompose.saturationCurve') }}
              </span>
              <!-- THE SHAPE IS DRAWN BEFORE THE SIZE IS KNOWN, AND SAYS WHICH IT IS SHOWING. Until
                   the saturation point is typed, this curve is the imported fit over a unit scale:
                   the shape is exactly the one the answer will produce — that is what the whole
                   wizard rests on — and every magnitude on it is a placeholder. So the picture stays
                   and the rulers go: no figures on either axis, no tooltip reading them back, and the
                   one place on the curve the screen is asking about marked with a question where it
                   falls. What remains is true: this shape, these five zones, this point among them.

                   AND THERE IS NO KEY. It stood in the top-right corner naming three things — this
                   curve, the one it was imported as, and the point between them — none of which needs
                   naming: there is one solid line and it is the channel, one dashed line drawn only
                   when an edit has moved it away from the fit it arrived with, and one purple dot
                   which is the card to the right of it wearing the same purple dot. Three labels for
                   three things a reader already has in front of them is a strip of the plot's own
                   height spent on saying nothing. `legendBottom` stays: it says the key does not
                   stand at the top of the plot, which is truer of none than of one, and it is what
                   lets the curve begin on the same line as the card beside it. -->
              <channel-curves-chart-multi
                v-if="curveChartData"
                class="clone-editor__chart"
                :data="curveChartData"
                titleString=""
                :animation="false"
                :show-legend="false"
                legend-orient="horizontal"
                :legend-bottom="true"
                :hide-title="true"
                :show-tooltips="editorStated"
                :export="false"
                :show-negatives="false"
                :x-name="$t('components.ekrm.CreateModelCompose.spend')"
                :y-name="$t('components.ekrm.CreateModelCompose.revenue')"
                :hide-axis-values="!editorStated"
                :x-axis-type-is-category="false"
                :x-axis-type-is-date="false"
                :x-axis-rotate="60"
                :same-axis-scale="true"
                :grid-bottom-margin="50"
                elevation="elevation-0"
                regions-channel="Revenue"
                :colors="curveChartColors"
                :name-translations="curveSeriesNames"
                :line-styles="curveLineStyles" />
              <div v-else class="clone-editor__noshape">{{ cardLabels.noCurve }}</div>
            </div>
            <!-- WHAT THE BANDS UNDER THE CURVE ARE, WHERE EACH OF THEM STARTS, AND THE PLACE
                 THAT IS SET. The same five zones the model report shades, in the same colours,
                 under the same names, off the report's own locale keys — because they are the same
                 zones: the boundaries travel here with the shape, and shading that reads as one
                 thing on the report and another here would be two claims in one colour. Zone 1 is
                 the one with no fill, which is the report's convention too: below the minimum
                 spending threshold there is nothing being bought worth colouring in.

                 It was a key of five swatches and it is a BAR: five colours in one continuous run
                 with the four boundaries as grips on it, because where a zone begins is a place and
                 a place is moved by taking hold of it. The figures underneath are the same five
                 that were there, and four of them are now the field their own boundary is typed
                 into — the bar for the gesture, the field for the amount, and the two are one
                 number. Both go through hillRegionSet, which is where the fact that four boundaries
                 come off two free numbers is stated once: exactly one thing can be held while one
                 of them is moved, and the switch on the heading line says which. Held boundaries
                 give up their grip and their field — what is held cannot also be dragged — and a
                 drag under the setting that holds the SHAPE is the placement, which is the same
                 edit as typing into the field beside the chart.

                 Drawn only when the bands are, so the bar never offers a grip on a boundary that is
                 not on screen — and the bands go the moment the steepness lever makes them untrue.
                 Greyed on a channel the payload does not carry yet, like the levers beside it.

                 AND CLOSED IT IS THE KEY IT STARTED AS. Where the five zones fall is worth reading
                 whether or not the reader has any intention of moving one — it is what the two
                 figures beside the chart came to — so the run of colour and the five figures stay
                 exactly where they are and everything that made them controls goes: no switch over
                 the bar, no grips on it, no fields under it.

                 WHAT OPENS THE PANEL IS ON THE PANEL. It was one switch at the foot of the dialog
                 turning on the controls of two different things at once, which is a reader looking
                 for what changed in two places; each section now carries its own way in, on its own
                 heading line, and neither says anything about the other. -->
            <div v-if="curveChartData" class="clone-editor__card">
              <div class="clone-editor__card-title clone-editor__zones-head">
                {{ $t('components.ekrm.CreateModelCompose.zonesBegin') }}
                <!-- Dropped with the figures it denominates: five em dashes are not in dollars
                     a month or in anything else. -->
                <span v-if="curveRegions && editorStated" class="clone-editor__zones-unit">
                  {{ $t('components.ekrm.CreateModelCompose.statedSuffix') }}
                </span>
                <!-- WHAT THE NEXT GESTURE HOLDS STILL. Four boundaries come off two numbers, so
                     one moved always moves the others and the only question is WHICH ONE THING
                     stands. Where the channel saturates, and the bar changes shape around a fixed
                     right-hand figure; or the shape itself, and the five widths come out identical
                     with the whole run of them slid along the spend axis; or a boundary the reader
                     POINTS AT, which is the general case the first of them is one setting of. Two
                     held while a third moves is not on the switch because it is not a thing that
                     exists: two boundaries name the exponent between them, either of them then
                     names the rest, and there is nothing left to have dragged.

                     ONE CONTROL AND NOT TWO. It was two labelled runs — the conventions, and then
                     the boundaries by number — which is the shape of the ANSWER rather than of the
                     question: the question is one, exactly one thing stands, and a reader who has
                     to work out which of two switches is currently the live one is being asked to
                     hold the grammar of the thing instead of the thing. One segmented run now,
                     five settings and one of them lit, so what is held is read in a glance and set
                     in one; the hairline before the third is all that is left of the grouping,
                     because the last three are places on the bar below and the first two are not.

                     ICONS AND NOT WORDS, with the words in the tooltip. The names are phrases —
                     "the saturation point", "where zone 3 begins" — and five of them on a heading
                     line is a paragraph pretending to be a control. The glyphs carry the family: a
                     pin for the one point, a curve for the shape, a numbered box for each boundary
                     it could be instead; each button says its own name to a screen reader, and the
                     tooltip gives that name and what the setting costs — which is what the row of
                     titles carried before. The tooltip hangs on a wrapper rather than on the
                     button, so it is still drawn on a channel whose payload has not arrived and
                     whose buttons are therefore disabled: a disabled control is exactly where a
                     reader most wants to be told what it would have done.

                     On the heading line and not over the bar, because it is a statement about the
                     whole bar and a control standing between two colours would read as belonging
                     to one of them. Greyed with everything else on a channel the payload does not
                     carry yet. -->
                <!-- THE WAY IN, AND NOTHING ELSE ON THE LINE. A disclosure and not a switch: what
                     it opens stands directly under it, so the control and its consequence are read
                     in one place, and the caret says which of the two states this is.

                     A GLYPH AND NOT A PHRASE, with the phrase in the tooltip — the same rule the
                     five settings under it already follow. "Move the boundaries" on a heading line
                     is a second heading competing with the first, in a card whose title is three
                     words; the split arrow says the one thing the word said, which is that the
                     lines between the bands are things that can be taken hold of. The tooltip
                     carries the name and what opening it puts on the screen, and hangs on a wrapper
                     rather than on the button so a disabled disclosure still explains itself.

                     Drawn only where there are bands to take hold of — a bar that is not on the
                     screen has no grips to offer — and greyed with the rest of the card on a
                     channel the payload does not carry yet. -->
                <v-tooltip v-if="curveRegions" top max-width="380">
                  <template v-slot:activator="{ on }">
                    <span class="clone-editor__more-slot" v-on="on">
                      <button
                        type="button"
                        class="clone-editor__more"
                        :class="{ 'clone-editor__more--on': editorZonesOpen }"
                        :aria-expanded="String(editorZonesOpen)"
                        :aria-label="$t('components.ekrm.CreateModelCompose.zonesAdjust')"
                        :disabled="!editorStated"
                        @click="editorZonesOpen = !editorZonesOpen">
                        <v-icon small>mdi-arrow-split-vertical</v-icon>
                        <v-icon class="clone-editor__more-caret" small>{{ editorZonesOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </button>
                    </span>
                  </template>
                  <span>
                    <b>{{ $t('components.ekrm.CreateModelCompose.zonesAdjust') }}</b>
                    — {{ $t('components.ekrm.CreateModelCompose.zonesAdjustHint') }}
                  </span>
                </v-tooltip>
              </div>
              <!-- Over the bar rather than on the heading line, which is where the disclosure now
                   stands: it is a statement about the whole bar and it arrives with the grips it
                   governs, so what a drag holds still is read immediately before the first drag. -->
              <div v-if="curveRegions && editorZonesOpen" class="clone-editor__zones-hold">
                <span class="clone-editor__zones-holds">
                  {{ $t('components.ekrm.CreateModelCompose.zonesHold') }}
                </span>
                <span class="clone-editor__zones-run">
                  <v-tooltip
                    v-for="choice in zoneHoldChoices"
                    :key="choice.key"
                    top
                    max-width="380">
                    <template v-slot:activator="{ on }">
                      <span
                        class="clone-editor__zones-slot"
                        :class="{ 'clone-editor__zones-slot--cut': choice.cut }"
                        v-on="on">
                        <button
                          type="button"
                          class="clone-editor__zones-pick"
                          :class="{ 'clone-editor__zones-pick--on': zoneHoldKey === choice.key }"
                          :aria-pressed="String(zoneHoldKey === choice.key)"
                          :aria-label="choice.name"
                          :disabled="!editorPlaced"
                          @click="setZoneHold(choice)">
                          <v-icon small>{{ choice.icon }}</v-icon>
                        </button>
                      </span>
                    </template>
                    <span><b>{{ choice.name }}</b> — {{ choice.hint }}</span>
                  </v-tooltip>
                </span>
              </div>
              <saturation-zones
                v-if="curveRegions"
                :zones="curveZones"
                :bounds="curveRegions"
                :axis="curveZoneAxis"
                :parse-value="parseAmount"
                :disabled="!editorPlaced"
                :readonly="!editorZonesOpen"
                @preview="onZonePreview"
                @input="onZoneInput" />
              <!-- AND WHEN THERE ARE NO ZONES, THE SECTION STAYS AND SAYS SO. A shape gentle enough
                   to have no interior peak has no threshold, no peak return and nothing to divide,
                   so there is no bar to draw — but a section that leaves the screen is a reader
                   asking what they broke, and the answer is a property of the curve and worth one
                   line. The steepness lever cannot be taken below one any more, so this is now the
                   channel that ARRIVED that way: its own fit is that gentle, and the way back is
                   the same lever. -->
              <p v-else class="clone-editor__note mt-0">
                {{ editorShapeOpen
                  ? $t('components.ekrm.CreateModelCompose.zonesNone')
                  : $t('components.ekrm.CreateModelCompose.zonesNoneSimple') }}
              </p>
            </div>
            <!-- The one thing left to say under the chart when there is no chart: a channel whose
                 source carries no curve this wizard can place. It is a caption on a state and not a
                 component of its own, said where the shape would have been. -->
            <p v-if="editorCard.pending === 'blocked'" class="clone-editor__note">
              {{ editorCard.pendingTitle }}
            </p>
          </v-col>

          <v-col cols="12" md="5" class="clone-editor__col">
            <!-- WHERE THE CHANNEL IS PLACED: ONE POINT, TYPED AS THE TWO NUMBERS IT TAKES.
                 They were two fields under two labels, which is two questions to answer and left
                 the reader to work out that the answers belong to each other. They are one thing:
                 the saturation point — the place on this medium's own response where the money
                 stops paying — and a point on a plane is an x and a y. So it is one control with
                 the pair inside it, the spend and what it generates there with an arrow between
                 them, under the name of the thing they are between them stating. It is also the
                 point marked on the chart to the left, which is what makes the two halves of this
                 screen one screen.

                 UNANSWERED, IT SAYS SO IN EVERY PLACE IT WOULD OTHERWISE GUESS. The frame goes
                 dashed, both numbers are an em dash, and the chart beside it drops its axis figures
                 and marks the point with a question — because until this pair is typed the curve is
                 standing on a placeholder scale, and every number that could be read off it is a
                 number nobody stated. The shape is real and is drawn; the magnitudes are not and
                 are not.

                 They commit exactly as they did — on blur and on Enter, through commitFigure, which
                 takes what parses to a positive amount and puts back what the page says otherwise. -->
            <div
              class="clone-editor__card clone-editor__point"
              :class="{ 'clone-editor__point--unstated': !editorStated }">
              <!-- THE SAME DOT THE TWO CHARTS UNDER THE GRID WEAR, in the colour of the point on
                   the chart beside it: the card states a place and the chart draws it, and a reader
                   looking from one to the other should not have to be told they are the same thing.
                   Hollow while nothing is stated, which is the question mark's own answer at the
                   size of a dot — there is a point here and nobody has said where. -->
              <span class="clone-editor__card-title">
                <span
                  class="clone-editor__point-dot"
                  :class="{ 'clone-editor__point-dot--unstated': !editorStated }"
                  :style="editorStated ? { backgroundColor: saturationColor } : null"></span>
                {{ $t('components.ekrm.CreateModelCompose.saturationPoint') }}
                <!-- AND THE SHAPE BETWEEN THE TWO FIGURES, BEHIND A DISCLOSURE ON THE SAME CARD.
                     It was a card of its own under a switch at the foot of the dialog, which put
                     the levers at the far corner of the screen from the pair they move the curve
                     between — and made one switch answer for them and for the zone bar's grips at
                     once. They belong to this card: the pair says where the point is, the levers
                     say how the response gets there, and the second is a detail of the first.
                     Greyed rather than absent while there is no curve to move, which is the rule
                     the levers themselves follow.

                     Three sliders for the glyph, because three sliders is exactly what is behind
                     it: the icon is a picture of the panel and not a symbol for the idea of one.
                     The name and what it opens are in the tooltip, the same way the zone bar's own
                     switch carries its five. -->
                <v-tooltip top max-width="380">
                  <template v-slot:activator="{ on }">
                    <span class="clone-editor__more-slot" v-on="on">
                      <button
                        type="button"
                        class="clone-editor__more"
                        :class="{ 'clone-editor__more--on': editorShapeOpen }"
                        :aria-expanded="String(editorShapeOpen)"
                        :aria-label="$t('components.ekrm.CreateModelCompose.responseShape')"
                        :disabled="!editorStated || !curveCommitted || !curveBounds"
                        @click="editorShapeOpen = !editorShapeOpen">
                        <v-icon small>mdi-tune-variant</v-icon>
                        <v-icon class="clone-editor__more-caret" small>{{ editorShapeOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </button>
                    </span>
                  </template>
                  <span>
                    <b>{{ $t('components.ekrm.CreateModelCompose.responseShape') }}</b>
                    — {{ $t('components.ekrm.CreateModelCompose.responseShapeHint') }}
                  </span>
                </v-tooltip>
              </span>
              <div class="clone-editor__point-pair">
                <div class="clone-editor__point-half">
                  <span class="clone-editor__point-label">
                    {{ $t('components.ekrm.CreateModelCompose.channelKnee') }}
                  </span>
                  <!-- The caret lands here when the dialog opens on a channel nobody has placed
                       yet — see focusKnee. It is the first of the two figures and the two are the
                       whole of what the dialog is opened to answer, so the field that is waiting
                       for the first of them is where a press on a pending card should leave you. -->
                  <input
                    ref="editorKneeField"
                    v-model="editorKnee"
                    class="clone-editor__point-value"
                    inputmode="decimal"
                    :placeholder="unstatedMark"
                    :aria-label="$t('components.ekrm.CreateModelCompose.channelKnee')"
                    :title="$t('components.ekrm.CreateModelCompose.channelKneeTitle', { channel: editorCard.medium })"
                    @keydown.enter.exact.prevent="commitFigure('knee')"
                    @keydown.tab.exact.prevent="editorTab('knee', false)"
                    @keydown.tab.shift.exact.prevent="editorTab('knee', true)"
                    @blur="commitFigure('knee')">
                  <span class="clone-editor__point-unit">
                    {{ $t('components.ekrm.CreateModelCompose.statedSuffix') }}
                  </span>
                </div>

                <v-icon class="clone-editor__point-arrow" small>mdi-arrow-right</v-icon>

                <div class="clone-editor__point-half">
                  <span class="clone-editor__point-label">
                    {{ $t('components.ekrm.CreateModelCompose.channelCeiling') }}
                  </span>
                  <input
                    ref="editorCeilingField"
                    v-model="editorCeiling"
                    class="clone-editor__point-value"
                    inputmode="decimal"
                    :placeholder="unstatedMark"
                    :aria-label="$t('components.ekrm.CreateModelCompose.channelCeiling')"
                    :title="$t('components.ekrm.CreateModelCompose.channelCeilingTitle', { channel: editorCard.medium })"
                    @keydown.enter.exact.prevent="commitFigure('ceiling')"
                    @keydown.tab.exact.prevent="editorTab('ceiling', false)"
                    @keydown.tab.shift.exact.prevent="editorTab('ceiling', true)"
                    @blur="commitFigure('ceiling')">
                  <span class="clone-editor__point-unit">
                    {{ $t('components.ekrm.CreateModelCompose.statedSuffix') }}
                  </span>
                </div>
              </div>

              <!-- The shape itself, under the pair it stands between and inside the same frame:
                   moving it is a claim about how this medium responds, which is the source model's
                   answer until somebody decides otherwise. Unanswered, the levers stand on the fit
                   the channel was imported with, placed at whatever the two fields currently say —
                   so they show the curve the answer is about to produce, and answering it turns
                   them on where they stand. -->
              <div
                v-if="editorShapeOpen && curveCommitted && curveBounds"
                class="clone-editor__panel">
                <saturation-levers
                  :hide-reset="true"
                  :params="curveLeverParams"
                  :imported="curveImported"
                  :bounds="curveBounds"
                  :limits="curveLimits"
                  :reason-label="curveReason"
                  :format-value="formatCurveValue"
                  :labels="curveLabels"
                  :note="curveNote"
                  :show-factor="false"
                  :disabled="!editorPlaced"
                  @preview="onCurvePreview"
                  @input="onCurveInput" />
              </div>
            </div>

            <!-- THE SECOND CURVE, AND THE FOURTH THING A CHANNEL IS. Where a medium saturates says
                 how much money it can take in a month and what it is worth; this says WHEN that
                 month's money arrives. They are two independent facts about one channel and neither
                 is a reading of the other, which is why this card stands beside the pair rather than
                 inside the saturation point's own panel with the things that move the shape between
                 two typed figures — and it is why a drag here may not move the kernel's total, that total
                 being the pair's business and not this control's.

                 IT IS LIVE ON A CHANNEL NOBODY HAS PLACED. Everything else on this half of the
                 screen is greyed or absent until the pair is typed, because everything else on it is
                 denominated in a size nobody has stated. This is not: the kernel is a SHAPE — what
                 share of a month's spend arrives in each of the months after it — and a share is as
                 true before the pair is typed as after. There is nothing here to wait for.

                 AND IT IS THE CURVE ITSELF THAT TRAVELS. The payload can carry a decay two ways —
                 as two brackets, months to maximum effect and months to half life, and as the
                 kernel the report measured — and the builder reads the kernel wherever there is one.
                 So the kernel is what this card hands over, and the brackets go with it derived from
                 it, which is what stops the two accounts of one channel's decay from disagreeing.
                 What the card ASKS is still the two figures, because they are the whole of what
                 anybody knows about a decay: every combination of them is a thumbnail, and pressing
                 one is the edit — and the peak of the plot above them is a handle, so the figures
                 between two thumbnails are reached by pulling the shape into them. -->
            <div class="clone-editor__card clone-editor__card--fill">
              <span class="clone-editor__card-title">
                {{ $t('components.ekrm.CreateModelCompose.decayTitle') }}
              </span>
              <decay-curve
                v-if="editorDecayKernel"
                class="mt-2"
                :kernel="editorDecayKernel"
                :templates="editorDecayTemplates"
                :source-kernel="editorDecaySourceTile"
                :selected="editorDecaySelected"
                :labels="editorDecayLabels"
                @pick="onDecayPick"
                @shape="onDecayShape" />
              <div v-else class="clone-editor__noshape">{{ cardLabels.noCurve }}</div>
            </div>

          </v-col>
        </v-row>
      </v-card-text>

      <!-- THE WAY BACK TO THE IMPORTED FIT, on the bar rather than in the levers' own foot. It was
           under the three sliders, which said it undid THEM; it undoes the channel — the zone bar's
           grips write the same edit, and with the shape's panel closed there are no sliders on the
           screen at all while an edit made with them open is still standing. Bottom left, opposite the
           way out, disabled while there is nothing to go back to: a channel still standing on the
           shape it arrived with has nowhere to be returned to, and a button that vanished when the
           edit was undone would take the reader's own undo off the screen at the moment they used
           it. -->
      <v-card-actions class="clone-editor__actions">
        <!-- Not gated on the channel being PLACED any more, and the decay is why: the two intervals
             are editable on a channel nobody has typed a pair for, so there is an edit to undo
             before there is a payload to undo it in. `curveCanReset` already answers the only
             question the button has — is this channel standing anywhere other than where its model
             left it — and for the saturation half the answer is no while there is no curve to have
             moved. -->
        <v-btn
          text
          small
          class="ml-1"
          :disabled="!curveCanReset"
          @click="resetCurve">
          <v-icon small class="mr-1">mdi-restore</v-icon>{{ $t('components.ekrm.CreateModelCompose.curveReset') }}
        </v-btn>
        <v-spacer></v-spacer>
        <!-- NOTHING LEAVES THIS DIALOG UNTIL IT IS SAVED. The channel is a small object with four
             statements on one screen and they are answered together — a name corrected on the way to
             a curve, a pair typed and then a lever moved to see what it does — so the unit of work is
             the SCREEN and not the keystroke. Cancel puts the channel back exactly as it was found,
             and it asks first wherever there is something to lose; so does the walk to the next
             channel, which offers to save on the way rather than making the reader come back. -->
        <v-btn color="gray darken-1" text @click="requestClose">
          {{ $t('components.ekrm.CreateModelCompose.editorCancel') }}
        </v-btn>
        <!-- ONE BUTTON, AND WHAT IT SAYS DEPENDS ON WHETHER THE MODEL IS FINISHED.
             A composition arrives as a grid of cards that each want two figures, and answering them
             one at a time meant saving, finding the next card with an error border on it and pressing
             it — a walk back out to the grid between every pair of numbers. The arrows above already
             cross the model, but they walk EVERY channel in the grid's own order, which is the right
             thing for going back over answers and the wrong thing for finishing: they stop on the
             ones that are done.

             So while any channel is still asking, the way out of this screen is the way on to it:
             the same button, saying so. It is not a second control beside Save — there is one thing
             to do here when a channel is answered, and offering two ways to do it would make the
             reader choose between them. When the last one is answered the sentence goes and the
             button is Save again, which is the model saying it is finished. -->
        <v-btn
          ref="editorSaveButton"
          color="primary"
          depressed
          @click="saveEditor"
          @keydown.native.tab.exact.prevent="editorTab('save', false)"
          @keydown.native.tab.shift.exact.prevent="editorTab('save', true)">
          {{ editorNextPending === null
            ? $t('components.ekrm.CreateModelCompose.editorSave')
            : $t('components.ekrm.CreateModelCompose.editorSaveNext') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- WHAT IS ABOUT TO BE LOST, ASKED BEFORE IT IS. It stands over the editor rather than replacing
       it, so the channel being asked about is still on the screen behind the question, and it is only
       ever raised where the answer matters: a channel nothing has moved on closes and walks without a
       word. The way ON is offered beside the way out because leaving is usually not what was meant —
       the reader pressed an arrow to see the next channel, not to throw this one away. -->
  <v-dialog v-model="editorLeaveDialog" width="460" persistent>
    <v-card>
      <v-card-title class="subtitle-1">
        {{ $t('components.ekrm.CreateModelCompose.editorLeaveTitle') }}
      </v-card-title>
      <v-card-text>{{ editorLeaveText }}</v-card-text>
      <v-card-actions>
        <v-btn text small @click="editorLeaveDialog = false">
          {{ $t('components.ekrm.CreateModelCompose.editorLeaveStay') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="leaveWithoutSaving">
          {{ $t('components.ekrm.CreateModelCompose.editorLeaveDiscard') }}
        </v-btn>
        <v-btn color="primary" depressed @click="leaveWithSave">
          {{ $t('components.ekrm.CreateModelCompose.editorLeaveSave') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- A CHANNEL TAKEN OUT IS TAKEN OUT FOR GOOD: its curve edits, its decay and its level go with it,
       and nothing here puts them back. The X on the card sits a few pixels from the pencil on a grid
       of small cards, so the question is asked before the card goes rather than after — and it names
       the channel, because which card the finger landed on is exactly what is in doubt. -->
  <!-- ASKED BEFORE A COMPOSITION IS THROWN AWAY. A copy answers most of this wizard at once, which
       means it also empties most of it: the channels, the pair typed on every card, the curves bent
       in the editor, the spend and the revenue. On an empty page nothing is asked at all — see
       askCopy — so the question only ever stands where there is work behind it. -->
  <v-dialog v-model="copyDialog" width="460">
    <v-card>
      <v-card-title class="subtitle-1">
        {{ $t('components.ekrm.CreateModelCompose.copyAskTitle') }}
      </v-card-title>
      <v-card-text>{{ copyAskText }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text small @click="cancelCopy">
          {{ $t('components.ekrm.CreateModelCompose.editorCancel') }}
        </v-btn>
        <v-btn color="error" depressed @click="confirmCopy">
          {{ $t('components.ekrm.CreateModelCompose.copyAskConfirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="removeDialog" width="460">
    <v-card>
      <v-card-title class="subtitle-1">
        {{ $t('components.ekrm.CreateModelCompose.channelRemoveTitle') }}
      </v-card-title>
      <v-card-text>{{ removeAskText }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text small @click="removeDialog = false">
          {{ $t('components.ekrm.CreateModelCompose.editorCancel') }}
        </v-btn>
        <v-btn color="error" depressed @click="confirmRemove">
          {{ $t('components.ekrm.CreateModelCompose.channelRemoveConfirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- What everything in the editor is, and what none of it touches. It opens from the editor's own
       corner, so it answers for all three of the things edited there: the two figures that place the
       curve — a sentence each, the long ones the fields carry only a line of — and then the levers
       that move it. In that order, which is the order they are answered in. -->
  <v-dialog v-model="curveDialog" width="600">
    <v-card>
      <v-card-title class="subtitle-1">
        {{ $t('components.ekrm.CreateModelCompose.curveAboutTitle') }}
      </v-card-title>
      <v-card-text>
        <template v-if="editorCard">
          <p class="font-weight-medium mb-1">{{ $t('components.ekrm.CreateModelCompose.channelKnee') }}</p>
          <p>{{ $t('components.ekrm.CreateModelCompose.channelKneeTitle', { channel: editorCard.medium }) }}</p>
          <p class="font-weight-medium mb-1">{{ $t('components.ekrm.CreateModelCompose.channelCeiling') }}</p>
          <p>{{ $t('components.ekrm.CreateModelCompose.channelCeilingTitle', { channel: editorCard.medium }) }}</p>
          <!-- The other curve, answered where it is edited: after the pair and before the shape,
               which is the order the right-hand column asks in. What it costs is said here and
               nowhere else — the card itself carries a line, and a line is no place for a sentence
               about which of two things in the payload the builder reads. -->
          <p class="font-weight-medium mb-1">{{ $t('components.ekrm.CreateModelCompose.decayTitle') }}</p>
          <p>{{ $t('components.ekrm.CreateModelCompose.decayAbout') }}</p>
          <p class="font-weight-medium mb-1">{{ $t('components.ekrm.CreateModelCompose.saturation') }}</p>
        </template>
        <p>{{ $t('components.ekrm.CreateModelCompose.curveAbout') }}</p>
        <!-- The levers, and what a boundary dragged on the bar holds still, are two paragraphs
             about controls that are not on the screen unless their own panel is open: an
             explanation of a thing nobody can see is a reader looking for it. So each is asked of
             its own disclosure, separately — this one of the response shape's — and while that one
             is closed a single line stands for it, saying that the curve IS a reading of the pair
             and where the controls that move it went. -->
        <p
          v-if="editorShapeOpen"
          :class="curveRegions ? 'mb-4' : 'mb-0'">{{ $t('components.ekrm.CreateModelCompose.curveHow') }}</p>
        <p
          v-else
          :class="curveRegions ? 'mb-4' : 'mb-0'">{{ $t('components.ekrm.CreateModelCompose.curveSimple') }}</p>
        <!-- And what the five bands mean, in the report's own words. The zones are the report's, so
             the explanation of them is too — one text, in one place, for one piece of shading. What
             the BAR does with them is this wizard's own and is said after them: it is a control and
             not a reading, and what a control holds still while it moves is the thing a reader has
             to be told once rather than discover by moving it. -->
        <template v-if="curveRegions">
          <p class="font-weight-medium mb-2">{{ $t('components.SaturationCurves.optimalZones') }}</p>
          <p
            v-for="(zone, index) in curveZones"
            :key="`about_${zone.key}`"
            :class="!editorZonesOpen && index === curveZones.length - 1 ? 'mb-0' : 'mb-2'">
            <v-icon class="pb-1" dense :color="zone.color">{{ zone.icon }}</v-icon>
            <b>{{ zone.label }}:</b> {{ zone.description }}
          </p>
          <p v-if="editorZonesOpen" class="mb-0">{{ $t('components.ekrm.CreateModelCompose.zonesHow') }}</p>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray darken-1" text @click="curveDialog = false">
          {{ $t('components.TextBox.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- What each bar of the decomposition is, and — for the base — what it is NOT. The base there
       is a residual: everything the curves and the seasonality row do not account for. Once this
       payload is built, the model fits a Gaussian process through the KPI row and the report splits
       that residual again, into a base and the noise the fit could not explain. That second split
       does not exist yet and cannot be computed from the payload, so it is stated rather than drawn.
       It is a dialog of this wizard's rather than the chart's own info slot because the chart is
       drawn here without its header, and that slot lives in the header. -->
  <!-- WHAT THE TWO DRAWN YEARS ARE, in one dialog because they are one section. Each keeps its own
       heading and its own two paragraphs — what it is, and how it is said — and the two stand one
       after the other in the order the plot draws them. Merging the prose as well would have been
       the wizard pretending the two claims are one: they share a picture, a colour and a cap, and
       they are still what comes back every year and what did not, which is the one thing a reader
       opening this dialog is here to be told. The 'How' of each is the same gesture said twice, and
       deliberately: it is the paragraph a reader arrives at from whichever half they were typing
       into. -->
  <v-dialog v-model="shapesDialog" width="600">
    <v-card>
      <v-card-title class="subtitle-1">
        {{ $t('components.ekrm.CreateModelCompose.shapesSection') }}
      </v-card-title>
      <v-card-text>
        <p class="font-weight-medium mb-1">{{ $t('components.ekrm.CreateModelCompose.metricSeasonality') }}</p>
        <p>{{ $t('components.ekrm.CreateModelCompose.seasonalityAbout') }}</p>
        <p class="font-weight-medium mb-1">{{ $t('components.ekrm.CreateModelCompose.metricSpot') }}</p>
        <p>{{ $t('components.ekrm.CreateModelCompose.spotAbout') }}</p>
        <!-- And ONE paragraph on how either of them is said, at the foot of the dialog. There were
             two, one under each, and they were the same sentence twice: the two rows are answered in
             one card by one gesture now, so a second copy of it under the second heading would be
             the dialog describing a distinction the chart does not make. -->
        <p class="mb-0">{{ $t('components.ekrm.CreateModelCompose.shapesHow') }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray darken-1" text @click="shapesDialog = false">
          {{ $t('components.TextBox.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="warningDialog" width="640">
    <v-card>
      <v-card-title class="subtitle-1">
        {{ $t('components.ekrm.CreateModelCompose.checkTitle') }}
      </v-card-title>
      <v-card-text>
        <v-alert v-for="(entry, index) in errors" :key="`error_${index}`" dense type="error" text border="left">
          {{ entry.text }}
        </v-alert>
        <v-alert v-for="(entry, index) in shownWarnings" :key="`warning_${index}`" dense type="warning" text border="left">
          {{ entry.text }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray darken-1" text @click="warningDialog = false">
          {{ $t('components.ekrm.CreateModelCompose.goBack') }}
        </v-btn>
        <v-btn v-if="errors.length === 0" color="primary" text @click="warningDialog = false; saveEkrm()">
          {{ $t('components.ekrm.CreateModelCompose.createAnyway') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-card>
</template>

<script>
import numbro from 'numbro'
import { mapActions, mapGetters } from 'vuex'
import { COMPOSER_ORIGIN } from '@/utils/ekrmOrigin.js'
import SalesDecomposition from '@/components/simulationDetails/SalesDecomposition.vue'
import MediaSpendAndReturn from '@/components/simulationDetails/MediaSpendAndReturn.vue'
import BarChart from '@/components/BarChart.vue'
import StackedBarChart from '@/components/StackedBarChart.vue'
import RiverChart from '@/components/RiverChart.vue'
import SaturationCurves from '@/components/SaturationCurves.vue'
import SaturationLevers from '@/components/ekrm/SaturationLevers.vue'
import SaturationZones from '@/components/ekrm/SaturationZones.vue'
import DecayCurve from '@/components/ekrm/DecayCurve.vue'
import EkrmChannelCard from '@/components/ekrm/EkrmChannelCard.vue'
import EkrmModelImporter from '@/components/ekrm/EkrmModelImporter.vue'
import EkrmRevenueCard from '@/components/ekrm/EkrmRevenueCard.vue'
import EkrmTradeCard from '@/components/ekrm/EkrmTradeCard.vue'
import EkrmGrowthCard from '@/components/ekrm/EkrmGrowthCard.vue'
import EkrmSpendMonths from '@/components/ekrm/EkrmSpendMonths.vue'
import EkrmShapeMonths from '@/components/ekrm/EkrmShapeMonths.vue'
import Spreadsheet from '@/components/ekrm/Spreadsheet.vue'
import ChannelCurvesChartMulti from '@/components/simulationDetails/ChannelCurvesChartMulti.vue'
import { loadModelReportFromClient, hasModelReport } from '@/utils/modelReport.js'
import { taxonomyRowId } from '@/utils/channelTaxonomy.js'
import { modelMetadata, MODEL_FACET_KEYS } from '@/utils/modelFacets.js'
import {
  buildEkrmDefinition,
  buildEkrmOriginalDefinition,
  mediumName,
  mediumNameError,
  validateEkrmForm,
  MEDIUM_NAME_MAX,
  MONTH_KEYS
} from '@/utils/ekrmDefinition.js'
import { displayName, kpiNames, monthlyDecayCurve, outputScope, toCell } from '@/utils/ekrmFromModel.js'
import {
  hillAt, hillDiminishingReturns, hillPlotWindow, hillRegions, hillRegionSet, hillSeries,
  isHillParams, HILL_HOLD_SATURATION, HILL_HOLD_SHAPE, HILL_HOLD_EDGE
} from '@/utils/hillCurve.js'
import { roasMantissa } from '@/utils/roasUnits.js'
import {
  cloneBaseFloor,
  cloneBaseMonthly,
  cloneCurveBounds,
  cloneCurveLimits,
  cloneKpiName,
  cloneMarketing,
  cloneMarketingByMedium,
  cloneMarketingMonthly,
  cloneMarketingMonthlyByMedium,
  cloneMixReach,
  cloneRatesKnown,
  cloneRoas,
  cloneRoasCurve,
  cloneRoasReach,
  cloneShapeBarLimits,
  cloneSpendFloorLimits,
  cloneSpendTotal,
  cloneSuggestedRates,
  cloneTradeWindow,
  cloneUnitRates,
  cloneUnits,
  decayBars,
  solveSpendFactor,
  solveSpendMix,
  sparklinePath,
  CURVE_KEYS,
  EKRM_UNIT,
  EXPECTED_WARNING_CODES,
  LIMIT_MARGIN,
  MAX_ATTRIBUTION_SHARE,
  SHAPE_MONTH_CAP,
  SHAPE_REVENUE_FACTOR
} from '@/utils/ekrmClone.js'
// The build itself. Every reader above takes a `form` and does not care how it was made, which is
// what lets the two wizards share them; only this half knows there is more than one source model.
import {
  buildComposeForm,
  COMPOSE_FLOOR,
  COMPOSE_MODE,
  COMPOSE_PRIORITY,
  COMPOSE_SHAPE_CUSTOM,
  COMPOSE_SHAPE_FLAT,
  composeAnchor,
  composeChannelSummaries,
  composeCopyPlan,
  composeCurveAboveFloor,
  composeCurveReading,
  composeDecayCurve,
  composeDecayKernel,
  composeDecayMoved,
  composeDecaySelected,
  composeDecayTemplates,
  composeRestate,
  composeRevenueCeiling,
  composeRevenueFloor,
  composeRevenueMonthAt,
  composeRevenueShape,
  composeRevenueShapeOf,
  composeSalesShape,
  composeSeasonShape,
  composeShapeYears,
  composeShareOfBase,
  composeImport,
  composeInputSeriesItems,
  composeInputShape,
  composeReadiness,
  composeScratchRead,
  composerLabel,
  COMPOSE_MONTHS
} from '@/utils/ekrmCompose.js'

// THE CHANNEL NOBODY IMPORTED, read once for the whole page. Generated rather than measured — see
// composeScratchRead — and shared by every scratch channel on the grid, because what one of them
// owns is not this shape but what the user has stated over it: the pair that places it, the ratios
// the levers wrote and the kernel the tiles drew, each of them keyed by uid and each of them
// measured against exactly this.
const SCRATCH_READ = composeScratchRead()

// WHERE A COMPOSITION STARTS. Two answers to the first question the wizard asks, and they are two
// ways of USING this wizard rather than two wizards: a copy seeds the same state a hand-built model
// is assembled into, and from the moment it lands there is nothing that tells the two apart — every
// figure is on the step that owns it, editable there, and the payload that leaves is the same one.
const SOURCE_SCRATCH = 'scratch'
const SOURCE_COPY = 'copy'

// The box every sparkline is drawn in. The paths are normalised into it by sparklinePath, and the
// svg stretches to the card's width, so these are ratios rather than pixels.
const PLOT_WIDTH = 120
const PLOT_HEIGHT = 46
// How many models the picker by taxonomy reads at once. See onTaxonomyNeed.
const TAXONOMY_READERS = 2

// Both axes of a saturation plot on ONE range. They are both dollars a month — what the channel is
// given and what it gives back — and scaling them apart lays two rulers of different lengths on one
// quantity, which is how a channel returning half what it costs came to draw the same picture as one
// returning three times it. The thumbnail and the chart it opens are read the same way now: the
// height of the curve against the width of the box IS the return. Only the saturation plot takes it;
// the decay kernel beside it is a proportion against months and has no such claim to make.
const PLOT_SCALE = { commonScale: true }

// How many segments a saturation curve is drawn in, in the dialog and on the card alike. Dense
// enough to read as a curve rather than as a run of chords at the size the dialog draws it, and the
// same number on the thumbnail because the two are the same polyline seen from further away: a card
// sampling its curve more coarsely would round off the knee the dialog shows, which is the one part
// of the shape a reader scanning a row of cards is looking at.
const CURVE_STEPS = 80

// THE GRID A MODEL REPORT DRAWS ITS SATURATION ON, which is not an even one: a report's x values are
// the model's own spend grid, and that grid is quadratic — 0, 2359, 9437, 21233 for a top of 5.84m,
// which is xmax * (i/n)^2 — so most of its points fall in the first tenth of the axis. It has to be.
// One grid serves every channel in a model, the widest of them sets its top, and a channel that
// turns at $80k on an axis running to $7m gets its knee out of the first few steps or it is drawn as
// two chords and a corner. hillSeries samples evenly, which is right for a card holding one curve in
// a box of its own size and wrong for the eleven of them on one pair of axes here.
function reportGrid (params, top, steps) {
  const count = steps && steps > 1 ? steps : 60
  const edge = isFinite(top) && top > 0 ? top : 1
  const x = []
  const y = []
  for (let i = 0; i <= count; i++) {
    const at = edge * (i / count) * (i / count)
    x.push(at)
    y.push(i === 0 ? 0 : hillAt(params, at))
  }
  return { x: x, y: y }
}

// WHAT AN UNSTATED FIGURE LOOKS LIKE. Every number in this editor is a reading of one curve, and
// before the saturation point is typed that curve is standing on a placeholder scale: the zone
// boundaries, the axes and the pair itself would all be reporting a magnitude nobody claimed. They
// all show this instead, so a blank field, a blank axis and five blank boundaries are one state
// rather than three coincidences.
const UNSTATED = '—'

// THE FIVE OPTIMAL ZONES, in the model report's own colours. One list, because the card's plot and
// the editor's chart shade the same five ranges of the same curve and a card that opens onto a
// differently coloured version of its own thumbnail is two pictures of one thing. The first is null
// and stays undrawn on both: below the minimum spending threshold there is nothing being bought
// worth colouring in, which is why the report's own markArea starts at the first boundary rather
// than at zero. The order is the report's — see components.SaturationCurves.zone1..5.
const ZONE_FILLS = [
  null, 'rgba(213, 244, 254)', 'rgba(235, 247, 225)', 'rgba(255, 243, 215)', 'rgba(255, 216, 219)'
]

// Which of the four boundaries the wizard states a channel in dollars with. The fifth zone begins
// where the curve saturates, which is the "Saturates at" figure beside the chart, so the switch's
// first setting — hold that — takes the grip off this edge: what is held cannot also be dragged.
// It is also the one boundary that can be held without naming a boundary at all, which is why it
// is the default and why it has a name of its own on the switch.
const ZONE_PLACEMENT = 3

// The three boundaries a reader may name as the thing to hold. The fourth is nameable too and is
// the setting beside them, under the name it goes by everywhere else in this wizard.
const ZONE_PINS = [0, 1, 2]

// The zone bar's axis, in multiples of the saturation point, and the band the boundaries may travel
// in before it is re-fitted around them. The headroom is what the fifth zone gets to be drawn as:
// it runs to infinity, and a bar stopping at its own first edge would draw a range as a boundary.
// The band is wide enough that no single gesture can re-fit the ruler it is being measured against,
// and narrow enough that a channel moved a long way is not left drawn in a corner of its own bar.
const ZONE_WINDOW_HEADROOM = 1.2
const ZONE_WINDOW_HIGH = 0.95
const ZONE_WINDOW_LOW = 0.45

// The box the trade-off between Media Spend and Total ROAS is drawn in. Wider and shallower than the
// channel plots, being one chart across a card rather than one of two in a column, and stretched to
// the card's width the same way — so these are ratios and not pixels.
const TRADE_WIDTH = 300
const TRADE_HEIGHT = 64

const TRADE_SAMPLES = 121
// HOW FAR OUTSIDE ITS CORRIDOR A PLAN HAS TO STAND before seatSpend treats it as outside at all.
// A part in a million, which is a thousand times the rounding the corridor's own ends carry and ten
// thousand times inside the narrowest margin any of them is stated to. See seatSpend, which is where
// the reason it has to be a number at all is written down, and seatRevenue, which is the same
// argument about the other figure.
const SEAT_EPSILON = 1e-6

// How far apart two labels under the chart have to be, in its own 300 units, before they can share a
// line. Three of them can be named at once — the peak and the two ends of what the wizard will
// accept — and a model fitted where its curves are still climbing sits right on top of its own peak.
const TRADE_LABEL_GAP = 64

// The grid labels createGrids resolves live in the original wizard's namespace, which is permanent —
// CreateEkrm.vue is the expert form and is not going anywhere. The strings are identical to the
// ones this wizard would say, and copying thirty-three of them into a second namespace would only
// give them somewhere to drift. Nothing here renders them: they are row labels inside originalDefinition, and
// CreateEkrm.initializeColumnHeaders rewrites them anyway when a clone is reopened there.
const GRID_LABEL_NAMESPACE = 'components.ekrm.CreateEkrm.'

// How much of the revenue box the tallest month may take. The rest is the room the figures stand in:
// every column carries its own amount over it, and a month whose bar reached the top of the box
// would be a number floating off the chart. The columns are shares of the tallest either way, so
// this scales all twelve together and nothing about the shape is said differently.
const REVENUE_BAR_CEILING = 82

// The period the quarterly ROAS bar sums over. Three, and named rather than written into the loop,
// because the twelve months are COMPOSE_MONTHS and not a promise: the last group is whatever is
// left over if that ever stops dividing by three.
const QUARTER_MONTHS = 3

// The green the revenue is drawn in throughout this wizard — the dot on the Total Revenue box, its
// slider, the base segment of its bars — and therefore the colour the two ends of the decomposition
// wear, those being the revenue before the media and after it.
const REVENUE_COLOR = '#43A047'

// HOW FAR ONE PRESS MOVES THE YEAR. Randomize multiplies every month by its own draw from
// 1 ± JITTER and Flatten pulls every month PULL of the way to the mean, and the two are sized to be
// each other's undo at roughly one press for one press: a year is made uneven a step at a time and
// made even again the same way, which is the whole point of a verb over a named pattern. Small
// enough that a press is a nudge — a control whose first press is the whole range is a control with
// one position — and large enough that a press is visible on twelve columns.
const SHAPE_JITTER = 0.18
const SHAPE_PULL = 0.3
// How far one press of Randomize moves a month of the season, in points of that month's base. An
// addition rather than a factor, so a season nobody has drawn — twelve zeros — can be started by it,
// the way a flat sales year is by SHAPE_JITTER.
const SHAPE_SEASON_JITTER = 5

// The purple what the media returns wears throughout this wizard — the dot on the Media Spend box,
// the top segment of the revenue bars, the response curve on every channel card — and therefore the
// colour of the one bar the decomposition credits the media with.
const MARKETING_COLOR = '#7E57C2'

// Seasonality's own colour, and deliberately in neither of the other two families: it is not revenue
// the media bought, so it may not wear the marketing's colour, and it is not the base, so it may not
// wear the revenue's. Amber for a component that is about WHEN the revenue arrives.
const SEASONALITY_COLOR = '#FFB300'
// The two other inputs, each in its own colour so the cards are told apart at a glance.
const COMARKETING_COLOR = '#1E88E5'
const COMPETITION_COLOR = '#E53935'
// The Input Over Time selector's key for the media, which is the report's own sentinel for the same
// option — see marketingSpendKey in ModelReportComponent.
const PREVIEW_MARKETING_SPEND = '__marketing_spend__'
// Whether the Future Trends step's answers reach the model. Off, the step can still be answered,
// marked Coming soon, but the payload carries no future trends, as it always has.
const FUTURE_TRENDS_ENABLED = false
// The Future Trends step's opening answer: every series expected to stay where it is.
function emptyFutureTrends () {
  return {
    sales: { min: 0, max: 0 },
    media: { min: 0, max: 0 },
    comarketing: { min: 0, max: 0 },
    competition: { min: 0, max: 0 }
  }
}

// AND THE SPOT EVENTS WEAR THE SAME AMBER, which is a statement and not a saving. They were blue —
// two hues for the two signed components, on the argument that a reader has to tell them apart in a
// segment three pixels tall. But nothing else on this page tells them apart: the waterfall credits
// them to one bar, the revenue columns stack them into one band, and the cap they are held under is
// one cap, counted across the two. A second colour was this wizard drawing a distinction its own arithmetic does not make, three
// pictures deep. They are one component said two ways — what comes back every year and what did not —
// and where the two DO have to be read apart, which is the editor they are drawn in, the fill says
// so: solid for the season, hatched for the events. A texture is the right weight for a distinction
// this small; a hue is not.

// HOW FAR ABOVE THE TALLEST STACK THE STACKED ROW'S AXIS REACHES, and the least it will ever span
// either side of the line. A model with a two-point season would otherwise be drawn as twelve
// hairlines against a hundred-point axis. The seasonality editor's own two figures, this row being
// the same picture said about a stack rather than about a bar.
const SHAPE_HEADROOM = 1.6
const SHAPE_MIN_SCALE = 5

// How far up its own half of the row the YEAR's column reaches when it is full. The months' tallest
// stack reaches exactly this far too — it is what the headroom above leaves it — so the thirteenth
// column is drawn to the same ceiling as the twelve beside it and only the axis behind it differs.
const SHAPE_TOTAL_CEILING = 100 / SHAPE_HEADROOM

// The year the seasonality editor opens on: twelve months each accounting for none of their own
// revenue. It is what this wizard has to say about when a business it is assembling out of other
// businesses' media sells, which is nothing — see seasonalityShape. Frozen, because it is handed
// straight to a child that reads it every frame and one editor writing into it would seed the next.
const COMPOSE_FLAT_YEAR = Object.freeze([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

// The two legend swatches for the curves, as filled paths. ECharts draws a line series' legend
// entry itself — a stroke with the series' own SYMBOL sitting in the middle of it, and it substitutes
// a circle when the symbol is 'none', which is why both curves wore a dot they have nowhere on the
// plot. Naming an icon takes that decision back: the swatch becomes this path, stretched into the
// legend's 25x14 box with its own aspect ratio kept and filled with the series' colour. Hence 100x8,
// which lands as a 25x2 bar — the width the solid curve is actually drawn at — and hence the dashed
// one being three bars rather than a stroke pattern: a filled path has no dash to set.
// THE COLOUR OF THE ONE POINT ON THE CURVE THIS EDITOR IS ABOUT. Not a zone colour and not a line
// colour: the five bands are pale washes and the two lines take the chart's own palette, so the
// point that sits ON the bands and ON the line has to be a third thing or it reads as part of
// whichever it is standing over. A saturated purple is the one strong ink none of them uses.
//
// It is worn twice — the marker on the chart and the dot on the card that states it — so it is a
// constant rather than a colour typed into two places, and the card's dot is bound to it in the
// template the way the metric dots below the grid are.
const SATURATION_MARK = '#7B1FA2'

// And the curve the channel was imported as, which is drawn behind the one being edited. Grey: it
// is the thing an edit is read AGAINST and not a second reading of its own, and the palette's next
// colour gave it a green as strong as the line in front of it — two curves of equal weight, one of
// which is over and done with. Dashed and grey, it is a memory of the shape rather than a claim
// about the channel.
const SOURCE_LINE = '#9E9E9E'

const LEGEND_LINE = 'path://M0,0 L100,0 L100,8 L0,8 Z'
const LEGEND_DASHED_LINE = 'path://M0,0 L34,0 L34,8 L0,8 Z M44,0 L72,0 L72,8 L44,8 Z M82,0 L100,0 L100,8 L82,8 Z'

// One colour per stacked channel, in the order the media stand in. The platform's own palette for
// stacked channels, so the same model reads the same way wherever it is drawn.
const CHART_COLORS = [
  '#A6CEE3', '#B2DF8A', '#FB9A99', '#FDBF6F', '#CAB2D6', '#B15928',
  '#1F78B4', '#33A02C', '#E31A1C', '#FF7F00', '#6A3D9A', '#1F77B4',
  '#FF7F0E', '#2CA02C', '#D62728', '#9467BD', '#8C564B', '#E377C2',
  '#7F717F', '#BCBD22', '#17BECF', '#AEC7E8', '#FFBB78', '#98DF8A',
  '#FF9896', '#C49C94', '#F7B6D2'
]

// WHETHER TWO OF THE EDITOR'S SNAPSHOTS OF ONE THING ARE THE SAME THING. Everything the channel
// editor writes is a flat map of numbers, an array of numbers, or absent, so this is all the
// comparison the dirty check needs — and absent has to compare equal to absent, an unedited channel
// carrying no entry in any of the three maps at all.
function sameSnapshot (a, b) {
  if (a === b) return true
  if (a === null || a === undefined || b === null || b === undefined) return false
  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false
    return a.every((value, index) => Number(value) === Number(b[index]))
  }
  const keys = Object.keys(a)
  if (keys.length !== Object.keys(b).length) return false
  return keys.every(key => Number(a[key]) === Number(b[key]))
}

// EACH MARKET'S CURRENCY, by the market's ISO 3166 code, as ISO 4217 names it. Only what the Setup's
// Currency list is drawn from, and only the markets in Admin > Countries reach it. The choice is a
// Coming soon: whatever is picked, the model is still built in EKRM_UNIT. When it is real, this
// belongs in the countries' own settings.
const MARKET_CURRENCIES = {
  AE: ['AED', 'UAE Dirham'],
  AR: ['ARS', 'Argentine Peso'],
  AT: ['EUR', 'Euro'],
  AU: ['AUD', 'Australian Dollar'],
  BD: ['BDT', 'Taka'],
  BE: ['EUR', 'Euro'],
  BG: ['EUR', 'Euro'],
  BO: ['BOB', 'Boliviano'],
  BR: ['BRL', 'Brazilian Real'],
  BZ: ['BZD', 'Belize Dollar'],
  CA: ['CAD', 'Canadian Dollar'],
  CH: ['CHF', 'Swiss Franc'],
  CL: ['CLP', 'Chilean Peso'],
  CN: ['CNY', 'Yuan Renminbi'],
  CO: ['COP', 'Colombian Peso'],
  CR: ['CRC', 'Costa Rican Colon'],
  CU: ['CUP', 'Cuban Peso'],
  CY: ['EUR', 'Euro'],
  CZ: ['CZK', 'Czech Koruna'],
  DE: ['EUR', 'Euro'],
  DK: ['DKK', 'Danish Krone'],
  DO: ['DOP', 'Dominican Peso'],
  EC: ['USD', 'US Dollar'],
  EE: ['EUR', 'Euro'],
  EG: ['EGP', 'Egyptian Pound'],
  ES: ['EUR', 'Euro'],
  FI: ['EUR', 'Euro'],
  FR: ['EUR', 'Euro'],
  GB: ['GBP', 'Pound Sterling'],
  GR: ['EUR', 'Euro'],
  GT: ['GTQ', 'Quetzal'],
  GY: ['GYD', 'Guyana Dollar'],
  HK: ['HKD', 'Hong Kong Dollar'],
  HN: ['HNL', 'Lempira'],
  HR: ['EUR', 'Euro'],
  HT: ['HTG', 'Gourde'],
  HU: ['HUF', 'Forint'],
  ID: ['IDR', 'Rupiah'],
  IE: ['EUR', 'Euro'],
  IL: ['ILS', 'New Israeli Sheqel'],
  IN: ['INR', 'Indian Rupee'],
  IT: ['EUR', 'Euro'],
  JM: ['JMD', 'Jamaican Dollar'],
  JP: ['JPY', 'Yen'],
  KE: ['KES', 'Kenyan Shilling'],
  KR: ['KRW', 'Won'],
  LT: ['EUR', 'Euro'],
  LU: ['EUR', 'Euro'],
  LV: ['EUR', 'Euro'],
  MA: ['MAD', 'Moroccan Dirham'],
  MT: ['EUR', 'Euro'],
  MX: ['MXN', 'Mexican Peso'],
  MY: ['MYR', 'Malaysian Ringgit'],
  NG: ['NGN', 'Naira'],
  NI: ['NIO', 'Cordoba Oro'],
  NL: ['EUR', 'Euro'],
  NO: ['NOK', 'Norwegian Krone'],
  NZ: ['NZD', 'New Zealand Dollar'],
  PA: ['PAB', 'Balboa'],
  PE: ['PEN', 'Sol'],
  PH: ['PHP', 'Philippine Peso'],
  PK: ['PKR', 'Pakistan Rupee'],
  PL: ['PLN', 'Zloty'],
  PR: ['USD', 'US Dollar'],
  PT: ['EUR', 'Euro'],
  PY: ['PYG', 'Guarani'],
  QA: ['QAR', 'Qatari Rial'],
  RO: ['RON', 'Romanian Leu'],
  RU: ['RUB', 'Russian Ruble'],
  SA: ['SAR', 'Saudi Riyal'],
  SE: ['SEK', 'Swedish Krona'],
  SG: ['SGD', 'Singapore Dollar'],
  SI: ['EUR', 'Euro'],
  SK: ['EUR', 'Euro'],
  SR: ['SRD', 'Surinam Dollar'],
  SV: ['USD', 'US Dollar'],
  TH: ['THB', 'Baht'],
  TR: ['TRY', 'Turkish Lira'],
  TT: ['TTD', 'Trinidad and Tobago Dollar'],
  TW: ['TWD', 'New Taiwan Dollar'],
  UA: ['UAH', 'Hryvnia'],
  US: ['USD', 'US Dollar'],
  UY: ['UYU', 'Peso Uruguayo'],
  VE: ['VES', 'Bolívar Soberano'],
  VN: ['VND', 'Dong'],
  ZA: ['ZAR', 'Rand']
}
const CURRENCY_NAMES = { USD: 'US Dollar' }
Object.keys(MARKET_CURRENCIES).forEach(market => {
  CURRENCY_NAMES[MARKET_CURRENCIES[market][0]] = MARKET_CURRENCIES[market][1]
})
// The Setup's History choices, in years.
const HISTORY_YEARS = [1, 2, 3, 4, 5]

export default {
  data () {
    return {
      // WHICH QUESTION IS ON SCREEN, one-based to match v-stepper's own step numbers: 1 the name and
      // the market, 2 the media, 3 what is spent on them, 4 the revenue that spend produced, 5 the
      // other spend around the media, 6 the preview. It is
      // only ever moved through stepValid — see goNext — so a step is never opened against figures
      // that are not there yet.
      step: 1,
      // WHETHER THE SPEND HAS BEEN PUT WHERE THE CURVES RETURN THE MOST, which is done once and on
      // arrival — see seedSpendAtPeak. It is a flag and not a reading of the level, because what it
      // records is that the question has been ASKED: a reader who walks back to the media, adds a
      // channel and comes forward again keeps the spend they chose, and a wizard that re-seated it
      // would be answering the step's own question every time they passed through it.
      spendSeeded: false,
      // WHICH SECTION OF THE MODEL PREVIEW IS ON SCREEN — 0 the summary, 1 the drivers, the Model
      // Report's own two tabs in its own order. Held here rather than in the URL or in the form,
      // because it is a place in a reading and not an answer: walking back to the media and forward
      // again returns the reader to the section they were reading.
      previewTab: 0,
      // WHETHER THE PREVIEW MAY DRAW YET, and it is about the DOM rather than about the answers.
      //
      // A horizontal stepper hides the steps it is not on with v-show, so every pane but the current
      // one is display:none and has no width. The preview's charts are echarts canvases: asked to
      // lay out inside a hidden element they measure zero and warn, and what makes that reachable is
      // that the step's own condition — moneyReady — turns on while the reader is still on the step
      // BEFORE it, the moment the revenue field is left. So the charts were built into a pane
      // nobody was looking at.
      //
      // Held here rather than fixed in the charts because it is not the charts' problem: nothing on
      // this step should be computed until it is being read. Ten charts, a response matrix and a
      // hill series per channel is real work, and it was being redone on every keystroke two steps
      // away from where it is shown.
      previewReady: false,
      name: '',
      market: '',
      // THE SETUP'S COMING SOON CHOICES, answerable and read by nothing: the model is built in
      // EKRM_UNIT, monthly and off one year whatever they say.
      currencyChoice: EKRM_UNIT,
      frequencyChoice: 'monthly',
      historyChoice: 1,
      // WHETHER THIS MODEL IS BEING WRITTEN OR COPIED, and everything the second answer needs.
      //
      // Scratch is the wizard as it has always been: an empty page, and the channels arrive one
      // picker at a time. Copy takes ONE model and answers as much of the wizard as that model can
      // answer — its channels, where each of their curves stands, the year each was bought over, the
      // revenue, its shape and its seasonality — and then gets out of the way. What it leaves is an
      // ordinary composition: nothing is locked, every step is open, and a reader who copies a model
      // and then retypes a saturation point is doing the same thing as one who typed it from empty.
      //
      // It is NOT the clone wizard, which reproduces a model by importing its rows and holds the user
      // to edits against that copy. This produces answers to the questions this wizard asks. See
      // composeCopyPlan for what that carries and what it cannot.
      // NOTHING IS CHOSEN ON ARRIVAL, and the name and the market are not on the page until one
      // is. A tile lit by default is an answer nobody gave, and this one decides what the two fields
      // under it start out carrying — a copy writes both — so a page that opened on those fields with
      // a preselected tile above them invited the reader to fill in the form and never see the
      // question. Null until pressed; see stepValid, which will not let the step be left before then.
      sourceMode: null,
      // Which model is being copied, and what one unit of its own money is worth in USD, keyed by
      // the unit's name — read off the rates the model carries (cloneSuggestedRates) and never asked,
      // copyModels offering only a model that has them. Empty for a model already reporting USD.
      //
      // The composer reads no units anywhere else, and deliberately: only the SHAPE of a curve
      // travels out of a picked channel, and a shape is dimensionless. A copy carries levels, so the
      // rate matters there — see composeCopyPlan.
      copyModelId: null,
      // The last name applyCopy wrote, so a name the user has typed over is never taken back — see
      // applyCopy.
      copyNameWritten: '',
      copyRates: {},
      copyLoading: false,
      copyError: null,
      // WHAT THE COPY COULD NOT CARRY, said rather than left to be noticed: the channels the import
      // refused, and the months whose seasonality was held at the cap on the way into the composer's
      // own unit. Both are cleared by the next copy.
      copySkipped: [],
      copyHeld: [],
      // The question asked before a composition is thrown away, and what to do once it is answered:
      // { mode } for the two tiles, { mode, modelId } for a model picked over another one. Nothing
      // here overwrites anything until it has been answered — see askCopy.
      copyDialog: false,
      copyPending: null,
      // The importer the model to copy is chosen in.
      copyImporterDialog: false,
      // The channels this EKRM will carry, in the order they were added. Index i is medium i, spend
      // row i and saturation rows 2i/2i+1 — buildEkrmDefinition pairs them by POSITION, so this list
      // is the payload's own order and not merely a display order.
      //
      // Each entry: { uid, modelId, raw, label } — and, for a channel nobody imported,
      // { uid, modelId: null, raw: null, scratch: true, label }. The label is claimed ONCE, when the
      // channel is added, and then never recomputed: it is the key of three maps of the definition,
      // and a name that moved when a neighbour left would silently overwrite another channel's rows.
      channels: [],
      // Monotonic, never reused. Everything keyed per channel keys on this rather than on the raw
      // name, because two models can both offer a channel called Search.
      nextUid: 0,
      // Everything read for one source model, keyed by its id:
      //   { model, report, scope, kpiName, readiness, imported }
      // `imported` is composeImport's output and holds the Levenberg-Marquardt fit per channel. It
      // is the expensive half and it depends on the report alone — not on a rate, not on the
      // revenue, not on a level — so it is read once per model and never again.
      models: {},
      catalogueLoading: true,
      catalogueError: null,
      catalogueTimer: null,
      reportError: null,
      // The uids of the channels the last add brought in, for as long as their cards are worth
      // pointing at. The picker closes on the add, so this is what tells the user which of the cards
      // behind it are the ones they just chose; it is emptied by a timer, a ring that stayed would
      // be a state rather than an arrival.
      justAdded: [],
      justAddedTimer: null,

      // IMPORTING THE YEAR THE SALES FALL OVER, off any model that has measured one. Its own state
      // rather than the picker's, and its own report cache: what it needs is a KPI series, where the
      // picker needs a Hill fit per channel, and a dialog reading a shape must not be made to wait
      // for — or fail on — work it has no use for.
      shapeImportDialog: false,
      // WHICH ROW THE DIALOG IS FILLING: the Sales year, or the season under it. One dialog and not
      // two, because everything it asks is the same question — which model, which KPI, which year,
      // and how many months along — and only two things differ: which series is read off the report,
      // and where the twelve numbers land when they are accepted.
      shapeImportTarget: 'revenue',
      // And, for the third row this dialog fills — an other input — which of the two cards, and
      // which of the source model's input series the year is read off. See composeInputSeriesItems.
      shapeImportOtherKey: null,
      shapeImportSeries: null,
      shapeImportModelId: null,
      // Which output the year is read off, and which year. Null is not an unanswered question here:
      // it is the average of every complete year the model has, which is what the dialog opens on.
      shapeImportKpi: 'Total',
      shapeImportYear: null,
      // How many months the year on the preview has been moved along, 0..11 — a hemisphere
      // correction made before the year is accepted rather than after. It survives a change of KPI
      // or of year, those being the same business on the same calendar, and is dropped when another
      // model is chosen.
      shapeImportShift: 0,
      shapeImportLoading: false,
      shapeImportError: null,
      // Reports read for a shape alone, keyed by model id. Separate from `models` because the entry
      // there carries a KPI chosen once and an import fitted against it, and this dialog lets the
      // KPI be changed under it — the report is the whole of what it needs and the only thing worth
      // keeping.
      shapeReports: {},

      // Why the last model read for a copy could not be read, when it could not.
      loadError: null,

      // The importer the channels are taken in. Its models are read into the `models` cache a few
      // at a time, as its rows come on screen: per model id 'queued', 'loading', 'ready' or
      // 'failed'.
      channelImporterDialog: false,
      taxonomyStatus: {},
      taxonomyQueue: [],
      taxonomyReading: 0,

      // What buildComposeForm returned: the form, the media, the entries it could build and the
      // band's own centre.
      built: null,

      // The SIZE of the model, in USD over the year, held as an anchor and a multiplier over it.
      //
      // NULL UNTIL THE USER TYPES ONE, and nothing on this page seeds it. The anchor was the
      // reference model's own annual revenue once, and then a reading of what the media placed so
      // far were credited with; both are gone. How big the business a channel was lifted out of
      // happened to be says nothing about the size of the business being built, and neither does
      // how much media has been drawn for it — the second is the first mistake with the arrow
      // turned around, revenue being the figure the spend is read against and not the other way
      // about. So the box opens empty and the money below it waits; see moneyReady.
      //
      // The anchor is the figure that was typed and the factor is everything done to it since. The
      // two are kept apart rather than collapsed into one because the provenance carries both.
      revenueAnchor: null,
      revenueFactor: 1,
      // Whether the size of the business has been stated at all. False is not a smaller revenue, it
      // is no revenue: the KPI row is twelve zeros, no attribution band is written, and every figure
      // read against the size of the business is withheld rather than shown as nothing. The media
      // spend is not among them — it is answered before this and against the curves alone. Raised by onTotalRevenueChange and onRevenueMonthChange, and
      // never lowered — a revenue, once stated, stays the user's.
      revenueTouched: false,
      // The same, for the money — though nothing seeds the spend either, so this separates a level
      // the user chose from the one the cards imply rather than from one the page picked. The first
      // time they move Media Spend, ask for a Total ROAS or take a level off the trade-off chart,
      // the level is theirs and nothing re-seats it but the corridor.
      spendTouched: false,

      // HOW THE REVENUE FALLS ACROSS THE YEAR, as the name of the shape chosen and the twelve
      // multipliers it came to. Both, and not just the name, because of `random`: its twelve numbers
      // are drawn ONCE and then kept, where a shape re-rolled inside every build would redraw the
      // year on every keystroke and nothing on the page would hold still. The named shapes are pure
      // and would survive being recomputed; keeping all of them the same way is what stops that
      // being a distinction the reader has to know about.
      //
      // Flat carries a null rather than twelve ones — writeGeneratedGlobals reads a null as the
      // twelve equal months it has always written, and twelve ones through toCell would be the same
      // row by a longer route.
      // THE YEAR OPENS FLAT, which is the only opening that claims nothing. A model assembled out of
      // media taken from several businesses has no year of its own, and a wizard that drew an uneven
      // one to open on was inventing the answer to the question it was about to ask — the reader who
      // left it alone shipped somebody's dice roll as this business's seasonality. Unevenness is now
      // something the reader ASKS for, a press at a time, on the two buttons over the columns: see
      // onRevenueRandomize and onRevenueFlatten, which move the row that is there rather than
      // replacing it with a named pattern.
      //
      // The twelve multipliers are still held beside the name and not recomputed at render time: a
      // randomised row is drawn once and then kept, where a shape re-rolled inside every build would
      // redraw the year on every keystroke and nothing on the page would hold still.
      revenueShapeName: COMPOSE_SHAPE_FLAT,
      revenueShapeValues: composeRevenueShape(COMPOSE_SHAPE_FLAT),
      // WHERE A BORROWED YEAR CAME FROM, for the payload alone: the model, the KPI and the year the
      // shape was read at. Null for every year this wizard drew itself, which is what tells the two
      // apart once the document is in Firestore — the twelve multipliers beside it reproduce the
      // row either way and say nothing about whose row it was. Cleared by anything that states a
      // year of its own afterwards; a nudge on the two buttons is not one of those, for the same
      // reason it leaves revenue_shape alone.
      revenueShapeSource: null,

      // The level of the media spend, over the plan the cards themselves lay out: every channel
      // standing at the saturation point its own card states, which is what a factor of one means
      // here and the only figure this wizard has that no revenue is behind. One factor over every
      // channel and every month, so the split between them is untouched however far it moves.
      //
      // It opens at one and stays there until the user moves it. The floor of the corridor was tried
      // as an opening instead and is a trap; see the note where seatSpend is defined.
      spendFactor: 1,
      // The deviation around that level, per channel, keyed by uid. Only ever written by
      // applySpendMix, when a Total ROAS was asked for that no common factor could reach — which is
      // the only thing in this wizard that makes one channel's spend differ from another's.
      mixFactors: {},
      // THE YEAR EACH CHANNEL BUYS ITS MEDIUM OVER, keyed by uid: one multiplier per month, on top
      // of both the level and the mix.
      //
      // A channel opens buying the same money every month — twelve copies of the saturation point
      // its own card states, which is the only year a card stating one figure can honestly produce —
      // and this is where a month typed on the spend chart lands. Empty until one is, so a composer
      // nobody has touched here writes exactly the cells it always wrote.
      //
      // NOT RENORMALISED, and that is the whole of what a typed month means: the other eleven stay
      // where they are and the channel's total moves by the difference, which moves the Media Spend
      // figure above the chart with it. It is the revenue row's own rule for the same gesture — see
      // onRevenueMonthChange — and the two rows are read as one picture, so they answer alike.
      spendShapes: {},
      // THE SAME CELLS AS A GRID, and whether the grid is showing.
      //
      // `spendSheetRows` is a MIRROR of what the form carries and never the source of it: it is
      // rewritten from `spendSheetValues` whenever the plan underneath it moves, and a cell typed
      // into it comes straight back out as a multiplier on the channel's own flat month — the same
      // thing a typed column becomes. Nothing on this page reads it, so a mirror that fell behind
      // could not corrupt a payload; it would only show the wrong year, which the watcher below is
      // what prevents.
      //
      // Shut by default: the bands above already say what it says, and the grid is what is asked
      // for when a whole year has to be written rather than one figure corrected.
      spendSheetOpen: false,
      spendSheetRows: [],
      // Bumped when the SHAPE of the grid changes — a channel added or taken out, the month columns
      // renamed by a language change — because jspreadsheet is built once from the columns it is
      // handed and setData rewrites the cells alone. A row count that moved without this would
      // write N rows into a grid still drawn with the old N.
      spendSheetKey: 0,
      // THE YEAR'S OWN GRIDS, on exactly the terms the spend's is: a mirror of what the form
      // carries, shut until it is asked for, and a key bumped whenever the SHAPE of the grid
      // changes rather than its cells.
      //
      // TWO OF THEM, AND EACH UNDER THE PICTURE IT IS A SECOND WAY OF TYPING. It was one table of
      // three rows under the whole card — what each month sold, how much of it comes back every
      // year, how much of it happened once — on the argument that they are one statement about the
      // same twelve months. They are, and the table still belonged nowhere: it stood under a
      // section it was a third about, and carried two rows drawn a screen away from it. The revenue
      // row goes under the revenue's own columns; the two drawn years go inside the section that
      // asks for them, where they are pasted together because they are answered together.
      revenueSheetOpen: false,
      revenueSheetRows: [],
      revenueSheetKey: 0,
      sharesSheetOpen: false,
      sharesSheetRows: [],
      sharesSheetKey: 0,
      // THE OTHER INPUTS, each a year of dollars a month or null for a series left blank: the brand's
      // own spend outside the category, and the competition's. See writeOtherSpend.
      otherSpend: { comarketing: null, competition: null },
      // The model each of those years was taken off, where it was taken off one — see
      // applyShapeImport. Null for a year typed here.
      otherSpendSource: { comarketing: null, competition: null },
      // What each of those series is credited with, as a signed share of the year's sales, or null
      // for the EKRM to choose — which is what a blank has always meant. What the build actually
      // wrote, held under the room the other rows leave, comes back as built.otherAttribution.
      otherAttribution: { comarketing: null, competition: null },
      // THE GROWTH EXPECTED OVER THE NEXT TWELVE MONTHS, per series, as a signed percentage band.
      // Every series opens at no growth. See writeFutureTrends.
      futureTrends: emptyFutureTrends(),
      // Which input the preview's Input Over Time is drawing: the media, or one of the two series.
      previewInputVariable: PREVIEW_MARKETING_SPEND,
      comarketingSheetOpen: false,
      comarketingSheetRows: [],
      comarketingSheetKey: 0,
      competitionSheetOpen: false,
      competitionSheetRows: [],
      competitionSheetKey: 0,
      // WHERE EVERY CURVE IS PLACED, keyed by uid: { knee, ceiling } in USD a month.
      //
      // The two figures that turn an imported shape into a medium — the spend at which it stops
      // responding, and what it generates there — and the only thing on this page that a channel
      // cannot be laid out without. Typed on the card, before there is a budget or a revenue to
      // relate them to, because that is what they are: properties of the medium and of the market it
      // is bought in, not of the plan. Empty for a channel just added, and deliberately so — nothing
      // here can convert a source model's own figures, and copying them raw would read pesos as
      // dollars.
      statedCurves: {},
      // Twelve numbers, the percentage of each calendar month's revenue the seasonality accounts
      // for. Null until the user draws one, and then theirs — nothing seeds it, a source model's
      // own year being a fact about that business rather than about the media taken from it. What
      // the editor opens on is COMPOSE_FLAT_YEAR, and null is also what tells the payload that the
      // flat year it is carrying was nobody's claim.
      // WHERE A BORROWED SEASON CAME FROM, for the payload alone: the model, the KPI, the year and
      // how many months it was moved along. Null for every year drawn on this page, which is what
      // tells the two apart once the document is in Firestore — the twelve percentages beside it
      // reproduce the row either way and say nothing about whose row it was. Cleared by any stroke
      // that states a season of its own afterwards; the two arrows are not one of those, for the
      // same reason a nudge leaves revenue_shape alone.
      seasonalitySource: null,
      drawnSeasonality: null,
      // The same twelve for the spot events, and null on the same terms: what happened ONCE in each
      // month, as a percentage of that month's own revenue. A separate drawing from the one above
      // and not a mode of it — the two are different claims about the same year, one about what
      // comes back and one about what did not — which is why they are two rows of the payload's
      // grid, two folds on the page and two values here.
      drawnSpot: null,
      // Per channel, keyed by uid: RATIOS over the Hill parameters the channel was fitted with. The
      // one thing here that moves a response rather than a level.
      curveEdits: {},
      // THE OTHER CURVE, per channel and keyed the same way: one weight per lag month, and ABSOLUTE
      // where the curve edits above are ratios. A saturation edit is a ratio because the thing it
      // moves has a size the user gave it and the ratio is what survives a re-placement; a decay
      // kernel has no size of anybody's to survive — its total is the source model's and no gesture
      // may move it — so what is stored is the curve itself, which is also what the payload carries.
      //
      // A uid missing from this map is a channel carrying the decay its source model measured, which
      // is every channel until one is redrawn.
      decayEdits: {},

      // Mid-gesture state. None of it reaches the form: a drag is read straight off the curves and
      // the form is rebuilt once, on release.
      curveDraft: null,

      // Bumped on every commit, and used to key the editable fields. They are bound to computed
      // values, and Vuetify keeps its own copy of what was typed — without this, a value the wizard
      // refuses or rounds would stay on screen as the user left it.
      formKey: 0,
      roasNote: null,
      // Where a typed revenue was held, and why — the same kind of line spendNote carries, for the
      // other box of the pair. Null the rest of the time, which is every revenue between the two
      // walls: see revenueWithin.
      revenueNote: null,
      // What the spend was brought to when the revenue moved out from under it, and why.
      spendNote: null,
      // Where the two drawn years were held when they were TYPED rather than dragged, and why. The
      // bars need no such line — the ground a bar cannot enter is greyed under the hand that is
      // dragging it, and the tooltip on that ground says the same sentence this does — but a cell
      // typed past a wall is greyed nowhere, and the reader is left with a figure they did not type
      // and nothing at all about where it came from. See onYearSheetInput.
      shareNote: null,
      creating: false,
      errors: [],
      shownWarnings: [],
      // THE EDITOR: which channel is open in it, and the three things it types into. The drafts live
      // here and not in the fields so that walking to the next channel is one assignment, and so
      // that what the parser will not have can be handed back exactly as it was written.
      editUid: null,
      editorName: '',
      editorKnee: '',
      editorCeiling: '',
      // THE CHANNEL AS IT STOOD WHEN THE DIALOG ARRIVED ON IT, and the whole of what Cancel means.
      //
      // Everything the editor writes — the name, the pair that places the curve, the ratios a lever
      // moves, the decay kernel — is written into the same maps the payload is built from, because
      // that is what the chart, the zone bar and the levers are all reading back. So the editor is
      // not made to hold its edits somewhere else; what it holds is the state it FOUND, and Cancel
      // puts it back. Save is simply this being dropped.
      //
      // Taken on every arrival — the first press and every step of the walk — so what is undone is
      // always the edits made to the channel currently on the screen. The pair of levels beside the
      // three maps is there because a curve edit re-seats them: see the seatSpend/seatRevenue at the
      // foot of onChannelCurveChange, which move the plan when the curves stop crediting it.
      editorSnapshot: null,
      // What the reader asked for while there were unsaved edits: { type: 'close' } or
      // { type: 'step', delta }. Held while the question above it is answered and then carried out.
      editorLeave: null,
      editorLeaveDialog: false,
      removeDialog: false,
      removeUid: null,
      // THE ZONE BAR'S OWN AXIS, and the one piece of state in this wizard that is deliberately not
      // a reading of the curve. See fitZoneWindow: a ruler that re-fitted itself under the grip
      // being dragged along it is not a ruler.
      zoneWindow: 0,
      zoneDragging: false,
      // What a boundary dragged on that bar holds still. A way of working and not a property of a
      // channel, so it is not reset when the editor is opened on the next one: somebody placing
      // six media moves them all the same way, and a switch that went back to its default between
      // cards would have to be set six times to mean one thing.
      zoneHold: HILL_HOLD_SATURATION,
      // And WHICH boundary, for the setting that names one. It outlives its own switch for the
      // same reason: coming back to the third setting is coming back to the boundary it was last
      // pointed at.
      zoneHoldPin: 0,
      // WHETHER EITHER PANEL OF CONTROLS IS OPEN. Closed, the whole channel is stated in the three
      // things it is stated with — its name, where it saturates and what it generates there — with
      // the chart and the zone bar as readings of what those three came to.
      //
      // TWO FLAGS AND NOT ONE, because they open two unrelated things. The first adds the three
      // levers under the pair, which move the SHAPE of the response between those two figures; the
      // second adds the switch over the zone bar and the grips on it, which move where the five
      // bands FALL on a shape already fixed. A single switch made a reader who wanted one of them
      // take the other, and made the answer to "what changed?" a thing to be found in two places.
      //
      // Both are ways of working, like zoneHold above them, so they survive the walk from one
      // channel to the next: somebody who wants the levers wants them for every channel they place.
      editorShapeOpen: false,
      editorZonesOpen: false,
      // Set by the add that writes a channel down and cleared by the arrival it is about: the
      // editor opens on the name for that one channel and on the pair for every other.
      editorNameArrival: false,

      warningDialog: false,
      // Whether the section under the year — the seasonality and the spot events, in one plot — is
      // unfolded. Closed to begin with, and it is the one block on this page that opens closed: a
      // flat year with nothing having happened to it is a complete answer and the wizard's own
      // opening one, so this is asked for rather than asked.
      shapesOpen: false,
      shapesDialog: false,
      curveDialog: false
    }
  },
  methods: {
    ...mapActions('manager', [
      'createEkrm',
      'loadMmmModels',
      'loadCustomModels'
    ]),

    modelById (id) {
      if (!id) return null
      return this.sourceModels.find(model => model.id === id) || null
    },

    // WHAT A MODEL HAS TO SAY FOR ITSELF on its row of the importer. What it can still offer, for the
    // ones that have been read — an unread model says nothing rather than being read to fill a line:
    // the reading is a report fetched and a curve fitted per channel, and a list that did it for
    // every model on the account to print a count would be the most expensive control on the page —
    // and how much of it this EKRM has already taken.
    modelNote (model) {
      const note = []
      const read = this.models[model.id]
      if (read) {
        const offers = read.imported.kept.length
        note.push(this.$tc('components.ekrm.CreateModelCompose.pickerCount', offers, { count: offers }))
      }
      const already = this.addedByModel[model.id] || 0
      if (already > 0) {
        note.push(this.$tc('components.ekrm.CreateModelCompose.pickerModelAdded', already, { count: already }))
      }
      return note.join(' · ')
    },
    // A country code as the market selector names it, so the importer shows and searches it that way.
    countryName (code) {
      const found = this.countries.filter(entry => entry.id === code)[0]
      return found ? found.name : code
    },
    // A country as a model stores it — a registry code ("CO") in older reference configs, a name
    // ("Colombia") in client_metadata — folded into the registry code the market selector uses. The
    // name is compared without case or accents; a value matching neither is returned as it came.
    // The same folding manageCustomModels' resolveCountryKey does for its country filter.
    countryKey (value) {
      const text = String(value === null || value === undefined ? '' : value).trim()
      if (!text) return text
      if (this.countries.some(entry => entry.id === text)) return text
      const fold = str => String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      const wanted = fold(text)
      const found = this.countries.filter(entry => fold(entry.name) === wanted || fold(entry.id) === wanted)[0]
      return found ? found.id : text
    },
    openMarketMenu () {
      this.openMenuOn(this.$refs.marketField)
    },
    // A LIST THAT IS ALREADY DOWN WHEN THE FIELD IS REACHED. The market is a question whose answer
    // is one of the rows, and a closed combobox asks the reader to press it before it will say what
    // the answers are. Vuetify's own method, so the menu is opened the way a click opens it.
    openMenuOn (field) {
      const el = Array.isArray(field) ? field[0] : field
      if (el && el.activateMenu) el.activateMenu()
    },

    // ---------------------------------------------------------------------------------------
    // The first question: written, or copied
    // ---------------------------------------------------------------------------------------

    openCopyImporter () {
      this.copyImporterDialog = true
    },
    onCopyImporterPick (id) {
      this.copyImporterDialog = false
      this.onCopyModelPick(id)
    },

    // Prefer the curated country, then the reference model's first brand — the same order
    // manageCustomModels uses to label an ad-hoc model's market. See modelMetadata.
    countryCodeFor (model) {
      if (!model) return null
      return modelMetadata(model, this.countryKey).country[0] || null
    },

    // THE TWO TILES, AND THE MODEL UNDER THE SECOND ONE. Both arrive here, because both can throw
    // away a composition and neither may do it without asking.
    onSourceMode (mode) {
      if (mode !== SOURCE_SCRATCH && mode !== SOURCE_COPY) return
      if (mode === this.sourceMode) return
      this.askCopy({ mode: mode, modelId: mode === SOURCE_COPY ? this.copyModelId : null })
    },
    onCopyModelPick (id) {
      if (!id || id === this.copyModelId) return
      this.askCopy({ mode: SOURCE_COPY, modelId: id })
    },

    // NOTHING IS OVERWRITTEN WITHOUT A QUESTION. A copy answers most of this wizard at once, so it
    // also throws away most of it — the channels, the pairs typed on their cards, the two curves
    // bent in the editor, the spend and the revenue. On an empty page that is nothing at all and the
    // question would be noise; the moment there is a channel it is the whole of the user's work.
    //
    // Held on the pending answer rather than carried out and undone, so a reader who says no is left
    // exactly where they were, tiles included.
    askCopy (pending) {
      if (!this.hasComposition) {
        this.runCopy(pending)
        return
      }
      this.copyPending = pending
      this.copyDialog = true
    },
    confirmCopy () {
      const pending = this.copyPending
      this.copyDialog = false
      this.copyPending = null
      if (pending) this.runCopy(pending)
    },
    cancelCopy () {
      this.copyDialog = false
      this.copyPending = null
    },
    runCopy (pending) {
      if (!pending) return
      if (pending.mode === SOURCE_SCRATCH) {
        this.sourceMode = SOURCE_SCRATCH
        this.copyModelId = null
        // The name and the market go back with the rest of the copy when they are still the copy's
        // own — they named a model that is no longer being copied. A name typed over that one is the
        // user's and stays, which is the same bargain applyCopy makes.
        if (this.copyNameWritten && this.name === this.copyNameWritten) {
          this.name = ''
          this.market = ''
        }
        this.copyNameWritten = ''
        this.copyRates = {}
        this.copyError = null
        this.copySkipped = []
        this.copyHeld = []
        this.resetComposition()
        this.focusAfterSource(SOURCE_SCRATCH)
        return
      }
      this.sourceMode = SOURCE_COPY
      // The model first: the importer opens only while there is still no model being copied.
      if (pending.modelId) this.startCopy(pending.modelId)
      this.focusAfterSource(SOURCE_COPY)
    },

    // WHERE THE READER GOES ONCE A TILE IS PRESSED, which is the next thing that has to be said and
    // is not the same thing in the two cases: from scratch it is the name, which is now the first
    // field on the page; from a copy it is the model being copied, since the name and the market
    // below it are about to be written by it — so the importer opens on it, unless a model is
    // already being copied. A tick, because the name is not on the page until the answer has
    // rendered it.
    focusAfterSource (mode) {
      if (mode === SOURCE_COPY) {
        if (!this.copyModelId) this.openCopyImporter()
        return
      }
      this.$nextTick(() => {
        const field = this.$refs.nameField
        if (field) field.focus()
      })
    },

    // The model read, and then asked what its own money is worth. A model reporting USD on both axes
    // is asked nothing and the copy lands here; anything else stops at the rates, which is not a
    // failure but the one question a copy cannot answer for itself — see composeCopyPlan.
    async startCopy (id) {
      this.copyModelId = id
      // The market is the chosen model's own, the moment it is chosen — not once its report has been
      // read and its rates answered — or none, where its country is not one of the market options.
      // Set here once rather than in applyCopy, which runs again on every rate typed and would take
      // back a market the user has since changed.
      const code = this.countryCodeFor(this.modelById(id))
      this.market = code && this.countries.some(country => country.id === code) ? code : ''
      this.copyError = null
      this.copySkipped = []
      this.copyHeld = []
      this.copyLoading = true
      let entry = null
      try {
        entry = await this.loadModel(id)
      } finally {
        // A slow report for a model the user has already moved on from must not land on the page.
        if (this.copyModelId === id) this.copyLoading = false
      }
      if (this.copyModelId !== id) return
      if (!entry) {
        this.copyError = this.loadError || this.$t('components.ekrm.CreateModelCompose.copyFailed')
        return
      }
      // The rate the model carries: copyModels only offers a model that has one, or needs none.
      this.copyRates = cloneSuggestedRates(entry.model, this.copyUnits)
      this.applyCopy()
    },

    // THE COPY ITSELF, and the order is the wizard's own order rather than the payload's.
    //
    // The channels and the pairs that place them first, because everything below is read off the
    // curves they make; then the year each medium was bought over, which is a multiplier on those
    // pairs; then the size of the business, held inside the same two walls a typed revenue is; and
    // last the seasonality, which cannot even be converted into the unit this wizard draws it in
    // until there is a revenue and a set of curves to take the base from.
    //
    // Every one of them lands in the state the step that asks for it writes, so the copy is a
    // starting position and not a mode: nothing below is locked and nothing reads a flag.
    applyCopy () {
      const entry = this.models[this.copyModelId]
      const rates = this.copyRatesResolved
      // A rate still owed is not a failure and says nothing here: the fields are on the screen and
      // the line under them already says why nothing has been copied.
      if (!entry || !rates) return
      const plan = composeCopyPlan(entry, rates)
      if (!plan) {
        this.copyError = this.$t('components.ekrm.CreateModelCompose.copyNothing')
        return
      }
      this.copyError = null
      this.resetComposition()
      this.copySkipped = plan.skipped || []

      // THE SOURCE'S OWN NAME, MARKED AS A COPY — a starting point like every other figure the
      // copy writes, and like them it is left alone the moment the user touches it. applyCopy runs
      // again whenever a rate is retyped, so what is remembered is the name this method last wrote:
      // anything else in the box came from the user and is theirs.
      const copied = this.$t('components.ekrm.CreateModelCompose.copyName',
        { name: String(entry.model.name || '').trim() })
      if (!String(this.name).trim() || this.name === this.copyNameWritten) {
        this.name = copied
        this.copyNameWritten = copied
      }

      const taken = []
      plan.channels.forEach(item => {
        const label = composerLabel(entry.model, item.raw, taken)
        taken.push(label)
        const uid = this.nextUid++
        this.channels.push({ uid: uid, modelId: this.copyModelId, raw: item.raw, label: label })
        this.$set(this.statedCurves, String(uid), { knee: item.knee, ceiling: item.ceiling })
        if (item.spendShape) this.$set(this.spendShapes, String(uid), item.spendShape)
      })

      // The level stays at one and the whole of the source's spending is in the shapes above, which
      // is what makes every channel's twelve cells the twelve that model measured. Seeded and
      // touched both: the figure is somebody's answer — the copied model's — so the step that asks
      // for it must not seat it at the peak of the curves on arrival.
      this.spendFactor = 1
      this.spendTouched = true
      this.spendSeeded = true

      if (plan.revenueShape) {
        this.revenueShapeName = COMPOSE_SHAPE_CUSTOM
        this.revenueShapeValues = plan.revenueShape
      }
      this.rebuild()

      // Through the same walls a typed revenue meets, and for the same reason: the copy states a
      // size, and a size the build refuses is not a copy of anything. It lands on the nearest figure
      // this plan can carry and says so where every held revenue says so.
      if (plan.revenue !== null) {
        const held = this.revenueWithin(plan.revenue)
        this.revenueAnchor = held.value
        this.revenueFactor = 1
        this.revenueTouched = true
        this.rebuild()
        if (held.reason) {
          this.revenueNote = this.$t(`components.ekrm.CreateModelCompose.revenueHeld_${held.reason}`,
            { revenue: this.formatMoney(held.value) })
        }
      }

      // LAST, AND ONLY IF THERE IS A BASE TO READ IT AGAINST. The source states its seasonality as a
      // share of each month's revenue and this wizard draws it as a share of each month's base, and
      // the ratio between them is the curves and the revenue that have just been written. A year
      // that will not fit inside the cap is held there month by month and the months are named.
      if (plan.seasonality && this.ready) {
        const shares = composeShareOfBase(this.built.form, plan.seasonality, null)
        if (shares) {
          const drawn = shares.year.some(value => Number(value) !== 0)
          this.drawnSeasonality = drawn ? shares.year : null
          this.seasonalitySource = null
          this.copyHeld = shares.held
          // AND THE SECTION OPENS, which is the one fold this wizard ever opens on the reader's
          // behalf. It is shut by default because a flat year nobody touched is a complete answer and
          // the opening one; a copy has just drawn a year that is neither, and a season written into
          // a folded panel is the wizard stating something on the reader's behalf and then hiding it.
          if (drawn) {
            this.shapesOpen = true
            this.rebuild()
          }
        }
      }
    },

    // EVERYTHING A COMPOSITION IS, back to the page this wizard opens on. Every map keyed by uid goes
    // with the channels it was keyed against — the uids are never reused, so a stale entry could not
    // be inherited, but a map that grew on every copy would be a leak with no reader.
    //
    // The name and the market are not here: the copy overwrites them outright and the scratch tile
    // is a reader saying they will type their own, which is not the same as the wizard clearing the
    // two fields under their hands.
    resetComposition () {
      this.channels = []
      this.statedCurves = {}
      this.curveEdits = {}
      this.decayEdits = {}
      this.mixFactors = {}
      this.spendShapes = {}
      this.spendFactor = 1
      this.spendTouched = false
      this.spendSeeded = false
      this.revenueAnchor = null
      this.revenueFactor = 1
      this.revenueTouched = false
      this.revenueShapeName = COMPOSE_SHAPE_FLAT
      this.revenueShapeValues = composeRevenueShape(COMPOSE_SHAPE_FLAT)
      this.revenueShapeSource = null
      this.drawnSeasonality = null
      this.seasonalitySource = null
      this.drawnSpot = null
      this.roasNote = null
      this.spendNote = null
      this.revenueNote = null
      this.shareNote = null
      this.otherSpend = { comarketing: null, competition: null }
      this.otherSpendSource = { comarketing: null, competition: null }
      this.otherAttribution = { comarketing: null, competition: null }
      this.futureTrends = emptyFutureTrends()
      this.editUid = null
      this.justAdded = []
      this.step = 1
      this.rebuild()
    },

    // ---------------------------------------------------------------------------------------
    // Reading the models channels come from
    // ---------------------------------------------------------------------------------------

    // Everything about one source model, read once. The report is fetched, narrowed to its KPI and
    // handed to composeImport, which fits a Hill curve per channel — the expensive half, and the
    // reason this is cached rather than re-run. It depends on the report and on nothing the user can
    // move afterwards: not a rate, not the revenue, not a level.
    async loadModel (id) {
      if (this.models[id]) return this.models[id]
      if (!this.modelById(id)) return null
      this.loadError = null
      try {
        const entry = await this.readModel(id)
        if (!entry) this.loadError = this.$t('components.ekrm.CreateModelCompose.reportEmpty')
        return entry
      } catch (error) {
        console.error('Could not read the report for ' + id, error)
        this.loadError = this.$t('components.ekrm.CreateModelCompose.reportLoadFailed', {
          error: error && error.message ? error.message : String(error)
        })
        return null
      }
    },

    // The read itself, apart from the copy's error line, so the channel importer can read several
    // models side by side without it being written. Null for a model with no
    // report; a failed fetch throws.
    async readModel (id) {
      if (this.models[id]) return this.models[id]
      const model = this.modelById(id)
      if (!model) return null
      const report = await loadModelReportFromClient(model)
      if (!report) return null
      const kpiName = cloneKpiName(report)
      const scope = outputScope(report, kpiName)
      // What the model reports in is deliberately not read. An EKRM is in USD on both axes and a
      // source need not be, but nothing of the source's LEVEL travels any more — only the shape of
      // each channel's response, which is dimensionless once its own operating point is divided
      // out — so there is no unit left to convert and nothing to ask the user for.
      const entry = {
        model: model,
        report: report,
        scope: scope,
        kpiName: kpiName,
        readiness: composeReadiness(scope),
        imported: composeImport(scope, { model: model })
      }
      this.$set(this.models, id, entry)
      return entry
    },

    // Channels out of models already read, as { modelId, raw } pairs, joining the list in the order
    // given, each claiming its name against the names already taken. That claim happens HERE and
    // once: composerLabel is never asked again for a channel that is already on the page, so a name
    // cannot move when a neighbour is removed. The uids of what arrived are returned for showArrived; a pair
    // whose model is not in the cache is passed over.
    placeChannels (pairs) {
      const taken = this.channels.map(channel => channel.label)
      const arrived = []
      pairs.forEach(pair => {
        const entry = this.models[pair.modelId]
        if (!entry) return
        const label = composerLabel(entry.model, pair.raw, taken)
        taken.push(label)
        const uid = this.nextUid++
        arrived.push(uid)
        this.channels.push({ uid: uid, modelId: pair.modelId, raw: pair.raw, label: label })
      })
      if (arrived.length > 0) this.rebuild()
      return arrived
    },

    // ---------------------------------------------------------------------------------------
    // The channel importer
    // ---------------------------------------------------------------------------------------

    openChannelImporter () {
      // A model that failed to read is given another try on every visit.
      Object.keys(this.taxonomyStatus).forEach(id => {
        if (this.taxonomyStatus[id] === 'failed') this.$delete(this.taxonomyStatus, id)
      })
      this.channelImporterDialog = true
    },

    // The models the rows on screen need, queued and read TAXONOMY_READERS at a time: a first
    // screen can span twenty models, and twenty reports fetched and fitted at once would stall the
    // page the dialog is standing over.
    onTaxonomyNeed (ids) {
      ids.forEach(id => {
        if (this.taxonomyStatus[id]) return
        if (this.models[id]) {
          this.$set(this.taxonomyStatus, id, 'ready')
          return
        }
        this.$set(this.taxonomyStatus, id, 'queued')
        this.taxonomyQueue.push(id)
      })
      this.pumpTaxonomyQueue()
    },

    pumpTaxonomyQueue () {
      while (this.taxonomyReading < TAXONOMY_READERS && this.taxonomyQueue.length > 0) {
        const id = this.taxonomyQueue.shift()
        this.taxonomyReading++
        this.$set(this.taxonomyStatus, id, 'loading')
        this.readModel(id)
          .then(entry => {
            this.$set(this.taxonomyStatus, id, entry ? 'ready' : 'failed')
          })
          .catch(error => {
            console.error('Could not read the report for ' + id, error)
            this.$set(this.taxonomyStatus, id, 'failed')
          })
          .then(() => {
            this.taxonomyReading--
            this.pumpTaxonomyQueue()
          })
      }
    },

    // Only a channel its model actually offers is placed — the dialog asks for nothing else, and
    // this says so again rather than trusting it.
    onTaxonomyAdd (pairs) {
      const placeable = pairs.filter(pair => {
        const entry = this.models[pair.modelId]
        return entry && entry.readiness.ok && entry.imported.kept.some(kept => kept.raw === pair.raw) &&
          !this.channels.some(channel => channel.modelId === pair.modelId && channel.raw === pair.raw)
      })
      const arrived = this.placeChannels(placeable)
      // NOTHING BUT THE CHANNELS ARRIVES — no year, no market, no level: each one is a pair of
      // curves and arrives marked and asking for its two figures. And the dialog goes, because the
      // cards it just made are the answer to the question it was asking and they are behind it.
      this.channelImporterDialog = false
      this.showArrived(arrived)
    },

    // What one read model's channels look like at the size of a picker row: the saturation line and
    // the decay bars, on the monthly axis the built model reads them on and on the lag grid they all
    // share — the same treatment the cards get, these rows being a preview of them. In the model's
    // own order.
    channelPlots (entry) {
      const granularity = this.granularityFor(entry.model.id)
      const decayCurves = entry.imported.kept.map(kept => monthlyDecayCurve(kept.read.sourceDecay, granularity))
      const lagSlots = decayCurves.reduce(
        (longest, curve) => Math.max(longest, curve && Array.isArray(curve.y) ? curve.y.length : 0), 0
      )
      return entry.imported.kept.map((kept, index) => {
        const curve = kept.read.curve
        const pairs = curve && Array.isArray(curve.x)
          ? curve.x.map((x, at) => [Number(x), Number(curve.y[at])])
          : []
        return {
          raw: kept.raw,
          path: pairs.length > 1 ? sparklinePath(pairs, PLOT_WIDTH, PLOT_HEIGHT) : null,
          // Off the REPORT, as the card's own is: the payload carries a decay curve only for a
          // monthly source, and a picker drawing nothing for every channel of a weekly model would be
          // reporting the payload's silence as the channel's.
          decayBars: decayBars(decayCurves[index], PLOT_WIDTH, PLOT_HEIGHT, lagSlots)
        }
      })
    },

    // A CHANNEL WRITTEN DOWN RATHER THAN TAKEN, and the whole of what it costs.
    //
    // It joins the same list the picker's channels join, claiming its name against the same taken
    // names, and from here on nothing tells it apart: readFor hands it the generated shape, the card
    // draws that shape, the editor bends it and the build places it out of the two figures typed on
    // it. What it does NOT carry is a model, a source medium or a KPI, and provenance says so.
    //
    // The editor opens on it immediately, which is the difference between this and the picker's add.
    // A picked channel arrives with a name its model gave it and a shape that model measured, so the
    // grid is a reasonable place to be left: there is something to look at. This one arrives with a
    // placeholder name and the same starting curve as every other scratch channel, so the grid has
    // nothing to say about it at all — everything that makes it a channel is typed in the dialog,
    // beginning with what it is called.
    addScratch () {
      const taken = this.channels.map(channel => channel.label)
      const label = composerLabel(null, this.$t('components.ekrm.CreateModelCompose.scratchChannel'), taken)
      const uid = this.nextUid++
      this.channels.push({ uid: uid, modelId: null, raw: null, scratch: true, label: label })
      this.rebuild()
      this.showArrived([uid])
      // The one arrival that opens on the name rather than on the pair — see loadEditor, which
      // consumes this.
      this.editorNameArrival = true
      this.openEditor(uid)
    },

    // Where the closed dialog leaves the user: on the cards it just made. The first of them is
    // scrolled to — `nearest`, so a grid that already had them in view does not jump — and all of
    // them wear a ring for a second and a half, which is how a card added at the end of twelve is
    // told from the eleven that were there before. The scroller is the fullscreen dialog's own
    // v-card-text, which is what scrollIntoView walks up to find.
    showArrived (uids) {
      if (this.justAddedTimer) clearTimeout(this.justAddedTimer)
      this.justAdded = uids
      if (uids.length === 0) return
      this.$nextTick(() => {
        const cell = this.$el.querySelector(`#clone_card_${uids[0]}`)
        if (cell && cell.scrollIntoView) cell.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      })
      this.justAddedTimer = setTimeout(() => { this.justAdded = [] }, 1600)
    },

    // The X on the card asks first, and the question is held on the uid rather than on the card, so
    // a rebuild between the press and the answer cannot move which channel is taken out.
    askRemove (uid) {
      const at = this.channels.findIndex(entry => entry.uid === uid)
      if (at === -1) return
      this.removeUid = uid
      this.removeDialog = true
    },

    confirmRemove () {
      const uid = this.removeUid
      this.removeDialog = false
      this.removeUid = null
      if (uid === null) return
      this.removeChannel(uid)
    },

    removeChannel (uid) {
      const at = this.channels.findIndex(entry => entry.uid === uid)
      if (at === -1) return
      // Its two curve edits, its mix factor and its stated level go with it. They are keyed by uid,
      // which is never reused, so nothing that arrives later can inherit them.
      this.channels.splice(at, 1)
      this.$delete(this.curveEdits, String(uid))
      this.$delete(this.decayEdits, String(uid))
      this.$delete(this.mixFactors, String(uid))
      this.$delete(this.statedCurves, String(uid))
      this.rebuild()
      // A medium gone is response gone with it, so the corridor the rest of the plan stands in
      // moves — and so does the ceiling over the revenue, which is what the curves that are left
      // are credited with. Both figures are re-seated, and each says so where it stands.
      this.seatSpend('channels')
      this.seatRevenue()
    },

    // The name the payload will carry, typed over on the card. What composerLabel claimed at add
    // time is a guess made on the user's behalf — the source model's pretty name, qualified by the
    // model it came from when two of them collide — and a model assembled out of four businesses is
    // exactly where that guess is worth overruling: `Paid Search (Globex)` names the model it was
    // taken from and not the medium of the model being built.
    //
    // It moves NOTHING but the name. The curve edits and the mix factors are keyed by uid, the
    // levels are a share of the revenue rather than of anything a channel is called, and the form is
    // rebuilt only because the name is the key of three of its maps — so there is nothing to re-seat
    // and seatSpend is not called, unlike an add or a remove.
    //
    // Checked again here rather than trusted from the card: the card owns the draft, this owns the
    // list, and a name that would overwrite another channel's rows must not get in on the strength
    // of a component's own bookkeeping.
    renameChannel (uid, raw) {
      const name = mediumName(raw)
      if (!name) return
      const at = this.channels.findIndex(entry => entry.uid === uid)
      if (at === -1) return
      if (this.channels[at].label === name) return
      const taken = this.channels.filter(entry => entry.uid !== uid).map(entry => entry.label)
      if (mediumNameError(name, taken) !== '') return
      this.$set(this.channels, at, Object.assign({}, this.channels[at], { label: name }))
      this.rebuild()
    },

    // The periods a source model's own curves were fitted on. It is a setting on that model rather
    // than anything the report carries, and the only thing left that reads it is the decay kernel,
    // which is re-binned onto the monthly axis the EKRM will be built on before it is drawn.
    granularityFor (modelId) {
      const source = this.models[modelId]
      const config = (source && source.model.reference_model && source.model.reference_model.config) || {}
      return config.decay_granularity === 'W' ? 'W' : 'M'
    },

    // HOW BIG the business is, in the card the year is drawn in — and the LAST thing this wizard
    // asks, which is the whole shape of the page.
    //
    // It sizes the KPI row and nothing else. No curve is a function of it and no spend cell is: the
    // media were modelled in dollars before it existed, so what moves when it moves is the marketing
    // ATTRIBUTION, which is what the curves are credited with over this figure. That is the reverse
    // of what it used to do — it used to resize every channel on both axes and leave the attribution
    // standing — and it is the honest direction: a business that sells twice as much with the same
    // media bought is a business whose media explain half as much of it.
    //
    // Nothing is re-seated after it, and that is a rule rather than an omission. The media are what
    // the user modelled by hand a section above; answering a revenue they have just typed by quietly
    // pulling their own spend out from under it is answering a statement with a question. What can
    // go wrong is said in words instead — baseWarning, whose copy already names the revenue that
    // would leave the curves room.
    //
    // Typed as a figure and stored as a multiple of the anchor, which is the same number said the
    // other way round. There is no anchor at all until this runs: the first typed figure becomes
    // one, and every one after it moves the factor over it.
    //
    // AND THE FIRST ONE OPENS EVERYTHING BELOW THE PAIR, without moving any of it. The media spend
    // above is already answered — it is a statement about the curves and waits for nothing — but the
    // attribution, the base, the decomposition and both charts are readings taken against the size
    // of the business, and until this lands there is nothing to take them against. See moneyReady.
    // What it reveals is the model the cards and the spend above already describe, not one chosen
    // here.
    onTotalRevenueChange (value) {
      const amount = this.parseAmount(value)
      this.formKey++
      // TEXT NOBODY CAN READ AS MONEY IS THE ONLY THING THAT SAYS NOTHING. Everything else is a
      // figure, and a figure lands on the nearest one this plan can carry — see revenueWithin.
      //
      // A zero and a negative used to be handed straight back with the box re-keyed, which put the
      // old year on screen and left the user looking at a field that had swallowed what they typed
      // without a word. They are not unreadable; they are too small, which is a thing this wizard
      // has an answer to and now gives: nothing is a revenue below the floor, so they land on it.
      if (!isFinite(amount)) return
      const held = this.revenueWithin(Math.max(amount, 0))
      this.revenueTouched = true
      if (!(this.revenueAnchor > 0)) {
        this.revenueAnchor = held.value
        this.revenueFactor = 1
      } else {
        this.revenueFactor = held.value / this.revenueAnchor
      }
      this.rebuild()
      // After the rebuild, which clears it: the note is about the figure the page ended up carrying,
      // and the same order seatSpend writes its own in.
      if (held.reason) {
        this.revenueNote = this.$t(`components.ekrm.CreateModelCompose.revenueHeld_${held.reason}`,
          { revenue: this.formatMoney(held.value) })
      }
    },
    // THE YEAR, STATED BY THE MONTH. The window is fixed and known, so an average is the total said
    // the other way round: it is multiplied back up and handed to the one handler that owns this
    // figure, walls, anchor, factor, note and all. Nothing is duplicated here — everything this
    // wizard does with a revenue happens exactly once, in onTotalRevenueChange, whichever of the two
    // boxes the user typed into.
    //
    // The note that handler may raise names the YEAR it landed on, not the month, and that is right:
    // it says what the model now carries, and what the model carries is a year. The month field
    // re-reads it as a twelfth on the way back, the formKey both handlers bump being what discards
    // whatever was typed in favour of what was kept.
    onAvgMonthChange (payload) {
      const amount = this.parseAmount(payload ? payload.value : '')
      if (!isFinite(amount)) {
        this.formKey++
        return
      }
      // Zero and below go up as well, for the reason they do in the box above: they are figures that
      // are too small, and the handler this defers to is the one that knows what too small means.
      this.onTotalRevenueChange(Math.max(amount, 0) * this.monthCount)
    },
    // THE TWO WALLS THE REVENUE HAS, and why it now has any.
    //
    // This box used to take whatever was typed into it, and the argument was that nothing binds: the
    // rules cloneRevenueLimits is made of are ratios — the implied attribution, the base floor, the
    // revenue against the spend — and a ratio does not move when both of its sides do. That is true
    // of the clone, where the revenue resizes the model. It is not true here. The media are stated
    // in dollars before this figure exists and no curve and no spend cell is a function of it, so
    // the revenue moves ONE side of every one of those ratios, and two of them are hard errors:
    //
    //   above  the marketing attribution is what the curves return over this figure, so raising it
    //          drives the band down, and under about 0.065 % `band` writes a minimum of nothing —
    //          which validateEkrmForm refuses. See composeRevenueCeiling.
    //   below  the KPI row is this figure spread over twelve months and rounded into twelve cells,
    //          and a year small enough rounds away to nothing, which validateEkrmForm refuses too.
    //          See composeRevenueFloor.
    //
    // Everything BETWEEN them is still the user's, warnings and all. Spending past the revenue and
    // crowding out the base are things this wizard says in words and lets the user answer — that is
    // what baseWarning and the "Create anyway" dialog are for — and neither is a wall here. The rule
    // is the one every rail in this wizard already follows: what the build refuses is bounded, and
    // what it merely doubts is said.
    //
    // The ceiling is skipped where it would land under the floor, which is a plan whose media are
    // credited with almost nothing at all. There is no revenue that satisfies both, the channels are
    // what is wrong, and holding the figure at a wall that cannot be met would say otherwise.
    revenueWithin (amount) {
      const cells = composeRevenueFloor(this.revenueShapeValues)
      // THE THREE FLOORS, and the one that binds. The cells' own is the year whose smallest month
      // still reaches a grid cell; the spend's is the year that comes to more than the money spent
      // on it; the base's is the year that leaves something for the base once the curves have been
      // credited. On any plan with media worth modelling the cells' floor is beneath the other two
      // by orders of magnitude, and which of those two is on top depends on how well the media
      // respond — see revenueLeast. Each says so in its own words, the three being different facts
      // about one wall.
      const least = this.revenueLeast
      const binds = least !== null && least > cells
      const floor = binds ? least : cells
      const marketing = this.ready ? cloneMarketing(this.formState) : null
      const ceiling = marketing === null ? null : composeRevenueCeiling(marketing)
      if (ceiling !== null && ceiling > floor && amount > ceiling) {
        return { value: ceiling, reason: 'high' }
      }
      if (amount < floor) {
        return { value: floor, reason: binds ? (this.revenueLeastReason || 'base') : 'low' }
      }
      return { value: amount, reason: null }
    },

    // composeRevenueMonthAt knows there is a floor on the year and not which of the two walls put it
    // there, that being a property of the plan rather than of the arithmetic. The box's own answer
    // is the one used, so a month held and a total held name the same rule.
    monthHeldReason (reason) {
      if (reason !== 'base') return reason
      return this.revenueLeastReason || 'base'
    },

    // The button pressed, whichever it was. One handler because the card emits one event: it knows
    // it has buttons and not what any of them mean.
    onRevenueAction (key) {
      if (key === 'randomize') this.onRevenueRandomize()
      if (key === 'flatten') this.onRevenueFlatten()
      if (key === 'shiftLeft') this.onRevenueShift(-1)
      if (key === 'shiftRight') this.onRevenueShift(1)
      if (key === 'import') this.openShapeImport()
      if (key === 'clear') this.onRevenueClear()
    },
    // BACK TO THE OPENING: no total and a flat year, which is what reset leaves this row as. The
    // season and the spot events are left alone — they are separate statements, and they come back
    // as they were once a total is typed again.
    onRevenueClear () {
      this.revenueAnchor = null
      this.revenueFactor = 1
      this.revenueTouched = false
      this.revenueShapeName = COMPOSE_SHAPE_FLAT
      this.revenueShapeValues = composeRevenueShape(COMPOSE_SHAPE_FLAT)
      this.revenueShapeSource = null
      this.revenueNote = null
      this.rebuild()
    },
    // A LITTLE MORE UNEVEN, AND A LITTLE FLATTER: the two things that may be done to the year the
    // revenue is spread across, each a press at a time on the row that is already there.
    //
    // They replaced a pair of named patterns — Flat and Random — and the difference is not the
    // arithmetic, it is what the gesture MEANS. A pattern is a year chosen instead of the one on
    // screen: Flat threw away whatever had been typed, and Random rolled a whole new set of twelve
    // for a reader who wanted this one a little less even. These act ON the row, so how uneven the
    // year is is arrived at rather than picked, and a reader who has typed months keeps them — what
    // moves is how far apart they stand, not which month is the big one.
    //
    // Randomize multiplies each month by its own draw from ±SHAPE_JITTER and Flatten moves each of
    // them a fraction of the way to the mean, which is the same operation with the sign reversed:
    // one press of each, in either order, leaves a year near where it started. Neither RESIZES
    // anything — the row is renormalised to a mean of one on the way in, so the total, the Total
    // ROAS and the marketing attribution stand exactly where they were and only the columns move.
    // That is the same bargain the named shapes made, and the two rows below no longer have to be
    // re-seated after it: they are percentages of each month's own base, so a year redistributed
    // under them moves what they come to in money and cannot take either of them out of range.
    onRevenueRandomize () {
      const jitter = () => 1 + SHAPE_JITTER * (2 * Math.random() - 1)
      this.applyRevenueShape(this.revenueShapeRow().map(value => value * jitter()))
    },
    onRevenueFlatten () {
      this.applyRevenueShape(this.revenueShapeRow().map(value => value + (1 - value) * SHAPE_PULL))
    },
    // THE WHOLE YEAR MOVED ONE MONTH, either way, and it wraps: going right, what January sold is
    // what February sells and December's comes round to January; going left, the other way about.
    //
    // The third verb, and the only one of the three that changes NOTHING about the year except when
    // it happens. Randomize and Flatten move the values against each other; this moves all twelve
    // together, so the shape — how uneven the year is, which months are the big ones relative to
    // their neighbours — survives a press exactly, and twelve presses are the identity.
    //
    // It is here for the year that was borrowed rather than drawn. A business in the other
    // hemisphere sells its December in July, and its year is the right SHAPE for a model on this
    // side of the equator standing six months out of place; the alternative was asking the reader to
    // retype twelve months they already have. Six presses is that move, and any other rotation is
    // however many presses it takes in whichever direction is nearer — the same bargain the two
    // verbs beside it make, a control whose first press is the whole range being a control with one
    // position.
    //
    // Nothing else moves. The row is renormalised to a mean of one on the way in and a rotation does
    // not change a mean, so the total, the Total ROAS and the marketing attribution are exactly
    // where they were; and the two drawn years below are percentages of each month's own base, which
    // is a wall per month rather than a pot, so neither can be taken out of range by it.
    //
    // The two drawn years are NOT rotated with it. They are separate statements about the same
    // twelve months — what comes back every year, and what happened once — and a wizard that moved
    // them along with the sales would be answering, on the reader's behalf, the question of whether
    // the season this business has is the season the borrowed one had.
    onRevenueShift (by) {
      const row = this.revenueShapeRow()
      this.applyRevenueShape(row.map((value, index) => row[(index - by + row.length * 2) % row.length]))
    },
    // The row those two act on: the twelve multipliers as they stand, or twelve ones for the flat
    // year, which is carried as a null rather than as a row of ones — see the data.
    revenueShapeRow () {
      const shape = this.revenueShapeValues
      if (Array.isArray(shape) && shape.length === COMPOSE_MONTHS) return shape.slice()
      const flat = []
      for (let index = 0; index < COMPOSE_MONTHS; index++) flat.push(1)
      return flat
    },
    // The year redistributed, however it was redistributed. It moves the KPI row and nothing else:
    // no curve is re-placed, no spend cell moves, and the row goes on summing to the figure typed
    // above — so the Total ROAS and the stated attribution are both untouched by it, and there is
    // nothing to re-seat but the two drawn years. What does move is every reading that was per-month
    // all along: the columns, the waterfall's split, and the periodic band, which
    // derivedAttributionRows weights by this row.
    //
    // composeRevenueShapeOf is the normalisation, and it is also the wall: a row it cannot read is a
    // row nothing is done with, which is what keeps a bad draw from reaching the form.
    //
    // THE NAME IS LEFT WHERE IT IS. revenue_shape records where this year came FROM — the flat
    // opening, or a month somebody typed — and a nudge is neither: it moves the row it finds without
    // changing whose row it is. What the twelve months actually came to travels beside that name in
    // revenue_shape_months and is what reproduces the year.
    applyRevenueShape (values) {
      const shape = composeRevenueShapeOf(values)
      if (shape === null) return
      this.revenueShapeValues = shape
      this.rebuild()
      // NOTHING IS RE-SEATED AFTER IT, and there used to be. When the two drawn rows were
      // percentages of each month's own REVENUE, redistributing the year moved what they claimed
      // without the total moving a cent, and every wall that had been asked about them stood on the
      // shape before — so both years had to be scaled back afterwards by a factor nobody asked for.
      // They are percentages of each month's own BASE now, and the rule they answer to is a cap on
      // that month alone, so a year reshaped under them changes what they come to in money and
      // cannot take either of them out of range. See SHAPE_MONTH_CAP.
    },

    // --- The year borrowed off another model --------------------------------

    // The importer opens on the list of models. A second visit for the same row keeps the model it
    // was reading, and opens on what to take from it.
    openShapeImport (target, otherKey) {
      const wanted = target === 'season' || target === 'other' ? target : 'revenue'
      const card = wanted === 'other' ? otherKey : null
      // Another row is another statement: a hemisphere correction made for the sales year says
      // nothing about the season, and the two are answered on their own screens anyway. The two
      // other inputs are two rows as well — the competition's year is not the brand's.
      if (wanted !== this.shapeImportTarget || card !== this.shapeImportOtherKey) {
        this.shapeImportShift = 0
        this.shapeImportModelId = null
        this.shapeImportSeries = null
      }
      this.shapeImportTarget = wanted
      this.shapeImportOtherKey = card
      this.shapeImportDialog = true
      this.shapeImportError = null
    },
    // Back to the list, to choose another model.
    onShapeImportBack () {
      this.shapeImportModelId = null
      this.shapeImportSeries = null
      this.shapeImportError = null
      this.shapeImportShift = 0
    },
    // The dialog's own words, which are the one thing in it that is not shared between the two rows:
    // the same six sentences said about a year of sales and about a season. The template names the
    // sentence and this names the row, which is the bargain every other control on this page is
    // written under.
    importText (key) {
      const prefix = this.shapeImportSigned
        ? 'shapeImportSeason'
        : (this.shapeImportOther ? 'shapeImportOther' : 'shapeImport')
      return this.$t(`components.ekrm.CreateModelCompose.${prefix}${key}`)
    },

    async onShapeImportModel (id) {
      this.shapeImportModelId = id
      this.shapeImportError = null
      // Another business, another calendar: a correction made for the last one says nothing here.
      this.shapeImportShift = 0
      if (!id) return
      const report = await this.loadShapeReport(id)
      // The model may have been changed again while this one was being fetched.
      if (this.shapeImportModelId !== id || !report) return
      this.shapeImportKpi = cloneKpiName(report)
      this.seatShapeSeries()
      this.seatShapeYear()
    },
    // WHICH INPUT THE DIALOG STANDS ON once another model is read: the one already chosen wherever
    // this model has it too, and otherwise the first it offers — all of its media together, where it
    // has media, that being the series most like a spend a brand or its competition would make.
    seatShapeSeries () {
      const keys = this.shapeImportSeriesChoices.map(item => item.key)
      if (keys.indexOf(this.shapeImportSeries) !== -1) return
      this.shapeImportSeries = keys.length > 0 ? keys[0] : null
    },
    onShapeImportSeries (key) {
      this.shapeImportSeries = key === undefined ? null : key
    },

    // ONE REPORT, AND NOTHING FITTED. loadModel reads a report and then fits a Hill curve per
    // channel, which is the expensive half and the whole of what the channel picker is there for; a
    // shape is twelve numbers off the KPI series and needs none of it. So this cache is its own, and
    // a model the picker has already read is taken from that entry rather than fetched twice.
    async loadShapeReport (id) {
      if (this.shapeReports[id]) return this.shapeReports[id]
      const read = this.models[id]
      if (read && read.report) {
        this.$set(this.shapeReports, id, read.report)
        return read.report
      }
      const model = this.modelById(id)
      if (!model) return null
      this.shapeImportLoading = true
      try {
        const report = await loadModelReportFromClient(model)
        if (!report) {
          this.shapeImportError = this.$t('components.ekrm.CreateModelCompose.reportEmpty')
          return null
        }
        this.$set(this.shapeReports, id, report)
        return report
      } catch (error) {
        console.error('Could not read the report for ' + id, error)
        this.shapeImportError = this.$t('components.ekrm.CreateModelCompose.reportLoadFailed', {
          error: error && error.message ? error.message : String(error)
        })
        return null
      } finally {
        this.shapeImportLoading = false
      }
    },

    onShapeImportKpi (name) {
      this.shapeImportKpi = name
      // A different output is a different series and therefore a different set of complete years:
      // the one on the selector may not exist under this KPI at all.
      this.seatShapeYear()
    },
    // One month along, either way, wrapping at both ends: December comes round to January going
    // right and January to December going left. Held in 0..11 so the two arrows are each other's
    // undo and twelve of either is where it started.
    onShapeImportShift (by) {
      this.shapeImportShift = (this.shapeImportShift + by + COMPOSE_MONTHS) % COMPOSE_MONTHS
    },
    onShapeImportYear (year) {
      this.shapeImportYear = year === undefined ? null : year
    },
    // WHICH YEAR THE DIALOG STANDS ON once the series under it has changed. The average, which is
    // what it opens on and the answer that carries what comes back every year rather than what
    // happened in one; the single year a model with one complete year has, there being no average
    // of one; and the year already chosen, wherever this KPI has it too — a reader who asked for
    // 2023 and then changed the output was not asking to go back to the average.
    seatShapeYear () {
      const years = this.shapeImportYears
      if (years.length === 1) {
        this.shapeImportYear = years[0]
        return
      }
      if (years.indexOf(Number(this.shapeImportYear)) === -1) this.shapeImportYear = null
    },

    // THE YEAR ACCEPTED. It goes in through applyRevenueShape and not around it, which is what makes
    // this the same statement the two buttons beside it make: the row is renormalised to a mean of
    // one, so the total typed above stands untouched and with it the Total ROAS and the marketing
    // attribution, and the only things that move are the columns and every reading that was
    // per-month all along.
    //
    // The name becomes `custom` because that is what it is — a year that is not the flat opening —
    // and where it came from rides beside it in revenueShapeSource, which is the only thing that
    // will tell a borrowed year from a drawn one once the payload is written.
    applyShapeImport () {
      const shape = this.shapeImportShape
      if (!shape) return
      const model = this.modelById(this.shapeImportModelId)
      const source = {
        model_id: this.shapeImportModelId,
        model_name: model ? model.name || null : null,
        kpi: this.shapeImportKpi,
        year: this.shapeImportYear,
        // Months the borrowed year was moved along before it was accepted, 0 for one taken as the
        // model reports it. Without it the twelve multipliers beside this could not be recognised as
        // that model's year at all.
        shift_months: this.shapeImportShift
      }
      // THE SEASON LANDS CONVERTED, which is what the preview has been drawing all along: the source
      // states a share of each month's revenue and this wizard draws a share of each month's base.
      // A year that converts to twelve zeros is not written at all — the section is left as it
      // opens, which is the composer saying it does not know when this business sells rather than
      // asserting that it never does.
      // AN OTHER INPUT TAKES THE SHAPE AND KEEPS ITS TOTAL, which is why the dialog will not apply
      // one to a card with no total: the source's own amounts are in its own currency and its own
      // market, and neither says anything about what this brand or its competition spent.
      if (this.shapeImportOther) {
        const key = this.shapeImportOtherKey
        const total = this.shapeImportOtherTotal
        if (!key || !(total > 0)) return
        const values = this.otherValues(key).map((value, index) => total * shape[index % shape.length] / COMPOSE_MONTHS)
        this.setOtherSeries(key, values, true)
        this.otherSpendSource = Object.assign({}, this.otherSpendSource, {
          [key]: Object.assign({}, source, { kpi: null, series: this.shapeImportSeries })
        })
        this.shapeImportDialog = false
        return
      }
      if (this.shapeImportSigned) {
        const shares = this.shapeImportSeason
        if (!shares) return
        const drawn = shares.year.some(value => Number(value) !== 0)
        this.drawnSeasonality = drawn ? shares.year : null
        this.seasonalitySource = drawn ? source : null
        this.rebuild()
        this.shapeImportDialog = false
        return
      }
      this.revenueShapeName = COMPOSE_SHAPE_CUSTOM
      this.revenueShapeSource = source
      this.applyRevenueShape(shape)
      // And the dialog goes: the row it just wrote is behind it, and a panel left standing over the
      // twelve columns says the choosing is still the work.
      this.shapeImportDialog = false
    },

    // ONE MONTH, TYPED IN THE MONEY IT IS DRAWN IN — and the one edit on this page that RESIZES the
    // year rather than redistributing it.
    //
    // The five shapes above move the columns around a total that was typed into the field over them;
    // this says what a single month sold, and the honest consequence is that the other eleven stay
    // exactly where they are and the total moves by the difference. A January raised by fifty
    // thousand is a business that sold fifty thousand more, not one that sold the same and took it
    // out of February — that second statement is available and is what dragging a shape does.
    //
    // So the revenue follows the row here rather than the row following the revenue, and everything
    // downstream of the revenue follows it as it always did: the marketing attribution is what the
    // curves return over the new total, and no curve, no spend cell and no seasonality moves. The
    // walls are the revenue's own two, asked of a month — see composeRevenueMonthAt — and where one
    // of them holds the figure it is said in words, exactly as a held revenue is.
    onRevenueMonthChange (payload) {
      const at = payload && payload.index
      const months = this.kpiVector
      if (!(at >= 0) || at >= months.length) return
      const typed = this.parseAmount(payload.value)
      // A figure that is not one re-keys the field and nothing else, which puts the month back on
      // screen: the same answer the revenue box gives to text nobody can read as money.
      if (!isFinite(typed)) {
        this.formKey++
        return
      }
      const marketing = this.ready ? cloneMarketing(this.formState) : null
      const ceiling = marketing === null ? null : composeRevenueCeiling(marketing)
      const held = composeRevenueMonthAt(months, at, typed, ceiling, this.revenueLeast)
      const shape = composeRevenueShapeOf(held.months)
      if (shape === null) return
      const total = held.months.reduce((sum, value) => sum + value, 0)
      this.revenueTouched = true
      this.revenueShapeName = COMPOSE_SHAPE_CUSTOM
      this.revenueShapeSource = null
      this.revenueShapeValues = shape
      if (!(this.revenueAnchor > 0)) {
        this.revenueAnchor = total
        this.revenueFactor = 1
      } else {
        this.revenueFactor = total / this.revenueAnchor
      }
      this.rebuild()
      // After the rebuild, which clears it — the same order every other note on this page is written
      // in. It names the month's own wall rather than the year's, that being what was typed.
      if (held.reason) {
        this.revenueNote = this.$t(
          `components.ekrm.CreateModelCompose.monthHeld_${this.monthHeldReason(held.reason)}`, {
            month: this.monthLabels[at] || '',
            amount: this.formatMoney(held.months[at])
          })
      }
    },

    // The month's components, each with the colour it is drawn in on the column beside it and its
    // own sign. The season and the spot events are left out where there are none and the media where
    // no channel carries a curve yet: a row reading '+ 0' would be a component that contributed
    // nothing rather than one nobody has claimed.
    //
    // THE TWO DRAWN YEARS ARE ONE ROW OF THIS TOOLTIP, which is what the column beside it draws:
    // they are the same amber and stack into one band, and a legend naming two things over a band
    // that shows one is the reading disagreeing with the picture. Summed, and named the way the
    // waterfall names the bar it credits them both to.
    revenueBarParts (entry, hasMedia) {
      const signed = amount => `${amount < 0 ? '−' : '+'} ${this.formatMoney(Math.abs(amount))}`
      const spot = Number(entry.spot) || 0
      const shapes = entry.season + spot
      const parts = [{
        name: this.$t('components.simulationDetails.SalesDecomposition.base'),
        value: this.formatMoney(entry.total - entry.media - entry.season - spot),
        color: REVENUE_COLOR
      }]
      if (shapes !== 0) {
        parts.push({ name: this.seasonalityLabel, value: signed(shapes), color: SEASONALITY_COLOR })
      }
      if (hasMedia) {
        parts.push({ name: this.marketingLabel, value: signed(entry.media), color: MARKETING_COLOR })
      }
      return parts.length > 1 ? parts : null
    },
    // The month's own split, spelled out on hover: the figure the column is worth and the components
    // it is made of, signed, in the order they are stacked. Nothing about the season is said where
    // there is none — a '+ 0' would be a component that contributed nothing rather than one nobody
    // has claimed — and nothing about the media where no channel carries a curve yet.
    revenueBarTitle (month, entry, hasMedia) {
      const head = `${month}: ${this.formatMoney(entry.total)}`
      const spot = Number(entry.spot) || 0
      if (!hasMedia && entry.season === 0 && spot === 0) return head
      const parts = [this.formatMoney(entry.total - entry.media - entry.season - spot)]
      if (entry.season !== 0) {
        parts.push(`${entry.season < 0 ? '−' : '+'} ${this.formatMoney(Math.abs(entry.season))}`)
      }
      if (spot !== 0) {
        parts.push(`${spot < 0 ? '−' : '+'} ${this.formatMoney(Math.abs(spot))}`)
      }
      if (hasMedia) parts.push(`+ ${this.formatMoney(entry.media)}`)
      return `${head} = ${parts.join(' ')}`
    },
    // One channel's readChannel output, out of the per-model cache. The build reads it through
    // composeEntries below; the CARDS read it directly, because a channel that has not been stated
    // yet has no entry in the build at all and its card still has a shape to draw and a decay to lay
    // out on the row's own grid.
    readFor (channel) {
      // A channel invented here reads off the generated one. Same structure, same fields, nothing
      // downstream told apart: the card draws it, the editor bends it and the build places it
      // exactly as it does a medium lifted out of a report. It is a constant and not a per-channel
      // object on purpose — the ONE thing a scratch channel's uid owns is what the user has said
      // about it, which is already held in statedCurves, curveEdits and decayEdits, all of them
      // ratios and kernels measured against this shape.
      if (channel.scratch) return SCRATCH_READ
      const source = this.models[channel.modelId]
      if (!source) return null
      const found = source.imported.kept.filter(entry => entry.raw === channel.raw)[0]
      return found ? found.read : null
    },
    // Everything the build needs, per channel, assembled from the caches above. Nothing about the
    // model a channel came from travels beyond its name: its size and its currency used to, and are
    // exactly what a shape no longer carries.
    composeEntries () {
      const entries = []
      this.channels.forEach(channel => {
        const source = this.models[channel.modelId]
        const read = this.readFor(channel)
        // The source is required of an IMPORTED channel and of nothing else: it is where the model's
        // name and its KPI are read from, and a channel nobody imported has neither.
        if ((!source && !channel.scratch) || !read) return
        entries.push({
          uid: channel.uid,
          raw: channel.raw,
          label: channel.label,
          modelId: channel.modelId,
          scratch: !!channel.scratch,
          modelName: source ? (source.model.name || channel.modelId) : null,
          read: read
        })
      })
      return entries
    },

    rebuild () {
      this.roasNote = null
      this.spendNote = null
      this.revenueNote = null
      this.shareNote = null
      this.built = buildComposeForm(this.composeEntries(), {
        // The two figures per channel that place its curve, and the only thing the build needs
        // before there is any money on the page. Everything below reads the curves they placed.
        statedCurves: this.statedCurves,
        // The size of the business, which sizes the KPI row and nothing else: no curve and no spend
        // cell is a function of it. What it moves is the marketing attribution, which is what the
        // media are credited with over it.
        revenue: this.revenue,
        revenueShape: this.revenueShapeValues,
        seasonalityShape: this.drawnSeasonality,
        spotShape: this.drawnSpot,
        category: this.name,
        market: this.market,
        spendFactor: this.spendFactor,
        spendFactors: this.mixFactors,
        spendShapes: this.spendShapes,
        curveEdits: this.curveEdits,
        decayEdits: this.decayEdits,
        otherSpend: this.otherSpend,
        otherAttribution: this.otherAttribution,
        futureTrends: FUTURE_TRENDS_ENABLED ? this.futureTrends : null,
        t: key => this.$t(GRID_LABEL_NAMESPACE + key)
      })
      this.formKey++
    },

    resetFactors () {
      this.spendFactor = 1
      this.mixFactors = {}
      this.spendShapes = {}
      this.roasNote = null
      this.spendNote = null
      this.revenueNote = null
      this.shareNote = null
    },
    // Typed figures come back through numbro, so "15m", "15M", "15,000,000" and "15000000" are all
    // the same answer — the fields show what the boxes showed, which is the compact form, and what a
    // field shows has to be something it will take back. numbro.unformat matches its abbreviations
    // in lower case only and returns undefined rather than NaN for anything it cannot read.
    parseAmount (value) {
      const text = String(value === null || value === undefined ? '' : value).trim()
      if (text === '') return NaN
      const direct = Number(text)
      if (isFinite(direct)) return direct
      const parsed = numbro.unformat(text)
      if (isFinite(parsed)) return Number(parsed)
      const lowered = numbro.unformat(text.toLowerCase())
      return isFinite(lowered) ? Number(lowered) : NaN
    },
    // One factor over every channel and every month, so the split between the media and the shape of
    // the year hold still however far the total is moved.
    //
    // HELD AT BOTH ENDS OF THE CORRIDOR, which is what the two labels under the axis promise: a
    // figure typed past Min. spend or past Max spend lands on the level that label names, and the
    // note under the box says which. See spendRatioWithin, which is also where the two ends are
    // distinguished — the low one is a wall the build refuses to go under, the high one is the end
    // of what the chart draws.
    //
    // WHAT IS STILL NOT A WALL is everything the revenue says about the spend. Spending past the
    // revenue, crowding out the base and the band reaching its own cap are warnings this wizard says
    // in words and lets the user answer — see revenueBelowSpend, baseWarning and the "Create anyway"
    // dialog — and none of them narrows this corridor. It is the media talking about themselves at
    // the low end and the window at the high end, and a spend legal on an empty page stays legal
    // however the revenue below it is answered.
    //
    // A RATIO OF ZERO IS A REQUEST FOR THE LOW END rather than a refusal, which is what "0" typed in
    // the box means: nobody is proposing to spend nothing on media — the payload has no such EKRM in
    // it — they are asking how little this plan may spend, and the corridor is where the answer
    // lives. It arrives here as any other figure outside the corridor does and is held at the same
    // end, with the same note under the box saying which. Anything actually negative or unreadable
    // is still refused in the plainest way there is: the field goes back to what the page says.
    applySpendRatio (ratio) {
      if (!(ratio >= 0) || !isFinite(ratio)) {
        this.formKey++
        return
      }
      const held = this.spendRatioWithin(ratio)
      if (!(held.ratio > 0)) {
        this.formKey++
        return
      }
      this.spendFactor = this.spendFactor * held.ratio
      this.rebuild()
      // THE DEPENDENT FIGURE FOLLOWS, before this one's own note is written: seatRevenue rebuilds
      // where it moves anything, and a rebuild clears every note on the page. The revenue's note is
      // written inside it and the spend's below, so a move that held both figures says both.
      this.seatRevenue()
      if (held.reason) {
        const key = 'components.ekrm.CreateModelCompose.'
        this.spendNote = this.$t(key + 'spendHeld',
          { spend: this.formatMoney(this.totals.spendTotal) }) +
          ' ' + this.$t(`${key}trade_${held.side}_${held.reason}`)
      }
    },
    // The same ratio, or the nearest end of the corridor this plan may spend inside — see
    // tradeCorridor, whose two ends are the two levels named under the axis. A figure typed outside
    // it lands ON it, at both ends, which is the whole of what those labels promise: the chart says
    // this is as far as it goes and the box agrees.
    //
    // THE TWO ENDS ARE NOT THE SAME KIND OF WALL, and the note under the box says which one was hit.
    //
    // The low end is a limit the build refuses to go under: beneath it either the marketing
    // attribution band rounds away to nothing or some medium's own twelve cells do, and both are
    // errors the save cannot get past. It is read off tradeLimits, in multiples of what the form
    // carries now, and a limit above one is a plan already standing under its own wall — which the
    // ratio then raises rather than lowers, that being the honest answer to "how far may this move"
    // for a plan that should not be where it is. Where that wall lies BELOW the window this chart
    // draws — which is the ordinary case, it being orders of magnitude under any plan the cards
    // describe — the box stops at the start of the window instead, that being the level the Min.
    // spend label names and the only low end the reader has ever been shown.
    //
    // The high end is the end of what the chart DRAWS. Nothing about these media bounds a spend from
    // above — the three ends that would are each read against the revenue, and each is said in words
    // below rather than drawn as a wall, see tradeLimits — so what stops a figure there is the
    // window rather than the build. It stops it all the same: a box that took a level the chart
    // beside it cannot show is a figure with no picture, and the trade-off is the whole reason the
    // two are in one card.
    //
    // Every way of setting the spend passes through here and every one of them stops at both ends:
    // the typed total, the solved ROAS, a level taken off the chart (already inside this corridor)
    // and seatSpend, which is where the low limit came from in the first place.
    spendRatioWithin (ratio) {
      if (!this.ready || !(this.spendFactor > 0)) return { ratio: ratio, side: null, reason: null }
      const limits = this.tradeLimits
      const wall = limits && limits.min ? Number(limits.min.factor) : NaN
      // AND THE LOW END IS THE CORRIDOR'S, not the wall's alone — the same end the Min. spend label
      // names. The wall is usually orders of magnitude beneath the window this chart draws (see
      // cloneTradeWindow, which only reaches down for a limit within WINDOW_REACH of the frame), and
      // clamping to the wall itself landed a figure typed below the box on a level the chart had
      // never shown: 1 typed under a Min. spend of 3.6k seated the plan at 736, the axis then
      // recentred on it, and the label that had promised 3.6k read 736 a moment later. So the floor
      // the box stops at is the higher of the two — the wall where the wall is inside the window,
      // the start of the window where it is not — which is exactly what tradeCorridor.from is and
      // exactly what the label under the axis says.
      //
      // A plan standing UNDER its own wall is still raised to it: the wall then stands above the
      // window's start (the window is drawn around where the plan is), so it is the higher end and
      // it is the one that binds. That is seatSpend's case and it is unchanged.
      const edge = this.tradeBounds.from / this.spendFactor
      const walled = isFinite(wall) && wall * (1 + SEAT_EPSILON) >= edge
      const low = walled ? wall : edge
      // Past the end by more than the end's own rounding, for the reason seatSpend spells out: a
      // plan already standing ON this limit — one click of Min. spend away — reports the limit
      // back as one-and-a-rounding, so a move that would leave it exactly where it is reads as a
      // move under the floor. Holding it there is a no-op that announces itself in an alert.
      if (isFinite(low) && low > 0 && low > ratio * (1 + SEAT_EPSILON)) {
        return { ratio: low, side: 'min', reason: walled ? limits.min.reason : 'window' }
      }
      // And the same margin at the top, where the end is the corridor's own rather than a limit's:
      // the level Max spend takes the form to, in multiples of what it carries now. A plan already
      // standing at the end of the window reports it back as one-and-a-rounding, and holding it
      // there would announce a move that did not happen.
      const high = this.tradeCorridor.to / this.spendFactor
      if (isFinite(high) && high > 0 && high * (1 + SEAT_EPSILON) < ratio) {
        return { ratio: high, side: 'max', reason: 'window' }
      }
      return { ratio: ratio, side: null, reason: null }
    },
    // A channel's own twelve months as the grid carries them BEFORE the level and the mix: the flat
    // year composeCells wrote, times whatever months have been typed on the chart. The same
    // multiplication shapeSpendCells does on the way into the form, done here so that anything
    // measuring a channel against its own row — a floor, a share of the plan — measures the row that
    // is actually drawn rather than the one it opened as.
    shapedSpendCells (index) {
      const item = this.built && this.built.built ? this.built.built[index] : null
      const cells = item ? item.cells.spendCells : []
      const medium = this.built && this.built.media ? this.built.media[index] : null
      const shape = medium ? this.spendShapes[medium.uid] : null
      return cells.map((cell, month) => {
        const value = Number(cell) || 0
        if (!Array.isArray(shape)) return value
        const factor = Number(shape[month])
        return isFinite(factor) && factor >= 0 ? value * factor : value
      })
    },
    // ONE MONTH OF ONE CHANNEL — OR SEVERAL OF THEM AT ONCE — TYPED IN THE MONEY THE COLUMN IS DRAWN
    // IN. The chart's counterpart to the revenue row's typed month, and the same kind of statement:
    // this is what that medium buys in that month, and the other eleven stay exactly where they are.
    //
    // SEVERAL AT ONCE because a column here is not one figure. The revenue row's month is a single
    // amount and a single field over the column will do; a spend month is the media stacked, and
    // asking for them one band at a time would be asking the reader to hit a three-pixel segment.
    // So the card that already names the column's split on hover is what opens, with every channel
    // in it as a field, and everything that was retyped in it arrives here together — which also
    // means the year is resized once rather than once per channel.
    //
    // What is stored is a MULTIPLIER and not the amount, for the reason every other edit on this
    // page is a ratio: the level above and the mix beside it go on moving this cell, and a stated
    // figure would be one that stopped following them. The typed amount is divided by exactly what
    // those two make of the channel's own flat cell, so the column reads back the figure that was
    // typed into it.
    //
    // ZERO IS AN ANSWER. A medium bought in some months and not others is an ordinary plan and the
    // payload states it without complaint — and so is a medium bought in none of them, which is a
    // channel carried for its curve.
    onSpendMonthChange (payload) {
      const at = payload && payload.index
      const edits = (payload && payload.values) || []
      if (!this.ready || !(at >= 0) || at >= this.monthCount || edits.length === 0) return

      const applied = this.applySpendCellEdits(
        edits.map(edit => ({ index: Number(edit.index), at: at, value: edit.value })))

      // Nothing readable, or nothing that moved: the card shuts and the columns stand where they
      // were.
      if (!applied.wrote) {
        this.formKey++
        return
      }
      this.spendTouched = true
      this.spendShapes = applied.shapes
      this.rebuild()
      // A year reshaped is a year that returns something else, so both figures below it are re-seated
      // exactly as they are after a curve edit: the spend against the corridor the media leave, and
      // then the revenue against the walls the media have just moved.
      this.seatSpend('months')
      this.seatRevenue()
    },
    // ONE CELL OF THE SPEND GRID, WRITTEN AS A MULTIPLIER — the arithmetic behind both ways of
    // typing a spend cell on this page: a column of the chart, where the month is fixed and the
    // media vary, and the table under it, where anything may vary.
    //
    // It computes and RETURNS the shapes rather than committing them, so each caller re-seats after
    // its own gesture. Nothing here rebuilds and nothing here touches the form.
    applySpendCellEdits (edits) {
      const media = this.built.media
      const shapes = Object.assign({}, this.spendShapes)
      let wrote = false

      edits.forEach(edit => {
        const index = Number(edit.index)
        const at = Number(edit.at)
        const medium = media[index]
        const item = this.built.built[index]
        if (!medium || !item || !(at >= 0) || at >= this.monthCount) return
        const typed = this.parseAmount(edit.value)
        // A figure that is not one says nothing at all, and the rebuild the caller runs puts the
        // cell back: the same answer every other box on this page gives to text nobody can read as
        // money.
        if (!isFinite(typed) || typed < 0) return
        // What the cell would be worth at a multiplier of one — the channel's flat year, at the
        // level and the mix the plan currently stands at. Both of those go on moving it afterwards.
        const base = item.cells.spendCells
        const factored = this.spendFactor * this.mixFactorFor(medium.uid)
        const unit = (Number(base[at]) || 0) * factored
        if (!(unit > 0)) return

        const shape = Array.isArray(shapes[medium.uid]) ? shapes[medium.uid].slice() : []
        while (shape.length < this.monthCount) shape.push(1)
        const before = shape[at]
        shape[at] = typed / unit
        if (shape[at] === before) return
        shapes[medium.uid] = shape
        wrote = true
      })

      return { wrote: wrote, shapes: shapes }
    },
    // THE WHOLE YEAR AT ONCE, TYPED OR PASTED INTO THE TABLE.
    //
    // jspreadsheet hands back its entire data array on every change, so what arrives here is the
    // grid as it now stands rather than the cell that moved. The cells that MOVED are found by
    // reading it against `spendSheetValues`, which is still the pre-edit form at this point —
    // nothing has been written yet — and only those go through as edits. That matters for more than
    // speed: rewriting a multiplier the user did not touch would divide and re-multiply every cell
    // in the plan on every keystroke, and the year would drift in the last bit a pasted column at a
    // time.
    //
    // A pasted block is one gesture and is applied as one: the year is resized once, both figures
    // below it are re-seated once, and the total, the return and the bands above all follow within
    // the same tick, which is the whole of what makes this table a view of the spend rather than a
    // second copy of it.
    onSpendSheetInput (rows) {
      if (!this.ready || !Array.isArray(rows)) return
      const was = this.spendSheetValues
      // The grid says exactly what the form says: a change event over nothing, which jspreadsheet
      // also sends for a cell retyped to the figure it already held.
      if (this.sameSheetCells(was, rows)) return
      const edits = []
      rows.forEach((row, index) => {
        const before = was[index]
        if (!Array.isArray(row) || !Array.isArray(before)) return
        for (let at = 0; at < this.monthCount; at++) {
          const typed = this.parseAmount(row[at + 1])
          if (!isFinite(typed) || typed < 0) continue
          if (this.sameAmount(typed, Number(before[at + 1]) || 0)) continue
          edits.push({ index: index, at: at, value: typed })
        }
      })
      // Something moved but nothing in it is money — a cell cleared, or text jspreadsheet sanitised
      // to nothing. The grid goes back to the form it never left, which is the same answer every
      // other box on this page gives to a figure it cannot read.
      if (edits.length === 0) {
        this.resetSheet('spendSheet')
        return
      }

      const applied = this.applySpendCellEdits(edits)
      // Nothing that moved, or nothing readable: the watcher puts the grid back to the form it never
      // left.
      if (!applied.wrote) {
        this.resetSheet('spendSheet')
        this.formKey++
        return
      }
      this.spendTouched = true
      this.spendShapes = applied.shapes
      this.rebuild()
      // Exactly what a typed column does, and for the same reason: a year reshaped is a year that
      // returns something else, so the spend is re-seated against the corridor the media leave and
      // the revenue against the walls they have just moved. Each writes its own note where it moved
      // something.
      this.seatSpend('months')
      this.seatRevenue()
    },
    // The grid back to the form, cells and all. The mirror is rebuilt from what the payload actually
    // carries and the component is remounted around it: jspreadsheet has already painted the refused
    // figure into its own DOM, and setData alone is not reliably enough to take it back out of a cell
    // the user is still standing in.
    // THE SAME MACHINERY, SAID ONCE FOR BOTH GRIDS. `name` is the prefix the three pieces of state
    // share — `<name>Rows`, `<name>Values`, `<name>Key` — which is what lets one method serve the
    // spend's table and the year's without either knowing about the other.
    //
    // The mirror is rebuilt from what the form actually carries and the component is remounted
    // around it: jspreadsheet has already painted the refused figure into its own DOM, and setData
    // alone is not reliably enough to take it back out of a cell the user is still standing in.
    resetSheet (name) {
      this[name + 'Rows'] = this[name + 'Values'].map(row => row.slice())
      this[name + 'Key']++
    },
    // The other half of the sync, and the half that makes either table a VIEW of the form rather
    // than a second copy of it: whatever moves the plan underneath rewrites the mirror
    // within the tick.
    //
    // ONLY WHERE A FIGURE ACTUALLY MOVED — a cell typed here goes into the form and comes back out
    // as very nearly the same number, off by the last bit of the arithmetic between, and a bare
    // assignment would call setData after every commit and take the selection out from under the
    // user mid-row. And a COPY, which is load-bearing: jspreadsheet keeps the array it is handed
    // and edits it in place, so handing it a computed's own cached array would let a keystroke
    // rewrite the pre-edit state the diff is read against.
    syncSheet (name, rows) {
      const held = this[name + 'Rows']
      if (this.sameSheetCells(rows, held)) return
      // A grid whose row count has changed is a grid drawn wrong, not one with stale cells.
      if (rows.length !== held.length) this[name + 'Key']++
      this[name + 'Rows'] = rows.map(row => row.slice())
    },
    // The header of a one-row month grid: the row's own name, then one column per month.
    //
    // THE NAME COLUMN IS NOT DECORATION. jspreadsheet refuses a paste that begins in column zero —
    // see onbeforepaste in Spreadsheet.vue, which is what keeps a pasted block from overwriting the
    // series names of the grid CreateEkrm draws — so a table whose first column was January is one
    // a year could not be pasted into.
    monthSheetColumns (labels, extra, title) {
      const columns = [{
        type: 'text',
        title: title || '',
        width: '200px',
        readOnly: true,
        wordWrap: true,
        align: 'left'
      }]
      labels.forEach(label => {
        columns.push(Object.assign({
          type: 'numeric',
          title: label || '',
          width: '110px',
          decimal: '.',
          allowEmpty: true
        }, extra))
      })
      return columns
    },
    // WHAT A ROW IS CALLED, AND THE UNIT IN THE NAME. The three rows these two grids hold between
    // them are not in one unit — a revenue is money and the two years are percentages of it — and a
    // grid has one format per COLUMN, not per cell. So the cells are left as bare figures and each
    // row says what its own are: the alternative is a column that prints a dollar sign over a share
    // of a month.
    sheetRowName (key) {
      return this.$t(`components.ekrm.CreateModelCompose.${key}`)
    },
    // The cells of a one-row grid that actually moved, read against the mirror the form last wrote.
    // The argument is the spend table's: jspreadsheet hands back the whole row on every change,
    // and putting a month nobody touched back through the arithmetic would let the year drift in
    // the last bit a pasted block at a time. Anything unreadable is passed over rather than read as
    // a zero — a cleared cell is not a month that sold nothing.
    monthSheetEdits (was, rows, index) {
      const before = was[index]
      const row = Array.isArray(rows) ? rows[index] : null
      const edits = []
      if (!Array.isArray(row) || !Array.isArray(before)) return edits
      for (let at = 0; at + 1 < before.length; at++) {
        const typed = this.parseAmount(row[at + 1])
        if (!isFinite(typed)) continue
        if (this.sameAmount(typed, Number(before[at + 1]) || 0)) continue
        edits.push({ at: at, value: typed })
      }
      return edits
    },
    // ---------------------------------------------------------------------------------------
    // The other inputs: co-marketing and competition spend
    // ---------------------------------------------------------------------------------------

    // One series written and the form rebuilt around it. A year that sums to nothing is stored as
    // blank, which is what writeOtherSpend would send for it anyway.
    //
    // Where the year came from goes with any edit that changes its shape — a month typed, a paste, a
    // flatten — and stays with one that only resizes it: that is `keepSource`.
    setOtherSeries (key, values, keepSource) {
      const total = Array.isArray(values) ? values.reduce((sum, value) => sum + (Number(value) || 0), 0) : 0
      this.otherSpend = Object.assign({}, this.otherSpend, { [key]: total > 0 ? values : null })
      if (!keepSource || !(total > 0)) {
        this.otherSpendSource = Object.assign({}, this.otherSpendSource, { [key]: null })
      }
      // A series with no spend has nothing to be credited with, and a share left standing over a
      // blank card would come back the moment a figure was typed, unasked.
      if (!(total > 0)) {
        this.otherAttribution = Object.assign({}, this.otherAttribution, { [key]: null })
      }
      this.rebuild()
    },
    // The series as twelve numbers, zeros where it is blank.
    otherValues (key) {
      const values = this.otherSpend[key]
      return Array.isArray(values) ? values.slice() : new Array(this.monthCount).fill(0)
    },
    // A total typed rescales the year it already has, or spreads evenly over one that has none.
    // Emptied or zero, the series goes blank; anything unreadable leaves it as it was, and the
    // rebuild re-keys the field back onto it.
    onOtherTotalChange (key, value) {
      const typed = this.parseAmount(value)
      if (String(value).trim() === '' || typed === 0) {
        this.setOtherSeries(key, null)
        return
      }
      if (!isFinite(typed) || typed < 0) {
        this.rebuild()
        return
      }
      const values = this.otherValues(key)
      const total = values.reduce((sum, month) => sum + month, 0)
      this.setOtherSeries(key, total > 0
        ? values.map(month => month * typed / total)
        : values.map(() => typed / values.length), true)
    },
    // What the preview's Input Over Time calls an other input's one series — the report's own name
    // for it, the variable followed by 'Input'.
    previewInputName (other) {
      return this.$t('components.ekrm.CreateModelCompose.inputSeriesName', { name: other.label })
    },
    // THE SHARE-OF-SALES FIELD beside a card's average month. Open only once the series has a spend
    // to be credited for; the figure on it is what the build wrote, so a co-marketing share held
    // under the room the other rows leave shows where it was held, and the line under it says why —
    // or, where nothing was held, what the share comes to in money.
    otherAttributionAside (key, total) {
      const t = name => this.$t(`components.ekrm.CreateModelCompose.${name}`)
      const stated = this.otherAttribution[key]
      const written = this.built && this.built.otherAttribution ? this.built.otherAttribution[key] : null
      const shown = written !== null && written !== undefined ? written : stated
      let hint = ''
      if (!(total > 0)) {
        hint = t('otherAttributionNeedsSpend')
      } else if (stated !== null && this.built && Math.abs((Number(written) || 0) - stated) > 0.005) {
        // Held, down to nothing where the other rows leave no room at all — written is then null.
        hint = this.$t('components.ekrm.CreateModelCompose.otherAttributionHeld', { cap: this.roundShare(Number(written) || 0) })
      } else if (stated === null) {
        hint = t('otherAttributionBlank')
      } else if (this.moneyReady && this.totals.kpiTotal > 0) {
        hint = this.$t('components.ekrm.CreateModelCompose.otherAttributionHint',
          { amount: this.formatMoney(this.totals.kpiTotal * shown / 100) })
      }
      return {
        label: t('otherAttribution'),
        value: shown !== null && shown !== undefined ? String(this.roundShare(shown)) : '',
        editable: total > 0,
        inputKey: `other_attribution_${key}_${this.formKey}`,
        title: t(key === 'competition' ? 'otherAttributionInfoCompetition' : 'otherAttributionInfo'),
        hint: hint
      }
    },
    // The card's two side fields: the average month, and the share of sales.
    onOtherAsideInput (key, payload) {
      if (payload && payload.index === 1) {
        this.onOtherAttributionChange(key, payload.value)
        return
      }
      this.onOtherAvgChange(key, payload)
    },
    // THE SHARE OF SALES A SERIES IS CREDITED WITH, typed. It cannot be emptied: a blank, a zero or
    // anything unreadable re-keys the field back onto the share it had. A competition share is
    // negative by definition, so one typed without its sign is read as the negative it can only be,
    // and both are held inside the range the builder accepts for them — co-marketing further, at
    // build, under what the other rows leave, which the hint then names.
    onOtherAttributionChange (key, value) {
      const text = String(value === null || value === undefined ? '' : value).replace('%', '').trim()
      const typed = text === '' ? NaN : this.parseAmount(text.replace('\u2212', '-'))
      const share = isFinite(typed)
        ? this.roundShare(key === 'competition'
          ? -Math.min(MAX_ATTRIBUTION_SHARE, Math.abs(typed))
          : Math.max(0, Math.min(MAX_ATTRIBUTION_SHARE, typed)))
        : 0
      if (share === 0) {
        this.formKey++
        return
      }
      this.otherAttribution = Object.assign({}, this.otherAttribution, { [key]: share })
      this.rebuild()
    },
    // A GROWTH BAND, typed or dragged. Either edge may arrive as text with a percent sign or a
    // typographic minus; anything unreadable keeps the edge it had, both are held inside what the
    // payload accepts, and a band typed upside down is put the right way up.
    onGrowthChange (key, band) {
      const current = this.futureTrends[key]
      const read = (value, fallback) => {
        const text = String(value === null || value === undefined ? '' : value)
          .replace('%', '').replace('\u2212', '-').replace('+', '').trim()
        const typed = text === '' ? NaN : Number(text.replace(',', '.'))
        if (!isFinite(typed)) return fallback
        return Math.round(Math.max(-100, Math.min(100, typed)) * 10) / 10
      }
      let min = read(band.min, current.min)
      let max = read(band.max, current.max)
      if (min > max) {
        const swap = min
        min = max
        max = swap
      }
      this.futureTrends = Object.assign({}, this.futureTrends, { [key]: { min: min, max: max } })
      // Off, the band is only the card's: the build never reads it, so there is nothing to redo.
      if (FUTURE_TRENDS_ENABLED) this.rebuild()
    },
    onOtherAvgChange (key, payload) {
      const raw = payload ? payload.value : ''
      const typed = this.parseAmount(raw)
      this.onOtherTotalChange(key, isFinite(typed) ? typed * this.monthCount : raw)
    },
    // One month typed on its column; the other eleven stand still and the total follows.
    onOtherMonthChange (key, payload) {
      const typed = this.parseAmount(payload ? payload.value : '')
      if (!isFinite(typed) || typed < 0) {
        this.rebuild()
        return
      }
      const values = this.otherValues(key)
      values[payload.index] = typed
      this.setOtherSeries(key, values)
    },
    // Randomize and Flatten move the months against each other and are rescaled back onto the total
    // they found, as the Sales row's are; a shift only changes which month is which, so it keeps
    // where the year came from as well.
    onOtherAction (key, action) {
      const values = this.otherValues(key)
      const total = values.reduce((sum, month) => sum + month, 0)
      const onto = row => {
        const sum = row.reduce((acc, month) => acc + month, 0)
        return sum > 0 ? row.map(month => month * total / sum) : row
      }
      if (action === 'clear') {
        this.setOtherSeries(key, null)
      } else if (action === 'randomize') {
        if (!(total > 0)) return
        this.setOtherSeries(key, onto(values.map(month => month * (1 + SHAPE_JITTER * (2 * Math.random() - 1)))))
      } else if (action === 'flatten') {
        if (!(total > 0)) return
        const mean = total / values.length
        this.setOtherSeries(key, onto(values.map(month => month + (mean - month) * SHAPE_PULL)))
      } else if (action === 'shiftLeft' || action === 'shiftRight') {
        if (!(total > 0)) return
        const by = action === 'shiftLeft' ? -1 : 1
        this.setOtherSeries(key, values.map((month, index) => values[(index - by + values.length * 2) % values.length]), true)
      } else if (action === 'import') {
        this.openShapeImport('other', key)
      }
    },
    toggleOtherSheet (key) {
      this[key + 'SheetOpen'] = !this[key + 'SheetOpen']
    },
    // The row typed or pasted at once, on the revenue table's terms: only the cells that moved go
    // through, and a grid where nothing readable moved goes back to the row it never left.
    onOtherSheetInput (key, rows) {
      if (!Array.isArray(rows)) return
      const was = this[key + 'SheetValues']
      if (this.sameSheetCells(was, rows)) return
      const edits = this.monthSheetEdits(was, rows, 0)
      if (edits.length === 0) {
        this.resetSheet(key + 'Sheet')
        return
      }
      const values = this.otherValues(key)
      edits.forEach(edit => { values[edit.at] = Math.max(edit.value, 0) })
      this.setOtherSeries(key, values)
    },
    // The table's one row: the series' name and unit, then its twelve months, blank where it is.
    otherSheetRow (key, label) {
      const values = this.otherSpend[key]
      const name = `${this.sheetRowName(label)} (${this.ekrmUnit})`
      return [[name].concat(Array.isArray(values)
        ? values.map(value => Number(value) || 0)
        : new Array(this.monthCount).fill(''))]
    },
    // The columns of one other input, drawn as the revenue card draws the sales: each month as a
    // share of the tallest, and the year beside them at its own scale.
    otherRow (values, label) {
      const labels = this.monthLabels
      const top = Math.max.apply(null, values.concat([0]))
      const year = values.reduce((sum, value) => sum + value, 0)
      const empty = { season: 0, spot: 0, media: 0, below: 0, belowSpot: 0, parts: null }
      const bars = values.map((value, index) => {
        const month = labels[index] || ''
        return Object.assign({}, empty, {
          key: index,
          base: top > 0 ? REVENUE_BAR_CEILING * Math.max(0, value) / top : 0,
          amount: this.formatMoney(value),
          initial: month.slice(0, 1),
          month: month,
          totalTitle: `${month}: ${this.formatMoney(value)}`
        })
      })
      const total = Object.assign({}, empty, {
        key: 'total',
        apart: true,
        base: year > 0 ? REVENUE_BAR_CEILING : 0,
        amount: this.formatMoney(year),
        initial: this.$t('components.simulationDetails.SalesDecomposition.total'),
        month: label,
        totalTitle: `${label}: ${this.formatMoney(year)}`
      })
      return { bars: bars, total: total }
    },
    // THE REVENUE ROW TYPED OR PASTED AT ONCE, and it goes back the way a pressed column does.
    // What arrives from jspreadsheet is the entire grid on every change, so the cells that MOVED are
    // found by reading it against `revenueSheetValues` — still the pre-edit form at this point,
    // nothing having been written yet — and only those go through. That matters for more than
    // speed: putting a month nobody touched back through the arithmetic would let the year drift in
    // the last bit a pasted block at a time.
    //
    // A cell says what a pressed column says — this month sold that — so the other eleven stand
    // still and the year is resized by the difference, through composeRevenueMonthAt and its two
    // walls.
    //
    // IT NO LONGER CARRIES THE TWO DRAWN YEARS, and the ordering problem it was written around went
    // with them: the walls those rows are held inside are read against the revenue, so one grid
    // carrying all three had to apply the revenue first or hold a pasted season against a revenue
    // the same paste had already replaced. Two grids are two gestures, and each is answered against
    // the year the other one left standing.
    onRevenueSheetInput (rows) {
      if (!this.moneyReady || !Array.isArray(rows)) return
      const was = this.revenueSheetValues
      if (this.sameSheetCells(was, rows)) return

      const revenue = this.applyRevenueMonths(
        this.monthSheetEdits(was, rows, 0)
          .map(edit => ({ at: edit.at, value: Math.max(edit.value, 0) })))

      // Nothing moved and nothing in it was readable: the grid goes back to the row it never left.
      if (!revenue.wrote) {
        this.resetSheet('revenueSheet')
        return
      }
      // After the rebuild inside applyRevenueMonths, which clears it. It names the months rather
      // than the year, those being what was typed: the revenue was held by what the media
      // underneath it can return.
      if (revenue.held.length > 0) {
        this.revenueNote = this.$t('components.ekrm.CreateModelCompose.revenueSheetHeld',
          { months: revenue.held.join(', ') })
      }
    },
    // THE TWO DRAWN YEARS TYPED OR PASTED AT ONCE, on exactly the terms above and each row going
    // back the way the plot over it does: a cell is held inside the walls a drawn month is held
    // inside, so nothing can be pasted in here that could not have been drawn.
    //
    // The two are one grid because they are one section and one gesture — what came back every year
    // and what did not, over the same twelve months — and they are written together and rebuilt
    // once: each of them rebuilding in turn would ask the same build twice. Their walls hold each
    // other still, so the pair is read against the shapes standing when the paste arrived.
    onSharesSheetInput (rows) {
      if (!this.moneyReady || !Array.isArray(rows)) return
      const was = this.sharesSheetValues
      if (this.sameSheetCells(was, rows)) return

      const season = this.applyShareSheetEdits(this.monthSheetEdits(was, rows, 0),
        this.seasonalityShape, (at, shape) => this.shapeBarLimits(at, shape, 0))
      // AGAINST THE SEASON AS THIS PASTE JUST LEFT IT, and not as the page carried it: the cap counts
      // the two rows of a month together, and holding the second against the first's old value lets
      // a paste land a pair neither cell was refused for. See shapeBarLimits.
      const spot = this.applyShareSheetEdits(this.monthSheetEdits(was, rows, 1),
        this.spotShape, (at, shape) => this.shapeBarLimits(at, shape, 1, season.shape))
      if (season.wrote) {
        this.drawnSeasonality = season.shape
        this.seasonalitySource = null
      }
      if (spot.wrote) this.drawnSpot = spot.shape
      if (season.wrote || spot.wrote) this.rebuild()

      // AFTER EVERY REBUILD ABOVE, WHICH CLEAR IT, AND BEFORE THE RETURN BELOW, WHICH DOES NOT.
      // The order is not an arrangement: a row standing past a rule already has both its walls on
      // the value it is standing on, so a month typed higher lands back on itself, writes nothing
      // and rebuilds nothing — and that is the ONE gesture in this whole grid where a reader is
      // owed a sentence most, the cell having visibly refused them and the year not having moved a
      // hair to show for it. Written under the early return, it would be the cases that need it
      // least that got it.
      this.shareNote = this.shareHeldNote([
        { name: this.$t('components.ekrm.CreateModelCompose.seasonalitySection'),
          prefix: 'seasonality',
          held: season.held },
        { name: this.$t('components.ekrm.CreateModelCompose.spotSection'),
          prefix: 'spot',
          held: spot.held }
      ])

      // Nothing moved and nothing in it was readable: the grid goes back to the year it never left.
      if (!season.wrote && !spot.wrote) this.resetSheet('sharesSheet')
    },
    // WHERE THE TWO DRAWN ROWS WERE HELD, IN WORDS. The cells first, each named the way the grid
    // shows it — row, month, and the figure it now carries — and then WHY, in the same sentences
    // the editors put on the greyed ground beside a dragged bar. The reasons are deduplicated: a
    // paste that runs a whole year past one wall meets one wall, and twelve copies of the sentence
    // saying so is the note shouting a rule the reader took in the first time.
    //
    // AND THE CAP IS NOT ONE OF THE WALLS IT SPEAKS FOR. A note exists because a typed cell meets a
    // wall the reader cannot see: the ground past a dragged bar is greyed before the drag reaches
    // it, and a cell greys nothing. The cap is the exception — it is one fixed figure, stated in
    // full on the line over the plot, and a month typed past it comes back carrying that very
    // figure. Explaining it is the wizard reading its own rule back to somebody who has just watched
    // it apply, and doing it once per row, which is how a hundred typed into both halves of one
    // month produced two sentences saying the same thing under a pair of cells that plainly say it
    // themselves. So a hold on the cap writes no line. The attribution wall still does: that one is
    // annual, invisible, and not stated anywhere on the page.
    //
    // Null for a gesture nothing was held in — the ordinary case — and for one held only by the cap.
    shareHeldNote (rows) {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      const cells = []
      const reasons = []
      rows.forEach(row => {
        if (!Array.isArray(row.held)) return
        row.held.forEach(hold => {
          if (hold.reason === 'month') return
          cells.push(this.$t('components.ekrm.CreateModelCompose.shareSheetCell', {
            row: row.name,
            month: this.monthLabels[hold.at] || '',
            value: hold.value
          }))
          const said = label(`${row.prefix}_stop_${hold.reason}`)
          if (reasons.indexOf(said) === -1) reasons.push(said)
        })
      })
      if (cells.length === 0) return null
      return this.$t('components.ekrm.CreateModelCompose.shareSheetHeld', {
        cells: cells.join(', '),
        reasons: reasons.join(' ')
      })
    },
    // THE KPI ROW, CELL BY CELL. Every one of them says what a pressed column says — this month
    // sold that — so the other eleven stand still and the year is resized by the difference. See
    // onRevenueMonthChange, whose walls and whose arithmetic these are, applied in the order the
    // cells were typed so each is held against the row as the ones before it left it.
    //
    // The ceiling is read ONCE, before any of them. It is a property of the media above and no cell
    // here moves a curve or a spend, so re-reading it between two cells of one paste would be
    // asking the same question twice.
    //
    // It rebuilds but writes no note, handing back what was held instead: the caller has two more
    // rows to write and every rebuild between here and the end of the gesture would clear one.
    applyRevenueMonths (edits) {
      const held = []
      if (edits.length === 0) return { wrote: false, held: held }
      const marketing = this.ready ? cloneMarketing(this.formState) : null
      const ceiling = marketing === null ? null : composeRevenueCeiling(marketing)
      let months = this.kpiVector.slice()
      edits.forEach(edit => {
        const step = composeRevenueMonthAt(months, edit.at, edit.value, ceiling,
          this.revenueLeast)
        months = step.months
        if (step.reason) {
          held.push(`${this.monthLabels[edit.at] || ''} (${this.formatMoney(months[edit.at])})`)
        }
      })
      const shape = composeRevenueShapeOf(months)
      if (shape === null) return { wrote: false, held: [] }
      const total = months.reduce((sum, value) => sum + value, 0)
      this.revenueTouched = true
      this.revenueShapeName = COMPOSE_SHAPE_CUSTOM
      this.revenueShapeSource = null
      this.revenueShapeValues = shape
      if (!(this.revenueAnchor > 0)) {
        this.revenueAnchor = total
        this.revenueFactor = 1
      } else {
        this.revenueFactor = total / this.revenueAnchor
      }
      this.rebuild()
      return { wrote: true, held: held }
    },
    // A DRAWN YEAR, TYPED. The cells that moved are held inside the walls the editor holds a
    // dragged month inside — read for each cell against the row as the cells before it left it,
    // which is what a hand drawing twelve months one after another gets — and rounded to the row's
    // own two decimals. Nothing can be pasted in here that could not have been drawn.
    //
    // AND EVERY HOLD IS HANDED BACK, which a dragged bar does not need and a typed cell cannot do
    // without. Under the hand, a wall is a thing you can see: the ground past it is greyed in the
    // month's own column before the drag reaches it, and the tooltip on that ground says which of
    // the three rules is standing there. A cell greys nothing. What the reader gets is a figure
    // other than the one they typed, no cursor anywhere near the wall that decided it, and — the
    // part that makes it unreadable rather than merely terse — a wall that is usually ANNUAL: the
    // base rule counts the whole year of both rows, so a March held at 12 was held by what the
    // other eleven months already claim, and there is nothing in March to look at. The caller says
    // it in words. See shareNote.
    //
    // A cell counts as held when what it SHOWS differs from what was typed, both read at the two
    // decimals a cell carries — a value that only lost a third decimal met no wall, it met the
    // rounding every cell in the row meets.
    //
    // The reason comes off the bound that actually bit. cloneShapeBarLimits leaves it null at the
    // ends it reaches without breaking anything, which are the cap on the month and the pair sharing
    // it: that end IS the month rule, and it is named as one rather than handed on as a hold with
    // nothing to say for itself.
    //
    // It commits nothing — the caller writes both rows together.
    applyShareSheetEdits (edits, shape, limitsFor) {
      const next = shape.slice()
      const held = []
      let wrote = false
      edits.forEach(edit => {
        const bounds = limitsFor(edit.at, next)
        const value = bounds
          ? Math.min(bounds.max.value, Math.max(bounds.min.value, edit.value))
          : edit.value
        const landed = Math.round(value * 100) / 100
        if (bounds && landed !== Math.round(edit.value * 100) / 100) {
          const wall = edit.value > bounds.max.value ? bounds.max : bounds.min
          held.push({ at: edit.at, value: landed, reason: wall.reason || 'month' })
        }
        if (landed === next[edit.at]) return
        next[edit.at] = landed
        wrote = true
      })
      return { wrote: wrote, shape: next, held: held }
    },
    // Whether two grids state the same money. Relative, and a thousand times looser than the
    // rounding a divide and a multiply leave behind — an amount typed into a cell becomes a
    // multiplier and is read back out as very nearly itself — and far tighter than anything the
    // table can show, so it never hides a difference a reader could see.
    sameAmount (left, right) {
      const a = Number(left) || 0
      const b = Number(right) || 0
      if (a === b) return true
      return Math.abs(a - b) <= 1e-9 * Math.max(Math.abs(a), Math.abs(b))
    },
    sameSheetCells (left, right) {
      if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) return false
      return left.every((row, index) => {
        const other = right[index]
        if (!Array.isArray(other) || row.length !== other.length) return false
        return row.every((cell, at) => at === 0
          ? String(cell) === String(other[at])
          : this.sameAmount(cell, other[at]))
      })
    },
    // Zero included, and on purpose: it goes through as a ratio of zero, which applySpendRatio reads
    // as the low end of the corridor rather than as a figure to refuse.
    onSpendTotalChange (value) {
      const target = this.parseAmount(value)
      const current = this.totals.spendTotal
      if (!(target >= 0) || !isFinite(target) || !(current > 0)) {
        this.formKey++
        return
      }
      this.spendTouched = true
      this.applySpendRatio(target / current)
    },
    // ROAS is not a number that can be set: with the curves fixed it is what the spend produces. So
    // the wizard solves for the spend that produces it, at the mix the form carries.
    //
    // AND A RETURN OUT OF REACH LANDS ON THE NEAREST END OF IT rather than being handed back, which
    // is what the Media Spend box beside it already does with a figure outside its corridor. The
    // two boxes are two coordinates of one curve and they now answer the same way: a figure past
    // what this plan can do puts the plan as far that way as it goes, and the note says where it
    // stopped and why. Zero is in that: it is not a return anybody is proposing, it is the low end
    // asked for in the plainest available word, and it arrives here as any other unreachable figure
    // does. Anything negative or unreadable is still refused — the field goes back to what the page
    // says.
    onRoasChange (value) {
      const target = this.parseAmount(value)
      if (!(target >= 0) || !isFinite(target) || !this.formState) {
        this.formKey++
        return
      }
      this.spendTouched = true
      const factor = solveSpendFactor(this.formState, target)
      if (factor === null) {
        this.solveRoasByMix(target)
        return
      }
      this.applySpendRatio(factor)
    },
    // A return one common factor cannot give. The same curves are asked whether ANOTHER mix of the
    // same channels can: it is the same money, and the only thing a common factor may not do with it
    // is move it between channels. If one can, it is applied — the user asked for a return and there
    // is one, and the mix note that then stands over the cards says what it cost.
    //
    // If none can, both ranges are reported — "not at this mix" and "not at any" are different
    // answers and only the second one is final — AND THE PLAN IS STOOD ON THE NEAREST END of what
    // this mix can do, the mix itself left exactly where the user placed it. Reporting the range and
    // leaving the box on the figure it already carried was an answer to a question nobody asked:
    // somebody typing a return past the top of these curves is asking for as much as they can get,
    // and the honest reply is the most there is rather than a sentence about it.
    solveRoasByMix (target) {
      const key = 'components.ekrm.CreateModelCompose.'
      const reach = cloneRoasReach(this.formState)
      if (!reach) {
        this.roasNote = this.$t(key + 'roasUnsolvable')
        this.formKey++
        return
      }
      const mix = solveSpendMix(this.formState, target)
      if (mix) {
        this.applySpendMix(mix)
        return
      }
      const wider = cloneMixReach(this.formState)
      const said = wider
        ? this.$t(key + 'roasOutOfReachEither', {
          min: this.formatRoas(reach.min),
          max: this.formatRoas(reach.max),
          mixMin: this.formatRoas(wider.min),
          mixMax: this.formatRoas(wider.max)
        })
        : this.$t(key + 'roasOutOfReach', {
          min: this.formatRoas(reach.min),
          max: this.formatRoas(reach.max)
        })
      // WHICH END OF THE REACH THAT IS, and the level it was read at — reachOf's own sample rather
      // than a solver's crossing, there being no crossing at a turning point. A target under the
      // bottom goes to the bottom and one over the top to the top; a figure inside the range never
      // reaches this branch, solveSpendFactor having answered it.
      const end = target > reach.max ? reach.maxFactor : reach.minFactor
      if (!(end > 0)) {
        this.roasNote = said
        this.formKey++
        return
      }
      // The spend's own corridor still binds — applySpendRatio holds it at both ends and writes its
      // own note under the other box when it does — so the return the plan comes to rest at is not
      // always the end that was asked for. It is read back off the form rather than assumed, and it
      // is the figure the note names, that being the one now standing in the box.
      this.applySpendRatio(end)
      const landed = this.roasTotal
      this.roasNote = landed === null
        ? said
        : said + ' ' + this.$t(key + 'roasHeldAt', { roas: this.formatRoas(landed) })
    },
    // The solver's factors are relative to the form as it stands, so they compose with whatever is
    // already there; the result is then split in two — a LEVEL, which is the whole plan's spend
    // against the source's and stays in spendFactor where the Media Spend box goes on moving it, and
    // a MIX around that level, which is what mixFactors is for. The split is exact: the level is the
    // spend-weighted mean, so the mix on its own multiplies the total spend by one and every later
    // edit of the three figures behaves exactly as it did before.
    //
    // EVERY CHANNEL IS STILL HELD ABOVE THE FLOOR, one at a time, which is the one thing a common
    // factor cannot be trusted to do for the mix. cloneSpendFloorLimits holds the LEVEL above the
    // spend at which some medium's cells round away, and that is enough while the money is shared out the
    // way the curves placed it; a solver free to move money between channels can take one of them
    // down on its own while the total stays comfortable. So the floor is asked of each factor here,
    // in the channel's own cells, and a factor under it lands on it. The return then comes out
    // slightly off the one that was asked for — which is the same bargain every rail in this wizard
    // makes, and it is said in a line rather than left to be noticed in the box.
    applySpendMix (solved) {
      if (!solved || !this.built) return
      this.spendTouched = true
      const media = this.built.media
      let moved = 0
      let base = 0
      let floored = false
      const factors = solved.map((factor, index) => {
        const cells = this.shapedSpendCells(index)
        const source = cells.reduce((total, cell) => total + (Number(cell) || 0), 0)
        // The channel's own largest month, unscaled: the cells are written before any factor
        // reaches them — see writeChannel, which is where the multiplication happens. Shaped, though,
        // because a month typed on the chart is part of the row a floor is measured in: a channel
        // bought in three months of the year has nine cells the floor has nothing to say about.
        const most = cells.reduce((top, cell) => Math.max(top, Number(cell) || 0), 0)
        const floor = most > 0 ? COMPOSE_FLOOR / most : 0
        let value = this.spendFactor * this.mixFactorFor(media[index].uid) * factor
        if (floor > 0 && value < floor) {
          value = floor
          floored = true
        }
        moved += value * source
        base += source
        return value
      })
      const level = base > 0 && moved > 0 ? moved / base : 1
      const mix = {}
      factors.forEach((value, index) => { mix[media[index].uid] = value / level })
      this.spendFactor = level
      this.mixFactors = mix
      this.rebuild()
      // Money moved between channels is a response moved, so the ceiling over the revenue moves
      // with it — the same seating applySpendRatio does, this being the other way the spend is set.
      this.seatRevenue()
      if (floored) this.roasNote = this.$t('components.ekrm.CreateModelCompose.roasHeldFloor')
    },
    // THE THREE LEVELS THIS CHART WILL TAKE YOU TO, and the only three clicks it has: where these
    // curves return the most per unit spent, and the two ends of the corridor the form may spend
    // inside. Each is a label under the axis that jumps to it — a chart that says "the most is here"
    // and will not take you there is a chart that has to be read twice — and with no slider left,
    // these are the whole of what the plot does rather than shortcuts along it.
    //
    // The peak also gets a mark on the line and a rule down to the axis, and it is read off the
    // samples the line is drawn from, so that mark cannot sit anywhere but on the line. It is dropped
    // where it lands on an end of the window, that being the edge of what is drawn rather than a peak
    // of the curve — and where it is dropped the chart is a line that only climbs or only falls,
    // which the two ends already name.
    //
    // The two ENDS are always named and never marked. They are boundaries and not points of
    // interest: what matters about them is the x they stand at, and that x is the frame itself here
    // — the axis starts on the floor and stops at the end of the window — so they carry no rule
    // either. A dashed line drawn on the edge of the box reads as a wall inside the chart rather
    // than as the end of it.
    tradeMarks (points, project) {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      const bounds = this.tradeBounds
      const inside = level => level > bounds.from && level < bounds.to
      const marks = []

      let best = 0
      points.forEach((point, index) => { if (point.roas > points[best].roas) best = index })
      if (best > 0 && best < points.length - 1) {
        marks.push({
          key: 'peak',
          kind: 'peak',
          level: points[best].level,
          label: label('tradePeakLabel'),
          title: label('tradePeak'),
          style: project.mark(points[best].level, points[best].roas)
        })
      }

      // The two ends of the corridor, which is where the buttons under them go: the level, and not
      // the limit that decided it, because the corridor is also what holds the plan when a limit has
      // moved out from under it — see corridorWithin.
      const limits = this.tradeLimits
      const corridor = this.tradeCorridor
      ;[
        { key: 'min', name: 'tradeMinLabel', level: corridor.from, edge: 'start' },
        { key: 'max', name: 'tradeMaxLabel', level: corridor.to, edge: 'end' }
      ].forEach(entry => {
        const limit = limits ? limits[entry.key] : null
        if (!(entry.level > 0)) return
        marks.push({
          key: entry.key,
          kind: 'limit',
          level: entry.level,
          label: label(entry.name),
          // WHY IT IS AS FAR AS IT GOES, which is two different kinds of answer. A limit says which
          // of the walls the corridor ran into — the marketing attribution, or the floor under the
          // cells — and an end with no limit behind it is simply as far as this chart draws, which
          // has to say so rather than borrow a wall's words. In this wizard the high end is always
          // the second kind: nothing about the media bounds a spend from above.
          title: limit ? label(`trade_${entry.key}_${limit.reason}`) : label(`trade_${entry.key}_window`),
          style: null,
          // Written against the end of the axis it names rather than centred on a mark, for the same
          // reason it carries none: it stands ON the frame.
          edge: entry.edge,
          // Standing on the frame, where a rule would be half a line on the edge of the box.
          rule: inside(entry.level)
        })
      })

      return this.placeMarks(marks, project)
    },
    // Left to right, and onto a second line whenever a label would sit on top of the one before it.
    // Two names and a peak have to fit under one width, and a label that lands on the one before it
    // is unreadable at either end of the pair.
    placeMarks (marks, project) {
      const placed = [null, null]
      return marks.map(entry => {
        return Object.assign({}, entry, { x: project.at(entry.level) })
      }).sort((one, other) => one.x - other.x).map(entry => {
        let row = 0
        if (placed[0] !== null && entry.x - placed[0] < TRADE_LABEL_GAP) {
          row = placed[1] === null || entry.x - placed[1] >= TRADE_LABEL_GAP ? 1 : 0
        }
        placed[row] = entry.x
        // An end of the axis is written against that end — flush left or flush right — rather than
        // centred on an x it shares with the frame. Everything else is centred on its own mark and
        // kept off the two edges, where a centred label would hang outside the card.
        const labelStyle = entry.edge
          ? { left: entry.edge === 'start' ? '0' : 'auto', right: entry.edge === 'end' ? '0' : 'auto' }
          : { left: project.round(Math.min(94, Math.max(6, entry.x / TRADE_WIDTH * 100))) + '%' }
        return Object.assign({}, entry, {
          x: project.round(entry.x),
          labelStyle: Object.assign(labelStyle, { top: row * 15 + 'px' })
        })
      })
    },
    // THE PEAK, TAKEN ONCE, on the first arrival at the step that draws it. The plan the channel
    // cards lay out is every curve at the saturation point typed on it, which is a statement about
    // each channel on its own and says nothing about what the media are worth TOGETHER; the level
    // where they return the most per unit spent is a reading of exactly that, and it is the one the
    // chart already names. Opening on it is the wizard answering its own question with the best
    // answer it has, which the reader then types over or leaves.
    //
    // It is the same commit pressing Max. ROAS makes — onTradeJump on the peak's own level — so
    // there is one path into the spend and not two. The mark is read off tradePlot rather than
    // recomputed: a curve that only climbs or only falls has no interior peak and gets none here
    // either, and the plan is left exactly where the cards put it.
    //
    // The flag is set whether or not anything moved. What it records is that the step has been
    // reached, and a wizard that went on trying to seed a plan it could not seed would jump the
    // spend on the first visit that happened to have a peak — which, to a reader who has been on
    // that step twice, is the figure moving on its own.
    seedSpendAtPeak () {
      if (this.spendSeeded) return
      if (!this.ready) return
      this.spendSeeded = true
      const marks = this.tradePlot ? this.tradePlot.marks : []
      const peak = marks.filter(mark => mark.kind === 'peak')[0]
      if (!peak) return
      this.onTradeJump(peak.level)
    },
    // THE TOTAL MEDIA SPEND IS AN ANSWER AND NOT A READING, once the step that asks for it has been
    // reached. What the media step decides is the SHAPE of the plan — which channels, where each of
    // their curves stands — and what the spend step decides is its SIZE. A saturation point retyped
    // two steps back moved the size as a side effect: every channel's row opens at the figure that
    // places its curve, so doubling one channel's saturation doubled its twelve cells and the total
    // with them, and a figure the reader typed on another step moved without being touched.
    //
    // So a media edit is made and then the LEVEL is put back to where it leaves the total exactly
    // where it stood. What moves instead is the mix — the edited channel takes more or less of the
    // same money — which is the honest reading of "this medium saturates higher than I said" made
    // against a budget somebody has already stated.
    //
    // Through applySpendRatio, so it is the same commit as every other move of the level: the ratio
    // is held inside the corridor the curves leave, and where the total cannot be restored because
    // the new curves will not carry it, the plan lands on the end it ran into and the box says so.
    // That is the one case where the figure does move, and it is the case the reader has to be told
    // about anyway.
    //
    // Nothing is held before the spend has been answered — see spendSeeded — and nothing is held
    // for a channel being PLACED for the first time: a medium given its first two figures is a
    // budget arriving, not one being moved, and holding the total there would quietly shrink every
    // other channel to pay for it. spendHeldBefore is where that is decided; this only restores
    // whatever it was handed.
    holdSpendTotal (before) {
      if (!(before > 0) || !this.ready) return
      const now = this.totals.spendTotal
      if (!(now > 0)) return
      const ratio = before / now
      if (Math.abs(ratio - 1) <= SEAT_EPSILON) return
      this.applySpendRatio(ratio)
    },
    // WHAT THERE IS TO HOLD, read before the edit is made. Zero — hold nothing — until the spend
    // step has been reached, and zero for an edit to a channel that is not in the payload yet, which
    // is the add case above.
    spendHeldBefore (uid) {
      if (!this.spendSeeded || !this.ready) return 0
      const media = this.built.media
      if (!media.filter(medium => medium.uid === uid)[0]) return 0
      return this.totals.spendTotal
    },
    // A named level on the chart, taken. Same commit as letting go of the slider there.
    onTradeJump (level) {
      const target = Number(level)
      if (!isFinite(target) || !(target > 0) || !(this.spendFactor > 0)) return
      this.applySpendRatio(target / this.spendFactor)
    },

    // The stretch of an axis the slider may leave the plan on: the corridor between that axis's two
    // limits, clipped to what is drawn, and always wide enough to hold where the plan already is.
    // `limits` answers in multiples of what the form carries now and `level` is against the source's
    // own, which is what the multiplication is for.
    corridorWithin (bounds, limits, level) {
      const plan = level > 0 ? level : 1
      let from = limits && limits.min ? Math.max(bounds.from, limits.min.factor * plan) : bounds.from
      let to = limits && limits.max ? Math.min(bounds.to, limits.max.factor * plan) : bounds.to
      from = Math.min(from, plan)
      to = Math.max(to, plan)
      // A corridor with nothing in it is not one anything can be held inside; the chart still shows
      // why, and the boxes still say what is wrong with it.
      return to > from ? { from: from, to: to } : { from: bounds.from, to: bounds.to }
    },
    // The seasonality, which is the one thing here that leads nothing and follows nothing. Its own
    // bounds are read against the spend and the revenue — the base has to survive all three — but
    // neither of theirs mentions it, so nothing is re-seated after a stroke and nothing needs to be.
    //
    // The converse is left open on purpose: a spend or a revenue edit CAN move a drawn year out from
    // under its own bounds, and a wizard that quietly retilted the year because a revenue was typed
    // would be doing to the lead figure what seatSpend is at pains to justify doing only to the
    // dependent one. decompositionBaseWarning is what speaks there.
    onSeasonalityInput (shape) {
      this.drawnSeasonality = shape
      this.seasonalitySource = null
      this.rebuild()
    },
    // ONE MONTH OF BOTH DRAWN YEARS, TYPED, and it arrives as the whole column: the card over a
    // stacked month holds a field per row and commits them together, which is what the two rows
    // require — their walls hold each other still, so a card that sent each field as it was left
    // would hold the second against a year the first had already moved.
    //
    // It goes through the SAME arithmetic the table under the plot goes through, and deliberately:
    // the two are two ways of typing the same thing, and a figure that is refused in one has to be
    // refused in the other for the same reason and be said to have been in the same words. So the
    // walls are re-read per row as each is applied, the pair is written together and rebuilt once,
    // and what was held is spoken by shareHeldNote.
    //
    // The rows come back indexed by their position in shapeRows, that being the only thing the card
    // carries about them. A figure that will not parse is passed over rather than read as a zero: a
    // cleared field is not a month that claimed nothing.
    onShapeMonthInput (moved) {
      if (!this.moneyReady || !moved || !Array.isArray(moved.values)) return
      const month = moved.index
      const typed = {}
      moved.values.forEach(entry => {
        const value = this.parseAmount(entry.value)
        if (isFinite(value)) typed[entry.index] = value
      })
      const editsFor = index => (index in typed ? [{ at: month, value: typed[index] }] : [])

      const season = this.applyShareSheetEdits(editsFor(0),
        this.seasonalityShape, (at, shape) => this.shapeBarLimits(at, shape, 0))
      // The season as this card just left it — see shapeBarLimits, and the sixty and the forty that
      // would otherwise both be allowed into one month.
      const spot = this.applyShareSheetEdits(editsFor(1),
        this.spotShape, (at, shape) => this.shapeBarLimits(at, shape, 1, season.shape))
      if (season.wrote) {
        this.drawnSeasonality = season.shape
        this.seasonalitySource = null
      }
      if (spot.wrote) this.drawnSpot = spot.shape
      if (season.wrote || spot.wrote) this.rebuild()

      // After the rebuild above, which clears it, for the reason the table's own note is written
      // after its: a month typed past a wall it is already standing on lands back on itself, writes
      // nothing and rebuilds nothing, and that is the one gesture here where a reader is owed a
      // sentence most — the field having visibly refused them and the row not having moved a hair to
      // show for it.
      this.shareNote = this.shareHeldNote([
        { name: this.$t('components.ekrm.CreateModelCompose.seasonalitySection'),
          prefix: 'seasonality',
          held: season.held },
        { name: this.$t('components.ekrm.CreateModelCompose.spotSection'),
          prefix: 'spot',
          held: spot.held }
      ])
    },
    // How far one month may be moved with the other eleven standing still, in the editor's own
    // units. Handed to the editor as a function so that everything it knows arrives through a prop.
    //
    // BOTH YEARS GO IN, and the one being moved is named by the last argument rather than by which
    // of the two this method is: the cap is on what the month claims of its own base ACROSS the two
    // rows, so neither can be held without the other in hand. They are passed as drawn rather than
    // read back out of the form, which carries them converted into the payload's unit — see
    // cloneShapeCells — and a wall that divided a converted cell back would be a wall built on an
    // arithmetic that divides by zero in exactly the month it matters.
    //
    // The shape the editor hands over is the row MID-GESTURE, so it replaces its own. `neighbour` is
    // the OTHER row as the caller has it, which is not always the one on the page: a card that types
    // both rows of one month writes the season first, and the spot figure has to be held against
    // that season and not against the one standing before the gesture began. Both would otherwise
    // pass — sixty and forty against an untouched neighbour are each inside the cap — and land
    // together at a hundred, which is the one thing the cap exists to refuse. It defaults to the
    // committed row, which is what a gesture touching one row alone means by it.
    shapeBarLimits (index, shape, rowIndex, neighbour) {
      if (!this.ready) return null
      const other = neighbour || (rowIndex === 1 ? this.seasonalityShape : this.spotShape)
      const shapes = rowIndex === 1 ? [other, shape] : [shape, other]
      return cloneShapeBarLimits(this.formState, shapes, index, rowIndex)
    },
    // BOTH DRAWN ROWS, ONE MONTH ALONG. The section's own verb, and it moves the two together: they
    // are drawn on one axis under one cap, and rotating one against the other would let a month be
    // claimed twice by rows that were inside the cap before the gesture. Rotated together, every
    // month's pair only changes which month it is, so nothing can leave the range it was already in.
    //
    // What it is for is the year borrowed off a business in the other hemisphere, whose season is the
    // right shape standing six months out of place — and it works on a year somebody drew by hand
    // just as well, which is why it is a verb on the section rather than a control in the dialog.
    //
    // A row that says nothing goes on saying nothing: twelve zeros rotate to twelve zeros, and it is
    // written back as the null that means the reader has not answered here rather than as a year of
    // noughts they did.
    onShapesAction (key) {
      if (key === 'randomize') this.onShapesRandomize()
      if (key === 'flatten') this.onShapesFlatten()
      if (key === 'shiftLeft') this.onShapesShift(-1)
      if (key === 'shiftRight') this.onShapesShift(1)
      if (key === 'import') this.openShapeImport('season')
      if (key === 'clear') this.onShapesClear()
    },
    // A LITTLE MORE SEASON, the season row alone: the spot events are things that happened once, and
    // a draw is not one. Each month moves by its own draw from ±SHAPE_SEASON_JITTER points and is held
    // inside the same walls a typed month is — see shapeBarLimits — so a press can never leave the
    // cap, however near it the month was standing.
    onShapesRandomize () {
      if (!this.moneyReady) return
      const shape = this.seasonalityShape
      const edits = shape.map((value, at) => ({
        at: at,
        value: (Number(value) || 0) + SHAPE_SEASON_JITTER * (2 * Math.random() - 1)
      }))
      const season = this.applyShareSheetEdits(edits, shape, (at, next) => this.shapeBarLimits(at, next, 0))
      if (!season.wrote) return
      this.drawnSeasonality = season.shape.some(value => Number(value) !== 0) ? season.shape : null
      this.seasonalitySource = null
      this.rebuild()
    },
    // A LITTLE LESS OF BOTH: each month of the two rows a SHAPE_PULL of the way to nothing, which is
    // where a flat season stands. Going towards zero cannot cross a wall, but it goes through the same
    // walls anyway, the second row held against the first as this press left it.
    onShapesFlatten () {
      if (!this.moneyReady) return
      const pull = row => row.map((value, at) => ({ at: at, value: (Number(value) || 0) * (1 - SHAPE_PULL) }))
      const season = this.applyShareSheetEdits(pull(this.seasonalityShape),
        this.seasonalityShape, (at, next) => this.shapeBarLimits(at, next, 0))
      const spot = this.applyShareSheetEdits(pull(this.spotShape),
        this.spotShape, (at, next) => this.shapeBarLimits(at, next, 1, season.shape))
      if (!season.wrote && !spot.wrote) return
      if (season.wrote) {
        this.drawnSeasonality = season.shape.some(value => Number(value) !== 0) ? season.shape : null
        this.seasonalitySource = null
      }
      if (spot.wrote) this.drawnSpot = spot.shape.some(value => Number(value) !== 0) ? spot.shape : null
      this.rebuild()
    },
    // Both rows back to saying nothing, which is how the section opens.
    onShapesClear () {
      if (!this.moneyReady) return
      this.drawnSeasonality = null
      this.drawnSpot = null
      this.seasonalitySource = null
      this.shareNote = null
      this.rebuild()
    },
    onShapesShift (by) {
      if (!this.moneyReady) return
      const rotate = row => row.map((value, index) => row[(index - by + row.length * 2) % row.length])
      const season = rotate(this.seasonalityShape)
      const spot = rotate(this.spotShape)
      this.drawnSeasonality = season.some(value => Number(value) !== 0) ? season : null
      this.drawnSpot = spot.some(value => Number(value) !== 0) ? spot : null
      this.rebuild()
    },
    // The spot row. It leads nothing and follows nothing either, and it is read against the
    // seasonality above it rather than the other way round only in the sense that the cap on a month
    // counts the two rows together — cloneShapeBarLimits is one rule asked from either side, so
    // neither can hand back a year the other would refuse.
    onSpotInput (shape) {
      this.drawnSpot = shape
      this.rebuild()
    },
    // The spend, brought inside what the media just left room for. This is the other half of
    // revenue-leads-spend, and it runs after every edit to the CHANNELS — one added, one dropped, a
    // curve moved — each of which moves what the curves return and therefore every end of the
    // corridor.
    //
    // It does NOT run after a revenue edit, and there is no exception to that — not even the first
    // one, which is the only revenue that ever arrives with no money on the page behind it. The rule
    // is the one onTotalRevenueChange states: the media are what the user modelled by hand a section
    // above, and answering a revenue they have just typed by quietly pulling their own spend out
    // from under it is answering a statement with a question. What can go wrong there is said in
    // words instead.
    //
    // SEATING THE FIRST REVENUE'S SPEND ON THE FLOOR OF THIS CORRIDOR was tried and reverted, and
    // the reason belongs here because this is where the corridor is read. The low end below is
    // almost always the ATTRIBUTION wall — the other two, a channel's cells rounding away against
    // COMPOSE_FLOOR and the media returning less than a unit a month between them, sit orders of
    // magnitude beneath it — and that wall is leastAttributionCentre, 0.065 %. A plan seated there
    // is not a small media budget; it is a model in which the media explain a fifteen-hundredth of
    // the business, two or three orders of magnitude under the plan the cards describe, with the
    // whole of FLOOR_MARGIN's one percent between it and a hard validator error.
    //
    // And composeRevenueCeiling is that same wall read as a revenue — `0.999 · marketing · 100 /
    // least` — so a plan standing on it puts the Total Revenue box hard against its own ceiling:
    // `ceiling/revenue = 0.999 · centre/least`, which with the plan a hair above the wall is between
    // 1.009 and about 1.03. The revenue could never be raised again by more than a percent or three,
    // while lowering it went on working and dragged the spend down to the new floor with it. The two
    // figures ratcheted in one direction only. The plan opens at saturation instead, which is the
    // plainest reading of what the cards say and leaves both figures room on both sides.
    //
    // WHAT THIS SEATS AGAINST IS NO LONGER THE REVENUE. The corridor is cloneSpendFloorLimits —
    // two floors read off the curves and nothing else, see tradeLimits — so a revenue that has
    // moved cannot leave the spend standing outside it, and nothing here runs on a revenue edit.
    // What can is a CHANNEL or a CURVE: both change the cells a floor is measured in and what the
    // media return between them, and a plan that was above the floor a moment ago can be under the
    // one that came up to meet it.
    //
    // It answers in multiples of where the spend already is, which is what makes the test the plain
    // one below: a minimum above 1 is a spend now too small. There is no maximum at all in this
    // wizard — the three ends that would give it one are all read against the revenue and are all
    // said in words instead — so the high branch stands for a corridor that never comes, and is
    // kept because it costs a line and because the corridor is a shape this page reads generically.
    //
    // seatRevenue is the other half, and the same edits raise it: with the spend leading it is the
    // REVENUE that is walked back inside its walls when the two drift apart.
    seatSpend (reason) {
      if (!this.ready) return
      const limits = this.tradeLimits
      if (!limits) return
      // A HAIR PAST THE END AND NOT MERELY PAST IT, for a plan standing exactly ON one of them.
      //
      // That is not the opening state, but it is one click away from it: the levels named under the
      // chart are the corridor's own two ends, so taking either of them leaves the plan on the limit
      // to the last bit. Asked again from there the same arithmetic has to return 1 — the low end is
      // its wall divided by FLOOR_MARGIN, the wall is then 0.99 of where the plan stands, and 0.99
      // over the margin is one — and it returns 1 to sixty bisections and two divisions of rounding,
      // which lands either side of it. Measured over four thousand walls it came back ABOVE one in
      // about a tenth of them, and a bare `> 1` reads those as a plan standing outside its own
      // floor: the next channel edit re-seats the plan by a part in ten thousand billion and
      // announces it in an alert, and retyping the spend figure already on screen reports itself as
      // held.
      //
      // So an end is only past when it is past by more than that noise can account for. A part in a
      // million is a thousand times the error and a ten-thousandth of the smallest margin any limit
      // here carries, so it can hide no real correction: anything this catches was already inside
      // the rounding the limits are stated to.
      const low = limits.min && limits.min.factor > 1 + SEAT_EPSILON ? limits.min : null
      const high = limits.max && limits.max.factor < 1 - SEAT_EPSILON ? limits.max : null
      const end = low || high
      if (!end || (low && high)) return
      this.applySpendRatio(end.factor)
      const key = 'components.ekrm.CreateModelCompose.'
      // Which of the two moved out from under the spend. 'spendSeated' names the revenue, which is
      // the only thing that ever moved before channels could be taken out, and would be a plain
      // falsehood over a removal — where what moved is what the curves are credited with.
      const seated = reason === 'channels'
        ? 'spendSeatedChannels'
        : (reason === 'curves'
          ? 'spendSeatedCurves'
          : (reason === 'months' ? 'spendSeatedMonths' : 'spendSeated'))
      this.spendNote = this.$t(key + seated,
        { spend: this.formatMoney(this.totals.spendTotal) }) +
        ' ' + this.$t(`${key}trade_${low ? 'min' : 'max'}_${end.reason}`)
    },
    // THE OTHER HALF OF THE PAIR, and the one that moves now that the spend leads.
    //
    // seatSpend's argument, read in the mirror. Both of the revenue's walls are statements about
    // the media standing above it — composeRevenueCeiling is what the curves are credited with over
    // leastAttributionCentre, composeRevenueFloor is the row the year has to survive being written
    // into — so anything that moves the curves or the level they are read at moves the walls under
    // a figure that was typed inside them. The ceiling is the one that matters: past it the
    // marketing attribution band writes a minimum of nothing and validateEkrmForm refuses the
    // payload outright, which is the one hard error the two figures can make between them.
    //
    // It used to be the spend that gave way there — the same wall is the spend's own low end when
    // it is read as a spend, and cloneSpendLimits still reads it that way for the clone. Holding the
    // spend against a revenue typed BELOW it is what this wizard no longer does: the spend is
    // answered first, against the media alone, and the figure that follows is the one that yields.
    //
    // ONCE, AND SAID. This is not the revenue tracking the spend — a revenue inside its walls is
    // left exactly where the user put it however far the media move, and raising the spend again
    // does not carry it back up. It is a figure held at a wall it has been pushed through, which is
    // the same thing revenueWithin does to a typed one, with the same note under the box.
    //
    // The epsilon is seatSpend's, for the same reason: a figure standing exactly ON a wall reports
    // itself as a hair outside one, and re-seating it there is a no-op that announces itself.
    seatRevenue () {
      if (!this.ready || !(this.revenue > 0) || !(this.revenueAnchor > 0)) return
      const held = this.revenueWithin(this.revenue)
      if (!held.reason || !(Math.abs(held.value - this.revenue) > this.revenue * SEAT_EPSILON)) return
      this.revenueFactor = held.value / this.revenueAnchor
      this.rebuild()
      this.revenueNote = this.$t(`components.ekrm.CreateModelCompose.revenueSeated_${held.reason}`,
        { revenue: this.formatMoney(held.value) })
    },
    // A channel's colour, for as long as it is on the page. Keyed by uid and not by position, so
    // adding or removing one never recolours another.
    colorFor (uid) {
      return CHART_COLORS[Number(uid) % CHART_COLORS.length]
    },
    mixFactorFor (uid) {
      const factor = Number(this.mixFactors[uid])
      return isFinite(factor) && factor > 0 ? factor : 1
    },
    statedFor (uid) {
      return this.statedCurves[String(uid)] || null
    },
    // The three parameters the payload is CURRENTLY carrying for this channel, edits and all — what
    // the two figures are read off, see composeCurveReading. Null for a channel that is not in the
    // payload, which is also a channel whose figures have nothing to be a reading of yet.
    hillFor (uid) {
      const summary = this.summaries.filter(entry => entry.uid === uid)[0]
      return summary ? summary.hill : null
    },
    // Where this channel's placement stands now — see composeCurveReading. It is the typed pair to
    // floating point until a lever is moved, and follows the curve from there.
    readingFor (uid) {
      return composeCurveReading(
        this.statedFor(uid), this.curveEdits[String(uid)], this.hillFor(uid)
      )
    },
    // What the card prints in each of its two fields, or an empty string where nothing has been
    // said yet. An unstated figure shows as blank rather than as a zero: a zero is a claim about a
    // medium that absorbs no money, and what is true is that nobody has answered.
    statedLabel (uid, key) {
      const reading = this.readingFor(uid)
      const said = this.statedFor(uid)
      const value = reading ? reading[key] : (said ? Number(said[key]) : NaN)
      return isFinite(value) && value > 0 ? this.formatMoney(value) : ''
    },
    // THE SATURATION POINT AS TWO NUMBERS, UNDER THE CURVE THAT MARKS IT.
    //
    // The card draws the point among its bands and says nothing about how much money it is, which is
    // the one thing a row of six cards is scanned for: what a reader is comparing across media is
    // where each of them stops paying and what it makes there, and the only way to that pair was to
    // open the card. It is the figure the editor exists to ask for, so it is also the figure the
    // thumbnail owes an answer to.
    //
    // The same two readings the editor's own fields carry — statedLabel, which follows the curve
    // wherever a lever has taken it rather than reporting what was typed — so the card and the dialog
    // it opens cannot disagree about the point they are both marking. Compact money, because this is
    // read and never typed back: the field that takes an edit is in the editor and keeps its extra
    // digit.
    //
    // An unanswered channel gets the em dash the editor's fields show and the hollow dot the plot's
    // own ring is: the place among the bands is true and the magnitude is not, which is exactly the
    // distinction the rest of this wizard makes while the pair is unstated. Either half missing is
    // enough — a point with one coordinate is not a point.
    saturationPairFor (uid, medium) {
      const knee = this.statedLabel(uid, 'knee')
      const ceiling = this.statedLabel(uid, 'ceiling')
      const stated = !!knee && !!ceiling
      return {
        knee: knee || UNSTATED,
        ceiling: ceiling || UNSTATED,
        unknown: !stated,
        title: stated
          ? this.$t('components.ekrm.CreateModelCompose.cardPoint', {
            channel: medium, knee: knee, ceiling: ceiling
          })
          : this.$t('components.ekrm.CreateModelCompose.cardPointUnstated', { channel: medium })
      }
    },
    // THE FIVE OPTIMAL ZONES AS BANDS ON A CARD'S OWN PLOT — the same four boundaries the editor's
    // chart shades, in the same colours, off the same solved function, so the thumbnail and the
    // chart it opens are one picture at two sizes rather than two drawings of one channel. It was
    // the last thing the card could not say about a curve: a sparkline with no bands under it shows
    // the SHAPE of the response and nothing about which parts of it are worth buying, which is the
    // question the card is scanned for when six of them are in a row.
    //
    // Projected through the sparkline's OWN scale rather than recomputed on a scale of ours. The
    // plot is normalised to whatever it happens to draw — the source's measured span on an
    // unanswered card, the plan's own spend on a placed one — and `project` is the function that
    // put the curve there, so a boundary handed to it lands under the point of the curve it is the
    // boundary of, whatever the box is showing. A boundary past the last spend drawn leaves its band
    // off the plot and it is dropped; one straddling the edge is cut at it.
    //
    // The last band runs to the right edge, the fifth zone having no end. The first is not drawn at
    // all: null in ZONE_FILLS, which is the report's convention and the dialog's.
    zoneBands (params, plot) {
      const bounds = plot ? hillRegions(params) : null
      if (!bounds) return []
      const at = edge => plot.project([edge, 0])[0]
      const bands = []
      ZONE_FILLS.forEach((fill, index) => {
        if (!fill) return
        const from = Math.max(0, at(bounds[index - 1]))
        const to = index === ZONE_FILLS.length - 1 ? PLOT_WIDTH : Math.min(PLOT_WIDTH, at(bounds[index]))
        if (!(to - from > 0.01)) return
        bands.push({ key: `zone_${index + 1}`, x: from, width: to - from, fill: fill })
      })
      return bands
    },

    // ONE CHANNEL'S SATURATION PLOT, drawn on the card exactly as the dialog draws it in full.
    //
    // A card and the editor it opens were two drawings of one channel. Both took the same three
    // parameters and neither took them the same way: the dialog runs hillSeries over a window that
    // is a few knees wide, the card ran channelPlotSeries over whatever span the SOURCE model
    // happened to measure, and a window is not a detail of a plot — it is what the shape IS. The
    // same curve came out turning early in one and late in the other, and the click between them
    // read as a change of subject rather than as a magnification. The dashed line differed for the
    // same reason: the dialog draws the imported FIT and the card drew the imported POINTS, which
    // stop where the measurement stopped and leave the two lines ending in different places.
    //
    // So the card asks for the same things the dialog does, off the same functions: hillPlotWindow
    // for the edge, hillSeries for the polyline, the imported fit for the line behind it, hillRegions
    // for the bands, and the fourth boundary for the point among them. What is left over is the box:
    // sparklinePath normalises the pair into the card's 120×46 the way ChannelCurvesChartMulti's
    // sameAxisScale normalises them into its own — one range for both axes, taken from the larger of
    // the two maxima — so the height of the curve against the width of the box is the return in
    // either of them.
    //
    // NO AREA UNDER THE LINE. The chart fills nothing under its curve, and a wash on the card would
    // be a sixth statement in a box that already carries five coloured bands.
    //
    // options: { source, stated }. `source` is the fit the channel was imported with, and it
    // is passed only where it is worth drawing — an untouched channel would be a dashed line exactly
    // under a solid one. `stated` is whether the pair that places this curve has been typed, which
    // is what the point among the bands is drawn AS: a reading, or the question it is still waiting
    // to be. Null for parameters no curve can be drawn from, which is the card's "no curve".
    channelCurvePlot (params, options) {
      if (!isHillParams(params)) return null
      const opts = options || {}
      const source = isHillParams(opts.source) ? opts.source : null
      const top = hillPlotWindow(params, { source: source })
      const pairs = curve => curve.x.map((x, at) => [x, curve.y[at]])
      const points = pairs(hillSeries(params, top, CURVE_STEPS))
      const overlay = source ? pairs(hillSeries(source, top, CURVE_STEPS)) : null
      const plot = sparklinePath(points, PLOT_WIDTH, PLOT_HEIGHT, overlay, PLOT_SCALE)
      if (!plot) return null

      // Where the fifth zone begins, which is where this channel saturates. Off the boundary array
      // itself wherever there is one, exactly as the dialog does it, so the mark cannot land a hair
      // off the colour change it is the colour change OF — and off hillDiminishingReturns for a
      // curve too gentle to have bands at all, where the point is still a fact about the response.
      //
      // Handed over as percentages rather than as svg coordinates because the svg is stretched to
      // the card's width through preserveAspectRatio=none, and a circle drawn inside it arrives as
      // an ellipse. It is an element over the plot instead, positioned in the box's own terms.
      const bounds = hillRegions(params)
      const at = bounds ? bounds[3] : hillDiminishingReturns(params)
      let point = null
      if (at > 0) {
        const placed = plot.project([at, hillAt(params, at)])
        point = {
          left: (placed[0] / PLOT_WIDTH) * 100,
          top: (placed[1] / PLOT_HEIGHT) * 100,
          unknown: !opts.stated
        }
      }

      return {
        saturation: { line: plot.line, area: null },
        sourceLine: overlay
          ? sparklinePath(overlay, PLOT_WIDTH, PLOT_HEIGHT, points, PLOT_SCALE).line
          : null,
        zones: this.zoneBands(params, plot),
        saturationPoint: point
      }
    },

    // --- The curve, per channel -------------------------------------------

    // WHERE THIS MEDIUM SATURATES AND WHAT IT GENERATES THERE, typed on its own card.
    //
    // The two figures that turn an imported shape into a medium, and the whole reason the media can
    // be modelled before there is a budget or a revenue anywhere on the page. A saturation curve is
    // a property of the MEDIUM and of the market it is bought in — how much money this channel
    // absorbs here before it stops responding, and how much revenue it can produce doing it — and
    // neither of those depends on what anybody later decides to spend. What the source model
    // contributes is the CURVATURE alone: how sharply the response turns on the way there.
    //
    // Both are money, so both go through parseAmount and come back through formatMoney, and "120k"
    // is the same answer as "120000". A figure that is not a positive number is refused in the
    // plainest way there is — the field goes back to what the page says, and the card that has not
    // been answered yet keeps its red border and its overlay, which is what it is waiting for.
    //
    // And a figure under COMPOSE_FLOOR is refused by the same rule and for the same reason. It is
    // not a small placement, it is one the payload cannot carry: the saturation point is written
    // into a cell with two decimals and the spend row is twelve copies of it, so a medium said to
    // saturate at a fraction of a unit a month reaches the build as a channel that absorbs nothing
    // and generates nothing. Refusing it here is what makes the two fields agree with the grips on
    // the bar and the levers under the chart, which stop at the same wall.
    onChannelCurveChange (uid, key, value) {
      if (key !== 'knee' && key !== 'ceiling') return
      const amount = this.parseAmount(value)
      if (!(amount >= COMPOSE_FLOOR)) {
        this.formKey++
        return
      }
      // What the plan is standing at before this channel moves, which is what it will be put back
      // to: a curve moved on the media step must not resize a budget answered on the next one. See
      // holdSpendTotal, and spendHeldBefore for the two cases where there is nothing to hold.
      const held = this.spendHeldBefore(uid)
      // Typed against what the card SHOWS, which is a reading of the curve as it stands, so the
      // figure is converted back to the placement that reads as it — see composeRestate. A channel
      // with no placement yet has nothing to convert against and no curve to have moved, and there
      // the typed figure IS the placement.
      const restated = composeRestate(
        this.statedFor(uid), this.curveEdits[String(uid)], this.hillFor(uid), key, amount
      )
      const said = restated || Object.assign({}, this.statedFor(uid))
      if (!restated) said[key] = amount
      this.$set(this.statedCurves, String(uid), said)
      this.rebuild()
      this.holdSpendTotal(held)
      // A curve that moved is a corridor that moved — both ends of the spend's are read off what
      // the curves return, and so is the revenue's ceiling — so the pair is re-seated: seatSpend
      // catches a plan left standing under its floor, seatRevenue a revenue the curves no longer
      // credit enough of. The hold above lands inside that corridor already, so what is left for
      // this is a plan it could not restore.
      this.seatSpend('curves')
      this.seatRevenue()
    },

    // --- The channel editor -------------------------------------------------

    // Everything about one channel, opened from the card. There is no other way in and no other
    // place any of it is edited: the name, the two figures that place the curve in dollars, and the
    // curve's own three levers are one screen, because they are one object.
    openEditor (uid) {
      this.editUid = uid
      this.curveDraft = null
      this.loadEditor(uid)
    },
    // The drafts, off the page as it stands. Called on every arrival — the first press and every
    // step of the walk — so what is in the fields is always the channel on the screen.
    loadEditor (uid) {
      const channel = this.channels.filter(entry => entry.uid === uid)[0]
      this.snapshotEditor(uid)
      this.editorName = channel ? channel.label : ''
      this.editorKnee = this.statedLabel(uid, 'knee')
      this.editorCeiling = this.statedLabel(uid, 'ceiling')
      // A new channel is a new curve and so a new ruler. It is the one moment the bar re-fits
      // unconditionally: holding the last channel's axis would draw this one against a scale that
      // belongs to a medium no longer on the screen.
      this.zoneDragging = false
      this.zoneWindow = 0
      this.fitZoneWindow()
      // A CHANNEL JUST WRITTEN DOWN IS OPENED ON ITS NAME, and every other arrival on the pair.
      //
      // What the dialog opens waiting for is whatever nobody has said yet. On an imported channel
      // that is the two figures: the name arrived from the model that measured it and is usually the
      // right one. A scratch channel has no such name — it is "New channel", written by the wizard
      // because a channel has to be called something — so the first thing about it that is still
      // unanswered is what it IS, and the pair comes after.
      //
      // Consumed here, so it is true of the arrival that was created and not of the walk that later
      // passes through the same channel: by then the name is the reader's own and a caret dropped
      // into it would be offering to retype an answer.
      if (this.editorNameArrival) {
        this.editorNameArrival = false
        this.focusNewName()
        return
      }
      this.focusKnee()
    },
    // WHERE THE CARET GOES ON THE WAY IN. A channel is opened to be answered, and what it is waiting
    // for is the pair on the saturation point card: the chart to the left is drawn on a placeholder
    // scale and every figure below the cards is silent about this channel until both are typed. So a
    // dialog that opens on a pair of em dashes puts the caret in the first of them.
    //
    // ONLY WHILE THE PAIR IS UNSTATED. A channel already placed is opened to be looked at as often
    // as to be corrected — the walk goes through every channel and not only the unanswered ones —
    // and taking the focus into a field that already holds a figure would put a stray keystroke into
    // a number nobody meant to retype.
    //
    // The delay is Vuetify's, and the same one the importer's search carries: VDialog moves the focus to its
    // own content on the tick after it opens, so a focus taken on nextTick is taken and given back.
    // Everything is re-checked when it fires — the dialog may have been closed, walked on to another
    // channel, or answered in the meantime.
    focusKnee () {
      const uid = this.editUid
      setTimeout(() => {
        if (this.editUid !== uid || this.editorStated) return
        const el = this.$refs.editorKneeField
        if (el && el.focus) el.focus()
      }, 220)
    },
    // TAB GOES ROUND THE FOUR THINGS THIS SCREEN ASKS FOR, and nothing else.
    //
    // The dialog holds three sliders, a bar with five grips, a dozen decay tiles, two arrows, a
    // reset and two more buttons — every one of them focusable, and every one of them a way of
    // MOVING something that has already been answered. What the screen ASKS is four things: what
    // this channel is called, where it saturates, what it generates there, and whether to keep it.
    // A reader answering those with the keyboard had to walk the whole dialog to get from the second
    // field to the third, so the tab key is given the four and made to loop.
    //
    // The rest keeps its own focus: the levers and the tiles are reached with the pointer, and each
    // one is still a real control that answers Enter and Space once it has been reached — nothing
    // here is taken out of the tab order, the four stops simply hand the focus straight on. Which is
    // also why Shift walks it backwards: a ring the key can only go one way round is a trap.
    editorTab (from, back) {
      const ring = ['name', 'knee', 'ceiling', 'save']
      const at = ring.indexOf(from)
      if (at === -1) return
      this.focusEditorStop(ring[(at + (back ? ring.length - 1 : 1)) % ring.length])
    },
    // One of the four, focused the way the browser would have focused it: a field arrived at by tab
    // holds its own value selected, so the answer standing there is typed over rather than edited
    // into. The button is a button and takes none of that.
    focusEditorStop (stop) {
      const refs = {
        name: 'editorNameField',
        knee: 'editorKneeField',
        ceiling: 'editorCeilingField',
        save: 'editorSaveButton'
      }
      const found = this.$refs[refs[stop]]
      const el = found && found.$el ? found.$el : found
      if (!el || !el.focus) return
      el.focus()
      if (stop !== 'save' && el.select) el.select()
    },
    // The caret in the name with the placeholder selected, on the same delay and under the same
    // re-checks focusKnee carries — VDialog takes the focus to its own content a tick after it
    // opens, so a focus taken any sooner is taken and given straight back.
    //
    // SELECTED and not merely focused, because what is standing there is not an answer: "New
    // channel" is the wizard's way of having something to call a card that has just appeared, and
    // the gesture it is waiting for is a name typed over it. A caret at the end would make the
    // reader clear it first.
    focusNewName () {
      const uid = this.editUid
      setTimeout(() => {
        if (this.editUid !== uid) return
        const el = this.$refs.editorNameField
        if (!el || !el.focus) return
        el.focus()
        if (el.select) el.select()
      }, 220)
    },
    closeEditor () {
      this.editUid = null
      this.editorSnapshot = null
      this.editorLeave = null
      this.editorLeaveDialog = false
      this.curveDraft = null
      this.editorName = ''
      this.editorKnee = ''
      this.editorCeiling = ''
      this.zoneDragging = false
      this.zoneWindow = 0
    },
    // Everything this channel is, as it stands. The three maps are the payload's, the label is the
    // channel's own, and the two levels are the plan's — a curve edit re-seats them, so putting the
    // curve back has to put them back too.
    snapshotEditor (uid) {
      const key = String(uid)
      const channel = this.channels.filter(entry => entry.uid === uid)[0]
      const stated = this.statedCurves[key]
      const curve = this.curveEdits[key]
      const decay = this.decayEdits[key]
      this.editorSnapshot = {
        uid: uid,
        label: channel ? channel.label : '',
        stated: stated ? Object.assign({}, stated) : null,
        curve: curve ? Object.assign({}, curve) : null,
        decay: Array.isArray(decay) ? decay.slice() : null,
        spendFactor: this.spendFactor,
        revenueFactor: this.revenueFactor
      }
    },
    // Whether anything on this channel has moved since the dialog arrived on it. It is asked of the
    // FORM and not of the fields: everything typed here commits on blur, and pressing any of the
    // three ways out of the dialog blurs whatever was being typed first.
    editorDirty () {
      const snap = this.editorSnapshot
      if (!snap) return false
      const key = String(snap.uid)
      const channel = this.channels.filter(entry => entry.uid === snap.uid)[0]
      if (channel && channel.label !== snap.label) return true
      return !sameSnapshot(snap.stated, this.statedCurves[key] || null) ||
        !sameSnapshot(snap.curve, this.curveEdits[key] || null) ||
        !sameSnapshot(snap.decay, this.decayEdits[key] || null)
    },
    // Cancel, in full: the channel goes back to what it was and so do the two levels its curve was
    // holding up. Rebuilt once, at the end, and then re-seated the way every other curve edit is.
    revertEditor () {
      const snap = this.editorSnapshot
      this.editorSnapshot = null
      this.curveDraft = null
      if (!snap) return
      const key = String(snap.uid)
      const at = this.channels.findIndex(entry => entry.uid === snap.uid)
      if (at !== -1 && snap.label && this.channels[at].label !== snap.label) {
        this.$set(this.channels, at, Object.assign({}, this.channels[at], { label: snap.label }))
      }
      const put = (map, value) => {
        if (value) this.$set(map, key, value)
        else this.$delete(map, key)
      }
      put(this.statedCurves, snap.stated)
      put(this.curveEdits, snap.curve)
      put(this.decayEdits, snap.decay)
      this.spendFactor = snap.spendFactor
      this.revenueFactor = snap.revenueFactor
      this.rebuild()
      this.seatSpend('curves')
      this.seatRevenue()
    },
    // THE THREE WAYS OUT, AND THE ONE QUESTION THEY ASK. Save keeps what is on the screen — which
    // the form is already carrying, so there is nothing to write, only a snapshot to drop. Cancel
    // and the walk to another channel both leave the edits behind, so both stop and ask first, and
    // only where there is something to lose.
    // SAVED, AND THEN WHATEVER THE BUTTON SAID IT WOULD DO. There is nothing to write either way —
    // every edit on this screen was committed as it was typed, so saving is dropping the snapshot
    // Cancel would have put back — and what is left is where the reader is taken: out to the grid
    // when the model is finished, and on to the next channel that is still asking while one is.
    //
    // It asks nothing on the way, unlike the arrows, which stop where there are edits that would be
    // lost: this button IS the save, and what it does with the edits is written on it.
    saveEditor () {
      this.editorSnapshot = null
      const uid = this.editorNextPending
      if (uid === null) {
        this.closeEditor()
        return
      }
      this.editUid = uid
      this.curveDraft = null
      this.loadEditor(uid)
    },
    requestClose () {
      if (this.editorDirty()) {
        this.editorLeave = { type: 'close' }
        this.editorLeaveDialog = true
        return
      }
      this.closeEditor()
    },
    requestStep (delta) {
      if (this.editorDirty()) {
        this.editorLeave = { type: 'step', delta: delta }
        this.editorLeaveDialog = true
        return
      }
      this.editorStep(delta)
    },
    // Answered: keep the edits, or drop them, and then do the thing that was asked for. Staying is
    // the dialog closing and nothing else.
    leaveWithSave () {
      this.editorSnapshot = null
      this.finishLeave()
    },
    leaveWithoutSaving () {
      this.revertEditor()
      this.finishLeave()
    },
    finishLeave () {
      const intent = this.editorLeave
      this.editorLeave = null
      this.editorLeaveDialog = false
      if (!intent) return
      if (intent.type === 'step') this.editorStep(intent.delta)
      else this.closeEditor()
    },
    onEditorDialog (open) {
      if (!open) this.requestClose()
    },
    // The walk, in the grid's own order and looping in both directions. It is every channel and not
    // only the unanswered ones: a queue is a thing the user is put through, and this is a way around
    // the model — after correcting Search, the channel wanted next is as likely to be one already
    // answered. It is reached through requestStep, which is where the walk stops to ask about edits
    // that have not been saved — by the time this runs the question is answered and the channel
    // being left is either kept or already put back.
    editorStep (delta) {
      const list = this.channels
      if (list.length < 2 || this.editUid === null) return
      const at = list.findIndex(entry => entry.uid === this.editUid)
      if (at === -1) return
      const next = list[(at + delta + list.length) % list.length]
      this.editUid = next.uid
      this.curveDraft = null
      this.loadEditor(next.uid)
    },
    // The name. Committed on blur and on Enter, and refused in the plainest way there is: a name the
    // payload cannot carry — empty, or one another channel has claimed — goes back to the one the
    // channel has. The message under the field is what says why while it is still being typed.
    // The whole title line answers a click, the pencil at its end included: it is a mark on the
    // rule and not a control, so what it does is what clicking the text does.
    focusName () {
      const el = this.$refs.editorNameField
      if (el) el.focus()
    },
    commitName () {
      if (this.editUid === null) return
      const uid = this.editUid
      const name = mediumName(this.editorName)
      const channel = this.channels.filter(entry => entry.uid === uid)[0]
      if (!channel) return
      if (this.editorNameError !== '' || !name) {
        this.editorName = channel.label
        return
      }
      this.renameChannel(uid, name)
      this.editorName = name
    },
    // A figure. The same rule and the same refusal: onChannelCurveChange takes what parses to an
    // amount at or above COMPOSE_FLOOR and leaves everything else alone, and the field then goes
    // back to what the page says — which is the empty string on a channel nobody has answered yet,
    // and the figure it already had on one being corrected.
    commitFigure (key) {
      if (this.editUid === null) return
      const uid = this.editUid
      const typed = key === 'knee' ? this.editorKnee : this.editorCeiling
      if (String(typed).trim() !== '' && this.parseAmount(typed) > 0) {
        this.onChannelCurveChange(uid, key, typed)
      }
      const back = this.statedLabel(uid, key)
      if (key === 'knee') this.editorKnee = back
      else this.editorCeiling = back
    },

    // --- The opening, and why there no longer is one -----------------------

    // NOTHING IS SEEDED ON THE USER'S BEHALF. The wizard used to open the Total Revenue box on a
    // reading of the media — the figure that left them explaining a tenth of it — and track that
    // reading until the box was typed into. It does not any more: the box opens EMPTY, and the
    // money below it stays inert until it is answered. See moneyReady, which is the gate.
    //
    // The argument was never that a revenue may not follow the media — it now does, the spend
    // leading and both of the revenue's walls being read off the curves. It is that a figure the
    // page put there is a figure the user is invited to accept without deciding, and the size of
    // the business is not a thing the wizard knows. The old opening did not derive a revenue from
    // the spend the user had chosen, either: it derived one from the media as IMPORTED, before
    // anybody had said what would be spent on them, and then went on rewriting it as cards arrived.
    // What follows the spend today follows it only where the build would otherwise be refused, once,
    // and says so in a note — see seatRevenue.
    //
    // What is lost with it is the coherent page a fresh set of channels used to open on. That is
    // the point: a page with no revenue on it has nothing true to say about attribution, ROAS or
    // base, and saying nothing is the honest version of that state.

    // AND THE SPEND IS NOT SEATED EITHER. It opens where the cards put it — every channel standing
    // at the saturation point its own card states — and nothing moves it until the user does.
    //
    // THE FLOOR OF THE CORRIDOR WAS TRIED HERE and is a trap, which is worth writing down because it
    // is the obvious thing to reach for once the revenue is asked first: seat the plan on the least
    // media the stated revenue can carry, and let the user raise it from there. Two things are wrong
    // with it, and they are the same thing seen twice.
    //
    // The corridor's low end WAS the ATTRIBUTION wall in the arrangement that tried this — the
    // other two, a channel's cells rounding away against COMPOSE_FLOOR and the media returning less
    // than a unit a month, sit orders of magnitude below it — and that wall is
    // leastAttributionCentre, which is 0.065 %. So the seated plan was not a small media budget, it
    // was a model in which the media explain a fifteen-hundredth of the business: two or three
    // orders of magnitude under the plan the cards describe, with the Max. ROAS mark the copy
    // invites the user to drag toward decades away to the right, and the whole of the 1 %
    // FLOOR_MARGIN between it and a hard validator error.
    //
    // And composeRevenueCeiling is that same wall read as a revenue — `0.999 · marketing · 100 /
    // least` — so a plan sitting on it puts the Total Revenue box against its own ceiling:
    // `ceiling/revenue = 0.999 · centre/least`, and with the plan seated a hair above the wall that
    // is between 1.009 and about 1.03. The revenue could then never be raised again by more than a
    // percent or three. That wall is now the revenue's alone — the spend is held by the two floors
    // and nothing else, see tradeLimits — which removes the seat this paragraph is about but not
    // the reason not to reach for it: a plan opened there would still put a box against its own
    // ceiling before the user had typed anything into it.
    //
    // The saturation opening has neither problem: it is the plainest reading of what the user typed
    // on the cards, it needs no constant of ours, and it leaves both figures room on both sides.

    // --- The curves, moved ------------------------------------------------

    // The one edit in this wizard that changes what the money BUYS rather than how much of it there
    // is. Everything else here is a level read off responses that stand where the source model
    // measured them; this moves a response, and every figure on the page follows because every
    // figure on the page is read off the curves.
    //
    // Opened per channel and one at a time, which is what makes the chart affordable: the cards draw
    // sparklines rather than fifteen ECharts instances, and this is one instance that exists only
    // while the dialog is open.
    // Mid-drag. The form is not rebuilt: the chart and the levers are drawn from these three
    // numbers alone. Nothing else in the editor reads them, because nothing else in the editor
    // is a reading of the plan — what a moved curve does to the revenue, the ROAS and the
    // attribution is read where those figures live, off the built form, once the drag commits.
    // AND NOT WHILE THE BAR OWNS THE GESTURE. The levers are handed the zone bar's own draft as it
    // is dragged — see curveLeverParams, a boundary moved being an exponent moved — and a slider
    // handed a value off its step grid re-emits the rounded one as though the thumb had been moved.
    // See sliderValue, which is where that is now stopped; this is the same statement from the
    // other end, and it is worth making twice. A lever cannot be moved while a boundary is being
    // dragged: there is one pointer.
    onCurvePreview (params) {
      if (this.zoneDragging) return
      this.curveDraft = params
    },
    // Committed. Stored as RATIOS over the fit the channel was imported with — see curveEdits — so
    // the edit goes on meaning the same thing after a period change or a change of unit rates, both
    // of which re-run the fit.
    onCurveInput (params) {
      const uid = this.editUid
      const imported = this.curveImported
      this.curveDraft = null
      if (uid === null || !imported) return

      // The budget this channel's curve is being moved under — see holdSpendTotal. A lever moves
      // the response and, through the cells the response places, the size of the plan; the size is
      // the next step's answer and is put back.
      const held = this.spendHeldBefore(uid)
      const ratios = {}
      let moved = false
      CURVE_KEYS.forEach(key => {
        const from = Number(imported[key])
        const to = Number(params[key])
        const ratio = isFinite(from) && from > 0 && isFinite(to) && to > 0 ? to / from : 1
        if (Math.abs(ratio - 1) > 0.0005) moved = true
        ratios[key] = ratio
      })
      // Back on the model's own numbers is not an edit, and an entry of three ones would keep the
      // channel on the code path that rewrites its rows for no reason.
      if (moved) this.$set(this.curveEdits, String(uid), ratios)
      else this.$delete(this.curveEdits, String(uid))

      this.rebuild()
      this.holdSpendTotal(held)
      // For the same reason it runs after a channel is dropped: a response that moved changes what
      // the payload's marketing attribution implies, which is the ceiling over the revenue — and it
      // moves the floor under the spend, the cells a medium's row rounds into being written at the
      // level the curve now says.
      this.seatSpend('curves')
      this.seatRevenue()
    },

    // --- The five zones, moved --------------------------------------------

    // WHAT A BOUNDARY DRAGGED ALONG THE BAR COMES TO, in the three parameters that are the only
    // thing this editor can actually commit.
    //
    // Held inside the exponent's own range and its own walls, which is the same corridor the lever
    // for it is held in: the bar and the third lever are two ways of moving one number, so a
    // boundary cannot be dragged somewhere the lever would have been stopped.
    //
    // AND HELD ABOVE THE FLOOR, which is the wall the exponent's corridor knows nothing about. Under
    // HILL_HOLD_SHAPE a dragged boundary does not move the shape at all — it slides the whole curve
    // along the spend axis, which is a move of the PLACEMENT and commits as one — so the exponent
    // never leaves its corridor however far the grip is taken, and there was nothing else in the way.
    // Dragged left, that is a factor under one on every boundary at once and on the saturation point
    // with them; and because the bar re-fits its own ruler around a curve that shrank, the same
    // gesture is available again immediately at the new size. A dozen of them put the channel at a
    // fraction of a unit a month, which reads as 0 in the field beside the chart and reaches the
    // build as a medium that absorbs nothing.
    //
    // So a solution whose own two figures fall under COMPOSE_FLOOR is not a solution: null, exactly
    // as for a place on the axis no exponent can put this boundary. The grip stops there, the curve
    // on the screen stays the last one that was actually asked for, and the release commits it —
    // see onZoneInput, which already holds the last curve a gesture drew for precisely this reason.
    zoneParamsFor (index, value) {
      const bounds = this.curveBounds
      const limits = this.curveLimits
      const range = bounds ? bounds.n : null
      const wall = limits ? limits.n : null
      const next = hillRegionSet(this.curveParams, index, value, {
        hold: this.zoneHold,
        pin: this.zoneHoldPin,
        nMin: Math.max(range ? Number(range.min) : 0, wall ? Number(wall.min.value) : 0),
        nMax: Math.min(range ? Number(range.max) : Infinity, wall ? Number(wall.max.value) : Infinity)
      })
      return composeCurveAboveFloor(next) ? next : null
    },
    // WHAT THE SWITCH IS HOLDING, ON THE BAR ITSELF.
    //
    // Two of the three settings name a boundary — the fourth under HILL_HOLD_SATURATION, and any of
    // the other three under HILL_HOLD_EDGE — and a named boundary does not take a pointer: a control
    // that says a thing is held and then hands you a handle on it is a label that is not true. The
    // grip stays where it is and stops being a grip, and the figure under it stops being a field.
    //
    // Nothing becomes unreachable by it. The held boundary is one click away from being the moved
    // one — that is what the switch is — and the fourth has its own field beside the chart besides,
    // which is where a placement is stated. Holding the SHAPE holds no boundary at all, and there
    // every grip on the bar moves.
    //
    // Asked of a boundary index, so it is one statement read by the zone that draws it, the drag
    // that would move it and the field that would type it.
    zoneLocked (index) {
      if (this.zoneHold === HILL_HOLD_SATURATION) return index === ZONE_PLACEMENT
      if (this.zoneHold === HILL_HOLD_EDGE) return index === this.zoneHoldPin
      return false
    },
    // The switch over the bar. It changes nothing that is on the screen — the boundaries stand
    // where they stood — and everything about what the NEXT gesture means, which is why it is a
    // control with a word on it rather than a preference somewhere else. A setting that names a
    // boundary carries which one, and the two are set together: a pin left over from the setting
    // before it would hold a boundary the switch is no longer pointing at.
    setZoneHold (choice) {
      if (!choice) return
      const hold = choice.value
      if (hold !== HILL_HOLD_SATURATION && hold !== HILL_HOLD_SHAPE && hold !== HILL_HOLD_EDGE) return
      if (hold === HILL_HOLD_EDGE && ZONE_PINS.indexOf(choice.pin) === -1) return
      this.zoneHold = hold
      if (hold === HILL_HOLD_EDGE) this.zoneHoldPin = choice.pin
    },
    // Mid-drag, and the same bargain the levers' own preview makes: the form is not rebuilt, the
    // chart and the bar are drawn from these three numbers, and everything that is a reading of the
    // PLAN waits for the release. The flag is what lets the levers show the drag as it happens —
    // a boundary moved is an exponent moved, and a lever that only caught up on release would be
    // saying the bar had done something else.
    onZonePreview (index, value) {
      if (this.zoneLocked(index)) return
      const next = this.zoneParamsFor(index, value)
      if (!next) return
      this.zoneDragging = true
      this.curveDraft = next
    },
    // Committed, and it matters WHERE. A boundary that moved the SHAPE commits as a moved curve,
    // which is what curveEdits is and what marks the channel as no longer a copy. A boundary that
    // moved the PLACEMENT says how far out in dollars this channel's whole response stands, which
    // is what the field above the levers states, and it goes through that field's own path — so
    // there is one meaning per number rather than two ways of saying the same thing that a rebuild
    // would then have to reconcile.
    //
    // Which of the two a gesture was is the switch's answer and not the grip's. Holding the SHAPE
    // makes every boundary the placement: nothing about the curve changes except how far out in
    // dollars the whole of it stands. Holding a boundary — the saturation point or one the reader
    // named — makes every drag a move of the exponent, the fourth boundary included, and that one
    // is the gesture no other setting can ask for: where the channel saturates, moved with
    // something else standing still. The figure handed to the placement is read off the parameters
    // that came back rather than off the pointer, the grip and the saturation point being different
    // numbers under three of the four grips.
    onZoneInput (index, value) {
      if (this.zoneLocked(index)) return
      const uid = this.editUid
      // The curve the release lands on, or the last one THIS GESTURE drew. A pointer that ran past
      // what the shape can follow leaves nothing to solve — see hillRegionSet, which refuses rather
      // than walking the exponent to the end of its range — and a gesture that ended out there is
      // still a gesture: what commits is what the bar was showing when it stopped moving, rather
      // than everything the drag did being thrown away because its last inch had no answer.
      //
      // Only its own, which is what the flag says: a draft left on the page by anything else is not
      // an answer to a gesture that has none, and committing one would move the curve to a place
      // nobody asked for.
      const drawn = this.zoneDragging ? this.curveDraft : null
      const next = this.zoneParamsFor(index, value) || drawn
      this.zoneDragging = false
      this.curveDraft = null
      if (uid === null || !this.editorPlaced || !next) return
      if (this.zoneHold === HILL_HOLD_SHAPE) {
        this.onChannelCurveChange(uid, 'knee', hillDiminishingReturns(next))
        return
      }
      this.onCurveInput(next)
    },
    // The bar's ruler, fitted AROUND the boundaries rather than following them: held for the length
    // of a gesture, and held afterwards too for as long as the saturation point stays inside the
    // band. A bar that re-fitted on every commit would redraw its own five widths each time a grip
    // was let go, and ask the reader to find the shape again every time they moved it.
    //
    // AND HELD HARDER WHILE A BOUNDARY IS PINNED, because there the ruler is the promise. A pinned
    // edge sits at its own figure over the top of the axis, so a ruler that re-fitted under it
    // would slide it along the bar with its figure unmoved — which is the reader's question
    // answered wrongly: what they see move is the thing the switch has just said stands still. So
    // the low end of the band does not apply: a curve that SHRANK keeps the ruler it was drawn on,
    // every band staying readable however small it gets because every zone has a floor of the bar
    // whatever its share of the axis. Only a curve that has outgrown the bar re-fits it, there
    // being no way to draw a boundary that runs off the end — and an interior boundary loses very
    // little of its place when the ruler grows, its share of a longer axis being smaller. The
    // convention that holds the saturation point reaches neither test: the ruler is a function of
    // the one thing it is not letting move.
    fitZoneWindow () {
      if (this.zoneDragging) return
      const at = this.curveSaturationAt
      if (!(at > 0)) return
      const held = this.zoneWindow
      if (!(held > 0)) {
        this.zoneWindow = at * ZONE_WINDOW_HEADROOM
        return
      }
      const floor = this.zoneHold === HILL_HOLD_EDGE ? 0 : ZONE_WINDOW_LOW
      if (at < held * ZONE_WINDOW_HIGH && at > held * floor) return
      this.zoneWindow = at * ZONE_WINDOW_HEADROOM
    },
    // BACK TO THE CHANNEL AS IT WAS IMPORTED, and the word is CHANNEL rather than curve.
    //
    // It used to hang under the three levers, where it could only mean "undo these three". It sits
    // on the bar now and undoes everything on this screen that was an edit to what the source model
    // measured: the saturation curve, wherever it was moved from — a lever, a grip on the zone bar,
    // or a figure typed into the pair — and the two decay intervals. The two are deleted in one
    // gesture because the reader's question is one: this channel is no longer the one its model
    // fitted, put it back.
    //
    // Not the two figures that PLACE it. Those are nobody's import — no source model can supply
    // them — so there is nothing to put them back to.
    resetCurve () {
      this.curveDraft = null
      if (this.editUid === null || !this.curveCanReset) return
      const held = this.spendHeldBefore(this.editUid)
      this.$delete(this.curveEdits, String(this.editUid))
      this.$delete(this.decayEdits, String(this.editUid))
      this.rebuild()
      this.holdSpendTotal(held)
      this.seatSpend('curves')
      this.seatRevenue()
    },
    curveReason (reason) {
      if (!reason) return ''
      return this.$t(`components.ekrm.CreateModelCompose.curve_stop_${reason}`)
    },
    // The number beside a lever is typed back into the same field, so it is the cell's own rounding
    // and never the compact form the headline boxes wear: a field of type="number" shows nothing at
    // all for "1.2m". Two decimals under a thousand, whole units over it, which is what toCell does
    // to every figure this payload carries.
    formatCurveValue (key, value) {
      const number = Number(value)
      if (!isFinite(number)) return ''
      if (key === 'n') return Math.round(number * 100) / 100
      return Number(toCell(number))
    },
    curveMoved (uid) {
      return Object.prototype.hasOwnProperty.call(this.curveEdits, String(uid))
    },

    // --- The decay, per channel -------------------------------------------

    // WHEN A MONTH'S SPEND ON THIS MEDIUM ARRIVES, as the kernel the payload carries: one weight per
    // lag month, the response climbing to a peak and falling away from it.
    //
    // It is the second of the two curves a channel is imported with, and it is the one that used to
    // be read-only. The reason it was is a good one and is still the opening: the source model
    // MEASURED this, off a spend history and a sales history, which is exactly the kind of claim
    // this wizard has no other way of making. The reason it could not stay read-only is that the
    // measurement is about that business — its market, its creative rotation, how long its customers
    // take to decide — and a channel lifted out of it into a model of another business carries the
    // shape and not the calendar.
    //
    // WHAT IS EDITED IS THE CURVE AND WHAT IS OFFERED IS ITS TWO FIGURES. The payload states a decay
    // twice, as the kernel and as two brackets beside it, and the builder reads the kernel wherever
    // there is one — so the kernel is the thing and the brackets are a reading of it. But a kernel
    // is not drawn bar by bar: its total is fixed, so every bar moved moves all the others, and a
    // row of bars each answered on its own stops being a decay at the second one. So the two figures
    // a decay has always been stated in are what the card moves — where it peaks and how fast it
    // falls — as a grid of generated shapes to pick from (composeDecayTemplates) and as a handle on
    // the peak of the plot for everything between them (composeDecayFromShape).
    //
    // AND IT IS NOT BEHIND THE EXPERT SWITCH AND DOES NOT WAIT FOR THE PAIR. Everything that switch
    // hides is a way of moving the shape BETWEEN two figures the user typed, and every reading on
    // that half of the screen is a reading of those figures. Neither is true here: the kernel is a
    // shape, and what share of a month's spend arrives in each month after it is as true before the
    // pair is typed as after.

    // The kernel this channel is currently carrying: its own edit if there is one, and the decay
    // its source model measured if there is not. Null for a channel whose source has no readable
    // decay at all, which is what the editor draws its "no curve" on.
    decayFor (uid) {
      const edit = this.decayEdits[String(uid)]
      return edit || this.sourceDecayFor(uid)
    },
    // What the source model measured, on the monthly lag axis the EKRM being built will read it on.
    // It is what an edit is measured against and what the first tile puts the channel back on, and
    // it is read off the channel's own readChannel output rather than off the built form: the form
    // carries the EDIT once there is one, and a channel that has not been placed has no entry in the
    // form at all.
    sourceDecayFor (uid) {
      const channel = this.channels.filter(entry => entry.uid === uid)[0]
      const read = channel ? this.readFor(channel) : null
      if (!read) return null
      return composeDecayKernel(read.sourceDecay, this.granularityFor(channel.modelId))
    },
    decayMoved (uid) {
      return composeDecayMoved(this.decayEdits[String(uid)], this.sourceDecayFor(uid))
    },
    // A SHAPE PICKED, which is the whole of the gesture. There is nothing to preview and nothing to
    // commit: a tile is a kernel, and pressing it is the edit.
    //
    // Stored only while it says something other than what the model measured — the first tile is the
    // model's own, so pressing it is how a channel is put back, and what it leaves behind is not an
    // edit that happens to agree with the source but no edit at all. That is what keeps the curve
    // the source measured in the payload rather than a redrawing of it.
    //
    // Nothing is re-seated on the plan. A decay is not money and not a response level: every
    // template is generated at the total the channel already carries, so no spend cell, no
    // saturation curve and no revenue can have moved with it. The rebuild is for the payload alone.
    onDecayPick (kernel) {
      if (this.editUid === null || !Array.isArray(kernel)) return
      this.writeDecay(this.editUid, kernel)
    },
    // THE SHAPE PULLED BY HAND, which arrives here already built. The component moves the two
    // figures a decay is stated in and composeDecayFromShape regenerates the whole kernel from them
    // at the total the channel already carries — so a drag cannot move what a month's spend is worth
    // in the end, only when it arrives, and what lands here is a decay rather than a row of bars
    // somebody pushed at.
    //
    // It goes through writeDecay like a tile does, which is what lets a drag that arrives back on
    // the model's own measurement leave no edit behind at all.
    onDecayShape (kernel) {
      if (this.editUid === null || !Array.isArray(kernel)) return
      this.writeDecay(this.editUid, kernel)
    },
    // What both of them come to. Stored only while it says something other than what the model
    // measured — the first tile is the model's own, so pressing it is how a channel is put back, and
    // what it leaves behind is not an edit that agrees with the source but no edit at all. That is
    // what keeps the curve the source measured in the payload rather than a copy of it.
    writeDecay (uid, kernel) {
      if (composeDecayMoved(kernel, this.sourceDecayFor(uid))) {
        this.$set(this.decayEdits, String(uid), kernel)
      } else {
        this.$delete(this.decayEdits, String(uid))
      }
      this.rebuild()
    },

    notReadyLabel (reason) {
      return this.$t(`components.ekrm.CreateModelCompose.notReady_${reason}`)
    },
    skippedLabel (entry) {
      return this.$t(`components.ekrm.CreateModelCompose.skipped_${entry.reason}`, { channel: entry.raw })
    },
    // The two decimals a drawn month is stored at, which is what the plot writes over a column and
    // what a field opens on. An edit round-trips through exactly what was on screen.
    roundShare (value) {
      return Math.round((Number(value) || 0) * 100) / 100
    },
    formatMoney (value) {
      return numbro(Number(value) || 0).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    // The same compact form with a digit more, for the figures that can be typed back in: an edit
    // round-trips through what is on screen, so a decimal dropped here is a decimal lost.
    formatAmount (value) {
      return numbro(Number(value) || 0).format({
        average: true,
        lowPrecision: false,
        mantissa: 2,
        optionalMantissa: true
      })
    },
    // A ROAS at the decimals it needs to keep two significant ones, as a NUMBER rather than as a
    // string: the bar charts of the model preview draw their labels full-precision — the report's
    // own bargain, and the reason its own values arrive already rounded — so what is rounded is the
    // datum and not the rendering of it. formatRoas below is the same rule for a figure that is
    // being written into a sentence.
    roundRoas (value) {
      const roas = Number(value) || 0
      const places = Math.pow(10, roasMantissa(roas))
      return Math.round(roas * places) / places
    },
    formatRoas (value) {
      return numbro(Number(value) || 0).format({
        thousandSeparated: true,
        mantissa: roasMantissa(Number(value) || 0),
        optionalMantissa: true,
        trimMantissa: true
      })
    },
    // Whether a figure has been moved from the source's. The threshold is there because every figure
    // round-trips through two decimals of a compact form, so a factor lands on 1.0003 rather than on
    // 1 often enough to matter.
    isMoved (factor) {
      return Math.abs((Number(factor) || 1) - 1) > 0.005
    },

    // --- Save -------------------------------------------------------------

    createReferenceModel () {
      if (!this.canCreate) return
      const result = validateEkrmForm(this.formState, 0)
      this.errors = result.errors
      // The warnings this wizard is designed to produce are its own decisions, not something the
      // user chose or can change: the saturation grid is placed on the curve on purpose, and a model
      // report carries no co-marketing attribution and no growth expectations. Showing them would be
      // asking about fields that were deliberately never displayed.
      this.shownWarnings = result.warnings.filter(warning => EXPECTED_WARNING_CODES.indexOf(warning.code) === -1)
      if (this.errors.length === 0 && this.shownWarnings.length === 0) {
        this.saveEkrm()
      } else {
        this.warningDialog = true
      }
    },
    saveEkrm () {
      this.creating = true
      this.createEkrm({
        definition: buildEkrmDefinition(this.formState),
        originalDefinition: buildEkrmOriginalDefinition(this.formState, {
          sources: this.provenance,
          curves: this.built.form.curves,
          // Always null. It names the calendar months a multi-year grid's columns are, and this
          // wizard sends one year: twelve columns that are January to December by construction and
          // have no real months to claim.
          months: null
        }),
        createdBy: this.createdBy,
        createdById: this.createdById,
        origin: COMPOSER_ORIGIN
      }).then(() => {
        this.creating = false
        this.$emit('close-dialog')
      }).catch(error => {
        console.error('Could not create the EKRM:', error)
        this.creating = false
      })
    },
    closeDialog () {
      this.$emit('close-dialog')
    },
    goNext () {
      if (!this.canLeaveStep || this.step >= 7) return
      this.step++
      this.scrollStepTop()
    },
    goBack () {
      if (this.step <= 1) return
      this.step--
      this.scrollStepTop()
    },
    // A step is a page, and a page opens at its top. The scroller is the card's own text pane —
    // .clone-page, which is what grows and what the fullscreen dialog leaves the overflow to — so a
    // long step left halfway down does not hand the next one to the user already scrolled.
    scrollStepTop () {
      this.$nextTick(() => {
        const pane = this.$el && this.$el.querySelector('.clone-page')
        if (pane) pane.scrollTop = 0
      })
    }
  },
  computed: {
    ...mapGetters('settings', ['countries']),
    ...mapGetters('manager', ['mmmModels', 'customModels']),
    ...mapGetters('clients', ['clients']),

    plotViewBox () {
      return `0 0 ${PLOT_WIDTH} ${PLOT_HEIGHT}`
    },
    plotHeight () {
      return PLOT_HEIGHT
    },

    // Every model the user can reach that carries a finished report. EKRM-derived models are left
    // out: an EKRM built from another EKRM's output would compound its assumptions rather than rest
    // on measured data. `clients` is merged in because reading the whole collection needs a
    // manager/customizer/ekrm_manager role, and /manageEkrm also admits scientists — for them the
    // two catalogue loaders come back empty and their own models are all there is.
    sourceModels () {
      const seen = {}
      const models = []
      const collect = list => {
        (list || []).forEach(model => {
          if (!model || !model.id || seen[model.id]) return
          if (model.type === 'ekrm') return
          if (!hasModelReport(model)) return
          seen[model.id] = true
          models.push(model)
        })
      }
      collect(this.mmmModels)
      collect(this.customModels)
      collect(this.clients)
      return models.sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')))
    },
    // THE MODELS A COPY CAN BE TAKEN FROM, which is a shorter list than the one the channel picker
    // offers, and shorter for a reason the picker does not share: a picked channel brings a SHAPE,
    // which is dimensionless, where a copy brings levels and has to be told what the source's money
    // is worth. Both lists are already models with a finished report — see sourceModels, there being
    // nothing to read off a model that has not produced one — and this one drops, on top of that,
    // every model whose spend and sales are counted in different units, and every model in another
    // currency that carries no rate to USD. See cloneRatesKnown.
    copyModels () {
      return this.sourceModels.filter(cloneRatesKnown)
    },
    // How many channels each model has already given this EKRM. Off the channel list rather than off
    // the cards, so a channel that is on the page without being a medium of the model yet still
    // counts — it was taken from that model either way, and the question the note answers is what
    // has been taken and not what has been built.
    addedByModel () {
      const count = {}
      this.channels.forEach(channel => {
        // A channel nobody imported was taken from no model and is counted against none.
        if (!channel.modelId) return
        count[channel.modelId] = (count[channel.modelId] || 0) + 1
      })
      return count
    },
    // --- The first question: written, or copied -----------------------------

    // WHETHER THERE IS ANYTHING TO LOSE. The channels alone, and not the revenue or the year beside
    // them: a composition IS its media — every figure on the three steps below is read off them —
    // and a page with a revenue typed on it and no channel at all is a field somebody filled in, not
    // work a question has to be asked about.
    hasComposition () {
      return this.channels.length > 0
    },
    // The two tiles, named here rather than in the template: the template is handed an icon and two
    // strings and owns no decision, which is the bargain every other control on this page is written
    // under.
    sourceTiles () {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return [
        {
          mode: SOURCE_SCRATCH,
          icon: 'mdi-pencil-plus-outline',
          title: label('sourceScratch'),
          note: label('sourceScratchNote')
        },
        {
          mode: SOURCE_COPY,
          icon: 'mdi-content-duplicate',
          title: label('sourceCopy'),
          note: label('sourceCopyNote')
        }
      ]
    },
    copyModel () {
      return this.copyModelId ? this.modelById(this.copyModelId) : null
    },
    // Whether the name, the market and the fields beside them are on the page. From scratch, as soon
    // as the tile is pressed; from a copy, only once the chosen model has been read — the copy writes
    // them, so until then there is nothing in them to correct and the loading line is all there is.
    setupDetailsShown () {
      if (this.sourceMode === SOURCE_SCRATCH) return true
      if (this.sourceMode !== SOURCE_COPY) return false
      return !!this.copyModelId && !this.copyLoading && !this.copyError
    },
    // What the model being copied is about, in the line under its name — the same line its row in
    // the importer carries.
    copyModelMeta () {
      if (!this.copyModel) return ''
      const meta = modelMetadata(this.copyModel, this.countryKey)
      return MODEL_FACET_KEYS
        .filter(key => meta[key].length > 0)
        .map(key => meta[key].map(value => key === 'country' ? this.countryName(value) : value).join(', '))
        .join(' · ')
    },
    // What the payload records about a copy — see provenance. Null for a composition assembled by
    // hand, and null too for a copy the user has since emptied: what it claims is that the answers in
    // this document came from that model, and a page with no channels left carries none of them.
    copyProvenance () {
      const entry = this.sourceMode === SOURCE_COPY && this.copyModelId
        ? this.models[this.copyModelId]
        : null
      if (!entry || !this.hasComposition) return null
      const rates = this.copyRatesResolved
      return {
        model_id: this.copyModelId,
        model_name: entry.model.name || null,
        kpi: entry.kpiName,
        unit_spend: this.copyUnits.spend,
        unit_output: this.copyUnits.output,
        usd_per_spend_unit: rates ? rates.spend : null,
        usd_per_output_unit: rates ? rates.revenue : null,
        seeded: ['channels', 'saturation', 'spend', 'revenue', 'revenue_shape', 'seasonality'],
        // The channels the source offered and the copy could not carry, with the reason each was
        // refused. A payload naming eight media out of a model that has eleven says nothing about
        // the other three, and this is the only place that difference is written down.
        skipped: this.copySkipped.map(skip => ({ channel: skip.raw, reason: skip.reason }))
      }
    },
    // The units the model being copied reports in — the KPI's and the spend's. Read off the entry
    // once it has landed, because the KPI is named by the report and not by the catalogue.
    copyUnits () {
      const entry = this.copyModelId ? this.models[this.copyModelId] : null
      return cloneUnits(this.copyModel, entry ? entry.kpiName : 'Total')
    },
    // The two multipliers the model's own rates come to, or null for a model without them — which
    // copyModels never offers, a rate of 1 being the claim that its unit is a dollar.
    copyRatesResolved () {
      return cloneUnitRates(this.copyUnits, this.copyRates)
    },
    // WHAT THE COPY CAME TO, in one line: how many channels it carried across and what the business
    // it copied sold. Only once there is something to report — a model still loading or refused
    // outright says so in its own words instead.
    copySummary () {
      // Nor while the next model is being read, or once it could not be: the channels still on the
      // page are the previous copy's, and the line would report them as this one's.
      if (this.sourceMode !== SOURCE_COPY || !this.ready || !this.copyModelId) return ''
      if (this.copyLoading || this.copyError) return ''
      return this.$tc('components.ekrm.CreateModelCompose.copyDone', this.channels.length, {
        channels: this.channels.length,
        revenue: this.revenue > 0 ? `${this.formatAmount(this.revenue)} ${this.ekrmUnit}` : '—'
      })
    },
    // The months whose seasonality would not fit inside the composer's own cap, named. The copy
    // carries the year as far as it can and this is the rest of the sentence: a share of each
    // month's REVENUE read as a share of its BASE is a larger number, and a source model with a
    // strong season can land past the wall this wizard holds its own drawn years to.
    copyHeldText () {
      if (this.copyHeld.length === 0) return ''
      return this.$t('components.ekrm.CreateModelCompose.copyHeldMonths', {
        months: this.copyHeld.map(month => this.monthLabels[month] || '').join(', '),
        cap: SHAPE_MONTH_CAP
      })
    },
    // What is being thrown away, named in the question that asks about it. A copy answers most of
    // this wizard at once and so also empties most of it.
    copyAskText () {
      return this.$tc('components.ekrm.CreateModelCompose.copyAsk', this.channels.length, { channels: this.channels.length })
    },
    // The cards the last add brought in, while the ring is on them.
    justAddedMap () {
      const map = {}
      this.justAdded.forEach(uid => { map[uid] = true })
      return map
    },
    ready () {
      return !!this.built && this.built.media.length > 0
    },
    // WHETHER THERE IS MONEY ON THIS PAGE YET, and the gate everything downstream of the revenue
    // stands behind.
    //
    // `ready` says the media are placed, which is a statement about the curves and needs no revenue
    // at all — the two figures that place a channel are typed in dollars on its own card, before
    // anything else exists. This says the SIZE of the business has been answered as well.
    //
    // IT NO LONGER GATES THE MEDIA SPEND, which is the whole of what the wizard's order now means.
    // What is spent on the media and what they return per unit are statements about the curves and
    // nothing else: cloneRoas is a response over a spend, and cloneSpendFloorLimits is the corridor
    // that spend is held in with the revenue left free. Both are answerable the moment the cards
    // are, and the card carrying them opens live.
    //
    // What stands behind this gate is everything the revenue is the DENOMINATOR or the whole of:
    // the marketing attribution is what the curves return over this figure, Base Revenue is this
    // figure less that, the decomposition is the two of them side by side, and the KPI row and both
    // charts are the year itself. cloneSpendLimits belongs here too — it is the wider corridor,
    // read against the revenue, that narrows the floors above once there is one.
    //
    // Withheld and not zeroed. With no revenue the KPI row is twelve zeros and writeImpliedBand
    // writes no band at all, so every one of those readings would come back as nothing, a negative
    // or a division by zero — and a page answering questions it has not been given the figures for
    // is worse than a page that says it is waiting. So the charts and the warnings stand down, and
    // the one thing on screen below the media is the box that unblocks them.
    moneyReady () {
      return this.ready && this.revenue > 0
    },
    // Every model at least one channel has been taken from, in the order they first contributed.
    contributingModels () {
      const seen = {}
      const list = []
      this.channels.forEach(channel => {
        if (!channel.modelId || seen[channel.modelId]) return
        seen[channel.modelId] = true
        if (this.models[channel.modelId]) list.push(this.models[channel.modelId])
      })
      return list
    },
    // WHAT MAY BE DONE TO THE YEAR, named here rather than in the card — the card is handed an icon
    // and a word and owns no arithmetic, the same bargain every other box on this page is written
    // under. Two verbs and no patterns: see onRevenueRandomize for why the row is something the
    // reader moves rather than something they pick, and SHAPE_JITTER for how far one press moves it.
    revenueActions () {
      return [
        {
          key: 'randomize',
          icon: 'mdi-shuffle-variant',
          title: this.$t('components.ekrm.CreateModelCompose.shapeRandomize')
        },
        {
          key: 'flatten',
          icon: 'mdi-format-align-middle',
          title: this.$t('components.ekrm.CreateModelCompose.shapeFlatten')
        },
        // THE SAME YEAR, EARLIER OR LATER. Not a nudge and not a replacement: the twelve values keep
        // their order and their sizes and only move along the calendar, which is the one edit that
        // leaves the SHAPE identical and changes what it is a shape of. What it is for is a year
        // borrowed off a business in the other hemisphere — see onRevenueShift.
        //
        // Both directions, because a year is as often three months early as three months late and
        // reaching one by nine presses of the other is a control that only goes one way round.
        {
          key: 'shiftLeft',
          icon: 'mdi-arrow-left-bold-outline',
          title: this.$t('components.ekrm.CreateModelCompose.shapeShiftLeft')
        },
        {
          key: 'shiftRight',
          icon: 'mdi-arrow-right-bold-outline',
          title: this.$t('components.ekrm.CreateModelCompose.shapeShiftRight')
        },
        // AND THE ONE THING THAT IS NOT A NUDGE. The two verbs beside it move the row that is there;
        // this replaces it with a year some business actually sold. It is a third button rather than
        // a control of its own on the card because it answers the same question those two do — how
        // does this year fall — and because it is used once if at all, where they are pressed in
        // sequence.
        {
          key: 'import',
          icon: 'mdi-database-import-outline',
          title: this.$t('components.ekrm.CreateModelCompose.shapeImport')
        },
        // And the way back to the opening: no total, and a flat year.
        {
          key: 'clear',
          icon: 'mdi-eraser',
          title: this.$t('components.ekrm.CreateModelCompose.shapeClear')
        }
      ]
    },
    // THE SAME SIX FOR THE SEASON AND THE SPOT EVENTS, in the same order — see onShapesAction.
    shapesActions () {
      const title = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return [
        { key: 'randomize', icon: 'mdi-shuffle-variant', title: title('shapeRandomizeSeason') },
        { key: 'flatten', icon: 'mdi-format-align-middle', title: title('shapeFlattenSeason') },
        { key: 'shiftLeft', icon: 'mdi-arrow-left-bold-outline', title: title('shapeShiftSeasonLeft') },
        { key: 'shiftRight', icon: 'mdi-arrow-right-bold-outline', title: title('shapeShiftSeasonRight') },
        { key: 'import', icon: 'mdi-database-import-outline', title: title('shapeImportSeason') },
        { key: 'clear', icon: 'mdi-eraser', title: title('shapeClearSeason') }
      ]
    },

    // --- The year borrowed off another model --------------------------------

    // The report this dialog is reading, and it alone: the KPI is chosen under it, so the scope is
    // derived rather than stored and a change of KPI is a change of one field.
    shapeImportReport () {
      return this.shapeImportModelId ? this.shapeReports[this.shapeImportModelId] || null : null
    },
    shapeImportScope () {
      const report = this.shapeImportReport
      if (!report) return null
      // An input is the model's and not one KPI's, so an other input is read at the root, where
      // inputs_over_time is carried whatever outputs the model has.
      return outputScope(report, this.shapeImportOther ? 'Total' : this.shapeImportKpi)
    },
    // THE INPUTS THE MODEL CAN LEND A YEAR OF, as composeInputSeriesItems lists them.
    shapeImportSeriesChoices () {
      return this.shapeImportOther && this.shapeImportScope
        ? composeInputSeriesItems(this.shapeImportScope)
        : []
    },
    // Those inputs under the selector: the media under one heading and the external series under
    // another, each named the way the model names it — a channel by its own dictionary, a variable
    // and a category as the report spells them.
    shapeImportSeriesItems () {
      const model = this.modelById(this.shapeImportModelId)
      const items = []
      let group = null
      this.shapeImportSeriesChoices.forEach(choice => {
        if (choice.group !== group) {
          group = choice.group
          items.push({
            header: this.$t(`components.ekrm.CreateModelCompose.${group === 'media' ? 'shapeImportOtherMedia' : 'shapeImportOtherExternal'}`)
          })
        }
        let text
        if (choice.key === 'media_total') {
          text = this.$t('components.ekrm.CreateModelCompose.shapeImportOtherMediaTotal')
        } else if (choice.group === 'media') {
          text = displayName(model, choice.name) || choice.name
        } else {
          text = choice.category === null ? choice.name : `${choice.name} · ${choice.category}`
        }
        items.push({ text: text, value: choice.key })
      })
      return items
    },
    shapeImportSeriesText () {
      const item = this.shapeImportSeriesItems.find(entry => entry.value === this.shapeImportSeries)
      return item ? item.text : ''
    },
    // Whether the dialog is filling one of the two other inputs.
    shapeImportOther () {
      return this.shapeImportTarget === 'other'
    },
    // That card's total, the figure an imported year is spread across. Zero for a blank card, which
    // is the one Apply is refused on.
    shapeImportOtherTotal () {
      if (!this.shapeImportOther || !this.shapeImportOtherKey) return 0
      return this.otherValues(this.shapeImportOtherKey).reduce((sum, value) => sum + (Number(value) || 0), 0)
    },
    shapeImportCanApply () {
      if (!this.shapeImportShape) return false
      return !this.shapeImportOther || this.shapeImportOtherTotal > 0
    },
    // The outputs the model can be read at. Same rule the expert wizard states: the root of a v2
    // report is the Total, and every named output stands beside it. A model offering one of these
    // is not asked at all — see the template.
    shapeImportKpiItems () {
      const report = this.shapeImportReport
      if (!report) return []
      const items = report.v2
        ? [{ text: this.$t('components.ekrm.CreateModelCompose.shapeImportTotal'), value: 'Total' }]
        : []
      kpiNames(report).forEach(name => {
        if (name !== 'Total') items.push({ text: name, value: name })
      })
      return items
    },
    // The complete calendar years that KPI has, oldest first — see composeShapeYears for why only
    // complete ones are offered.
    shapeImportYears () {
      return this.shapeImportScope ? composeShapeYears(this.shapeImportScope) : []
    },
    // Those years under the selector, newest first, with the average of all of them over them —
    // which is what the dialog opens on and, for a model with several years, the better answer: one
    // year carries whatever happened to that business in it, and the average carries what comes
    // back. A model with a single complete year is offered that year and no average, an average of
    // one being the same row said twice.
    shapeImportYearItems () {
      const years = this.shapeImportYears
      if (years.length === 0) return []
      const items = years.length > 1
        ? [{
          text: this.$t('components.ekrm.CreateModelCompose.shapeImportAverage', { count: years.length }),
          value: null
        }]
        : []
      years.slice().reverse().forEach(year => items.push({ text: String(year), value: year }))
      return items
    },
    // Twelve multipliers of mean one, or null while there is nothing to read them off. Null is what
    // the Import button is disabled on: a year that cannot be read is not a year.
    //
    // The model's own year, moved by however many months the two arrows have moved it. A rotation
    // does not change a mean, so what comes out is still of mean one and the shape is untouched —
    // only which month each value belongs to. For the season it is not a mean that is preserved but
    // every value: the twelve percentages are the same twelve, on different months.
    //
    // The SOURCE's unit either way — multipliers for the sales year, percentages of each month's
    // revenue for the season — because that is what the model states. What the season becomes in the
    // unit this wizard draws it in is shapeImportSeason's, which needs a built form and therefore
    // cannot be this.
    shapeImportShape () {
      const scope = this.shapeImportScope
      let shape = null
      if (scope && this.shapeImportOther) {
        const choice = this.shapeImportSeriesChoices.find(item => item.key === this.shapeImportSeries)
        shape = choice ? composeInputShape(scope, choice.series, this.shapeImportYear) : null
      } else if (scope) {
        shape = this.shapeImportSigned ? composeSeasonShape(scope, this.shapeImportYear) : composeSalesShape(scope, this.shapeImportYear)
      }
      if (!shape || this.shapeImportShift === 0) return shape
      const by = this.shapeImportShift
      return shape.map((value, index) => shape[(index - by + shape.length * 2) % shape.length])
    },
    // Whether the dialog is filling the season row, which is the one difference the template has to
    // know about: a season is signed and a sales year is not.
    shapeImportSigned () {
      return this.shapeImportTarget === 'season'
    },
    shapeImportColor () {
      if (this.shapeImportOther) return this.shapeImportOtherKey === 'competition' ? COMPETITION_COLOR : COMARKETING_COLOR
      return this.shapeImportSigned ? SEASONALITY_COLOR : REVENUE_COLOR
    },
    shapeImportTrack () {
      if (this.shapeImportOther) {
        return this.shapeImportOtherKey === 'competition' ? 'rgba(229, 57, 53, 0.10)' : 'rgba(30, 136, 229, 0.10)'
      }
      return this.shapeImportSigned ? 'rgba(255, 179, 0, 0.14)' : 'rgba(67, 160, 71, 0.10)'
    },
    // THE SEASON AS IT WOULD LAND, and not as the model states it. The source says what share of each
    // month's REVENUE its season accounts for and this wizard draws what share of each month's BASE
    // — the two differ by a ratio that only exists once there is a form — so the preview is the
    // conversion itself, cap and all, which is also what lets the dialog say which months would not
    // fit before anything is accepted. Read against the spot row as it stands, that being the other
    // half of the cap. Null while there is nothing to convert against.
    shapeImportSeason () {
      if (!this.shapeImportSigned || !this.ready) return null
      const shape = this.shapeImportShape
      if (!shape) return null
      return composeShareOfBase(this.formState, shape, this.spotShape)
    },
    // The months the cap held, named. Empty for a year that fitted whole, which is most of them.
    shapeImportHeldText () {
      const shares = this.shapeImportSeason
      if (!shares || shares.held.length === 0) return ''
      return this.$t('components.ekrm.CreateModelCompose.shapeImportHeldMonths', {
        months: shares.held.map(month => this.monthLabels[month] || '').join(', '),
        cap: this.shapeCap
      })
    },
    // What the arrows have done, said in months and in the shorter direction: seven presses right is
    // five months left, and reporting it as seven would be the count of presses rather than the
    // statement they add up to. Empty for a year standing where the model put it.
    shapeImportShiftLabel () {
      const by = this.shapeImportShift
      if (by === 0) return ''
      const signed = by > COMPOSE_MONTHS / 2 ? by - COMPOSE_MONTHS : by
      return this.$tc('components.ekrm.CreateModelCompose.shapeImportShifted', Math.abs(signed),
        { count: (signed > 0 ? '+' : '\u2212') + Math.abs(signed) })
    },
    // THAT SHAPE AS THE COLUMNS THE DIALOG DRAWS, at the size it will land: in money wherever a
    // total has already been typed on the step behind, and as bare multipliers where it has not.
    // The heights are the shape either way — the two readings differ by a constant — so what the
    // reader is shown is the year they are about to accept and not a normalised sketch of it.
    shapeImportBars () {
      // The season is drawn as it will LAND — converted, capped — and the sales year as it stands,
      // there being no conversion between the model's multipliers and this wizard's.
      const season = this.shapeImportSeason
      const shape = this.shapeImportSigned ? (season ? season.year : null) : this.shapeImportShape
      if (!shape) return []
      const total = this.shapeImportOther ? this.shapeImportOtherTotal : this.revenue
      const unit = this.$t('components.ekrm.CreateModelCompose.shapeUnit')
      const peak = shape.reduce((most, value) => Math.max(most, Math.abs(Number(value) || 0)), 0)
      return shape.map((value, index) => {
        const share = Number(value) || 0
        const month = this.monthLabels[index] || ''
        const height = peak > 0 ? Math.max(2, 100 * Math.abs(share) / peak) : 0
        const reading = this.shapeImportSigned
          ? `${share > 0 ? '+' : ''}${this.roundShare(share)} ${unit}`
          : (total > 0 ? this.formatMoney(total * share / COMPOSE_MONTHS) : `x${this.roundShare(share)}`)
        return {
          key: `shape_import_${index}`,
          label: month,
          // A floor under the bar so a month that claims almost nothing is still a column rather
          // than a gap in the row: the reader is counting twelve of them. A month at exactly
          // nothing gets no bar at all, that being a statement of its own.
          height: `${share > 0 || (share === 0 && !this.shapeImportSigned) ? height : 0}%`,
          down: `${share < 0 ? height : 0}%`,
          title: `${month}: ${reading}`
        }
      })
    },
    // The model the row being imported into already borrowed from, marked on its row of the list.
    activeShapeModelId () {
      let source = this.shapeImportTarget === 'season' ? this.seasonalitySource : this.revenueShapeSource
      if (this.shapeImportOther) source = this.shapeImportOtherKey ? this.otherSpendSource[this.shapeImportOtherKey] : null
      return source && source.model_id ? source.model_id : null
    },
    // What is about to be taken, beside the button that will take it: the model, the KPI where the
    // model has more than one, and the year. By the time a reader has changed the KPI twice the line
    // is the only place the three answers stand together.
    shapeImportSummary () {
      if (!this.shapeImportShape) return ''
      const model = this.modelById(this.shapeImportModelId)
      const parts = [String((model && model.name) || this.shapeImportModelId)]
      if (this.shapeImportOther) {
        if (this.shapeImportSeriesText) parts.push(this.shapeImportSeriesText)
      } else if (this.shapeImportKpiItems.length > 1) {
        const kpi = this.shapeImportKpiItems.find(item => item.value === this.shapeImportKpi)
        if (kpi) parts.push(kpi.text)
      }
      parts.push(this.shapeImportYear === null
        ? this.$t('components.ekrm.CreateModelCompose.shapeImportAverage', { count: this.shapeImportYears.length })
        : String(this.shapeImportYear))
      return parts.join(' · ')
    },
    // The size on screen, in the box that asks for it. The STATED figure and not totals.kpiTotal —
    // the two agree once a form has been built, and this is the one the user typed, so it is the one
    // that is handed back to the field they typed it into. The row's own sum is printed beside the
    // columns instead, where it is a reading of the shape rather than an echo of the input.
    // Empty until it is answered, rather than a formatted zero. A box showing 0 is a box claiming
    // the business sold nothing, and it is also a figure the user has to clear before typing over
    // it; both are wrong for a field whose whole job is to be the first thing filled in.
    revenueValue () {
      return this.revenue > 0 ? this.formatAmount(this.revenue) : ''
    },
    // --- The channel editor -------------------------------------------------

    editorCard () {
      if (this.editUid === null) return null
      return this.cards.filter(card => card.uid === this.editUid)[0] || null
    },
    // What is at stake, named with the channel and with what the reader just pressed: closing loses
    // the edits, and walking to another channel loses them too. The name is the one the channel
    // carries now, edits included — it is the card the reader has been working on.
    // The channel named in the removal question, read off the list rather than off the card that
    // raised it: the grid rebuilds while the dialog stands, the uid does not.
    removeAskText () {
      const channel = this.channels.filter(entry => entry.uid === this.removeUid)[0]
      return this.$t('components.ekrm.CreateModelCompose.channelRemoveText', {
        channel: channel ? channel.label : ''
      })
    },
    editorLeaveText () {
      const channel = this.editorCard
      const key = this.editorLeave && this.editorLeave.type === 'step'
        ? 'editorLeaveStepText'
        : 'editorLeaveText'
      return this.$t(`components.ekrm.CreateModelCompose.${key}`, {
        channel: channel ? channel.medium : ''
      })
    },
    // Where this channel stands among all of them, for the walk. 1-based, and it counts every
    // channel on the page rather than the unanswered ones: the arrows go round all of them.
    editorPosition () {
      const at = this.channels.findIndex(entry => entry.uid === this.editUid)
      return { index: at === -1 ? 0 : at + 1, count: this.channels.length }
    },
    nameMaxLength () {
      return MEDIUM_NAME_MAX
    },
    // Why the name in the field cannot be used, or '' while it can. Against the names the OTHER
    // channels have claimed, so retyping the name this one already has is not a collision with
    // itself. It reads while it is being typed and the commit reads it again.
    editorNameError () {
      if (this.editUid === null) return ''
      const taken = this.channels.filter(entry => entry.uid !== this.editUid).map(entry => entry.label)
      const code = mediumNameError(this.editorName, taken)
      if (code === 'empty') return this.$t('components.ekrm.CreateModelCompose.channelNameEmpty')
      if (code === 'taken') return this.$t('components.ekrm.CreateModelCompose.channelNameTaken')
      return ''
    },
    // Whether the payload carries this channel yet, which is the one thing that decides what the
    // editor can DO rather than what it shows. Everything is on the screen either way.
    editorPlaced () {
      return this.curveIndex !== null
    },
    // THE NEXT CHANNEL THAT IS STILL ASKING, from this one, looping — or null when this is the only
    // one left that is. `pending` is the grid's own word for it and is read the same way the cards
    // and the warning read it: a channel is unanswered exactly when the build has no summary for it,
    // whether because nobody typed the pair or because its curve has no knee to place one through.
    //
    // The channel on the screen is never the answer, even while it is itself unanswered: the button
    // is a way ON, and one that came back to the card it was pressed from would be a save that looked
    // like a walk. From the current position rather than from the top of the list, so finishing a
    // grid runs forwards through it instead of jumping back to the first gap every time.
    editorNextPending () {
      if (this.editUid === null) return null
      const summaries = {}
      this.summaries.forEach(entry => { summaries[entry.uid] = true })
      const list = this.channels
      const at = list.findIndex(entry => entry.uid === this.editUid)
      if (at === -1) return null
      for (let step = 1; step < list.length; step++) {
        const channel = list[(at + step) % list.length]
        if (!summaries[channel.uid]) return channel.uid
      }
      return null
    },
    // WHETHER ANY NUMBER ON THIS SCREEN MEANS ANYTHING, which is a different question from the one
    // above and is asked of the FIELDS rather than of the payload: the preview curve is built out
    // of what is typed, keystroke by keystroke, so the moment the pair is complete the magnitudes
    // are real — a commit and a rebuild later, but real. Until then the curve is the imported shape
    // over a unit scale, and every figure readable off it is a placeholder: the axes carry none,
    // the zone boundaries carry none, and the pair itself carries none.
    editorStated () {
      return this.parseAmount(this.editorKnee) > 0 && this.parseAmount(this.editorCeiling) > 0
    },
    unstatedMark () {
      return UNSTATED
    },
    // Whether this channel is standing anywhere other than on the fit it was imported with, which
    // is the one condition the way back has. It is the same question curveShowsSource asks — the
    // dashed line and the button appear together and for the same reason — and resetCurve asks it
    // again before it does anything.
    curveCanReset () {
      if (this.editUid === null) return false
      return this.curveMoved(this.editUid) || this.decayMoved(this.editUid)
    },

    // --- The decay card ---------------------------------------------------

    // THE KERNEL ON THE SCREEN, the one the source model measured, and every shape the channel could
    // be carrying instead. Null where the channel's source has no readable decay at all, which is
    // the editor's own "no curve": there is nothing to draw and nothing to generate a template at
    // the total of.
    editorDecayKernel () {
      return this.editUid === null ? null : this.decayFor(this.editUid)
    },
    editorDecaySource () {
      return this.editUid === null ? null : this.sourceDecayFor(this.editUid)
    },
    // Generated at THIS channel's own total and over its own months, so a tile and the plot above it
    // are one picture at two sizes and pressing one cannot move what a month's spend is worth.
    editorDecayTemplates () {
      const kernel = this.editorDecayKernel
      if (!kernel) return []
      const total = kernel.reduce((sum, value) => sum + (Number(value) || 0), 0)
      return composeDecayTemplates(kernel.length, total)
    },
    // Which tile is lit. Read off the kernel rather than stored: a selection kept beside the thing
    // it selects is a second piece of state that can disagree with it, and there is nothing here the
    // kernel does not already say.
    editorDecaySelected () {
      return composeDecaySelected(
        this.editorDecayKernel, this.editorDecayTemplates, this.editorDecaySourceTile
      )
    },
    // THE TILE THAT SAYS "AS IMPORTED", AND THE CHANNEL THAT MAY NOT SHOW IT.
    //
    // On an imported channel it is the one tile that is not a shape anybody chose: it is what that
    // channel's model measured, and it is how a reader puts the decay back. A channel written on
    // this page has no such thing. What it opens on is a template — see composeScratchRead, which
    // picks one — so a tile captioned "as imported" would be pointing at a shape nothing imported,
    // and the row already carries that shape under its own two figures. So the tile is withheld and
    // the channel's kernel lights the template it actually is.
    //
    // Only the TILE. The kernel itself still comes from the read: it is what the card opens on, what
    // Back to Original returns to and what the payload carries while nobody has picked anything —
    // see editorDecaySource, which is unchanged.
    editorDecaySourceTile () {
      return this.editorScratch ? null : this.editorDecaySource
    },
    // Whether the channel on the screen is one nobody imported.
    editorScratch () {
      if (this.editUid === null) return false
      const channel = this.channels.filter(entry => entry.uid === this.editUid)[0]
      return !!(channel && channel.scratch)
    },
    editorDecayLabels () {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return {
        lagAt: label('decayLagAt'),
        imported: label('decayImported'),
        custom: label('decayCustom'),
        peak: label('decayPeak'),
        shapeTitle: label('decayShapeTitle'),
        drag: label('decayDrag'),
        now: label('decayShapeNow')
      }
    },
    // The channel as it was imported: its measured curve, its fit and the knee the placement is
    // normalised through. What the editor stands on before there is anything in the payload.
    editorRead () {
      if (this.editUid === null) return null
      const channel = this.channels.filter(entry => entry.uid === this.editUid)[0]
      return channel ? this.readFor(channel) : null
    },
    // WHERE THE PREVIEW STANDS: the two figures as they are being typed, over the imported curve's
    // own knee and the response there. It is the same division the build does — see composeAnchor —
    // so the shape drawn while the fields are being answered is exactly the shape the answer
    // produces, and answering it changes the colour of the chart rather than its contents.
    //
    // A figure not yet typed contributes ONE, which puts that axis on a unit scale rather than on
    // the source business's own. A foreign magnitude on the axis is precisely what this wizard exists
    // not to import, and a placeholder that reads 0→1 says it is a placeholder.
    // The knee of the imported curve and the response there, which is what the placement divides
    // through. Its own computed because it depends on the CHANNEL and not on what is being typed:
    // it walks the source pairs, and it would otherwise do that once per keystroke.
    editorAnchor () {
      return composeAnchor(this.editorRead)
    },
    editorFactors () {
      const anchor = this.editorAnchor
      if (!anchor) return null
      const knee = this.parseAmount(this.editorKnee)
      const ceiling = this.parseAmount(this.editorCeiling)
      return {
        spend: (knee > 0 ? knee : 1) / anchor.spend,
        response: (ceiling > 0 ? ceiling : 1) / anchor.response
      }
    },
    // The imported fit at that placement. A Hill under x → x·f and y → y·g is the same Hill with k·f
    // and vmax·g, the exponent being what survives a change of scale on either axis — which is the
    // whole claim this wizard rests on, stated here as three multiplications.
    editorPreviewHill () {
      const read = this.editorRead
      const factors = this.editorFactors
      if (!read || !factors || !isHillParams(read.fit)) return null
      return {
        vmax: read.fit.vmax * factors.response,
        k: read.fit.k * factors.spend,
        n: read.fit.n
      }
    },
    // What the plan spends on this channel, for the chart's own window. A placed channel has a row
    // to read; an unplaced one opens standing at the figure being typed, which is what it will do
    // the moment it is answered.
    editorSpend () {
      const summary = this.curveSummary
      if (summary) return summary.monthlySpend
      const knee = this.parseAmount(this.editorKnee)
      if (knee > 0) return knee
      const preview = this.editorPreviewHill
      return preview ? preview.k : 0
    },
    // --- The channel importer --------------------------------------------

    // What the channel importer needs of the composition: which of its rows (modelId::raw) are
    // already on the page.
    taxonomyAdded () {
      const added = {}
      this.channels.forEach(channel => {
        if (channel.modelId) added[taxonomyRowId(channel.modelId, channel.raw)] = true
      })
      return added
    },
    // And what has been read of every model so far: the plots of the channels it can offer, why the
    // others cannot be offered, and — for a model that cannot contribute at all — why not.
    taxonomyReads () {
      const reads = {}
      Object.keys(this.models).forEach(id => {
        const entry = this.models[id]
        if (!entry) return
        const read = { channels: {}, reasons: {}, blocked: null }
        if (!entry.readiness.ok) {
          const reasons = entry.readiness.reasons || []
          read.blocked = reasons.length > 0
            ? this.notReadyLabel(reasons[0])
            : this.$t('components.ekrm.CreateModelCompose.notReadyTitle')
        } else {
          this.channelPlots(entry).forEach(plot => { read.channels[plot.raw] = plot })
          entry.imported.skipped.forEach(skipped => { read.reasons[skipped.raw] = this.skippedLabel(skipped) })
        }
        reads[id] = read
      })
      return reads
    },
    // THE OTHER INPUTS CARRYING A SPEND AND NO SHARE OF SALES. A blank share used to hand the choice
    // to the EKRM, which could credit a small spend with most of the revenue; now the user says it,
    // and a series with money in it cannot be left without the statement.
    otherAttributionMissing () {
      return ['comarketing', 'competition'].filter(key => {
        const spent = this.otherValues(key).reduce((sum, value) => sum + (Number(value) || 0), 0)
        return spent > 0 && this.otherAttribution[key] === null
      })
    },
    canCreate () {
      return this.ready && !this.creating && this.liveErrors.length === 0 &&
        this.otherAttributionMissing.length === 0 &&
        String(this.name).trim().length > 0 && String(this.market).length > 0
    },
    // WHAT EACH STEP HAS TO CARRY BEFORE THE NEXT ONE MEANS ANYTHING, keyed by step number. These
    // are the gates the single page drew as greyed-out cards: `ready` says the media are placed,
    // which is what the spend is a statement about, and `moneyReady` says a revenue has been typed,
    // which is what everything under the steps is read against. The first step's test is the same
    // pair of fields canCreate ends on, asked where they are typed — behind the question that puts
    // those fields on the page at all, which is answered first and cannot be skipped past.
    //
    // The spend cannot fail its own step: it opens live on the plan the cards describe and there is
    // no answer it can be left without.
    // The fifth step's two series are optional, but a series given a spend is not finished until it
    // is given a share of sales too — see otherAttributionMissing. The sixth is optional and opens
    // answered, every series at no growth. The seventh asks nothing at all: it is the preview of the model the steps before it describe, so
    // it is answered by definition and only canCreate stands between it and the button under it.
    stepValid () {
      return {
        1: this.setupDetailsShown && String(this.name).trim().length > 0 && String(this.market).length > 0,
        2: this.ready,
        3: this.ready,
        4: this.moneyReady,
        5: this.otherAttributionMissing.length === 0,
        6: true,
        7: true
      }
    },
    // THE FURTHEST STEP THE WIZARD HAS EARNED, which is the first one whose own gate is still shut.
    // Every step behind it has been answered, so its header is clickable and the way back is free;
    // ahead of it there is nothing to show. Read by the headers and by the watcher that pulls the
    // user back when an answer is taken away — a channel removed on step 2 empties step 3.
    maxReachableStep () {
      let reached = 1
      while (reached < 7 && this.stepValid[reached]) reached++
      return reached
    },
    canLeaveStep () {
      return !!this.stepValid[this.step]
    },
    // The market as it is named rather than as it is stored: the field holds a country id and an id
    // over the step bar says nothing.
    marketName () {
      if (!this.market) return ''
      const found = this.countries.filter(entry => entry.id === this.market)[0]
      return found ? found.name : String(this.market)
    },
    // The channels in one line: how many, and which, up to the point where naming them stops being
    // a reminder and starts being the grid printed twice.
    channelsRecap () {
      const labels = this.channels.map(entry => entry.label)
      if (labels.length <= 3) return labels.join(', ')
      return labels.slice(0, 3).join(', ') + ' +' + (labels.length - 3)
    },
    // ONE LINE PER ANSWER ALREADY GIVEN, in the order it was given in. Each entry is added by the
    // step that leaves it behind — the name and the market as soon as step 1 is done, the media
    // when step 2 is, and so on — so the strip grows as the wizard is walked and never reports a
    // figure the user has not settled yet.
    stepRecap () {
      const items = []
      if (this.step > 1) {
        items.push({
          key: 'name',
          label: this.$t('components.ekrm.CreateModelCompose.name'),
          value: String(this.name).trim()
        })
        items.push({
          key: 'market',
          label: this.$t('components.ekrm.CreateModelCompose.market'),
          value: this.marketName
        })
      }
      if (this.step > 2 && this.ready) {
        items.push({
          key: 'channels',
          label: this.$t('components.ekrm.CreateModelCompose.channels') + ' (' + this.channels.length + ')',
          value: this.channelsRecap
        })
      }
      if (this.step > 3 && this.ready) {
        items.push({
          key: 'spend',
          label: this.$t('components.ekrm.CreateModelCompose.stepSpend'),
          value: this.formatAmount(this.totals.spendTotal) + ' ' + this.ekrmUnit
        })
      }
      if (this.step > 4 && this.moneyReady) {
        items.push({
          key: 'revenue',
          label: this.$t('components.ekrm.CreateModelCompose.stepRevenue'),
          value: this.formatAmount(this.revenue) + ' ' + this.ekrmUnit
        })
      }
      if (FUTURE_TRENDS_ENABLED && this.step > 6 && this.moneyReady) {
        const sales = this.futureTrends.sales
        const signed = value => (value > 0 ? '+' : value < 0 ? '\u2212' : '') + Math.abs(value) + '%'
        items.push({
          key: 'futureTrends',
          label: this.$t('components.ekrm.CreateModelCompose.recapFutureTrends'),
          value: sales.min === sales.max ? signed(sales.min) : signed(sales.min) + ' – ' + signed(sales.max)
        })
      }
      return items
    },
    // Why Next is refused, said beside the button rather than left for the user to work out from a
    // greyed-out control. Silent on a step that is answered, and silent on the spend, which cannot
    // be unanswered.
    stepHint () {
      if (this.stepValid[this.step]) return ''
      if (this.step === 1) {
        if (!this.sourceMode) return this.$t('components.ekrm.CreateModelCompose.stepHintSource')
        if (this.setupDetailsShown) return this.$t('components.ekrm.CreateModelCompose.stepHintDetails')
        // The loading line and any error already say where a copy stands.
        if (this.copyLoading || this.copyError) return ''
        return this.$t('components.ekrm.CreateModelCompose.stepHintCopyModel')
      }
      if (this.step === 2) return this.$t('components.ekrm.CreateModelCompose.stepHintChannels')
      if (this.step === 4) return this.$t('components.ekrm.CreateModelCompose.stepHintRevenue')
      if (this.step === 5) return this.$t('components.ekrm.CreateModelCompose.stepHintOtherAttribution')
      return ''
    },
    // Whether the strip above the steps has anything to say. The div carries its own padding, so it
    // is asked rather than left to draw a band of empty grey over every step.
    hasTopAlerts () {
      if (this.reportError || this.catalogueError) return true
      if (!this.moneyReady) return false
      return this.liveErrors.length > 0 || this.liveWarnings.length > 0 ||
        !!this.baseWarning || !!this.decompositionBaseWarning
    },
    // Whether the money is still shared out between the channels the way the source shared it. Only
    // a ROAS target the source's own mix could not return can move it, and only after the user has
    // said yes to the offer under the box.
    //
    // Asked of the media the form actually carries rather than of the keys mixFactors happens to
    // hold. A channel taken out of the copy keeps its factor there on purpose — that is what lets it
    // come back at the share it left with — and a factor nothing is laid out for is not a mix that
    // has moved.
    mixMoved () {
      if (!this.built) return false
      return this.built.media.some(entry => this.isMoved(this.mixFactorFor(entry.uid)))
    },

    // Run on every commit, because two of the things the user can now do are refused by the
    // validator and both deserve an answer at the moment they are done rather than at the save:
    // emptying a channel, and driving revenue under the spend it is supposed to have produced.
    //
    // The two reference errors are dropped: the name and the market fields carry their own rules,
    // and the validator phrases them as a step this wizard does not have.
    liveValidation () {
      if (!this.formState) return { errors: [], warnings: [] }
      return validateEkrmForm(this.formState, 0)
    },
    liveErrors () {
      return this.liveValidation.errors.filter(entry => {
        return !(entry.sections.length === 1 && entry.sections[0] === 2)
      })
    },
    liveWarnings () {
      return this.liveValidation.warnings.filter(entry => entry.code === 'revenueBelowSpend')
    },
    nameRules () {
      return [value => String(value || '').trim().length > 0 || this.$t('components.ekrm.CreateModelCompose.nameRequired')]
    },
    marketRules () {
      return [value => String(value || '').length > 0 || this.$t('components.ekrm.CreateModelCompose.marketRequired')]
    },
    formState () {
      return this.built ? this.built.form : null
    },
    // Said once above the cards, and only where the mix has been moved off what was imported. That a
    // channel keeps its own model's curves and takes an equal share of the budget is how every
    // channel here arrives, so stated in the resting state it was a caption on the wizard rather
    // than a reading of it; what is worth a line is the departure from it, which the cards
    // themselves cannot state, each one showing only its own figure.
    channelsInfo () {
      if (this.mixMoved) return this.$t('components.ekrm.CreateModelCompose.channelsInfoMixed')
      return ''
    },
    // The channels on the grid that are not media of this model yet. It is the same question each
    // card answers about itself — a card is pending exactly when the build has no summary for it,
    // whether because nobody has stated the pair that places its curve or because its imported fit
    // has no knee to place one through — asked once for the page. Off the summaries rather than off
    // `cards`, which builds a plot and a decay row per channel to answer it.
    pendingChannels () {
      const summaries = {}
      this.summaries.forEach(entry => { summaries[entry.uid] = entry })
      return this.channels.filter(channel => !summaries[channel.uid])
    },
    channelsPendingText () {
      const count = this.pendingChannels.length
      if (count === 0) return ''
      return this.$tc('components.ekrm.CreateModelCompose.channelsPending', count, { count: count })
    },
    summaries () {
      if (!this.ready) return []
      return composeChannelSummaries(this.built.form, this.built.built)
    },

    // --- The curve editor -------------------------------------------------

    // Everything the dialog draws hangs off this one index. Null whenever nothing is open, and null
    // for a channel that has since been dropped or has left the import under a new period — which is
    // what closes the dialog rather than leaving it drawing a medium the form no longer carries.
    curveIndex () {
      if (!this.ready || this.editUid === null) return null
      const index = this.built.media.findIndex(entry => entry.uid === this.editUid)
      return index === -1 ? null : index
    },
    curveSummary () {
      return this.curveIndex === null ? null : this.summaries[this.curveIndex] || null
    },
    // The fit the channel arrived with. The reset goes back to it, the sliders are anchored to it,
    // and the ratios stored in curveEdits are measured against it.
    // The fit the channel arrived with. The reset goes back to it, the sliders are anchored to it,
    // and the ratios stored in curveEdits are measured against it. Before the payload carries the
    // channel it IS the preview: the levers are showing the curve the two figures would place, and
    // nothing has been moved from it.
    curveImported () {
      const summary = this.curveSummary
      if (summary && summary.importedHill) return summary.importedHill
      return this.editorPreviewHill
    },
    // The three parameters the FORM carries. What the levers are handed, so a preview does not come
    // straight back at the component as a new prop and cancel the draft it is holding.
    curveCommitted () {
      const summary = this.curveSummary
      if (summary && summary.hill) return summary.hill
      return this.editorPreviewHill
    },
    // Where the levers stand right now: the draft while one is down, the form's own the rest of the
    // time. What the chart and the levers are drawn from.
    curveParams () {
      return this.curveDraft || this.curveCommitted
    },
    curveBounds () {
      const summary = this.curveSummary
      if (summary && summary.hill) {
        return cloneCurveBounds(summary.importedHill, summary.hill, summary.monthlySpend)
      }
      // Ranges for levers that cannot be moved: they exist so the three thumbs stand somewhere
      // sensible on their tracks while they are greyed, and they are read off the preview, which is
      // the curve those levers would open on.
      const preview = this.editorPreviewHill
      return preview ? cloneCurveBounds(preview, preview, this.editorSpend) : null
    },
    // Read at the values the FORM carries and not at the draft, so it is computed once per commit
    // rather than once per frame. That is not only cheaper, it is right: a wall for one lever is a
    // statement about the other two standing still, which is exactly what they do for the length of
    // a gesture.
    //
    // The floor is this wizard's own and is passed rather than imported over there: a lever's range
    // is anchored to the fit the channel currently carries, so every commit re-anchors it — a tenth
    // of where the knee lever stands, a quarter of where the ceiling lever does — and without a wall
    // in absolute money the pair of them walk a channel down to nothing, ten commits at a time,
    // each one of which looked like an ordinary drag.
    curveLimits () {
      const summary = this.curveSummary
      if (!summary || !summary.hill || !this.curveBounds) return null
      return cloneCurveLimits(
        this.formState, this.curveIndex, summary.hill, this.curveBounds,
        { centre: this.built.centre, floor: COMPOSE_FLOOR }
      )
    },
    // WHERE THIS CHANNEL SATURATES, on the axis the chart is drawn on: the same solved boundary the
    // card reports, the same one the fifth zone begins at, off the same function. The zone key's
    // last figure, the band's edge and the card's own are one number computed once, so no lever can
    // part them — and before the payload carries the channel it comes off the preview, which is the
    // curve the two figures being typed would place. Read here for the chart's WINDOW: a plot that
    // crops the point this editor is about is the wrong plot, whether or not it is marked.
    curveSaturationAt () {
      return hillDiminishingReturns(this.curveParams)
    },
    // THE FOUR BOUNDARIES OF THE FIVE ZONES, solved off the curve on screen rather than imported.
    //
    // They were carried over from the source model and stretched by the placement, which was right
    // for two of the three levers and wrong for the third: the knee lever is a stretch on x and the
    // boundaries ride it, the ceiling lever is a stretch on y and leaves every one of them where it
    // is, but the exponent changes WHERE ON THE CURVE each of those things happens, and no amount of
    // scaling an imported array can say where they went. So the bands had to be dropped the moment
    // the steepness moved — the one lever whose whole job is to change the shape the zones describe.
    //
    // hillRegions solves the report backend's own four definitions on the parameters directly, so
    // the bands are a reading of the curve being drawn and of nothing else: they follow all three
    // levers, they need no source array, and a channel whose figures have not been typed yet gets
    // them off the preview like everything else in this dialog.
    curveRegions () {
      return hillRegions(this.curveParams)
    },
    // THE TWO FIGURES THE EDITOR SHOULD BE SHOWING, whatever the curve is doing this frame: the
    // draft while a lever is down, the committed curve the rest of the time, and nothing at all for
    // a channel the payload does not carry — an unplaced one has its levers disabled, and its
    // preview curve is built FROM these two fields, so writing them back would be a loop rather than
    // a reading.
    //
    // A computed, watched, rather than a write at each of the places a curve can move. Those were
    // three call sites and the question was always whether they were all of them; this is the one
    // condition — the curve changed — stated once. The fields themselves cannot BE this computed,
    // because they are also what the user types into.
    editorFigures () {
      if (!this.editorPlaced) return null
      const params = this.curveParams
      if (!isHillParams(params)) return null
      const at = hillDiminishingReturns(params)
      if (!(at > 0)) return null
      return { knee: this.formatMoney(at), ceiling: this.formatMoney(hillAt(params, at)) }
    },
    // The five zones, named, coloured, described and now PLACED exactly as the model report does it,
    // off the report's OWN locale keys and its own colours. Four boundaries make five zones, and the
    // first one is unfilled: the range below the minimum spending threshold is drawn by being the
    // only part of the plot nothing is painted over, which is why the shared chart's markArea starts
    // at the first boundary rather than at zero — and why the first entry's swatch is an outline.
    //
    // WHERE EACH ONE BEGINS is the fourth thing each entry carries, and it is the boundary itself
    // rather than a reading of one: zone n starts at the (n-1)th of curveRegions, which is the same
    // array the chart's own shading is drawn from, so a figure here and an edge up there cannot come
    // apart under a lever. The first begins at nothing, the axis having nowhere further left to go.
    //
    // It is also what that figure is SET with. The bar under the chart is the four boundaries as
    // grips and the five figures as fields, so each entry carries the two names a control needs
    // beside the two a legend needs — what the grip on its left edge does, and what the field under
    // it is.
    //
    // The bounds are read through a guard because this list is also the about dialog's, which draws
    // the five names and descriptions on a curve whose bands may not exist at all.
    curveZones () {
      const key = 'components.SaturationCurves.zone'
      const bounds = this.curveRegions
      return ZONE_FILLS.map((fill, index) => {
        const label = this.$t(key + (index + 1))
        const description = this.$t(key + (index + 1) + 'Desc')
        const begins = this.$t('components.ekrm.CreateModelCompose.zoneBegins', { zone: label })
        return {
          key: `zone_${index + 1}`,
          label: label,
          description: description,
          title: `${label}: ${description}`,
          fill: fill,
          color: fill || 'darkgrey',
          icon: fill ? 'mdi-square-rounded' : 'mdi-square-rounded-outline',
          field: this.editorStated
            ? (bounds ? this.formatMoney(index === 0 ? 0 : bounds[index - 1]) : '')
            : UNSTATED,
          aria: begins,
          handle: this.$t('components.ekrm.CreateModelCompose.zoneDrag', { zone: label }),
          locked: this.zoneLocked(index - 1),
          held: this.$t(
            index - 1 === ZONE_PLACEMENT
              ? 'components.ekrm.CreateModelCompose.zonesHeld'
              : 'components.ekrm.CreateModelCompose.zonesHeldEdge',
            { zone: label }
          )
        }
      })
    },
    // THE AXIS THE ZONE BAR IS DRAWN ACROSS, which is the one measurement in this editor that is
    // deliberately not a reading of the curve in front of it.
    //
    // Everything else here re-reads the parameters every frame, which is right for a picture and
    // wrong for a ruler: the bar's own scale is a function of the saturation point, the saturation
    // point is one of the things being dragged along it, and a ruler that re-fits under the grip
    // travelling down it moves the ground it is being measured against. The trade-off chart's axis
    // already answers this — see cloneTradeWindow, whose whole point is that the axis holds still
    // while the slider moves along it — and this is the same answer: fitted when the editor opens
    // on a channel, held while the curve is moved, and re-fitted only when the boundaries would
    // otherwise leave the bar. See fitZoneWindow.
    curveZoneAxis () {
      if (this.zoneWindow > 0) return this.zoneWindow
      const at = this.curveSaturationAt
      return at > 0 ? at * ZONE_WINDOW_HEADROOM : 0
    },
    // Which setting of the switch is the one that is on. A setting that names a boundary is two
    // pieces of state and one answer, so the answer is spelled once here rather than as the same
    // pair of conditions at every place that has to draw it.
    zoneHoldKey () {
      return this.zoneHold === HILL_HOLD_EDGE ? `edge_${this.zoneHoldPin}` : this.zoneHold
    },
    // THE FIVE THINGS THAT CAN BE HELD, in the order they are read in: the two the bar has one of
    // — where the channel saturates, and the shape — and then the three interior boundaries, which
    // are the general case the first of them is a single setting of. ONE FLAT LIST and not two
    // groups, because the switch is one question with five answers and the grouping was a fact
    // about the answers rather than about the choosing; `cut` is where the hairline falls, the last
    // three being a boundary NAMED rather than a convention of their own.
    //
    // Each carries a glyph, a name and a sentence. The glyph is the button, the name is what the
    // button says to a screen reader, and the tooltip carries both — an icon on its own says
    // nothing at all to a reader who has not met it, which is the price of a row of icons and the
    // reason none of them is left to be guessed at.
    //
    // The interior three are named by "where zone n begins", which is the heading directly above
    // them: the name is in a tooltip now rather than on the face of the button, so it can be the
    // whole sentence instead of the number it had to shrink to.
    zoneHoldChoices () {
      const key = 'components.ekrm.CreateModelCompose.'
      const zone = 'components.SaturationCurves.zone'
      const edges = ZONE_PINS.map((pin, index) => {
        const label = this.$t(zone + (pin + 2))
        return {
          key: `edge_${pin}`,
          value: HILL_HOLD_EDGE,
          pin: pin,
          cut: index === 0,
          icon: `mdi-numeric-${pin + 2}-box-outline`,
          name: this.$t(key + 'zoneBegins', { zone: label }),
          hint: this.$t(key + 'zonesHoldEdgeHint', { zone: label })
        }
      })
      return [
        {
          key: HILL_HOLD_SATURATION,
          value: HILL_HOLD_SATURATION,
          pin: ZONE_PLACEMENT,
          cut: false,
          icon: 'mdi-pin',
          name: this.$t(key + 'zonesHoldSaturation'),
          hint: this.$t(key + 'zonesHoldSaturationHint')
        },
        {
          key: HILL_HOLD_SHAPE,
          value: HILL_HOLD_SHAPE,
          pin: null,
          cut: false,
          icon: 'mdi-vector-curve',
          name: this.$t(key + 'zonesHoldShape'),
          hint: this.$t(key + 'zonesHoldShapeHint')
        }
      ].concat(edges)
    },
    // What the three levers are handed. The committed curve while nothing is being dragged on the
    // bar below the chart, and the DRAFT while something is: the levers and the zones are two views
    // of one shape, so a boundary moved has to move the exponent under it as it goes — which is the
    // whole of what the bar promises. It is not the levers' own preview coming back at them: those
    // arrive as curveDraft too, and are excluded here by the flag, so a lever's thumb goes on
    // owning its gesture the way it always has.
    curveLeverParams () {
      return this.zoneDragging ? this.curveParams : this.curveCommitted
    },
    // Whether the curve the channel arrived with is drawn behind the one being edited: only once a
    // lever has actually moved it, and only when the fit is a shape these levers can describe. It is
    // its own computed because it decides two things that have to agree — whether the second line is
    // drawn, and whether the legend names the first.
    curveShowsSource () {
      const summary = this.curveSummary
      const source = summary ? summary.importedHill : null
      return !!(source && isHillParams(source) && this.curveMoved(this.editUid))
    },
    // The curve as it will be sent, the curve as it was copied, and the band the payload's own
    // variation range puts around the first. Drawn from the parameters rather than from the ten
    // stored values, so it follows a drag continuously and reads as a curve rather than as ten
    // segments.
    curveChartData () {
      const summary = this.curveSummary
      const params = this.curveParams
      if (!params || !isHillParams(params)) return null

      const at = this.curveSaturationAt
      // Out to a few knees rather than to the end of the grid, and then wide enough to hold the
      // response: the whole rule is hillPlotWindow, which is where it has to be — the cards below
      // this dialog draw the same curve at a sixth of the size and the two pictures are only one
      // picture while they agree about where the right edge is. See it for what each term is for.
      const top = hillPlotWindow(params, {
        saturation: at,
        source: this.curveShowsSource ? summary.importedHill : null
      })
      const series = hillSeries(params, top, CURVE_STEPS)
      const curve = { x: series.x, y: series.y }
      // Shaded under the curve being edited and not under the one it started as: the zones describe
      // the shape on screen, which is the one the reader is moving.
      const regions = this.curveRegions
      if (regions) curve.regions = regions
      // AND THE ONE POINT THIS SCREEN IS ASKING FOR, WHILE IT IS STILL UNANSWERED. The shape is
      // drawn and its axes are blank, which leaves the reader looking at a curve and a question
      // they have not been shown the place of; this is the place — where the fourth boundary falls,
      // the edge the fifth zone begins at, which is the saturation point by definition. Off the
      // boundary array itself where there is one, so the mark cannot land a hair off the colour
      // change it is the colour change OF. It goes the moment the pair is typed: from then on the
      // point is on both axes in the reader's own money, and a question mark over it would be the
      // chart doubting a figure the reader had just stated.
      if (!this.editorStated) {
        const point = regions ? regions[3] : at
        if (point > 0) {
          curve.mark = {
            x: point,
            y: hillAt(params, point),
            name: this.$t('components.ekrm.CreateModelCompose.saturationPoint')
          }
        }
      }
      // Two lines and no more. The revenue variation range a curve carries is a fitter tolerance
      // rather than part of the response, and two dashed bands beside a dashed source curve would
      // be three dashed lines saying three different things.
      const data = { Revenue: curve }
      // What the model itself said, drawn behind it, so an edit is read against the thing it is an
      // edit OF. Dropped when the two are the same curve — a dashed line exactly under a solid one
      // is a legend entry that says nothing.
      if (this.curveShowsSource) {
        const from = hillSeries(summary.importedHill, top, CURVE_STEPS)
        data.Source = { x: from.x, y: from.y }
      }
      // AND THE POINT ITSELF, ONCE THERE IS ONE. The question mark above marks the place while the
      // pair is unstated; this is the same place once it has been stated, drawn as what it now is —
      // a reading, on both axes, in the reader's own money. A series of one point rather than a
      // markPoint, because a legend entry is a series entry: the chart is being asked to say what
      // the purple dot IS, and a mark on a line cannot be named in the key. Last, so the legend
      // reads in the order the eye meets them — the curve, the one it came from, the point on it.
      if (this.editorStated) {
        const placed = regions ? regions[3] : at
        if (placed > 0) data.Saturation = { x: [placed], y: [hillAt(params, placed)] }
      }
      return data
    },
    // The two series named for a reader. The keys are identifiers — they are what lineStyles is
    // keyed by, and they may not move with the locale — so the chart is given the translations
    // separately and renders those in the legend and the tooltip.
    //
    // Current and Original, because that is the only thing the two lines are to each other. Naming
    // the first one Revenue named the AXIS, which is already named, and said nothing about why there
    // were two of them; naming the second one after the model it came from asked the reader to hold
    // onto where a shape was imported from in order to read what is in front of them.
    curveSeriesNames () {
      const key = 'components.ekrm.CreateModelCompose.'
      return {
        Revenue: this.$t(key + 'curveSeriesCurrent'),
        Source: this.$t(key + 'curveSeriesOriginal'),
        Saturation: this.$t(key + 'saturationPoint')
      }
    },
    // Two swatches that say what kind of thing each entry is before a word of it is read: a bar and
    // a dashed bar. Neither names a colour: both take the chart's own palette, which is where they
    // have always stood.
    //
    // CURRENT IS NAMED ONLY WHEN ORIGINAL IS. "Current" is a comparative: it means this curve rather
    // than the one it started as, and with one line on the chart there is no other one for it to be
    // current against — the entry would be labelling the only shape in view, which is what a chart
    // with one line does by being the chart. It is the series' place in the LEGEND that is dropped
    // and not the series: the line goes on being drawn either way.
    curveLineStyles () {
      return JSON.stringify({
        Revenue: {
          smooth: false,
          type: 'solid',
          width: 2,
          legendIcon: LEGEND_LINE,
          hideInLegend: !this.curveShowsSource
        },
        Source: { smooth: false, type: 'dashed', width: 1, legendIcon: LEGEND_DASHED_LINE },
        // One point and no line between it and itself: width 0, a circle at ordinary point size,
        // and a round swatch in the key rather than either of the two bars — the two lines are
        // lines and this is a place on one of them.
        Saturation: { symbol: 'circle', symbolSize: 9, type: 'solid', width: 0, legendIcon: 'circle' }
      })
    },
    // The one series this chart names a colour for. The two curves go on taking the palette's own
    // first two, which is what they have always been drawn in; a key missing from this object is a
    // series the chart colours for itself.
    curveChartColors () {
      return { Saturation: SATURATION_MARK, Source: SOURCE_LINE }
    },
    saturationColor () {
      return SATURATION_MARK
    },
    curveLabels () {
      // All six live in this wizard's own namespace. Four of them were read out of the retired
      // expert wizard's while it existed; the two that name the KPI have always been this one's,
      // which calls it Sales from top to bottom.
      const own = 'components.ekrm.CreateModelCompose.'
      return {
        vmax: this.$t(own + 'curveCeiling'),
        vmaxInfo: this.$t(own + 'curveCeilingInfo'),
        k: this.$t(own + 'curveKnee'),
        kInfo: this.$t(own + 'curveKneeInfo'),
        n: this.$t(own + 'curveSteepness'),
        nInfo: this.$t(own + 'curveSteepnessInfo'),
        reset: this.$t(own + 'curveReset')
      }
    },
    // A channel whose Hill fit could not follow its own curve is one where moving a lever changes
    // the SHAPE and not only the size, and that is worth one sentence before it is moved rather
    // than an explanation afterwards. A fit that DID follow it says nothing: the levers standing on
    // the real thing is what the user already assumes, and a line confirming it is furniture.
    curveNote () {
      const summary = this.curveSummary
      if (!summary) return ''
      const pct = Number(summary.fitPct)
      if (summary.mode === 'sampled' || !isFinite(pct)) {
        return this.$t('components.ekrm.CreateModelCompose.curveNoteSampled')
      }
      return ''
    },
    // The media whose curves no longer are the source model's. Read for its length: the reason the
    // line over the cards stops saying "as they are", and the flag the payload carries.
    curvesMoved () {
      if (!this.ready) return []
      return this.built.media
        .filter(entry => this.curveMoved(entry.uid))
        .map(entry => entry.label)
    },
    // The same for the decay, and it is a separate list rather than a second condition on the one
    // above: the two edits are independent — a channel can be sent with its model's response and
    // somebody else's carryover, or the other way round — and the payload records them separately
    // because the builder reads them from two different blocks.
    decaysMoved () {
      if (!this.ready) return []
      return this.built.media
        .filter(entry => this.decayMoved(entry.uid))
        .map(entry => entry.label)
    },
    // Twelve, always. There is no history to copy verbatim here, so there is no window to widen it.
    monthCount () {
      return COMPOSE_MONTHS
    },
    // The twelve month names, for a grid column and for anything else that wants them spelled out.
    monthNames () {
      return MONTH_KEYS.map(key => this.$t(GRID_LABEL_NAMESPACE + key))
    },
    // The x axis of both charts. Bare month names, the year being a typical one rather than any
    // particular one — a January and not January 2024.
    monthLabels () {
      return this.monthNames
    },
    // The size of the model, in USD over the year — the anchor and everything the user has done to
    // it. Null until the user types one, which is the whole of what stops this page building at a
    // size nobody chose. Everything that reads it goes through moneyReady rather than through a
    // zero: a revenue of nothing is not a small business, it is an unanswered question.
    revenue () {
      return this.revenueAnchor > 0 ? this.revenueAnchor * this.revenueFactor : null
    },
    // The KPI row the summary and the revenue chart read. Straight off the form, with no level over
    // it: the revenue is typed rather than dragged, so the row the form carries is always the row
    // the user asked for and there is no mid-gesture state to correct for.
    kpiVector () {
      if (!this.ready) return []
      return this.built.form.kpi.data[0].slice(2).map(cell => Number(cell))
    },
    // One colour per medium, looked up by where its channel stands in the IMPORT rather than by where
    // One colour per medium, looked up by the channel's own uid rather than by where it stands in
    // what was laid out. Everything that draws the media colours by position in the list it is handed,
    // so without this, taking one channel out would re-colour every channel below it. The uid is monotonic and
    // never reused, so a colour belongs to a channel for as long as that channel is on the page —
    // adding one cannot move another's, which the clone's import-pinned scheme could not promise
    // once there was more than one import to pin to.
    //
    // It is the same colour the card wears as a left border, which with channels from several models
    // is the only thing tying a card to its segment of the stack.
    chartColors () {
      if (!this.ready) return CHART_COLORS
      return this.built.media.map(entry => this.colorFor(entry.uid))
    },
    // The figures the boxes above the charts read off the form itself, and the attribution band.
    // Base Revenue is not among them: it is this KPI total less a reading of the curves, and is
    // computed beside that reading rather than here. "Total" is
    // every month the form carries — the same months the charts draw, which is twelve for an
    // averaged year and 12·N for a real window — and the average is that total over however many
    // those are. Media spend is the own-controllable channels alone, which are the ones that become
    // media of the EKRM; cloneSpendTotal reads it off the same grid the payload is built from.
    totals () {
      if (!this.ready) return { spendTotal: 0, spendMonthly: 0, kpiTotal: 0, kpiMonthly: 0, attributionMin: '0', attributionMax: '0' }
      const months = this.monthCount
      const spendTotal = cloneSpendTotal(this.formState)
      const totalKpi = this.kpiVector.reduce((total, value) => total + value, 0)
      const attribution = this.built.form.attributions.data[0]
      return {
        spendTotal: spendTotal,
        spendMonthly: months > 0 ? spendTotal / months : 0,
        kpiTotal: totalKpi,
        kpiMonthly: months > 0 ? totalKpi / months : 0,
        attributionMin: attribution[1],
        attributionMax: attribution[2]
      }
    },
    // The revenue these curves say the media spend returns — the numerator the Total ROAS is the
    // per-unit form of, and the line between the two revenue boxes.
    //
    // Null, never zero, when a channel has no curve — the silence cloneMarketing keeps.
    marketingTotal () {
      if (!this.ready) return null
      return cloneMarketing(this.formState)
    },
    // What this model would have made with no media at all: the revenue it carries, less what the
    // curves credit that media with. No box shows it — the summary is the spend, its return and the
    // revenue — but it is still the figure that decides whether this clone is a model of anything:
    // curves credited with more than the whole of what was sold leave it negative. It is the bottom
    // segment of the revenue stack, the floor under both figures, and the warning below them.
    baseRevenue () {
      const marketing = this.marketingTotal
      if (marketing === null) return null
      return this.totals.kpiTotal - marketing
    },
    // The least Base Revenue these curves leave room for at this spend. It does not move with the
    // revenue — see cloneBaseFloor — which is what lets it bound the revenue rather than follow it,
    // and it rises as the spend does, the reading under it being the whole of what it is made of.
    baseFloor () {
      return this.ready ? cloneBaseFloor(this.marketingTotal) : null
    },
    // Base Revenue is not a row of the form, so validateEkrmForm cannot see it — a clone whose curves
    // are credited with more than the revenue standing beside them passes every check the payload
    // has and is still not a model of anything. No level the chart offers can reach it, its three
    // named ends all standing inside a corridor that carries this floor; a figure typed into a box
    // still can, boxes not being clamped in this wizard, and this is the answer at the moment one is.
    // THE LEAST REVENUE THESE MEDIA LEAVE ROOM FOR, and the wall the box is now held above.
    //
    // It is the base floor read the other way round. Base is the revenue less what the curves are
    // credited with and less what the two drawn rows take, and it has to clear cloneBaseFloor; the
    // curves are placed and priced in dollars before this figure exists, so the whole of that
    // subtraction is known and the smallest revenue that survives it can simply be stated. Both rows
    // are shares of each month's own BASE and every month is capped, so the worst pair that can ever
    // be drawn is known too, and the wall is stated against that rather than against what is drawn:
    //
    //     R − marketing − (season + spot) ≥ floor,   and both rows are shares of B = R − marketing
    //     (1 − cap)·(R − marketing) ≥ floor
    //     R ≥ marketing · SHAPE_REVENUE_FACTOR
    //
    // WHY IT IS A WALL AND NOT A WARNING. baseWarning below says exactly this and lets the user
    // answer it, and that was the whole rule until the two editors under the columns turned out to
    // be unusable underneath it: every bar of the seasonality and every bar of the spot events is
    // held inside a corridor that carries this same floor, so a revenue typed below it freezes both
    // rows solid — see cloneShapeBarLimits — and the section the user went to next cannot be filled in at
    // all. A figure that makes half the card inert is not a figure to warn about.
    //
    // The warning stays for the sideways routes, which are still open: raise the spend under a
    // revenue that was fine when it was typed, or shape a year and a spend so unevenly against each
    // other that a month's curves take the whole of it — the cap is a share of a month's own base
    // and a month with none left to share is the one case this wall cannot see, because it is an
    // annual figure and that is a monthly accident. decompositionBaseWarning speaks there.
    // THE OTHER WALL UNDER THE SAME BOX, and the one a reader meets first: a year cannot be smaller
    // than the money spent on it. validateEkrmForm says so in as many words — revenueBelowSpend,
    // raised at EQUALITY, the rule being that the revenue is LARGER — and it is the plainest
    // statement on the page: a business that sold less than it spent on its media is not a business
    // this wizard is modelling.
    //
    // A tenth of a percent above the spend rather than on it, for the reason every other wall in
    // this wizard stands a hair inside itself: the year is spread over twelve cells and rounded into
    // them after this figure is chosen, and a revenue seated exactly on the equality lands under it
    // as often as not — which trips the very warning the wall exists to keep it out of.
    revenueSpendFloor () {
      const spend = this.ready ? this.totals.spendTotal : 0
      return spend > 0 ? spend / LIMIT_MARGIN : null
    },
    // WHICH OF THE TWO WALLS IS THE ONE, so the note under the box names the rule that actually
    // stopped the figure. Null where neither is stated.
    revenueLeastReason () {
      const spend = this.revenueSpendFloor
      const base = this.revenueBaseFloor
      if (base === null) return spend === null ? null : 'spend'
      if (spend === null) return 'base'
      return spend > base ? 'spend' : 'base'
    },
    // Both of them as one figure: the least revenue this plan can carry. Which of the two is higher
    // is not fixed — the base wall is a multiple of what the CURVES return and this one is the money
    // put through them, so a plan whose media are efficient is held by the base and a plan buying
    // media that barely respond is held by the spend.
    revenueLeast () {
      const spend = this.revenueSpendFloor
      const base = this.revenueBaseFloor
      if (base === null) return spend
      if (spend === null) return base
      return Math.max(spend, base)
    },
    revenueBaseFloor () {
      const marketing = this.marketingTotal
      const floor = this.baseFloor
      if (marketing === null || floor === null) return null
      // AND IT NO LONGER ASKS WHAT HAS BEEN DRAWN, which is the whole of what the composer's unit
      // for the two years bought. It used to divide by the room the drawn rows left — the revenue
      // had to clear the curves, the floor AND whatever the season and the spot events had claimed
      // — so the wall under this box moved every time a bar did, and a revenue typed before the
      // section was opened could be left under a wall that rose behind it.
      //
      // The rows are percentages of each month's own base now and every month is capped at
      // SHAPE_MONTH_CAP of it, so the WORST year that can be drawn is known before anything is: the
      // base cannot fall below (1 − cap) of what the curves leave, and a revenue clearing
      // SHAPE_REVENUE_FACTOR times the curves' own return survives it whatever is drawn on top. One
      // figure, decided by the media alone, that no gesture below can move.
      //
      // A HAIR ABOVE THE WALL AND NOT ON IT, which is what LIMIT_MARGIN is for everywhere else in
      // this wizard read the other way up. The base is compared against its floor after the year has
      // been spread over twelve cells and rounded into them, and a revenue seated exactly on the
      // equality lands a rounding under it about half the time — which is a plan that trips the very
      // rule the wall exists to keep it out of, and freezes both editors below. A tenth of a percent
      // is inside every rounding involved and invisible in a figure printed as money.
      return marketing * SHAPE_REVENUE_FACTOR / LIMIT_MARGIN
    },
    // The same figure in words, under the field it holds. It stands whether or not anything has been
    // typed yet, which is the point: it is what the media above have already decided about the
    // question this box asks, and a reader who knows it before typing never meets the wall.
    revenueFloorHint () {
      const floor = this.revenueLeast
      if (!this.ready || floor === null || !(floor > 0)) return ''
      return this.$t('components.ekrm.CreateModelCompose.revenueFloorHint',
        { revenue: this.formatMoney(floor) })
    },
    baseWarning () {
      const floor = this.baseFloor
      const base = this.baseRevenue
      if (floor === null || base === null || base >= floor) return null
      return this.$t('components.ekrm.CreateModelCompose.baseBelowFloor', {
        floor: this.formatMoney(floor),
        revenue: this.formatMoney(this.marketingTotal + floor)
      })
    },
    // The same floor, asked of the base the DECOMPOSITION is left with — the revenue less what the
    // curves are credited with AND what the seasonality takes. A separate warning rather than a
    // widening of the one above, because that one answers a different question: whether the curves
    // are credited with more than the whole of what was sold, in which the seasonality has no part.
    // Both can stand at once and that is two claims, not one said twice.
    //
    // It is the same rule as the seasonality corridor's own base end, so the rail stops exactly
    // where this starts — a slider greying ground the warning is silent about would be two answers
    // to one question. What it exists for is the box, which is unclamped here as every box is, and
    // the sideways route the corridors deliberately leave open: raise the seasonality to its limit,
    // then raise the spend, and neither corridor is watching the sum of the two.
    decompositionBaseWarning () {
      const marketing = this.marketingTotal
      const seasonality = this.seasonalityTotal
      const spot = this.spotTotal
      // BOTH of the signed components come out of the base, so both are subtracted here. Either one
      // alone is enough to trip it, hence the pair of nulls read separately rather than one guard
      // over both.
      //
      // AND IT IS THE ONE ANNUAL RULE LEFT ON THIS PAGE. The revenue box is held above the figure
      // that makes this true for every year inside the cap — see revenueBaseFloor — so the ordinary
      // way in is closed and no bar in the editors below is held by it any more. What is still open
      // is a MONTH: the cap is a share of a month's own base, and a revenue shaped one way against a
      // spend shaped another can leave a month whose curves return the whole of it. That month
      // claims nothing, the eleven around it still claim theirs, and the year can come out under the
      // floor without any cell having been typed past a wall. The answer is the spend or the revenue
      // and the sentences below say so.
      if (marketing === null || (seasonality === null && spot === null)) return null
      const floor = cloneBaseFloor(marketing)
      if (floor === null) return null
      const claimed = (seasonality || 0) + (spot || 0)
      const base = this.totals.kpiTotal - marketing - claimed
      if (base >= floor) return null
      // WHAT THE TWO ROWS HAVE TO SPEND, and it is the figure this sentence is about: the revenue,
      // less what the curves are credited with, less the least base those curves leave room for,
      // which is the share the two drawn years may take between them over the year. It was
      // printed here under the word "base", which it is not: the base is what is left AFTER they
      // have taken their share, and naming a pot of 10 as a floor of 758 in the same breath is a
      // sentence nobody can act on, read at exactly the moment a reader is trying to.
      //
      // AND IT CAN BE NEGATIVE, which is a different warning rather than a smaller one. Where the
      // curves alone have already taken the base under its floor there is no pot at all: no season
      // and no row of events can be drawn small enough to help, and the two answers are the spend
      // and the revenue. Sending a reader to a swing that is not what is wrong is the one thing this
      // line must not do.
      const room = this.totals.kpiTotal - marketing - floor
      if (!(room > 0)) {
        return this.$t('components.ekrm.CreateModelCompose.decompositionBaseNoRoom',
          { floor: this.formatMoney(floor) })
      }
      return this.$t('components.ekrm.CreateModelCompose.decompositionBaseBelowFloor', {
        floor: this.formatMoney(floor),
        room: this.formatMoney(room),
        claimed: this.formatMoney(claimed)
      })
    },
    // The same reading month by month, for the top segment of the revenue box's bars. Off the form
    // itself, exactly as the figures above it are: nothing on this page reads a level the form does
    // not carry, there being no gesture left that proposes one.
    marketingMonthly () {
      if (!this.ready) return null
      return cloneMarketingMonthly(this.formState, 1)
    },
    // WHAT EVERY MONTH IS MADE OF, one column apiece: what the model would have made on its own at
    // the bottom, what the season and the spot events add to it, and what the media spend returns on
    // top. It is the waterfall below said twelve times — the same components, the same colours, the
    // same order — so a reader who has understood one has understood the other, and this one says
    // WHEN each of them happens, which is the only thing the waterfall cannot.
    //
    // A COMPONENT CAN BE NEGATIVE, AND TWO OF THESE ARE. A month selling under its own trend has a
    // season that took revenue OUT of it, a spot event can be a month that gave some up, and there
    // is no segment inside a bar that can be drawn for something the bar does not contain. So the
    // row grows a floor: what they took hangs under the line — one segment each, in their own two
    // colours — the stack above the line is what the month would have sold without either, and the
    // difference between the two regions is the figure written over the column, which is the month's
    // revenue, the same figure the field opens on and the same one the row sums to.
    //
    // The two regions are sized so that a dollar is the same height in both. The one above carries
    // the figures and is therefore held under the ceiling; the one below carries nothing and is not.
    // Solving the two against a common unit is the whole of `up` below — and where nothing hangs, it
    // comes out at the whole column and every figure here means what it always meant.
    //
    // Percentages rather than pixels, because the plot fills whatever height the card's other
    // contents leave it and the two cards stretch to the taller of them.
    revenueRow () {
      if (!this.ready) return null
      const kpi = this.kpiVector
      if (kpi.length === 0) return null
      const marketing = this.marketingMonthly
      const shape = this.seasonalityShape
      const spotShape = this.spotShape

      // What each month is credited with, before any of it is turned into a height. `season` and
      // `spot` are a dot product one month at a time, and the year they are multiplied by is the
      // BASE and not the revenue: the two rows are percentages of what the month sold that the
      // curves are not credited with — see baseByCalendarMonth — and cloneShapeCells converts them
      // into the payload's own unit at the one place the payload is written. Floored at zero the
      // same way, so a month the curves have taken whole claims nothing here rather than claiming
      // backwards.
      const months = kpi.map((total, index) => {
        const media = marketing ? Number(marketing[index]) || 0 : 0
        const base = Math.max(0, (Number(total) || 0) - media)
        const season = base * (Number(shape[index % 12]) || 0) / 100
        const spot = base * (Number(spotShape[index % 12]) || 0) / 100
        // BOTH signed components can hang, and a month can hang two of them at once, so the floor is
        // the sum of what each gave up rather than the deeper of the two. It generalises what was
        // here: with one component `above` was `total - Math.min(0, season)`, which is `total` plus
        // that component's own share of the floor, and this is the same sentence with two terms.
        const below = Math.max(0, -season) + Math.max(0, -spot)
        return {
          total: Number(total) || 0,
          season: season,
          spot: spot,
          media: media,
          // What the month would have sold with neither of them taking anything out of it, which is
          // what stands on the line.
          above: (Number(total) || 0) + below,
          below: below,
          belowSeason: Math.max(0, -season),
          belowSpot: Math.max(0, -spot)
        }
      })

      let upMost = 0
      let downMost = 0
      months.forEach(entry => {
        if (entry.above > upMost) upMost = entry.above
        if (entry.below > downMost) downMost = entry.below
      })
      if (!(upMost > 0)) return null
      // One dollar, the same height on both sides of the line: the region above is `up` percent of
      // the column and its tallest month reaches REVENUE_BAR_CEILING of it, the region below is the
      // rest and its deepest month reaches all of it. Equating the two units and solving for `up` is
      // the line below; downMost of nothing gives the whole column back, which is the row as it was.
      const up = 100 * upMost / (upMost + REVENUE_BAR_CEILING / 100 * downMost)
      const zeroLine = 100 - up

      const labels = this.monthLabels
      const bars = kpi.map((total, index) => {
        const entry = months[index]
        // Every segment as a share of the REGION ABOVE THE LINE, which is what the card lays them out
        // in. A month the curves credit with more than the whole of it has no base left, and the
        // segments still add up to the stack: what stands on the line is what the month would have
        // sold, however it is split.
        const height = Math.max(0, Math.min(1, entry.above / upMost)) * REVENUE_BAR_CEILING
        const share = amount => (entry.above > 0 ? height * Math.max(0, Math.min(1, amount / entry.above)) : 0)
        const mediaHeight = entry.media > 0 ? share(entry.media) : 0
        const seasonHeight = entry.season > 0 ? share(entry.season) : 0
        const spotHeight = entry.spot > 0 ? share(entry.spot) : 0
        const depth = amount => (downMost > 0 ? 100 * Math.max(0, Math.min(1, amount / downMost)) : 0)
        const month = labels[index] || ''
        return {
          key: index,
          base: Math.max(0, height - mediaHeight - seasonHeight - spotHeight),
          season: seasonHeight,
          spot: spotHeight,
          media: mediaHeight,
          // The region under the line is `downMost` deep, so a month's own share of it is against
          // that and not against the year. One segment per component that gave something up, each
          // measured against the same depth, so the two stack to the month's whole floor.
          below: depth(entry.belowSeason),
          belowSpot: depth(entry.belowSpot),
          // The month's own figure, over its own column — and the same string the field opens on,
          // so the click that swaps the one for the other changes nothing but the box around it.
          // The compact form the whole page reads money in: a year is twelve of these at once and
          // the digits past the first are what a reader is not comparing. It is the month's REVENUE
          // and not the stack standing over the line, those being two different figures wherever the
          // season took something out of the month.
          amount: this.formatMoney(total),
          // The first letter of the month, which is the same character whether the label is a bare
          // month name or one carrying its year — the axis under the bars has room for exactly one.
          initial: month.slice(0, 1),
          // The month, and what its column comes to, for the tooltip's own head and its sum. The
          // amount above is the same string, so the two never disagree about what the month sold.
          month: month,
          totalLabel: this.$t('components.simulationDetails.SalesDecomposition.total'),
          // WHAT THE COLUMN IS MADE OF, NAMED AND COLOURED. The names are the decomposition's own
          // and the colours are the segments' own, so a row of the tooltip and a band of the column
          // are the same object said twice — which is the whole point of naming them here rather
          // than writing one grey line of arithmetic. Signed, and in the order they are stacked.
          parts: this.revenueBarParts(entry, marketing !== null),
          totalTitle: this.revenueBarTitle(month, entry, marketing !== null)
        }
      })
      // AND THE YEAR ITSELF, as a thirteenth column. The same components in the same order and the
      // same colours as the twelve beside it — this is what they add up to, and a reader who has
      // followed a month has followed it.
      //
      // AT ITS OWN SCALE, which is why the card sets it apart with a rule. A year is twelve months
      // tall: put on the months' axis it would leave them a row of hairlines, and the point of the
      // column is the SPLIT rather than the size, the size being the figure written over it. So it
      // fills its own region exactly as the tallest month fills the months'.
      //
      // The floor is the row's, though. Both stand on one zero and the region under it is one band,
      // so what the year gives up to the season is measured against that band in the year's own unit
      // — which is what the last line does. A year can only be under the line if some month is, so
      // there is no case where this needs a floor the row has not already grown.
      const yearSeason = months.reduce((sum, entry) => sum + entry.season, 0)
      const yearSpot = months.reduce((sum, entry) => sum + entry.spot, 0)
      const yearMedia = months.reduce((sum, entry) => sum + entry.media, 0)
      const yearTotal = months.reduce((sum, entry) => sum + entry.total, 0)
      // The year's own floor is the year's own components, not the sum of the months' floors: a
      // season that took from June and gave to December nets to nothing over a year and hangs
      // nothing here, which is exactly the reading this column exists to give.
      const yearBelowSeason = Math.max(0, -yearSeason)
      const yearBelowSpot = Math.max(0, -yearSpot)
      const year = {
        total: yearTotal,
        season: yearSeason,
        spot: yearSpot,
        media: yearMedia,
        above: yearTotal + yearBelowSeason + yearBelowSpot,
        below: yearBelowSeason + yearBelowSpot
      }
      const yearShare = amount => (year.above > 0 ? REVENUE_BAR_CEILING * Math.max(0, Math.min(1, amount / year.above)) : 0)
      const yearMediaHeight = year.media > 0 ? yearShare(year.media) : 0
      const yearSeasonHeight = year.season > 0 ? yearShare(year.season) : 0
      const yearSpotHeight = year.spot > 0 ? yearShare(year.spot) : 0
      // The year hangs in the ROW's band, at the year's own unit: the two plots stand on one zero
      // and the region under it is one band, so what the year gave up is measured against that band
      // and then converted into the column's own scale. One expression, applied to each component.
      const yearDepth = amount => (zeroLine > 0 && year.above > 0
        ? 100 * amount * ((100 - zeroLine) / 100) * REVENUE_BAR_CEILING / year.above / zeroLine
        : 0)
      const total = {
        key: 'total',
        apart: true,
        base: Math.max(0, REVENUE_BAR_CEILING - yearMediaHeight - yearSeasonHeight - yearSpotHeight),
        season: yearSeasonHeight,
        spot: yearSpotHeight,
        media: yearMediaHeight,
        below: yearDepth(yearBelowSeason),
        belowSpot: yearDepth(yearBelowSpot),
        amount: this.formatMoney(year.total),
        initial: this.$t('components.simulationDetails.SalesDecomposition.total'),
        month: this.$t('components.ekrm.CreateModelCompose.metricTotalKpi'),
        totalLabel: this.$t('components.simulationDetails.SalesDecomposition.total'),
        parts: this.revenueBarParts(year, marketing !== null),
        totalTitle: this.revenueBarTitle(this.$t('components.ekrm.CreateModelCompose.metricTotalKpi'), year, marketing !== null)
      }
      return { bars: bars, zeroLine: zeroLine, total: total }
    },
    // The three parts of the row above, each where the card asks for it.
    revenueBars () {
      return this.revenueRow ? this.revenueRow.bars : null
    },
    revenueZeroLine () {
      return this.revenueRow ? this.revenueRow.zeroLine : 0
    },
    revenuePlotTotal () {
      return this.revenueRow ? this.revenueRow.total : null
    },
    // Thirty-six months in the width of one box cannot each afford two pixels of air.
    barGap () {
      return { gap: this.monthCount > 18 ? '1px' : '2px' }
    },
    // The Total ROAS the EKRM being created will report, off the form that is about to be sent —
    // not the source model's, which covers a different period and every channel it ever fitted.
    roasTotal () {
      if (!this.ready) return null
      return cloneRoas(this.formState)
    },

    // --- The trade-off between spend and return ---------------------------

    // The range the chart covers, as multiples of THE PLAN'S OWN OPENING SPEND — the
    // sum of the saturation points typed on the cards, which is where every channel's spend row
    // starts. No source model's spend is anywhere in it: nothing of any source's LEVEL reaches this
    // wizard, only the shape of each response, so the only figure there is to be a multiple of is
    // the one the user stated. (The clone wizard shares cloneTradeWindow and its axis IS its source
    // model's own spend, which is why that function's own comments say so.)
    //
    // Anchored to the opening rather than to whatever the form carries now, so the axis does not
    // slide out from under the user every time a figure is typed. Widened only when an edit has
    // already taken the plan outside it — which nothing but a mix solved for a far-off return does.
    // Drawn in log10, so the opening sits in the middle and a halving is as far from it as a
    // doubling.
    //
    // AND THE LEFT END IS THE FLOOR ITSELF, which is this wizard's own departure from the window
    // cloneTradeWindow draws and the reason the clamp is here rather than in it.
    //
    // The two wizards differ in what is out there to the left. The clone's low end is a limit on a
    // plan its source model already stands at, and the user drags away from it in both directions,
    // so greyed ground on that side is ground they can be standing in and has to be drawn. This
    // wizard's low end is a wall nothing can be on the far side of: under it a medium's twelve cells
    // round away or the media stop returning a unit a month between them, both hard validator
    // errors, and applySpendRatio refuses to write a plan there by any route — typed, solved or
    // taken off the axis. So the stretch of axis to its left is not ground the plan might occupy, it
    // is dead track, and a chart whose first inch cannot be reached is a picture lying about its own
    // range.
    //
    // So the axis STARTS there: the left edge of the plot, the Min. spend label under it and the
    // floor are one point, and the corridor begins at the frame instead of inside it. The HIGH end
    // is untouched, and in this wizard it greys nothing at all: the three
    // ends that would bound a spend from above are each read against the revenue, and each is said
    // in words below rather than drawn as a wall — see tradeLimits. Nothing is out there because the
    // window IS the end: a figure typed past it lands on it, so the axis stops where the form does.
    //
    // AND NEVER PAST THE PLAN ITSELF, which has to be checked here and cannot be assumed.
    //
    // applySpendRatio refuses to write a plan below the floor, but it refuses at the moment of
    // writing and the floor MOVES afterwards: a curve edited or a channel dropped rewrites the cells
    // that floor is measured in, and seatSpend runs after those but cannot always seat — a plan is
    // left exactly where the user put it when the corridor comes out empty. That is the one state
    // the paragraph above does not describe, and it is a real one. Clamping the axis to that floor
    // would then draw the frame to the RIGHT of the plan, and the chart would misreport the one
    // thing it exists to show — the 'here' rule and dot would be drawn on the frame, inside the
    // legal ground, at a level that is not legal, and tradePlot's greyed rectangle for the low end
    // would collapse to nothing because its edge and the frame are the same point. The one visual
    // that says the plan is standing somewhere it may not be would disappear exactly when it became
    // true.
    //
    // So the axis only starts on the floor when the plan is at or above it, which is every state
    // this clamp was written for and none of the states it would lie about. Outside them the window
    // is cloneTradeWindow's own, greyed ground and all.
    tradeBounds () {
      const span = cloneTradeWindow(this.spendFactor, this.tradeLimits)
      const limits = this.tradeLimits
      const floor = limits && limits.min ? limits.min.factor * this.spendFactor : null
      const inside = floor !== null && floor > span.from && floor < span.to && floor <= this.spendFactor
      return { from: inside ? floor : span.from, to: span.to }
    },
    // THE STRETCH OF THE AXIS THE CHART WILL TAKE THE PLAN TO: the corridor between the two limits,
    // clipped to what is drawn and always wide enough to hold where the plan already is. Its two
    // ends are the two levels named under the axis — Min. spend and Max spend — so what those
    // buttons do is exactly what the corridor says, and neither of them can land the form somewhere
    // applySpendRatio would refuse.
    //
    // At the LOW end it coincides with the frame, and by the chart moving rather than by any
    // clamping here: see tradeBounds, which starts the axis on the floor. At the HIGH end there is
    // no limit at all in this wizard — see tradeLimits — so it is the end of the window, which is as
    // far as this chart draws.
    //
    // AND THE BOX ABOVE IS HELD AT BOTH, which is a change from what this comment used to say. A
    // level typed outside the corridor was kept and the corridor opened to hold it, on the argument
    // that a figure typed is a deliberate act; what that produced was a chart whose axis had been
    // stretched by a number rather than a chart the number could be read on. Spending past the
    // revenue is still a warning the user answers — that is a question about the revenue, and it is
    // asked in words below — but the SPEND itself now goes no further than the two levels named
    // under the axis. See spendRatioWithin.
    tradeCorridor () {
      return this.corridorWithin(this.tradeBounds, this.tradeLimits, this.spendFactor)
    },
    tradeViewBox () {
      return `0 0 ${TRADE_WIDTH} ${TRADE_HEIGHT}`
    },
    // THE LEAST AND THE MOST THIS FORM MAY SPEND and still be an EKRM the wizard will send — and
    // which of two corridors that is depends on whether a revenue has been answered yet.
    //
    // BEFORE ONE IS, the spend is the lead figure and is answered against the media alone: the two
    // floors that mention no revenue at all, and no ceiling — see cloneSpendFloorLimits. Nothing
    // about the curves bounds a spend from above while the revenue is still free to be whatever it
    // produced, and the three ends that would bound it are the three that name it.
    //
    // AND AFTER ONE IS, IT IS STILL THAT CORRIDOR, which is the whole of what leading means and is
    // this wizard's one departure from cloneSpendLimits.
    //
    // That function's other four ends are all read against the revenue, and each of them is now
    // answered on the revenue's own side of the pair or not answered as a wall at all:
    //
    //   attribution (low)   the spend at which the media explain so little of the business that the
    //                       band rounds away. It is the same wall composeRevenueCeiling is, read as
    //                       a spend instead of as a revenue — so with the spend leading it binds the
    //                       REVENUE, and seatRevenue is what walks the revenue down to meet a spend
    //                       that has been cut past it. Holding the spend there instead would leave
    //                       the slider stopped by a figure typed below it, which is the wizard's own
    //                       order read backwards.
    //   revenue (high)      the spend passes the revenue it is supposed to have produced. This
    //                       wizard has always said that in words and let the user answer it — see
    //                       the revenueBelowSpend alert and the "Create anyway" dialog — and it is
    //                       not a wall on either figure.
    //   base (high)         what the curves return leaves no Base Revenue standing. Said in words
    //                       too, by baseWarning, for the same reason.
    //   attribution (high)  the band reaches MAX_ATTRIBUTION_SHARE, where writeImpliedBand clamps
    //                       it rather than failing.
    //
    // So the two floors are the whole of it, before a revenue and after one, and the corridor never
    // changes shape under a figure typed below it. A spend legal on an empty page stays legal.
    //
    // Kept out of tradePlot, which is redrawn on its own: these move with the form and with nothing
    // else.
    tradeLimits () {
      return this.ready ? cloneSpendFloorLimits(this.formState, { floor: COMPOSE_FLOOR }) : null
    },
    tradeHeight () {
      return TRADE_HEIGHT
    },
    // The Total ROAS at every level of media spend, at the mix the form carries — the line the two
    // figures are two coordinates of. Recomputed with the form, a moved mix being a different curve.
    tradeCurve () {
      if (!this.ready || !(this.spendFactor > 0)) return null
      const bounds = this.tradeBounds
      const points = cloneRoasCurve(this.formState, {
        from: bounds.from / this.spendFactor,
        to: bounds.to / this.spendFactor,
        samples: TRADE_SAMPLES
      })
      if (!points) return null
      return points.map(point => ({
        level: point.factor * this.spendFactor,
        spend: point.spend,
        roas: point.roas
      }))
    },
    // Everything the chart draws: the line, the fill under it, the rule at the level currently
    // chosen, the three levels worth naming on the axis, and the samples the hover reads. The
    // response axis is anchored at zero, so the height of the line is the whole of the return and
    // not a slice of it.
    tradePlot () {
      const points = this.tradeCurve
      if (!points || points.length < 2) return null
      const bounds = this.tradeBounds
      const logFrom = Math.log(bounds.from)
      const span = Math.log(bounds.to) - logFrom
      const top = Math.max.apply(null, points.map(point => point.roas)) * 1.08
      if (!(span > 0) || !(top > 0)) return null

      const level = this.spendFactor
      const here = this.roasTotal
      if (here === null) return null

      const round = value => Math.round(value * 100) / 100
      const at = value => (Math.log(Math.min(bounds.to, Math.max(bounds.from, value))) - logFrom) / span * TRADE_WIDTH
      const up = roas => TRADE_HEIGHT - Math.min(1, Math.max(0, roas / top)) * TRADE_HEIGHT
      const mark = (value, roas) => ({
        left: round(at(value) / TRADE_WIDTH * 100) + '%',
        top: round(up(roas) / TRADE_HEIGHT * 100) + '%'
      })

      const line = points.map((point, index) => {
        return (index === 0 ? 'M' : 'L') + round(at(point.level)) + ' ' + round(up(point.roas))
      }).join(' ')
      const first = round(at(points[0].level))
      const last = round(at(points[points.length - 1].level))

      // The ground outside what the wizard will accept, greyed over rather than left to the two
      // rules to imply. A corridor is what the user is choosing inside, and it should not have to be
      // worked out from two vertical lines.
      const limits = this.tradeLimits
      const blocked = []
      if (limits && limits.min) {
        const edge = round(at(limits.min.factor * this.spendFactor))
        if (edge > 0) blocked.push({ key: 'min', x: 0, width: edge })
      }
      if (limits && limits.max) {
        const edge = round(at(limits.max.factor * this.spendFactor))
        if (edge < TRADE_WIDTH) blocked.push({ key: 'max', x: edge, width: TRADE_WIDTH - edge })
      }

      return {
        blocked: blocked,
        line: line,
        area: `${line} L${last} ${TRADE_HEIGHT} L${first} ${TRADE_HEIGHT} Z`,
        // The two ends of the axis, in money rather than in multiples: what the range means. Written
        // in the compact form every other figure on this page wears — the raw level here is a
        // floating-point end of a log range and prints as 1446414.0000000002.
        from: this.formatMoney(points[0].spend),
        to: this.formatMoney(points[points.length - 1].spend),
        currentX: round(at(level)),
        currentY: round(up(here)),
        currentStyle: mark(level, here),
        marks: this.tradeMarks(points, { at: at, up: up, mark: mark, round: round }),
        // EVERY LEVEL THE LINE IS DRAWN THROUGH, named and placed, for the card to read the pointer
        // against. The three labels under the axis are the levels worth TAKING, and they are not
        // the same question as what the curve says where the reader is looking: the samples answer
        // that one, at the resolution the line itself is drawn at.
        //
        // Formatted here rather than in the card, which owns no arithmetic and no money: `at` is a
        // fraction of the plot's width, which is what a pointer arrives as.
        readings: points.map(point => ({
          // The level itself travels with the reading: the tooltip says what this point of the
          // curve costs and returns, and clicking is taking it — see onTradeJump, which is the same
          // commit the named levels under the axis make.
          level: point.level,
          at: at(point.level) / TRADE_WIDTH,
          left: round(at(point.level) / TRADE_WIDTH * 100) + '%',
          style: mark(point.level, point.roas),
          spend: this.formatMoney(point.spend),
          roas: this.formatRoas(point.roas) + this.roasUnitSuffix
        }))
      }
    },
    // The marks that stand on the line itself, which is only ever the peak: a limit is a boundary
    // and belongs on the axis rather than on the curve.
    tradeDots () {
      return this.tradePlot ? this.tradePlot.marks.filter(mark => mark.style) : []
    },
    // One line of labels, or two when any of them had to be pushed off the first.
    tradeTicksHeight () {
      const marks = this.tradePlot ? this.tradePlot.marks : []
      return (marks.some(mark => mark.labelStyle.top !== '0px') ? 30 : 15) + 'px'
    },

    // --- Why the revenue has two walls and no rail -----------------------
    //
    // The clone draws a corridor under its revenue and this wizard draws none, which is not the same
    // thing as taking any figure at all. What it has is two walls, and only the two the build
    // actually refuses: a ceiling where the marketing attribution band rounds away to nothing, and a
    // floor where the twelve KPI cells do. See revenueWithin, which holds a typed figure at
    // whichever it passed and says so, and composeRevenueCeiling and composeRevenueFloor for the
    // arithmetic of each.
    //
    // Between them nothing binds, and that is why there is no rail. The other rules that could bound
    // a revenue — the base floor, the revenue against the spend — are warnings here rather than
    // errors: this wizard says them in words and lets the user answer, which is what baseWarning and
    // the "Create anyway" dialog are for. Greying ground under a slider for a level the user is
    // allowed to choose would be refusing a plan the wizard will in fact build, so the figure is
    // typed and nothing else, and rangeFor — which drew the ground and the named ends around a
    // bounded slider — is still gone.
    //
    // NOTHING IS RE-SEATED WHEN IT MOVES, and it is now this figure that is re-seated when the
    // MEDIA move. The media are stated in dollars before it and the spend on them is settled before
    // it, so answering a revenue by quietly pulling the user's own spend out from under it would be
    // answering a statement with a question — see onTotalRevenueChange. The traffic runs the other
    // way: both walls above are readings of the curves at the spend standing over this box, so a
    // channel, a curve or a spend that moves can leave a typed revenue on the wrong side of one, and
    // seatRevenue holds it at the wall it was pushed through, once, with a note under the box.

    // What the payload carries and the editor draws: the drawing if there is one, a flat year
    // otherwise, and whatever is under the pointer while a stroke is in progress.
    //
    // FLAT IS THE OPENING AND NOT A PLACEHOLDER. The clone wizard opens on the year its one source
    // model sells in, because there it is reproducing that business; this one is assembling a
    // business out of media taken from several, and none of their years is this one's. A seasonality
    // asserted on the user's behalf out of whichever model happened to be picked first would be the
    // wizard claiming something about a business it knows nothing about — so it claims nothing, and
    // a flat year is exactly that statement said in twelve numbers.
    seasonalityShape () {
      return this.drawnSeasonality || COMPOSE_FLAT_YEAR
    },
    // THE BASE EACH CALENDAR MONTH IS LEFT WITH, so a bar can say what it comes to in money: the
    // figure the two drawn years are percentages OF, and therefore the one every reading in this
    // section multiplies by. It is what the month sold less what the curves are credited with
    // returning in it, and it is kept as a mapping rather than as a row because the editor is
    // drawing a YEAR — assuming the two are the same array stops being true the moment a window is
    // added.
    //
    // The unit is the whole reason the section has no pot to ration — see SHAPE_MONTH_CAP. A
    // percentage of the revenue makes the rule that binds annual, because what one month claims
    // comes out of what every other month may; a percentage of the base makes it local, because a
    // month capped at four fifths of its own base leaves a fifth of it standing whatever the other
    // eleven do.
    //
    // Zeros where a month's curves are credited with the whole of it, which cloneBaseMonthly floors
    // rather than letting the arithmetic run negative, and twelve zeros where there is no reading at
    // all: the section then draws nothing and every bar is pinned, which is the honest picture of a
    // model whose media have taken the year.
    baseByCalendarMonth () {
      const totals = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      const monthly = this.ready ? cloneBaseMonthly(this.formState) : null
      if (!monthly) return totals
      monthly.forEach((value, index) => {
        const month = index % 12
        totals[month] += Number(value) || 0
      })
      return totals
    },
    // The two readings of the drawn year, in money. Taken off the SHAPE rather than off the form so
    // that a stroke in progress moves the waterfall and the footer without a rebuild — the arithmetic
    // is a dot product against the month totals above, which is what cloneSeasonality is against the
    // spread row. Null, never zero, for a source that carried no seasonality at all.
    seasonalityReading () {
      const shape = this.seasonalityShape
      if (!this.ready || !shape) return null
      let net = 0
      let amplitude = 0
      let any = false
      shape.forEach((share, month) => {
        const value = (Number(this.baseByCalendarMonth[month]) || 0) * (Number(share) || 0) / 100
        if (Number(share) !== 0) any = true
        net += value
        amplitude += Math.abs(value)
      })
      return any ? { net: net, amplitude: amplitude } : null
    },
    seasonalityTotal () {
      return this.seasonalityReading ? this.seasonalityReading.net : null
    },
    // Its colour, handed to the dot that ties the section's label to the bars it draws. A computed
    // and not the constant inline, for the reason every other colour on this page is one: the
    // template says which thing is being drawn and the script says what that thing looks like.
    seasonalityColor () {
      return SEASONALITY_COLOR
    },
    // The cap, for the one sentence that states it and for the axis it is drawn against. A computed
    // and not the constant inline, for the same reason the colour above is one: the template says
    // which rule is being stated and the script says what the rule is.
    shapeCap () {
      return SHAPE_MONTH_CAP
    },
    // The net beside December in the other unit: the share of the whole revenue the seasonality is
    // credited with, which is what the sales decomposition's own Seasonality bar is read as. One
    // decimal, the figure being near nothing in the ordinary case and the point of showing it being
    // that the reader can see how near. Empty where there is no revenue to be a share of.
    seasonalityShareLabel () {
      const total = this.moneyReady ? this.totals.kpiTotal : 0
      const net = this.seasonalityTotal
      if (!(total > 0) || net === null) return ''
      return `${(100 * net / total).toFixed(1)} %`
    },
    // No `reset` among them, and so no reset button: the editor's reset goes back to the source
    // year, and this wizard has none — see the flat opening at seasonalityShape.
    seasonalityLabels () {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return {
        // What the legend over the merged plot calls this row, and it is the section's own word for
        // it — the section names one thing now, so the two rows have to be named where they are
        // drawn or nothing on the page tells them apart.
        name: label('seasonalitySection'),
        // The name over the figure beside December, and what it means on hover. The same two strings
        // the footer used to carry it under: it is one reading and is now said in one place.
        total: label('metricSeasonalityNet'),
        totalInfo: label('metricSeasonalityNetInfo')
      }
    },

    // THE SPOT EVENTS, and everything below here is the block above said about the other row of the
    // same grid. Deliberately a copy rather than a factory over the two: they are two claims about
    // the same year that happen to be laid out alike, they are already diverging where it matters —
    // the walls are read against different neighbours and the bands are written by different
    // arithmetic, see seasonalityRowBand — and a pair of six-line computeds is a cheaper thing to
    // read than a parameterisation of them would be.
    //
    // Flat is the opening for the reason it is above, and a stronger one: a spot event is by
    // definition something that HAPPENED, and there is nothing in a composed model that could have
    // happened to it. Nobody has claimed one, so the wizard claims none.
    spotShape () {
      return this.drawnSpot || COMPOSE_FLAT_YEAR
    },
    // The two readings of the drawn year in money, off the SHAPE rather than off the form so that a
    // month just typed moves the columns and the waterfall without waiting on a rebuild. Null, never
    // zero, for a year nobody has said anything about — which is what lets the folded line say
    // "optional" where nothing was stated and a figure where something was.
    spotReading () {
      const shape = this.spotShape
      if (!this.ready || !shape) return null
      let net = 0
      let amplitude = 0
      let any = false
      shape.forEach((share, month) => {
        const value = (Number(this.baseByCalendarMonth[month]) || 0) * (Number(share) || 0) / 100
        if (Number(share) !== 0) any = true
        net += value
        amplitude += Math.abs(value)
      })
      return any ? { net: net, amplitude: amplitude } : null
    },
    spotTotal () {
      return this.spotReading ? this.spotReading.net : null
    },
    // The net in the other unit, exactly as seasonalityShareLabel is. A year of spot events does NOT
    // net to nearly nothing the way a season does — an event that happened once added revenue in the
    // month it happened and took none out of any other — so this figure is the one that is usually
    // worth reading of the two.
    spotShareLabel () {
      const total = this.moneyReady ? this.totals.kpiTotal : 0
      const net = this.spotTotal
      if (!(total > 0) || net === null) return ''
      return `${(100 * net / total).toFixed(1)} %`
    },
    spotLabels () {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return {
        name: label('spotSection'),
        total: label('metricSpotNet'),
        totalInfo: label('metricSpotNetInfo')
      }
    },
    // --- The two drawn years, read as one --------------------------------

    // WHAT THE SECTION COMES TO, which is the figure the waterfall's one bar carries and the figure
    // the fold says on the line that closes it. Null — never zero — while nobody has said anything
    // about either year, which is what lets that line say 'optional' where nothing was stated and a
    // sum where something was. A section carrying one stated year and one untouched one is a section
    // carrying that year: the untouched one adds nothing and its silence is not a zero.
    shapesTotal () {
      const season = this.seasonalityTotal
      const spot = this.spotTotal
      if (season === null && spot === null) return null
      return (season || 0) + (spot || 0)
    },
    // The same figure as a share of the whole revenue, exactly as each row's own is: what the sales
    // decomposition's Seasonality bar is read as, now that the bar is the two of them.
    shapesShareLabel () {
      const total = this.moneyReady ? this.totals.kpiTotal : 0
      const net = this.shapesTotal
      if (!(total > 0) || net === null) return ''
      return `${(100 * net / total).toFixed(1)} %`
    },
    // HALF THE AXIS OF THE STACKED ROW, in percentage points, read across BOTH years and both
    // sides of the line. It is the tallest stack the row has to draw: the two positives of a month
    // added, or its two negatives, whichever reaches further from the line.
    //
    // One scale for the whole row, because the one reading this plot exists to give is a month
    // claimed by both — two axes would be two pictures sharing a frame. Symmetric, because the two
    // sides of the line are the same claim with its sign changed and a reader measuring a June
    // against a December must not have to check which half of the row each is standing in. The
    // headroom keeps the tallest month clear of the top, and the floor keeps a model with a
    // two-point season from being drawn as twelve hairlines against a hundred-point axis.
    shapeScale () {
      let most = 0
      for (let month = 0; month < 12; month++) {
        const season = Number(this.seasonalityShape[month]) || 0
        const spot = Number(this.spotShape[month]) || 0
        most = Math.max(most,
          Math.max(season, 0) + Math.max(spot, 0),
          -Math.min(season, 0) - Math.min(spot, 0))
      }
      return Math.max(SHAPE_MIN_SCALE, SHAPE_HEADROOM * most)
    },
    // THE TWO DRAWN YEARS AS ONE STACKED ROW OF TWELVE. Every figure in it is read off the SHAPES
    // rather than off the form, which is where the bars and the two totals read them from as well,
    // so a month just typed is in the picture before the rebuild that follows it.
    //
    // A month is a stack and not two bars. They were two, side by side inside one column, which drew
    // the two years honestly and made the one reading that matters hard to take: what the two of
    // them come to TOGETHER in a month is what the base has to survive, and stacked, that is the
    // height of the column. The positives stand over the line and the negatives hang under it, each
    // side stacked outward from the line in the same order, so the distance from the line to a
    // component is the same whichever side it fell on.
    //
    // `up` is handed over in markup order — the box is laid out top-down and packed to its foot, so
    // the segment nearest the line is the LAST of them — and `down` in markup order too, where the
    // first is nearest. Both read outward from the line; only the markup runs opposite ways.
    shapeMonths () {
      if (!this.moneyReady) return null
      const scale = this.shapeScale
      const basis = value => (scale > 0 ? 100 * Math.min(1, Math.abs(value) / scale) : 0)
      const signed = value => `${value > 0 ? '+' : ''}${this.roundShare(value)}%`
      const rows = this.shapeRows
      return this.monthNames.map((name, month) => {
        const values = rows.map(row => Number(row.shape[month]) || 0)
        const up = []
        const down = []
        rows.forEach((row, index) => {
          const value = values[index]
          if (value > 0) up.push({ key: row.key, color: row.color, hatched: row.hatched, basis: basis(value) })
          else if (value < 0) down.push({ key: row.key, color: row.color, hatched: row.hatched, basis: basis(value) })
        })
        const net = values.reduce((sum, value) => sum + value, 0)
        return {
          key: month,
          month: name,
          // The first letter of the month, the axis under the columns having room for exactly one.
          initial: String(name || '').slice(0, 1),
          // The two rows SUMMED, which is what the column's height is. The split between them is the
          // card's to give.
          amount: signed(net),
          totalLabel: this.$t('components.simulationDetails.SalesDecomposition.total'),
          totalTitle: `${name}: ${signed(net)}`,
          up: up.reverse(),
          down: down,
          // EVERY row, whether it claimed anything or not: `claimed` is what the reading filters on,
          // and a month is also where a claim that was never made is made. `value` is what the field
          // opens on — the bare figure, so an edit round-trips through exactly what was on screen —
          // and `shown` is the signed reading beside it.
          parts: rows.map((row, index) => ({
            index: index,
            name: row.labels.name,
            color: row.color,
            hatched: row.hatched,
            value: String(this.roundShare(values[index])),
            shown: signed(values[index]),
            claimed: values[index] !== 0
          }))
        }
      })
    },
    // WHICH OF THE TWO FILLS IS WHICH, under the plot. The row draws both years in one amber and
    // tells them apart by the fill alone — see SEASONALITY_COLOR, where the case for one colour is
    // made — and a texture says nothing at all until it has been named once.
    //
    // BOTH ROWS, ALWAYS, which is what makes it a legend rather than a reading. The year's own card
    // carries the same two swatches and cannot do this job: it has to be opened to be read at all,
    // and the reader who has just drawn their first spot event, and is looking at one hatched band
    // for the first time, is exactly the reader who does not know there is anything to open.
    shapeLegend () {
      return this.shapeRows.map(row => ({
        key: row.key,
        name: row.labels.name,
        color: row.color,
        hatched: row.hatched
      }))
    },
    // WHAT THE TWO COME TO OVER THE YEAR, AS A THIRTEENTH COLUMN beside December. It was two
    // figures in a block of their own to the right of the plot, which said the same thing and said
    // it in a column of its own width: the twelve months were laid out inside whatever that block
    // left them and the revenue row's twelve were laid out inside whatever ITS year column left, so
    // the two rows of the same card — the same twelve months, one under the other, which is the
    // whole argument for putting them in one card — did not stand over each other. Drawn as a
    // column on the revenue row's own width and behind the revenue row's own rule, they do.
    //
    // IN MONEY, which is the one place the two are read apart and the reason they are two rows and
    // not one: a year of seasonality nets to nearly nothing — it moves sales between the months
    // rather than making any over a whole one — and a year of spot events does not, an event that
    // happened once having added sales in its own month and taken none out of any other. The figure
    // over the column carries its unit for the same reason the block did: the twelve columns are
    // shares of each month's own base and this is what those shares are WORTH, and a number that
    // changes unit halfway across a row has to say so.
    //
    // AT ITS OWN SCALE, which is what the rule down its left says. A year is twelve months of claims
    // added up; put on the months' axis it would leave them a row of hairlines, and the reading this
    // column exists to give is the SPLIT between the two rows, the size being the figure over it.
    //
    // IT IS NOT EDITABLE and does not need to say so: it is the twelve added up, the child opens no
    // form on a column marked `apart`, and the way to change it is to change one of them.
    //
    // A row nobody has said anything to is not among the bands: silence is not a claim of nothing,
    // which is what `claimed` carries — the card lists what was actually said.
    shapeTotalColumn () {
      if (!this.moneyReady) return null
      const rows = this.shapeRows
      const values = rows.map(row => Number(row.total) || 0)
      // Its own axis, symmetric like the months': whichever side of the line reaches further is what
      // fills the column, so the two sides stay comparable to each other and to nothing else.
      const gained = values.reduce((sum, value) => sum + Math.max(0, value), 0)
      const given = values.reduce((sum, value) => sum - Math.min(0, value), 0)
      const scale = Math.max(gained, given)
      const basis = value => (scale > 0 ? SHAPE_TOTAL_CEILING * Math.abs(value) / scale : 0)
      const up = []
      const down = []
      rows.forEach((row, index) => {
        const value = values[index]
        const band = { key: row.key, color: row.color, hatched: row.hatched, basis: basis(value) }
        if (value > 0) up.push(band)
        else if (value < 0) down.push(band)
      })
      const net = values.reduce((sum, value) => sum + value, 0)
      const money = amount => `${this.formatMoney(amount)} ${this.ekrmUnit}`
      const label = this.$t('components.simulationDetails.SalesDecomposition.total')
      return {
        key: 'total',
        apart: true,
        // The year names itself in full under its own column: it is not one of twelve of anything,
        // so there is no initial to take.
        initial: label,
        month: this.$t('components.ekrm.CreateModelCompose.shapesSection'),
        amount: money(net),
        totalLabel: this.$t('components.ekrm.CreateModelCompose.metricShapesNet'),
        totalTitle: `${this.$t('components.ekrm.CreateModelCompose.metricShapesNet')}: ${money(net)}`,
        up: up.reverse(),
        down: down,
        // The two rows named for what each COMES TO — the words the block beside the plot carried,
        // now where the figure they name is — each in money and then in the unit the sales
        // decomposition reads this bar in, which is the pair of readings that block gave. `info` is
        // what the row meant on hover there and means on hover here.
        parts: rows.map((row, index) => ({
          index: index,
          name: row.labels.total,
          color: row.color,
          hatched: row.hatched,
          info: row.labels.totalInfo,
          value: String(values[index]),
          shown: row.total === null
            ? ''
            : `${money(row.total)}${row.share ? ` · ${row.share}` : ''}`,
          claimed: row.total !== null
        }))
      }
    },
    // THE TWO ROWS THE STACK IS BUILT OUT OF, in the order they are drawn and read: the season
    // first, which is the ordinary answer, and the events under it, which are the exception. They
    // share the plot's zero line, its axis and its colour; what tells them apart is the hatching,
    // which is why a row carries `hatched` and no colour of its own.
    //
    // The order is load-bearing twice over: it is the order the segments stack outward from the line
    // in, and it is the order `parts` are indexed in — which is the only thing a figure typed into
    // the card comes back as. See onShapeMonthInput.
    shapeRows () {
      return [{
        key: 'seasonality',
        shape: this.seasonalityShape,
        labels: this.seasonalityLabels,
        color: SEASONALITY_COLOR,
        hatched: false,
        total: this.seasonalityTotal,
        share: this.seasonalityShareLabel
      }, {
        key: 'spot',
        shape: this.spotShape,
        labels: this.spotLabels,
        color: SEASONALITY_COLOR,
        hatched: true,
        total: this.spotTotal,
        share: this.spotShareLabel
      }]
    },

    // What the block where the summary would be says while there is no summary. Two different
    // silences: an empty composer has nothing to read because nothing has been added, and one whose
    // channels are all still unplaced has nothing to read because no curve has been given a size.
    // The first asks for a channel; the second asks for the pair, which is the same sentence the
    // alert over the grid carries once at least one channel has been answered.
    emptyStateText () {
      if (this.channels.length === 0) {
        return this.$t('components.ekrm.CreateModelCompose.emptyState')
      }
      return this.channelsPendingText
    },
    // The EKRM being built is always in USD on both axes — a source model's own units never reach
    // it, only the shape of each channel's response does, and there is no field in the payload in
    // which it could say otherwise — so its Total ROAS is a dimensionless return multiple and always
    // carries the 'x'.
    roasLabel () {
      return this.$t('components.ekrm.CreateModelCompose.metricRoas')
    },
    // The field carries a `≈` prefix, because it is a simulation of the build and not a reading of
    // it: the backend refits its own curve through the points this payload carries, so the figure is
    // close rather than exact.
    roasUnitSuffix () {
      return 'x'
    },
    // THE SAME SPEND AS A TABLE — one row per medium, one column per month, in the money the grid
    // beside it is drawn in.
    //
    // Read off `built.form.mediaSpend.ownControllable.data`, which is the row the payload will
    // actually carry: the level, the mix and the month shape are already multiplied into it (see
    // writeChannel and shapeSpendCells), so the table states what is spent rather than what would be
    // spent at a factor of one. That is also what makes it the same reading the bands above are —
    // spendMonths takes its cells from this very row — so the two cannot disagree.
    //
    // The variation range is NOT here. It is column two of the grid CreateEkrm shows and it is not a
    // spend: this wizard reads it off the source model for every channel and no card on the page
    // asks about it, so a column of it here would be a figure nobody typed sitting between the
    // medium and its year.
    spendSheetValues () {
      if (!this.ready) return []
      const rows = this.built.form.mediaSpend.ownControllable.data
      const media = this.built.media
      return rows.map((row, index) => {
        const name = media[index] ? media[index].label : String(row[0])
        return [name].concat(row.slice(2).map(cell => Number(cell) || 0))
      })
    },
    // The header the grid is built with: the medium, then the months this payload carries. The month
    // names come from the same list the columns above are labelled with, so a band and a column of
    // the table are the same month spelled the same way.
    spendSheetColumns () {
      const columns = [{
        type: 'text',
        // This wizard's own word and not the grid's. CreateEkrm calls the column "Own Controllable
        // Media" because its step draws two grids and the name is what tells them apart — that one
        // against the co-marketing and competition rows under it. There is one grid here and every
        // row in it is a channel taken off a model, so the distinction has nothing to distinguish.
        title: this.$t('components.ekrm.CreateModelCompose.spendSheetChannels'),
        width: '200px',
        readOnly: true,
        wordWrap: true,
        align: 'left'
      }]
      for (let index = 0; index < this.monthCount; index++) {
        columns.push({
          type: 'numeric',
          title: this.monthLabels[index] || '',
          width: '110px',
          decimal: '.',
          allowEmpty: true,
          customFormat: '$'
        })
      }
      return columns
    },
    // THE REVENUE AS ONE ROW OF TWELVE. Every figure in it is read off what the wizard is actually
    // carrying — the KPI row the payload will send — so the grid and the columns above it cannot
    // disagree, and everything that moves the year moves it: the total typed over the columns, a
    // shape pressed, a column typed into, a month held at one of its own walls.
    revenueSheetValues () {
      if (!this.moneyReady) return []
      return [
        [`${this.sheetRowName('metricRevenueShape')} (${this.ekrmUnit})`]
          .concat(this.kpiVector.map(cell => Number(cell) || 0))
      ]
    },
    // AND THE TWO DRAWN YEARS AS TWO ROWS OF TWELVE, in the order the plot over them draws them.
    // Taken off the SHAPE rather than off the form, which is where the bars and the two totals read
    // them from as well, so a month just drawn is in the grid before the rebuild that follows it.
    sharesSheetValues () {
      if (!this.moneyReady) return []
      const unit = this.$t('components.ekrm.CreateModelCompose.shapeUnit')
      return [
        [`${this.sheetRowName('seasonalitySection')} (${unit})`]
          .concat(this.seasonalityShape.map(share => Number(share) || 0)),
        [`${this.sheetRowName('spotSection')} (${unit})`]
          .concat(this.spotShape.map(share => Number(share) || 0))
      ]
    },
    // The header of the revenue's grid: the row's name, then the twelve months. No negatives — the
    // grid strips a minus sign unless the column says otherwise, and a month that sold less than
    // nothing is not a thing the KPI row can carry.
    revenueSheetColumns () {
      return this.monthSheetColumns(this.monthLabels, {},
        this.$t('components.ekrm.CreateModelCompose.sheetSeries'))
    },
    // And the pair's, where both rows DO take a minus sign: a month can sell below its own year, and
    // a spot event can have cost revenue rather than made it.
    sharesSheetColumns () {
      return this.monthSheetColumns(this.monthLabels,
        { allowNegativesRows: [0, 1] },
        this.$t('components.ekrm.CreateModelCompose.sheetSeries'))
    },
    // The two other inputs' tables, one row each, blank cells where the series is.
    comarketingSheetValues () {
      return this.otherSheetRow('comarketing', 'otherComarketing')
    },
    competitionSheetValues () {
      return this.otherSheetRow('competition', 'otherCompetition')
    },
    otherSheetColumns () {
      return this.monthSheetColumns(this.monthLabels, {},
        this.$t('components.ekrm.CreateModelCompose.sheetSeries'))
    },
    // THE SAME SIX VERBS THE SALES ROW HAS, in the same order: this card is drawn like that one and
    // answers to the same gestures, the total standing still under all of them but Clear.
    otherActions () {
      const title = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return [
        { key: 'randomize', icon: 'mdi-shuffle-variant', title: title('otherRandomize') },
        { key: 'flatten', icon: 'mdi-format-align-middle', title: title('otherFlatten') },
        { key: 'shiftLeft', icon: 'mdi-arrow-left-bold-outline', title: title('otherShiftLeft') },
        { key: 'shiftRight', icon: 'mdi-arrow-right-bold-outline', title: title('otherShiftRight') },
        // The year some model's inputs actually fell in, spread over the total on the card. See
        // applyShapeImport.
        { key: 'import', icon: 'mdi-database-import-outline', title: title('otherImport') },
        { key: 'clear', icon: 'mdi-eraser', title: title('otherClear') }
      ]
    },
    // WHAT THE FUTURE TRENDS STEP DRAWS, one card per series the payload carries a year of: the
    // sales and the media spend always, co-marketing and competition only where Other Inputs gave
    // them a spend. Each reads last year off the form about to be sent.
    growthCards () {
      if (!this.built) return []
      const form = this.built.form
      const t = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      const numbers = row => row.map(value => Number(value) || 0)
      const cards = [{
        key: 'sales',
        label: t('growthSales'),
        title: t('growthSalesInfo'),
        color: REVENUE_COLOR,
        past: numbers(form.kpi.data[0].slice(2))
      }, {
        key: 'media',
        label: t('growthMedia'),
        title: t('growthMediaInfo'),
        color: MARKETING_COLOR,
        past: form.mediaSpend.ownControllable.data.reduce((sum, row) => {
          return sum.map((value, month) => value + (Number(row[month + 2]) || 0))
        }, new Array(this.monthCount).fill(0))
      }]
      ;[
        { key: 'comarketing', label: 'otherComarketing', color: COMARKETING_COLOR },
        { key: 'competition', label: 'otherCompetition', color: COMPETITION_COLOR }
      ].forEach(entry => {
        const values = this.otherValues(entry.key)
        if (!(values.reduce((sum, value) => sum + value, 0) > 0)) return
        cards.push({
          key: entry.key,
          label: t(entry.label),
          title: t('growthOtherInfo'),
          color: entry.color,
          past: values
        })
      })
      return cards.map(card => Object.assign(card, this.futureTrends[card.key]))
    },
    growthTexts () {
      const t = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return {
        min: t('growthMin'),
        max: t('growthMax'),
        pastYear: t('growthLastYear'),
        nextYear: t('growthNextYear'),
        change: t('growthChange'),
        noChange: t('growthNoChange'),
        pastGroup: t('growthPastGroup'),
        futureGroup: t('growthFutureGroup'),
        pastColumn: t('growthPastColumn'),
        nextColumn: t('growthNextColumn'),
        legendPast: t('growthLegendPast'),
        legendFuture: t('growthLegendFuture'),
        legendMark: t('growthLegendMark')
      }
    },
    // WHAT THE OTHER INPUTS STEP DRAWS, one card per series: the revenue card's own columns, with a
    // single segment each since nothing here is split.
    otherCards () {
      return [
        { key: 'comarketing', label: 'otherComarketing', info: 'otherComarketingInfo', color: COMARKETING_COLOR },
        { key: 'competition', label: 'otherCompetition', info: 'otherCompetitionInfo', color: COMPETITION_COLOR }
      ].map(entry => {
        const label = this.$t(`components.ekrm.CreateModelCompose.${entry.label}`)
        const values = this.otherValues(entry.key)
        const total = values.reduce((sum, value) => sum + value, 0)
        const row = this.otherRow(values, label)
        return {
          key: entry.key,
          label: label,
          title: this.$t(`components.ekrm.CreateModelCompose.${entry.info}`),
          color: entry.color,
          value: total > 0 ? this.formatAmount(total) : '',
          bars: row.bars,
          total: row.total,
          aside: [{
            label: this.$t('components.ekrm.CreateModelCompose.metricAvgMonth'),
            value: total > 0 ? this.formatAmount(total / values.length) : '',
            editable: true,
            inputKey: `other_avg_${entry.key}_${this.formKey}`,
            title: this.$t('components.ekrm.CreateModelCompose.otherAvgMonthInfo')
          }, this.otherAttributionAside(entry.key, total)],
          sheetOpen: this[entry.key + 'SheetOpen'],
          sheetRows: this[entry.key + 'SheetRows'],
          sheetKey: this[entry.key + 'SheetKey']
        }
      })
    },
    // THE YEAR'S SPEND, MONTH BY MONTH, SPLIT BETWEEN THE MEDIA — the second row of the Media Spend
    // card, under the figure it is a reading of.
    //
    // Read off the spend grid rather than off the summaries, so the columns are the months the
    // payload carries and the stack order is the media order: the grid's rows are written from the
    // same list built.media is, in the same order, which is what lets the two be zipped by index. A
    // channel takes its colour from its own uid — see chartColors — so a band and the card that
    // placed it are the same colour for as long as that channel is on the page.
    //
    // Every band is a percentage of ITS OWN COLUMN and the column is a share of the tallest month,
    // which is the same arithmetic revenueBars does and the same bargain: the height says the shape
    // and the figure over it says the amount. The ceiling is the revenue row's, so a month at the
    // top of this row and a month at the top of that one reach the same height and the two rows read
    // as one picture.
    //
    // And the year beside them, at its own scale: it fills its own region exactly as the tallest
    // month fills the months', because what the column is FOR is the split — the size is the figure
    // written over it, and it is the same figure typed two rows above.
    spendMonths () {
      if (!this.ready) return null
      const rows = this.built.form.mediaSpend.ownControllable.data
      const media = this.built.media
      if (!rows.length) return null

      const colors = this.chartColors
      const cells = rows.map(row => row.slice(2).map(value => Number(value) || 0))
      const months = this.monthCount
      const labels = this.monthLabels
      const totalLabel = this.$t('components.simulationDetails.SalesDecomposition.total')

      const monthTotals = []
      for (let index = 0; index < months; index++) {
        monthTotals.push(cells.reduce((sum, row) => sum + (row[index] || 0), 0))
      }
      const tallest = monthTotals.reduce((top, value) => Math.max(top, value), 0)
      if (!(tallest > 0)) return null

      // One column, however tall it stands and whatever it is a column of: the year is drawn by this
      // too, against its own tallest — itself.
      const column = (key, initial, name, amounts, against) => {
        const total = amounts.reduce((sum, value) => sum + value, 0)
        const height = Math.max(0, Math.min(1, total / against)) * REVENUE_BAR_CEILING
        // Top down, because the box is laid out from the top down and the media stack from the line
        // up: the first channel is at the bottom of every column and the order never moves under the
        // reader.
        const segments = amounts.map((value, index) => ({
          key: index,
          color: colors[index] || colors[colors.length - 1],
          basis: total > 0 ? height * Math.max(0, Math.min(1, value / total)) : 0
        })).reverse()
        return {
          key: key,
          initial: initial,
          month: name,
          segments: segments,
          amount: this.formatMoney(total),
          totalLabel: totalLabel,
          // WHAT THE COLUMN IS SPENT ON, NAMED AND COLOURED, read from the line up — the revenue
          // row's own order, where the bottom band is the first row of the card.
          //
          // EVERY medium, with a flag saying which of them took anything. Read, the card shows only
          // the ones that did: a channel switched off in a month has nothing to say about that
          // month, and a card listing eleven channels at nothing is a list rather than a reading.
          // TYPED, it shows all of them, because a month is also where a channel that buys nothing
          // is given something to buy, and a row that hid the answer would be a card that can only
          // move money it has already been given. `index` is the channel's own position in the
          // media list, which is what the edit comes back as — see onSpendMonthChange.
          parts: amounts.map((value, index) => ({
            index: index,
            name: media[index] ? media[index].label : '',
            color: colors[index] || colors[colors.length - 1],
            value: this.formatMoney(value),
            spent: value > 0
          })).filter(part => part.name),
          totalTitle: `${name}: ${this.formatMoney(total)}`
        }
      }

      const bars = []
      for (let index = 0; index < months; index++) {
        const label = labels[index] || ''
        bars.push(column(index, label, label, cells.map(row => row[index] || 0), tallest))
      }
      const year = cells.map(row => row.reduce((sum, value) => sum + value, 0))
      const yearTotal = year.reduce((sum, value) => sum + value, 0)
      // Named the way the revenue row's thirteenth column is named: 'Total' under it, because it is
      // not one of twelve of anything and has no initial to take, and the box's own name in the card
      // over it — which is the figure typed two rows above, said here as a split.
      const total = column(
        'total',
        this.$t('components.simulationDetails.SalesDecomposition.total'),
        this.$t('components.ekrm.CreateModelCompose.metricSpendTotal'),
        year,
        yearTotal > 0 ? yearTotal : 1
      )
      total.apart = true
      return { bars: bars, total: total }
    },
    // What this EKRM's revenue is made of, in the shape SalesDecomposition reads: the components in
    // the order they accumulate in, and the total they land on.
    //
    // Every component the payload can actually state is here, and that is a shorter list than the
    // report's. The saturation curves give one bar per channel and the periodic row gives the
    // seasonality — see cloneSeasonality for why that percentage IS the share of sales rather than
    // an estimate of it, and the spot events are the other row of the same grid, read the same way.
    // What is NOT here is the noise: the report reads it as the model's residual, which is
    // what a fitted Gaussian process fails to explain about the KPI row it was handed, and no
    // arithmetic over this payload produces it — it does not exist until the build has run. So the
    // base below is a residual too, and still carries the noise the report will later take out of
    // it. The info dialog beside the chart says exactly that, because a Base here that will not
    // match the Base in the report of the model this becomes is worth stating rather than hiding.
    //
    // The base is taken as the total less the other bars rather than off baseRevenue, so the
    // waterfall closes on the figure written over it by construction: they are the same readings at
    // the same factor, and deriving it here means they cannot come apart at a rounding. It differs
    // from baseRevenue by exactly the seasonality, which is deliberate — baseRevenue answers a
    // different question, whether the curves are credited with more than the whole of what was sold,
    // and seasonality has no part in it.
    //
    // 'base' is the raw key rather than a translated string, because SalesDecomposition's own
    // defaultDictionary translates exactly that key — the base of a decomposition is its vocabulary,
    // not this wizard's. Medium names pass through it untouched.
    decompositionData () {
      if (!this.ready) return null
      // The same figure the Media Spend box's return is, read the same way and at the same level:
      // one bar for the whole of the media, not one per channel. The per-channel split is what the
      // cards below already are — each with its own curve, its own spend and its own return — and
      // saying it twice made the widest chart in the wizard the least legible of the three.
      const marketing = this.marketingTotal
      // Null, never zero, when a medium has no curve: a waterfall claiming the whole revenue is base
      // would be a statement, not a gap.
      if (marketing === null) return null
      // A total of zero is not drawable and is not merely an empty chart: SalesDecomposition falls
      // back to summing its own components when `total` is falsy, and the components it would be
      // summing here are objects rather than numbers.
      const total = this.totals.kpiTotal
      if (!(total > 0)) return null
      // The two drawn years stand between the base and the marketing rather than inside either: they
      // are neither what this model sells on its own nor anything the media bought, and a waterfall
      // of three bars is exactly the three things this payload can state. A year of seasonality
      // often nets to nearly nothing — it moves revenue between months rather than adding any over a
      // whole one — which is a reading and not a fault; a year of spot events does not, an event
      // that happened once having added revenue in its own month and taken none out of any other.
      //
      // ONE BAR FOR BOTH DRAWN YEARS, and it is the seasonality's. They were two, side by side and
      // in two colours, on the argument that they are two claims: what comes back every year and
      // what happened once. They are — and this chart is not where that difference is read. A
      // waterfall says what the revenue is MADE of, and against the base and the marketing these two
      // are one thing: revenue that is neither what the model sells on its own nor anything the
      // media bought. The section that asks for them says the difference, and the editor there draws
      // it in the fill of the bars; here they are summed into the component they both are. Signed,
      // and absent entirely — rather than drawn at zero — while nobody has said anything about
      // either.
      const shapes = this.shapesTotal
      // AND THE TWO OTHER INPUTS, each a bar of its own where the user said what it is credited
      // with, and in the report's own order: base, the media, co-marketing, competition, then the
      // season. A series nobody put a share on has no bar, the EKRM choosing its share — the info
      // dialog says so rather than the chart drawing a guess.
      const others = this.previewOtherBars
      const credited = others.reduce((sum, other) => sum + other.total, 0)
      const components = [{ name: 'base', value: total - marketing - (shapes || 0) - credited }]
      // 'marketing' is a raw key for the reason 'base' is, and is renamed by decompositionDictionary
      // rather than passed as a string: SalesDecomposition's own dictionary holds that key and would
      // translate anything named 'Marketing' into 'Instant Marketing', which this bar is not — it is
      // the whole of what the curves return, carry-over and all.
      components.push({ name: 'marketing', value: marketing })
      others.forEach(other => components.push({ name: other.label, value: other.total }))
      if (shapes !== null) {
        components.push({ name: this.seasonalityLabel, value: shapes })
      }
      return { components: components, total: total }
    },
    // Named from the decomposition's own vocabulary and not this wizard's, for the reason 'base' is
    // left as a raw key: it is the same component of the same chart, and a second name for it would
    // only give the two somewhere to drift. Spelled out here rather than left to the dictionary
    // because that dictionary keys seasonality off a name the EKRM's own grid does not use.
    seasonalityLabel () {
      return this.$t('components.simulationDetails.SalesDecomposition.seasonality')
    },
    // THE TWO OTHER INPUTS AS THE PREVIEW DRAWS THEM: every series the payload carries a spend for,
    // with the share the build actually wrote for it — null where the EKRM is left to choose — and,
    // where there is one, what that share comes to in money over the year and in each month.
    //
    // The month is the year spread by the series' own spend, which is an approximation and is
    // said to be one: the model puts saturation and carry-over between a month's spend and what it
    // is credited with, and neither exists until the model does.
    previewOthers () {
      if (!this.ready) return []
      const written = this.built.otherAttribution || {}
      const revenue = this.moneyReady ? this.totals.kpiTotal : 0
      const list = [
        { key: 'comarketing', label: this.$t('components.ekrm.CreateModelCompose.decompositionComarketingName'), color: COMARKETING_COLOR },
        { key: 'competition', label: this.$t('components.ekrm.CreateModelCompose.decompositionCompetitionName'), color: COMPETITION_COLOR }
      ]
      return list.map(entry => {
        const spend = this.otherValues(entry.key)
        const spent = spend.reduce((sum, value) => sum + (Number(value) || 0), 0)
        if (!(spent > 0)) return null
        const share = written[entry.key] === null || written[entry.key] === undefined ? null : Number(written[entry.key])
        const total = share === null || !(revenue > 0) ? null : revenue * share / 100
        return Object.assign({}, entry, {
          spend: spend,
          share: share,
          total: total,
          monthly: total === null ? null : spend.map(value => total * (Number(value) || 0) / spent)
        })
      }).filter(entry => entry !== null)
    },
    // Those of them that have a bar to draw.
    previewOtherBars () {
      return this.previewOthers.filter(other => other.total !== null)
    },
    // And those that do not: a spend with no share on it, credited with whatever the EKRM chooses.
    previewOthersChosenByModel () {
      return this.previewOthers.filter(other => other.share === null)
    },
    // NO `colors` PROP, and that is the whole of what makes this the chart the Model Report draws.
    // Handed one, SalesDecomposition gives every component its own colour and plots a negative bar
    // downwards from the axis in that colour; handed none, it draws the waterfall it draws
    // everywhere else in the app — each bar standing on the one before it, and anything that TAKES
    // revenue out drawn in red. A seasonality that nets negative is the ordinary case here, and the
    // reader who has seen a model report has already learnt to read the red one. Two pictures of the
    // same arithmetic, one of them only in this wizard, was the thing worth giving up: the palette
    // that tied the bars to the boxes above them is worth less than the chart being the chart.
    // What the marketing bar is called, and the term the info dialog beside it defines. Named from
    // this wizard rather than from the decomposition's vocabulary, which has no word for the whole
    // of what the curves return — only for the instant half and the carry-over half separately.
    marketingLabel () {
      return this.$t('components.ekrm.CreateModelCompose.decompositionMarketingTerm')
    },
    // The one rename the chart needs. SalesDecomposition merges what it is handed over its own
    // dictionary by DISPLAYED name — a prop keyed with a default label replaces every raw key that
    // resolved to it — so keying this with 'Instant Marketing' is what puts marketingLabel on the
    // 'marketing' bar. Nothing else is remapped: base, seasonality and the total keep the names the
    // decomposition gives them everywhere else in the app.
    decompositionDictionary () {
      const dictionary = {}
      dictionary[this.$t('components.simulationDetails.SalesDecomposition.instantMarketing')] = this.marketingLabel
      return dictionary
    },
    // WHAT EACH CHANNEL COST AND WHAT EACH CHANNEL RETURNED, side by side, in the shape the Model
    // Report's own Media Spend and Return chart reads: the channels, a spend per channel and an
    // attributed revenue per channel, from which that chart draws the two bars and the ROAS between
    // them.
    //
    // It is the per-channel split of the two figures the summary already states as totals — the
    // waterfall's Marketing bar and the Media Spend card's own total — and it is the one reading in
    // this wizard that puts them against each other channel by channel. The cards on the media step
    // each state their own pair, one card at a time; ranking them against one another is a different
    // question and it belongs where the model is read as a whole.
    //
    // Both halves come off the form the payload is built from, by the same traversals the totals do:
    // the spend is the twelve cells of each medium's own row, and the return is
    // cloneMarketingByMedium, which sums to cloneMarketing exactly — so the bars here add up to the
    // figures written above them rather than to a second opinion about them.
    //
    // Null, never a chart of zeros, wherever the return is: a medium with no curve is a channel this
    // reading has nothing to say about, and the silence is the one cloneMarketing keeps.
    spendReturnData () {
      if (!this.ready) return null
      const returns = cloneMarketingByMedium(this.formState)
      if (returns === null) return null
      const media = this.built.media
      const rows = this.built.form.mediaSpend.ownControllable.data
      const channels = []
      const spend = {}
      const attributedSales = {}
      media.forEach((medium, index) => {
        const label = medium.label
        if (!label || label in spend) return
        const row = rows[index] || []
        const cells = row.slice(2).map(value => Number(value) || 0)
        channels.push(label)
        spend[label] = cells.reduce((total, value) => total + value, 0)
        attributedSales[label] = returns[index] ? returns[index].response : 0
      })
      if (channels.length === 0) return null
      return { channels: channels, spend: spend, attributedSales: attributedSales }
    },
    // THE SAME TWO FIGURES AGAIN, DIVIDED AND READ ACROSS THE YEAR. The chart above puts the spend
    // and the return of each channel side by side over the whole twelve months; this one collapses
    // the channels and opens the year, which is the reading the Model Report calls Quarterly Average
    // Total ROAS — what every euro spent in that quarter came back as, on the curves as they stand.
    //
    // A quarter and not a month because that is the report's own period, and because the figure is a
    // ratio: three months of spend under one bar is enough money for the ratio to say something
    // about the plan rather than about a single thin month.
    //
    // Both halves come off the same traversals the totals do — cloneMarketingMonthly for the return,
    // the medium rows of the spend sheet for the spend — so the four bars are the year's own split
    // of the figures written above them rather than a second opinion. Null wherever cloneMarketing
    // is: a medium with no curve is a channel this reading has nothing to say about.
    //
    // A quarter that bought nothing has NO BAR rather than a zero: a ratio over no spend is not a
    // ROAS of nought, and echarts leaves a null out of the plot and out of the axis's own range.
    //
    // Rounded here, to the decimals the figure needs to keep two significant ones, because the bar
    // labels are drawn full-precision — the report's own bargain, and the reason its own values
    // arrive already rounded.
    quarterlyRoasData () {
      if (!this.ready) return null
      const monthly = cloneMarketingMonthly(this.formState)
      if (monthly === null) return null
      const rows = this.built.form.mediaSpend.ownControllable.data
      const months = this.monthCount
      const spend = []
      for (let month = 0; month < months; month++) {
        spend.push(rows.reduce((sum, row) => sum + (Number(row[month + 2]) || 0), 0))
      }
      const x = []
      const y = []
      let drawn = 0
      for (let start = 0; start < months; start += QUARTER_MONTHS) {
        const end = Math.min(start + QUARTER_MONTHS, months)
        let cost = 0
        let response = 0
        for (let month = start; month < end; month++) {
          cost += spend[month]
          response += Number(monthly[month]) || 0
        }
        x.push(`Q${x.length + 1}`)
        if (cost > 0) {
          y.push(this.roundRoas(response / cost))
          drawn++
        } else {
          y.push(null)
        }
      }
      if (drawn === 0) return null
      return { x: x, y: y }
    },
    // --- THE MODEL PREVIEW'S OWN CHANNEL LIST -----------------------------
    //
    // Every per-channel chart on the last step iterates THIS and not built.media, so the five of
    // them name the same channels in the same order and give each one the same colour. A medium is
    // named once: a label repeated in the list is the first row of it and the rest are dropped,
    // which is the rule spendReturnData already applies and the only one a chart keyed by name can
    // apply — two series called the same thing are one series in every component here.
    //
    // `index` is the position in the built form, which is what the spend sheet, the response matrix
    // and the summaries are all indexed by; `label` is what the charts call it, and `color` is the
    // channel's own — the colour its card wears, looked up by uid, so a channel keeps it across the
    // whole wizard and taking one out does not re-colour the rest.
    previewChannels () {
      if (!this.ready) return []
      const colors = this.chartColors
      const seen = {}
      const list = []
      this.built.media.forEach((medium, index) => {
        const label = medium.label
        if (!label || label in seen) return
        seen[label] = true
        list.push({ label: label, index: index, color: colors[index] || colors[colors.length - 1] })
      })
      return list
    },
    // The colour of each series, keyed the way every chart in the report keys it: by the name on the
    // legend. Same map for the mix, the attribution, the spend, the ROAS lines and the saturation
    // tabs, so one channel is one colour across the whole preview.
    previewChannelColors () {
      const colors = {}
      this.previewChannels.forEach(channel => { colors[channel.label] = channel.color })
      return colors
    },
    // WHAT EACH CHANNEL BUYS IN EACH MONTH, off the same grid the payload is built from — one row
    // per channel of previewChannels, in that order.
    previewSpendByChannel () {
      if (!this.ready) return []
      const rows = this.built.form.mediaSpend.ownControllable.data
      return this.previewChannels.map(channel => {
        const row = rows[channel.index] || []
        return row.slice(2).map(value => Number(value) || 0)
      })
    },
    // AND WHAT EACH ONE RETURNS IN EACH MONTH — the same matrix every other reading on this step is
    // a margin of, so a media mix, an attribution river and a waterfall drawn side by side cannot
    // disagree about one channel in one month. Null wherever cloneMarketing is silent: a medium with
    // no curve is a channel none of these charts has anything to say about.
    previewReturnByChannel () {
      if (!this.ready) return null
      const rows = cloneMarketingMonthlyByMedium(this.formState)
      if (rows === null) return null
      return this.previewChannels.map(channel => {
        const row = rows[channel.index]
        return row ? row.monthly : []
      })
    },
    // The two drawn years as one signed amount of money per month: the share each row claims of that
    // month's own base, which is the unit the section states them in. Summed over the year it is
    // shapesTotal exactly — the figure the waterfall's own Seasonality bar carries — so the stacked
    // columns below land on the bars beside them.
    previewShapeMonthly () {
      const base = this.baseByCalendarMonth
      const season = this.seasonalityShape
      const spot = this.spotShape
      const monthly = []
      for (let month = 0; month < this.monthCount; month++) {
        const at = month % 12
        const share = (Number(season[at]) || 0) + (Number(spot[at]) || 0)
        monthly.push((Number(base[at]) || 0) * share / 100)
      }
      return monthly
    },

    // --- DRIVERS PERFORMANCE ----------------------------------------------

    // THE WATERFALL, MONTH BY MONTH. The same three components the summary's decomposition states
    // for the whole year — what the model sells on its own, what the two drawn years move, and what
    // the curves return — each column adding to that month's revenue and the twelve columns adding
    // to the bars above them. Nothing is credited here that is not credited there: the base is the
    // residual of the other two for the reason it is a residual in decompositionData, so the two
    // pictures close on the same figure by construction rather than by agreement.
    decompositionByPeriodData () {
      if (!this.moneyReady) return null
      const marketing = this.previewReturnByChannel
      if (marketing === null) return null
      const labels = this.monthLabels
      const shapes = this.previewShapeMonthly
      const kpi = this.kpiVector
      const base = []
      const seasonality = []
      const media = []
      for (let month = 0; month < this.monthCount; month++) {
        const returned = marketing.reduce((sum, row) => sum + (Number(row[month]) || 0), 0)
        const moved = Number(shapes[month]) || 0
        media.push(returned)
        seasonality.push(moved)
        base.push((Number(kpi[month]) || 0) - returned - moved)
      }
      // The two other inputs, each spread across the year by its own spend, and out of the base.
      const others = this.previewOtherBars
      others.forEach(other => {
        for (let month = 0; month < this.monthCount; month++) base[month] -= Number(other.monthly[month]) || 0
      })
      // In the report's own order: the base, the season, co-marketing, competition, then the media.
      const data = {}
      data[this.baseLabel] = { x: labels, y: base }
      data[this.seasonalityLabel] = { x: labels, y: seasonality }
      others.forEach(other => {
        const y = []
        for (let month = 0; month < this.monthCount; month++) y.push(Number(other.monthly[month]) || 0)
        data[other.label] = { x: labels, y: y }
      })
      data[this.marketingLabel] = { x: labels, y: media }
      return data
    },
    // Their colours, which are this wizard's own rather than the chart's: the same three the
    // waterfall wears and the same three the boxes above it are dotted with, so a reader who has
    // learnt that green is what the business sells on its own reads the columns without a second
    // legend.
    //
    // AN ARRAY, AND IN THE DATA'S OWN KEY ORDER. Alone among the charts on this step, the stacked
    // bar takes its palette positionally — it indexes this by where a series stands in
    // Object.keys(data) — where the rivers and the bars take a map keyed by series name. Handed a
    // map it reads `.length` off an object, indexes at NaN and hands the gradient an undefined
    // colour, which throws inside echarts and leaves the section blank. So it is built by walking
    // the data itself rather than written out as three entries: the order is then the order by
    // construction, and a fourth component added to the waterfall cannot silently shift the palette
    // by one.
    decompositionByPeriodColors () {
      const named = {}
      named[this.baseLabel] = REVENUE_COLOR
      named[this.seasonalityLabel] = SEASONALITY_COLOR
      named[this.marketingLabel] = MARKETING_COLOR
      this.previewOthers.forEach(other => { named[other.label] = other.color })
      const data = this.decompositionByPeriodData
      if (!data) return []
      return Object.keys(data).map(key => named[key] || MARKETING_COLOR)
    },
    // What the decomposition calls the revenue the media had no part in. Off its own vocabulary and
    // not this wizard's, for the reason 'base' is left as a raw key in decompositionData: it is the
    // same component of the same chart, and a second name for it would only give the two somewhere
    // to drift.
    baseLabel () {
      return this.$t('components.simulationDetails.SalesDecomposition.base')
    },
    // WHAT EACH CHANNEL COST IN EACH MONTH, which is the whole of what an EKRM puts in and so is
    // the whole of the preview's Input Over Time. The spend card on the media step says this too, in
    // the wizard's own hand and under the figure it is a reading of; here it is the report's chart,
    // under the report's own name for the input.
    // WHAT THE INPUT OVER TIME SELECTOR OFFERS, as the report's does: the media, and each other
    // input the payload carries a spend for.
    previewInputItems () {
      const items = [{ text: this.$t('components.ekrm.CreateModelCompose.inputMarketingSpend'), value: PREVIEW_MARKETING_SPEND }]
      this.previewOthers.forEach(other => items.push({ text: other.label, value: other.key }))
      return items
    },
    // The variable on screen, falling back to the media when the one chosen has gone blank.
    previewInputSelected () {
      const wanted = this.previewInputVariable
      return this.previewInputItems.some(item => item.value === wanted) ? wanted : PREVIEW_MARKETING_SPEND
    },
    // The chart's data for that variable. An other input is one series, named the way the report
    // names its only category — '<name> Input' — and coloured as its card is.
    previewInputData () {
      const key = this.previewInputSelected
      if (key === PREVIEW_MARKETING_SPEND) return this.mediaSpendByPeriodData
      const other = this.previewOthers.find(entry => entry.key === key)
      if (!other) return null
      const y = []
      for (let month = 0; month < this.monthCount; month++) y.push(Number(other.spend[month]) || 0)
      return { [this.previewInputName(other)]: { x: this.monthLabels, y: y } }
    },
    previewInputColors () {
      const key = this.previewInputSelected
      if (key === PREVIEW_MARKETING_SPEND) return this.previewChannelColors
      const other = this.previewOthers.find(entry => entry.key === key)
      return other ? { [this.previewInputName(other)]: other.color } : {}
    },
    mediaSpendByPeriodData () {
      if (!this.ready) return null
      const spend = this.previewSpendByChannel
      if (spend.length === 0) return null
      const labels = this.monthLabels
      const data = {}
      this.previewChannels.forEach((channel, at) => {
        // Written out month by month rather than sliced off the row, so `y` is exactly as long as
        // `x` whatever the row happens to carry. A series one value short is not an empty tail in
        // echarts: the chart pairs its axis with its data by position and animates the pair, and the
        // undefined at the end of it throws inside that animation rather than being left undrawn.
        const y = []
        for (let month = 0; month < this.monthCount; month++) y.push(Number(spend[at][month]) || 0)
        data[channel.label] = { x: labels, y: y }
      })
      return data
    },
    // THE QUARTERLY ROAS, ONE LINE PER CHANNEL — the per-channel counterpart of the total the
    // summary states as bars, and the reading that says which channel earned the year's shape.
    //
    // A quarter a channel bought nothing in is a gap in its line rather than a zero, exactly as it
    // is a missing bar in the total: a ratio over no spend is not a ROAS of nought. A channel that
    // bought nothing all year has no line at all.
    quarterlyRoasByMediaData () {
      const returns = this.previewReturnByChannel
      if (returns === null) return null
      const spend = this.previewSpendByChannel
      const months = this.monthCount
      const data = {}
      this.previewChannels.forEach((channel, at) => {
        const x = []
        const y = []
        let drawn = 0
        for (let start = 0; start < months; start += QUARTER_MONTHS) {
          const end = Math.min(start + QUARTER_MONTHS, months)
          let cost = 0
          let response = 0
          for (let month = start; month < end; month++) {
            cost += Number(spend[at][month]) || 0
            response += Number(returns[at][month]) || 0
          }
          x.push(`Q${x.length + 1}`)
          if (cost > 0) {
            y.push(this.roundRoas(response / cost))
            drawn++
          } else {
            y.push(null)
          }
        }
        if (drawn > 0) data[channel.label] = { x: x, y: y }
      })
      return Object.keys(data).length > 0 ? data : null
    },
    // EVERY CHANNEL'S RESPONSE ON ONE PAIR OF AXES, in the report's own component: the curve, the
    // five optimal zones and the marginal ROAS, per channel and against each other.
    //
    // The line is the channel's own three parameters through hillSeries over hillPlotWindow, which
    // is exactly the picture the card and the editor draw — one curve read three ways would be three
    // curves. The dots are the plan's own levels: one per month the channel bought anything in, at
    // that month's spend. The bands are hillRegions, the same four boundaries the editor shades and
    // the card carries.
    //
    // A DOT IS THE CURVE READ AT THAT SPEND, and not what the attribution credits the month with.
    // The two are different numbers — a month's credit carries the previous months' decay into it,
    // so it sits above or below the curve rather than on it — and the difference is not free to
    // have here: the report's chart does not draw its datapoints beside the line, it SPLICES them
    // into it (ChannelCurvesChartMultiInstance.mergeLine), which is invisible for a report, whose
    // points are a spend on the grid against that grid's own response, and which turns a smooth
    // Hill into a zigzag the moment a point is off it. Two months of near-equal spend credited
    // differently were drawn as a vertical step in the middle of the curve. So the dots say what
    // they say in the report — this is what this level buys — and what the attribution makes of
    // those levels is the whole of the rivers above, drawn there and read there.
    //
    // AND EVERY LINE IS DRAWN TO THE SAME EDGE, which is the one thing this chart needs that the
    // cards do not. A card is one curve in its own box and hillPlotWindow frames it there; here the
    // eleven of them share a pair of axes, and a curve drawn over its own window stops wherever its
    // own saturation is — a channel that turns at $80k ends a fifth of the way across a plot a
    // channel that turns at $3m has stretched, leaving the reader to wonder what happened to it.
    // A model report has no such gap because a report's grid is the MODEL'S, one set of x values
    // for every channel in it, so the widest curve sets the box and the rest run the whole width of
    // it. The window here is the same rule read off the wizard's own parameters: the largest of the
    // eleven, given to all of them.
    //
    // Null for a channel with no curve to read, and null altogether when none of them has one.
    saturationCurvesData () {
      if (!this.ready) return null
      const spend = this.previewSpendByChannel
      const fitted = this.previewChannels.map(channel => {
        const medium = this.built.media[channel.index]
        const params = medium ? this.hillFor(medium.uid) : null
        return isHillParams(params) ? params : null
      })
      let top = 0
      fitted.forEach(params => {
        if (params) top = Math.max(top, hillPlotWindow(params))
      })
      const data = {}
      this.previewChannels.forEach((channel, at) => {
        const params = fitted[at]
        if (!params) return
        const series = reportGrid(params, top, CURVE_STEPS)
        const datapoints = []
        for (let month = 0; month < this.monthCount; month++) {
          const cost = Number(spend[at][month]) || 0
          if (cost > 0) datapoints.push({ x: cost, y: hillAt(params, cost) })
        }
        const entry = { x: series.x, y: series.y, datapoints: datapoints }
        const regions = hillRegions(params)
        if (regions) entry.regions = regions
        data[channel.label] = entry
      })
      return Object.keys(data).length > 0 ? data : null
    },
    // THE SAME CURVES FOR THE MEDIA STEP, where they are compared before anything is spent on them:
    // the lines of saturationCurvesData, on its shared window, without the plan's dots or the zones —
    // eleven sets of bands on one pair of axes would hide the curves they are bands of.
    channelsCompareData () {
      const curves = this.saturationCurvesData
      if (!curves) return null
      const data = {}
      Object.keys(curves).forEach(label => {
        data[label] = { x: curves[label].x, y: curves[label].y }
      })
      return data
    },
    // The colours that section is handed, and only for the channels it actually draws. It iterates
    // the COLOUR MAP rather than the data to lay out its per-channel tabs, so a channel coloured
    // here and missing from saturationCurvesData — one with no curve to read — would open a tab
    // onto nothing. Keyed off the data itself, the two cannot come apart.
    saturationChannelColors () {
      const data = this.saturationCurvesData
      if (!data) return {}
      const colors = {}
      Object.keys(data).forEach(label => { colors[label] = this.previewChannelColors[label] })
      return colors
    },
    // THE CLIENT THE REPORT'S SATURATION SECTION READS, and there is not one: this model does not
    // exist yet. What that component takes off a client is the granularity it names its spend axis
    // in and a component dictionary — the rest of what it touches is behind the impressions-model
    // path, which an EKRM is never on — so it is handed the two facts that are true of every EKRM:
    // the curves are monthly, and there are no custom names to translate.
    previewClient () {
      return {
        name: this.$t('components.ekrm.CreateModelCompose.previewModelName'),
        pretty_names: {},
        reference_model: { config: { saturation_granularity: 'M' } }
      }
    },
    // EVERY CHANNEL'S CARRY-OVER ON ONE PAIR OF AXES — what share of a month's spend is still
    // working one month later, two months later, and so on. Per channel the editor draws it as bars
    // on a card; this is the comparison between them, which is the shape the report asks it in.
    //
    // Normalised to sum to one, which is the unit the axis is labelled in: a kernel is a
    // distribution over lags, and the figure worth reading off it is the share, not the weight the
    // curve happens to carry.
    //
    // Drawn as the payload will carry it: a redrawn kernel is the drawing, an untouched one is the
    // source's own measurement on the monthly axis the EKRM reads it on — the same two branches the
    // cards use, for the same reason.
    decayCurvesData () {
      if (!this.ready) return null
      const data = {}
      this.previewChannels.forEach(channel => {
        const medium = this.built.media[channel.index]
        const entry = medium ? this.channels.filter(item => item.uid === medium.uid)[0] : null
        if (!entry) return
        let curve = null
        if (this.decayMoved(entry.uid)) {
          curve = composeDecayCurve(this.decayFor(entry.uid))
        } else {
          const read = this.readFor(entry)
          curve = read ? monthlyDecayCurve(read.sourceDecay, this.granularityFor(entry.modelId)) : null
        }
        if (!curve || !Array.isArray(curve.y) || curve.y.length === 0) return
        const total = curve.y.reduce((sum, value) => sum + (Number(value) || 0), 0)
        if (!(total > 0)) return
        data[channel.label] = {
          x: curve.y.map((value, lag) => lag),
          y: curve.y.map(value => (Number(value) || 0) / total)
        }
      })
      return Object.keys(data).length > 0 ? data : null
    },
    // Both axes of an EKRM are in USD by construction — a source reporting in anything else was
    // converted on the way in — so the chart's unit is the payload's, not the source model's.
    ekrmUnit () {
      return EKRM_UNIT
    },
    // The currencies of the markets in Admin > Countries, one entry each however many markets share
    // it, and always the one the model is really built in.
    currencyItems () {
      const codes = [EKRM_UNIT]
      this.countries.forEach(country => {
        const currency = MARKET_CURRENCIES[country.id]
        if (currency && codes.indexOf(currency[0]) === -1) codes.push(currency[0])
      })
      return codes.map(code => ({
        text: `${CURRENCY_NAMES[code] || code} (${code})`,
        value: code
      })).sort((a, b) => a.text.localeCompare(b.text))
    },
    frequencyItems () {
      return [
        { text: this.$t('components.ekrm.CreateModelCompose.frequencyMonthly'), value: 'monthly' },
        { text: this.$t('components.ekrm.CreateModelCompose.frequencyWeekly'), value: 'weekly' }
      ]
    },
    historyItems () {
      return HISTORY_YEARS.map(years => ({
        text: this.$tc('components.ekrm.CreateModelCompose.historyYears', years, { n: years }),
        value: years
      }))
    },
    // What the source model called the thing it measured, which is what this decomposition is a
    // decomposition OF. The chart names itself after it when it has no title of its own, and still
    // wants it for its export filename.
    decompositionKpiName () {
      return 'Total'
    },
    // And what the chart beside it calls it. The Media Spend and Return chart names its second bar
    // after the KPI — "Attributed <kpi>" — so this is the word the wizard uses for the thing the
    // media are credited with returning, which is the revenue the whole page is about.
    spendReturnKpiName () {
      return this.$t('components.ekrm.CreateModelCompose.spendReturnKpi')
    },
    // Everything the per-channel cards draw, computed once rather than per binding: the two paths,
    // the marker position, the bars and the four figures.
    // The static strings the channel card needs. Interpolated ones ride on the card itself, which
    // is what lets the same component be drawn by a wizard that names a channel's origin
    // differently.
    cardLabels () {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      return {
        saturation: label('saturation'),
        decay: label('decay'),
        noCurve: label('noCurve'),
        // The one word the card's own overlay wears. It names what the press OPENS — the channel's
        // editor, all of it — rather than the section the press used to land on, and the two name
        // messages are gone from here with the field they belonged to: the editor carries them.
        edit: label('curveEditAction'),
        // The decay axis, named once for every card rather than per card: the EKRM being built is
        // monthly, so a kernel taken from a weekly model is re-binned onto months before it is drawn
        // and there is no longer a card that could say anything else.
        lag: label('lagMonths'),
        // The saturation plot's x, named the way the dialog's chart names it. It was deliberately
        // empty while the plan's own spend was marked on the plot: naming the axis and then naming
        // the rule standing on it said the same thing twice in sixty pixels, and the rule was the
        // more particular of the two. The rule is gone — the chart this card is now a small copy of
        // marks nothing there — so what is left to say about the axis is what it is.
        //
        // And no `largestMonth`: there is no rule left for it to name. It is left out rather than
        // left empty, the card's own test being for the marker and not for the word.
        spend: label('spend')
      }
    },
    // The cards below take their state as one object each, so the component holds no rule about
    // which of its parts may be missing. Nothing here is new arithmetic — every figure is the one the
    // template read directly before the cards were pulled out.
    //
    // The one reading under the columns, and it is the year at a month's scale — the same figure the
    // spend card carries under its own plot, so the two cards close on comparable numbers. The total
    // is deliberately not repeated here: it is typed into the field at the top of this same card and
    // no shape may move it, so printing it under the columns would be the card echoing its own input
    // back.
    //
    // What stood here was the tallest month over the shortest, which is a reading of the SHAPE — and
    // every column now carries its own figure over it, so the pair was naming two of the twelve
    // amounts already on the card while saying nothing about the other ten.
    // The one reading of the typed total, beside the total rather than under the card: it is that
    // figure divided by the window, and the two belong on a line together. Under the card it stood
    // below the twelve months and the shapes, a chart away from the number it divides.
    //
    // AND IT IS TYPED, because the division goes both ways and only one of the two figures is ever
    // the one a user actually has. A business that knows it sells about eighty thousand a month
    // should not have to multiply by twelve to tell this wizard so — the wizard has the twelve. It
    // is the same statement either way and it lands in the same place: see onAvgMonthChange, which
    // multiplies and hands the year to the box beside it.
    revenueAside () {
      return [{
        label: this.$t('components.ekrm.CreateModelCompose.metricAvgMonth'),
        // formatAmount and not formatMoney: it stands beside the typed total in the same size, and
        // two figures of one year set side by side have to be rounded alike or the reader is left
        // dividing '1.5b' by twelve and getting something other than what is printed next to it. It
        // is also what an edit round-trips through, and a decimal dropped here is a decimal lost.
        value: this.moneyReady ? this.formatAmount(this.totals.kpiMonthly) : '',
        editable: true,
        // Bumped with the headline's, and for the same reason: the year that lands may be the wall
        // rather than the figure typed — see revenueWithin — and a month field left showing a
        // twelfth of something else would be the one place on the card that disagreed with it.
        inputKey: `avg_${this.formKey}`,
        title: this.$t('components.ekrm.CreateModelCompose.metricAvgMonthInfo')
      }]
    },
    spendBox () {
      const ready = this.ready
      return {
        // The box's own name and not the card's: the card above it is the Media Spend section, and
        // this is the figure inside it — the year's total, beside the return it buys.
        label: this.$t('components.ekrm.CreateModelCompose.metricSpendTotal'),
        value: ready ? this.formatAmount(this.totals.spendTotal) : '',
        // THE FIRST OF THE TWO FIGURES, and it needs no revenue to be typed. What it is held inside
        // is the corridor tradeLimits draws, which before a revenue exists is the two floors that
        // mention none: the media are placed and priced on the cards above, so what is spent on
        // them is a question those cards have already made answerable.
        disabled: !ready,
        inputKey: `spend_${this.formKey}`,
        // Where the opening figure came from: the plan the cards themselves describe, every channel
        // at the saturation point typed on it.
        title: this.$t('components.ekrm.CreateModelCompose.metricSpendInfo')
      }
    },
    // THE RETURN, READ OFF THE CHART RATHER THAN BOXED BESIDE THE SPEND. It was a second field on
    // the row and it is one figure: the y of the point the curve is already marked at, which the
    // plot draws whether or not a box repeats it. Standing in the plot's header it costs the row no
    // width — the width went to the picture it is a point of — and it is where a reader looking at
    // the curve already is.
    //
    // Still typed, by pressing it. With the curves fixed a return is not a figure that can be set,
    // so what a typed one does is solve for the spend that produces it — see onRoasChange, and
    // solveRoasByMix for what happens when no common factor can.
    roasNow () {
      return {
        label: this.roasLabel,
        // What the curves return over what they are given, which names no revenue either — see
        // cloneRoas. Null only where a channel has no curve to read.
        value: !this.ready || this.roasTotal === null ? '' : this.formatRoas(this.roasTotal),
        suffix: this.roasUnitSuffix,
        disabled: !this.ready || this.roasTotal === null,
        title: this.$t('components.ekrm.CreateModelCompose.metricRoasInfo')
      }
    },
    // ONE CARD PER CHANNEL ON THE PAGE, whether or not the payload carries it yet.
    //
    // Driven by `channels` and not by `summaries`, which is the difference between a wizard and a
    // dead end. A channel arrives stating nothing, so it is not a medium of the model and has no
    // summary — and the card is the only place the two figures that would make it one can be typed.
    // Built off the summaries alone, the page answered an added channel with a warning naming a card
    // that was not there.
    //
    // So a channel with no summary gets a PENDING card: the same name, the same origin, the same way
    // out, the same two editable rows standing empty, and the shape of the curve it would place drawn
    // from the source model's own points. That last one is not decoration — the shape is precisely
    // what is being imported, and it is the same picture the card will carry once the two figures
    // give it a size, because a sparkline is normalised against its own range and a level cannot
    // change it.
    cards () {
      const label = key => this.$t(`components.ekrm.CreateModelCompose.${key}`)
      const summaries = {}
      this.summaries.forEach(entry => { summaries[entry.uid] = entry })

      // Every kernel on the monthly axis the built model will read them on, and the longest of them,
      // which is the grid they are ALL laid out on: bars sized to each card's own kernel would put a
      // re-binned weekly channel's three fat bars beside a monthly one's twelve thin ones, and the
      // difference in width would read as a difference in the response.
      //
      // THE ONE THAT WAS REDRAWN IS DRAWN AS IT WAS REDRAWN. The decay is editable now, and a card
      // showing the model's measurement beside a dialog showing the user's drawing would be two
      // pictures of one channel — which is the defect this wizard has already removed once from the
      // saturation half of the same card. It is the payload's kernel with its unused tail cut, the
      // same one composeDecayPayload sends, so the card is laid out on exactly the months the
      // channel will be built with. Everything untouched is still read off the channel's own source
      // rather than off its summary, which is what lets a card that has not been answered yet be
      // laid out on the same grid as the rest.
      const decayCurves = {}
      this.channels.forEach(channel => {
        if (this.decayMoved(channel.uid)) {
          decayCurves[channel.uid] = composeDecayCurve(this.decayFor(channel.uid))
          return
        }
        const read = this.readFor(channel)
        decayCurves[channel.uid] = read
          ? monthlyDecayCurve(read.sourceDecay, this.granularityFor(channel.modelId))
          : null
      })
      const lagSlots = this.channels.reduce((longest, channel) => {
        const curve = decayCurves[channel.uid]
        return Math.max(longest, curve && Array.isArray(curve.y) ? curve.y.length : 0)
      }, 0)

      // What every card carries whether or not it has been answered: who it is, where it came from,
      // the way out, the way to rename it, and the two rows that place it.
      const shell = (uid, medium, modelName, channel) => ({
        uid: uid,
        medium: medium,
        channel: channel,
        // The model this channel came from, on every card and not only on a renamed one. With
        // channels from several models it is the thing a reader most needs to know about a card,
        // and two cards can otherwise be near-identical: the same medium name from two models
        // differs only by a bracket.
        // A channel invented here names no model and no source medium, because there are none: what
        // the line says instead is that this card was written on the page, which is the same kind of
        // fact and the one a reader needs to tell it from the imported cards beside it.
        originLabel: modelName
          ? this.$t('components.ekrm.CreateModelCompose.fromModel', { model: modelName, channel: channel })
          : this.$t('components.ekrm.CreateModelCompose.fromScratchOrigin'),
        originTitle: modelName
          ? `${modelName} · ${channel}`
          : this.$t('components.ekrm.CreateModelCompose.fromScratchOrigin'),
        color: this.colorFor(uid),
        removeTitle: this.$t('components.ekrm.CreateModelCompose.channelRemove', { channel: medium }),
        removeLastTitle: this.$t('components.ekrm.CreateModelCompose.channelRemoveLast'),
        // What the press on this card opens, said in full: the card carries no control of its own
        // any more, so its one title has to name the whole editor rather than a section of it.
        editTitle: this.$t('components.ekrm.CreateModelCompose.channelEditTitle', { channel: medium }),
        // WHERE THIS CHANNEL SATURATES AND WHAT IT GENERATES THERE, printed under the plot that
        // marks it. Not one of the `figures` below: those are readings taken off the plan — what
        // this medium is given and what it returns for it — and they close the card as a list. This
        // is the point the curve above it is drawn through, and it belongs against that curve.
        saturationPair: this.saturationPairFor(uid, medium),
        // No share bar. Every channel here opens at the saturation point stated on its own card, so
        // the bar would be reporting a figure the row under it already carries. The card closes its
        // head on a plain hairline instead. When the ROAS solver moves money the shares do part, and
        // that is said as a number on the card the mix factor appears on, which is also the only
        // card it is true of.
        sharePercent: null,
        shareLabel: '',
        // Answered until the pending branch says otherwise. See below: what used to be a warning
        // over the whole grid is now a state of the one card it was about.
        pending: null,
        pendingLabel: '',
        pendingTitle: '',
        decayBars: decayBars(decayCurves[uid], PLOT_WIDTH, PLOT_HEIGHT, lagSlots),
        // NO FIGURES. The card carried the two that place the curve — where the channel saturates
        // and what it generates there — and they were there because the card was where they were
        // typed. It is not: the editor is, and it carries both as labelled fields, with the sentence
        // each of them needs, over a chart that redraws as they are answered. Printing them here as
        // well left one statement in two places, the second of which could only ever restate what
        // the first had been used to say — and it spent a third of a card six to a row on it.
        //
        // What the card is FOR is the shape: two sparklines, the axis rule under them and the name
        // over them, which is what a reader compares one card against the next by. The two figures
        // are not that comparison; they are the answer to a question, and the question is asked
        // where the answer goes. An unanswered channel still says so on the card — the error border
        // and the overlay wearing the word — and neither of those was ever one of these rows.
        figures: []
      })

      return this.channels.map(channel => {
        const entry = summaries[channel.uid]
        if (!entry) {
          // Not a medium of this model yet, and drawn as the editor draws it before the pair is
          // typed: the imported fit over a UNIT scale. That division is the placement itself with
          // both figures standing at one — see editorPreviewHill, which is the same three lines
          // with the typed pair in them — so this is the shape the answer will produce, at the size
          // it has until somebody states one. No spend rule, because there is no spend.
          //
          // It is a fit and not the measured points. The dialog has no way of drawing a polyline
          // nobody has fitted, and a card that drew one stopped where the MEASUREMENT stopped while
          // the chart it opens ran on to its own window: the same channel turning in two different
          // places, which is exactly what this card is scanned for.
          const read = this.readFor(channel)
          const anchor = read ? composeAnchor(read) : null
          const unit = anchor && isHillParams(read.fit)
            ? { vmax: read.fit.vmax / anchor.response, k: read.fit.k / anchor.spend, n: read.fit.n }
            : null
          const plot = this.channelCurvePlot(unit, { stated: false })
          const source = this.models[channel.modelId]
          // WHY it is not a medium yet, which decides what the card asks for. Two reasons, answered
          // in opposite directions. The ordinary one is that nobody has stated the two figures —
          // every channel arrives that way — and the answer is the two rows on this card, so the
          // card asks for them where they are typed. The other is the channel's own imported curve
          // having no knee to normalise through, which nothing typed here can fix; composeAnchor is
          // what decides it, no figure the user states can move it, and the answer is to take the
          // channel out. So the first is a control and the second is a statement.
          //
          // This is what the warning over the grid used to say. A block listing channels by name,
          // above a grid of cards each carrying that name, made the reader match a sentence to a
          // card and then find the rows the sentence meant — and it grew a line per unanswered
          // channel, which on a fresh composition is every card on the page. The card says it about
          // itself, in the place the answer is typed.
          const placeable = anchor !== null
          return Object.assign(shell(
            channel.uid,
            channel.label,
            channel.scratch ? null : (source ? source.model.name || channel.modelId : channel.modelId),
            channel.raw
          ), {
            saturation: plot ? plot.saturation : null,
            // Off the curve this plot is drawn from, which is the imported fit at unit scale. The
            // two figures have not been typed, so there is no placement to carry the boundaries into
            // the plan's own money — but the zones are a statement about the CURVATURE, and the
            // curvature is exactly what arrives with the channel and what a scaling cannot touch.
            zones: plot ? plot.zones : [],
            // The place among those bands where this channel saturates, marked as the question it
            // still is: the card has the same nothing to say about its magnitude that the editor's
            // blank axes have, and the same reason to show where it falls.
            saturationPoint: plot ? plot.saturationPoint : null,
            sourceLine: null,
            spendMarker: null,
            pending: placeable ? 'stated' : 'blocked',
            pendingLabel: label(placeable ? 'unbuiltAction' : 'unbuiltBlocked'),
            pendingTitle: this.$t(
              `components.ekrm.CreateModelCompose.${placeable ? 'unbuiltChannel' : 'unbuiltNoCurve'}`,
              { channel: channel.label }
            )
          })
        }

        // THE CHANNEL'S RESPONSE, DRAWN AS THE DIALOG DRAWS IT. Same window rule, same polyline,
        // same imported fit behind it, same point among the bands — see channelCurvePlot, which is
        // the whole of it and is shared with the unanswered card above.
        //
        // What stood here was the same three parameters read a different way, and a curve read a
        // different way is a different curve: the window came off the span the SOURCE model
        // happened to measure rather than off this channel's own knee, so a card and the chart it
        // opened disagreed about where the response turns. The dashed line came off the source's
        // measured POINTS, which stop where that business stopped buying, where the dialog draws
        // the fit and runs it to the same edge as the line in front of it.
        //
        // Only where there is something to see: an untouched channel would be a dashed line exactly
        // under a solid one, which is why the badge in the title row is drawn instead in that case.
        // Both are normalised together — see sparklinePath's `extra` — so the pair is read against
        // each other and a lowered ceiling cannot put the source line above the top edge, where the
        // svg would clip it away.
        //
        // AND NO SPEND ANYWHERE IN IT — neither a mark nor a window. The dialog's chart marks
        // nothing at the plan's own spend, and the card is that chart at a sixth of the size: a
        // dashed vertical the reader meets on one of the two and not on the other is a difference
        // between the pictures rather than a fact about the channel. What this plan spends is a
        // figure the wizard states elsewhere, on the cards it belongs to — and it is not in the
        // WINDOW either, which is what stops a budget typed on the next step from re-zooming a grid
        // of curves nobody touched. See hillPlotWindow.
        const plot = this.channelCurvePlot(entry.hill, {
          source: this.curveMoved(entry.uid) ? entry.importedHill : null,
          stated: true
        })

        return Object.assign(shell(entry.uid, entry.medium, entry.modelName, entry.channel), {
          saturation: plot ? plot.saturation : null,
          // Off the curve the payload CARRIES, which is the one the solid line draws — not the one
          // the channel was imported with. The bands and the line move together under every lever,
          // and they are the same four boundaries the zone key under the editor's chart prints as
          // figures: one number, drawn on the card and written in the dialog.
          zones: plot ? plot.zones : [],
          // WHERE THIS CHANNEL SATURATES, marked on the card as the dialog marks it: a dot in the
          // one purple no zone and no line wears, standing on the boundary the fifth zone begins at.
          // It is the figure the whole editor is about, and the card was the one place it could be
          // seen among its bands and could not be found.
          saturationPoint: plot ? plot.saturationPoint : null,
          // Null for every channel nobody has moved, which is what keeps those cards drawing exactly
          // one line and what tells the card there is nothing left for the Moved badge to say.
          sourceLine: plot ? plot.sourceLine : null,
          spendMarker: null,
          // The dashed line is the one thing on this card that has no label of its own — the plot
          // has room for two lines and none for a legend — so what it is rides on the title the card
          // already carries on the way to the click, replacing the plain one the shell put there.
          editTitle: plot && plot.sourceLine
            ? this.$t('components.ekrm.CreateModelCompose.curveEditMoved', { channel: entry.medium })
            : this.$t('components.ekrm.CreateModelCompose.channelEditTitle', { channel: entry.medium })
        })
      })
    },
    // Provenance in the shape every EKRM built from a model report carries it, so one made here is
    // traceable the same way — plus the multipliers the user moved, without which the numbers in
    // the payload cannot be traced back to the report they came from.
    provenance () {
      if (!this.ready) return null
      const channels = {}
      this.built.built.forEach(item => {
        const entry = item.entry
        const source = this.models[entry.modelId]
        const anchor = composeAnchor(entry.read)
        const said = this.statedFor(entry.uid)
        channels[entry.label] = {
          model_id: entry.modelId,
          model_name: entry.modelName,
          channel: entry.raw,
          kpi: source ? source.kpiName : null,
          // NOBODY'S MEDIUM. The four fields above are null together and only together, and this is
          // what says the nulls are the truth rather than a lost lookup: this channel was written on
          // the page out of the wizard's own starting shape, and everything that makes it this
          // channel — the pair below, the curve factors and the decay — is the user's statement over
          // it. A later reader of this document has no other way to know that.
          scratch: !!entry.scratch,
          window: COMPOSE_MODE,
          saturation_priority: COMPOSE_PRIORITY,
          // WHERE THIS CHANNEL RAN in the model it came from, in that model's own units: the spend
          // it averaged in a month and what its curve returned there. The point its curve was
          // normalised through, and therefore the whole difference between the curve in the payload
          // and the curve in the source model's report — the payload's own axes are this pair
          // divided out and the stated pair multiplied back in. Once this is in Firestore nothing
          // else records it, and without it the source curve cannot be recovered from the payload.
          anchor_spend: anchor ? anchor.spend : null,
          anchor_response: anchor ? anchor.response : null,
          // What this channel's spend was multiplied by in the end, level and mix together. The
          // level alone is on the model record below; this is the only record of the two apart.
          spend_factor: this.spendFactor * this.mixFactorFor(entry.uid),
          // THE TWO FIGURES THAT PLACED THIS CURVE: where the user said this medium stops responding,
          // and what they said it generates there, both in USD a month. With anchor_spend and
          // anchor_response above they are the whole of the transformation between the source
          // model's curve and the one in the payload, and nothing else records them — the saturation
          // block carries the placed curve and not the two statements that placed it.
          //
          // saturation_point is also in the payload's own grid, as the Saturation Point cell, and
          // that is not a duplication worth removing: the cell is rounded by toCell on the way in.
          saturation_point: said ? said.knee : null,
          saturation_revenue: said ? said.ceiling : null,
          // How far this channel's response was moved from the one its model fitted, as the three
          // ratios the wizard stores. Null for a channel taken as it stands. Once the payload is in
          // Firestore its curve is just a curve, and this is the only thing that says the model
          // never claimed it: the saturation block carries the EDITED x/y and nothing beside it.
          curve_factors: this.curveMoved(entry.uid)
            ? Object.assign({}, this.curveEdits[String(entry.uid)])
            : null,
          // And the same for the other curve: the kernel as it was redrawn, one weight per lag
          // month. Null for a channel still carrying the decay its model measured. Once this
          // document is in Firestore its decay block is just a curve, exactly as the saturation
          // block is just a curve, and this is the only thing that says the model never claimed it.
          //
          // A channel nobody imported always carries it, moved or not: "unmoved" there means the
          // kernel is still the wizard's own opening template, which is not a measurement anybody
          // made and is not recorded anywhere else in this document.
          decay_curve: (entry.scratch || this.decayMoved(entry.uid))
            ? this.decayFor(entry.uid).slice()
            : null
        }
      })
      return {
        base_model: {
          // THERE IS NO BASE MODEL HERE, and this block says so by being the shape an EKRM built
          // from a model report carries, with the name left out. What a later reader needs from
          // this one is `composed` and the list of models below it: no single model was reproduced, so naming one would be
          // pointing at a source for figures that came from four of them or from nobody.
          //
          // It used to carry the model whose year was drawn on, its name and its KPI, plus
          // `reference_seeded: ['seasonality']`. Nothing is seeded any more — the seasonality opens
          // flat and the KPI row's variation range is the platform's — so all four named a
          // provenance that no longer exists.
          composed: true,
          // AND WHETHER THE COMPOSITION IS A COPY OF ONE MODEL AFTER ALL. The flag above says no
          // single model was reproduced, which is the truth for a model assembled by hand and is
          // exactly what stops being true when the first step's second tile is taken: the channels,
          // their placements, the year each was bought over, the revenue, its shape and the season
          // all came from one report. Null for a composition, and once this document is in Firestore
          // nothing else can say the difference — the channel blocks below name a model each, and
          // four channels from one model look the same whichever tile produced them.
          //
          // The rates ride because every LEVEL in the copy went through them: without the pair, the
          // saturation points and the revenue in this payload cannot be read back against the source
          // model's own report. `seeded` names what the copy answered, which is what a later reader
          // needs to tell a figure the wizard wrote from one the user typed over it.
          copied_from: this.copyProvenance,
          window: COMPOSE_MODE,
          period_years: 1,
          period_months: null,
          // The size the business was said to have, in USD over the year. It places nothing: every
          // curve in this payload was placed by the two figures on its own card, and this one only
          // sizes the KPI row the attribution is read against.
          //
          // The flag beside it is now always true and rides anyway. It used to separate two claims
          // wearing one number — a revenue the user typed from the one the media implied while the
          // box was still the page's own — and there is no second claim any more: nothing seeds this
          // figure, and a payload cannot be saved without it. Kept so that a reader of the field
          // does not have to know which side of this change wrote the document.
          revenue: this.revenue,
          revenue_stated: this.revenueTouched,
          // How that revenue falls across the year: where the row came from, and the twelve
          // multipliers it came to. The name alone would not reproduce it — the year opens flat and
          // is then nudged, a press at a time, by the two buttons over the columns, and those draws
          // exist nowhere else once the payload is in Firestore, the KPI row carrying the money
          // rather than the shape.
          revenue_shape: this.revenueShapeName,
          revenue_shape_months: this.revenueShapeValues ? this.revenueShapeValues.slice() : null,
          // And the model that year was taken off, where it was taken off one — the model, the KPI
          // it was read at and the year, or null for the average of every complete year. Null for a
          // year this wizard drew, which is the only thing that tells a borrowed shape from a
          // nudged one.
          revenue_shape_source: this.revenueShapeSource,
          // What the level is a level OF, and whether it is the user's. Every channel's spend row
          // opens at the saturation point stated on its own card, so the media spend this payload
          // carries is those figures moved by this one factor and by the mix — and an untouched
          // factor is the plan the cards themselves laid out rather than anything anybody chose.
          // Once this is in Firestore nothing else says where the figure in the spend rows came
          // from.
          spend_factor: this.spendFactor,
          spend_stated: this.spendTouched,
          // The size as the first figure typed into the box and the multiple of it the revenue ended
          // on. One figure cannot say both, which is why both ride.
          revenue_seed: this.revenueAnchor,
          revenue_factor: this.revenueFactor,
          // The year this EKRM sells in, as the twelve percentages the payload carries — and whether
          // anybody drew them. Worth carrying because the payload's row can be read back but not
          // attributed, and the two claims wear the same twelve numbers: a flat year nobody touched
          // is this wizard declining to say when the business sells, where a flat year somebody
          // drew flat is them saying it sells evenly.
          seasonality_shape: this.seasonalityShape ? this.seasonalityShape.slice() : null,
          seasonality_drawn: this.drawnSeasonality !== null,
          // And the model that season was taken off, where it was taken off one. Null for a season
          // drawn here and for a copy, whose own provenance already names the model every one of its
          // answers came from.
          seasonality_source: this.seasonalitySource,
          // And the models the two other inputs' years were taken off, the series each was read at
          // included. Null for a year typed here.
          other_spend_source: this.otherSpendSource,
          // And the share of sales the user said each of them accounts for, before any hold — the
          // band the payload carries is what the build wrote from it.
          other_attribution: this.otherAttribution,
          // And the growth expected of each series over the next twelve months, as stated.
          future_trends: FUTURE_TRENDS_ENABLED ? this.futureTrends : null,
          spot_shape: this.spotShape ? this.spotShape.slice() : null,
          spot_drawn: this.drawnSpot !== null,
          // Whether the money is still shared out the way the channels' own models shared it.
          mix_changed: this.mixMoved,
          // Whether any channel's response is still its model's own.
          curves_changed: this.curvesMoved.length > 0,
          decays_changed: this.decaysMoved.length > 0,
          source_models: this.contributingModels.map(entry => ({
            model_id: entry.model.id,
            model_name: entry.model.name || null
          })),
          unit: EKRM_UNIT
        },
        channels: channels
      }
    }
  },
  components: {
    SalesDecomposition,
    SaturationLevers,
    SaturationZones,
    DecayCurve,
    ChannelCurvesChartMulti,
    // The three cards this wizard is built out of, and the editor that used to arrive inside a
    // fourth. They own no arithmetic: every path, every bound and every formatted
    // figure is computed here and handed down, because a component cannot be mounted in a test in
    // this project.
    //
    // The seasonality arrives as the EDITOR and not as a card of its own: the seasonal swing is a
    // second question asked inside the revenue card about the twelve columns already drawn there,
    // and a card's border and headline inside another card's border would say it was a separate
    // fact about a separate year.
    EkrmChannelCard,
    EkrmRevenueCard,
    EkrmGrowthCard,
    // The channel picker asked by taxonomy across every model. It filters and ticks; reading a model
    // and placing its channels stay here, beside the picker that does the same.
    EkrmModelImporter,
    MediaSpendAndReturn,
    // THE MODEL REPORT'S OWN CHARTS, drawn off this payload rather than off a fitted model. Every
    // one of them is the component the report mounts, with its header dropped — the wizard names its
    // own sections in its own small grey — and its export toolbar off: what is on screen has not
    // been built yet, and a PNG of it filed away as a model's report is the one thing this step
    // must not hand out.
    BarChart,
    StackedBarChart,
    RiverChart,
    SaturationCurves,
    EkrmTradeCard,
    EkrmSpendMonths,
    // The same row asked about the other statement: the seasonality and the spot events stacked in
    // one signed column per month, with the spend row's own card under the pointer and pinned as a
    // form. A component of its own rather than a mode of the spend's, that row having no line
    // through the middle of it and no need of one.
    EkrmShapeMonths,
    // The grid CreateEkrm asks this same data on, brought under the figure it is a reading of. It
    // is the one component here that DOES own arithmetic — jspreadsheet's — which is exactly why it
    // is handed plain amounts and hands plain amounts back: everything that turns one into a
    // multiplier is in this file, beside the typed column that already did it.
    Spreadsheet
  },
  props: {
    createdBy: {
      type: String,
      required: true
    },
    createdById: {
      type: String,
      required: true
    }
  },
  watch: {
    // THE SPEND OPENS WHERE THESE CURVES RETURN THE MOST, once, on the first arrival at the step
    // that asks for it. Reaching Media Spend is what makes that question live, and the best answer
    // the wizard has to it is the peak of the very curve the step draws — the level the chart's own
    // Max. ROAS label names, taken by the same commit pressing that label makes.
    //
    // Only the FIRST arrival. Every later visit finds a figure the reader has been shown and may
    // have typed, and a step that jumped back to the peak whenever a channel was edited would be
    // overwriting an answer with a default. The step headers are clickable, so this hangs off the
    // step itself rather than off goNext.
    step (value) {
      if (value === 3) this.seedSpendAtPeak()
      // AND THE PREVIEW DRAWS ONLY ONCE ITS PANE IS ON SCREEN. A tick late, deliberately: the
      // stepper turns the pane's v-show on in the same flush this watcher runs in, and this
      // component renders before the pane it is inside does — so a flag set here and read now would
      // still be building canvases into a display:none. By the next tick the pane is shown and has a
      // width to measure. Cleared on every other step, so a reader who walks back to the media and
      // returns gets the same wait rather than a remount into whatever the transition is mid-way
      // through. See previewReady.
      this.previewReady = false
      if (value === 7) this.$nextTick(() => { this.previewReady = this.step === 7 })
      // AND THE CARET LANDS IN THE FIGURE THE STEP ASKS FOR, with what is standing there selected.
      // Both of these steps open on a number the wizard wrote — the spend seeded at the peak of the
      // curves, the revenue held over it — so the gesture they are waiting for is a figure typed
      // over one, and a reader who has one in mind can type it without reaching for the box first.
      //
      // A tick late on purpose: the step's own pane is only rendered as it is reached, and on step 3
      // the seed above has just re-keyed the field, so the element to focus does not exist yet.
      this.$nextTick(() => {
        const other = this.$refs.otherCard_comarketing
        const growth = this.$refs.growthCard_sales
        const card = value === 3 ? this.$refs.tradeCard
          : value === 4 ? this.$refs.revenueCard
            : value === 5 && other ? other[0]
              : value === 6 && growth ? growth[0]
                : null
        if (card) card.focusValue()
      })
    },
    // AND THE TWO DISCLOSURES CLOSE WITH THE PAIR THAT MADE THEM MEAN ANYTHING.
    //
    // Neither of them is a picture of a shape: the levers move a curve in dollars and the grips move
    // boundaries along one, and until the saturation point is typed there are no dollars on this
    // screen at all — the curve is the starting shape over a unit scale and every figure readable
    // off it is a placeholder. So both are refused while the pair is incomplete, which is what the
    // `disabled` on the two buttons says, and this is the other half of the same rule: a panel
    // already open when the pair is emptied — or when the walk arrives at a channel nobody has
    // placed — would go on offering controls over figures that just stopped meaning anything.
    //
    // On the flags themselves rather than on what reads them, so there is one statement of it
    // instead of one per place the template asks whether a panel is open.
    editorStated (value) {
      if (value) return
      this.editorShapeOpen = false
      this.editorZonesOpen = false
    },
    // AN ANSWER TAKEN AWAY CLOSES THE STEPS THAT STOOD ON IT. Removing the last channel on step 2
    // empties the spend and the revenue, and a wizard left standing on a step it can no longer fill
    // would be asking a question about media that are not there. The user is brought back to the
    // first step still open.
    maxReachableStep (value) {
      if (this.step > value) this.step = value
    },
    // A curve that moved rewrites the two figures that report it. They are readings, and a reading
    // that does not move when the thing it reads moves is a caption on a curve that is no longer
    // there — which is the defect this wizard keeps finding one level down.
    //
    // It fires on every recompute rather than on a change of value, the computed handing back a new
    // object each time; a drag that lands on the same rounded figure therefore writes the same string
    // back, which Vue's own setter drops. Nothing re-renders for a lever that moved less than the
    // field can show.
    editorFigures (value) {
      if (!value) return
      this.editorKnee = value.knee
      this.editorCeiling = value.ceiling
    },
    // The zone bar's axis follows the curve at arm's length: this asks whether the boundaries have
    // left the ruler they were drawn against, and answers by re-fitting it if they have. A watcher
    // rather than a computed, because holding a scale still is a decision made once per move and
    // not a reading taken every frame.
    curveSaturationAt () {
      this.fitZoneWindow()
    },
    // The two fields the user can edit are the only ones that reach the form after it is built, and
    // rebuilding for a keystroke would re-run every channel import. They are written straight in.
    name (value) {
      if (this.built) this.built.form.reference.category = String(value).trim()
    },
    market (value) {
      if (this.built) this.built.form.reference.market = value
    },
    // THE GRID FOLLOWS THE FORM, and this is the half of the sync that makes it bidirectional: the
    // total typed above, a Total ROAS solved for, a level taken off the chart, a month typed into a
    // column and a channel's curve edited all land in the same cells, and the table has to show
    // them within the keystroke or it is a second account of the spend rather than a view of it.
    //
    // ONLY WHERE A FIGURE ACTUALLY MOVED. A cell typed into the grid comes back through
    // onSpendSheetInput, is written as a multiplier and read out again as very nearly the same
    // amount — off by the last bit of a divide and a multiply — so a bare assignment would call
    // setData on every keystroke and take the selection out from under the user mid-row. The
    // comparison is relative and a thousand times looser than that rounding, and tighter than any
    // difference the grid can show.
    spendSheetValues: {
      immediate: true,
      handler (rows) {
        this.syncSheet('spendSheet', rows)
      }
    },
    // The year's own grids, on the same terms: the revenue row follows a total typed above it, a
    // shape pressed and a column typed into, and the two drawn rows follow every stroke of the plot
    // they are folded under.
    revenueSheetValues: {
      immediate: true,
      handler (rows) {
        this.syncSheet('revenueSheet', rows)
      }
    },
    sharesSheetValues: {
      immediate: true,
      handler (rows) {
        this.syncSheet('sharesSheet', rows)
      }
    },
    comarketingSheetValues: {
      immediate: true,
      handler (rows) {
        this.syncSheet('comarketingSheet', rows)
      }
    },
    competitionSheetValues: {
      immediate: true,
      handler (rows) {
        this.syncSheet('competitionSheet', rows)
      }
    },
    // jspreadsheet writes its header once, at mount, from the columns it was handed. So a language
    // changed under an open grid renames the months everywhere on the page except in the one place
    // they are written down, and the only way to move them is to build the grid again.
    spendSheetColumns () {
      this.spendSheetKey++
    },
    revenueSheetColumns () {
      this.revenueSheetKey++
    },
    sharesSheetColumns () {
      this.sharesSheetKey++
    },
    otherSheetColumns () {
      this.comarketingSheetKey++
      this.competitionSheetKey++
    }
  },
  created () {
    Promise.all([
      this.loadMmmModels(),
      this.loadCustomModels()
    ]).then(() => {
      this.catalogueLoading = false
    }).catch(error => {
      console.error('Could not load the full model catalogue:', error)
      this.catalogueLoading = false
      this.catalogueError = this.$t('components.ekrm.CreateModelCompose.catalogueRestricted')
    })
    // Reading the whole clients collection needs a manager, customizer or ekrm_manager role, and
    // /manageEkrm also admits scientists. Firestore reports that refusal through the snapshot error
    // callback, which neither loader wires up, so for those users the promises above simply never
    // settle. The deadline stops the picker spinning forever and falls back to whatever models the
    // user already has access to.
    this.catalogueTimer = setTimeout(() => {
      if (!this.catalogueLoading) return
      this.catalogueLoading = false
      if (this.sourceModels.length === 0) {
        this.catalogueError = this.$t('components.ekrm.CreateModelCompose.catalogueRestricted')
      }
    }, 8000)
  },
  beforeDestroy () {
    if (this.catalogueTimer) clearTimeout(this.catalogueTimer)
    if (this.justAddedTimer) clearTimeout(this.justAddedTimer)
  }
}
</script>

<style scoped>
  /* The page under the toolbar. The top padding is the gap between the black bar and the first row
     of boxes, and it is the page's rather than the row's so that whatever leads the page — today the
     name and the market — stands clear of the bar by the same amount.

     It has to out-specify .v-dialog > .v-card > .v-card__text, which is three classes and sets
     padding: 0 24px 20px — this wizard IS a card in a fullscreen dialog, so that rule has been
     flattening the top of the page all along and a bare .clone-page, being two, never touched it.
     Naming the Vuetify class alongside our own is what wins it, and the sides and the bottom are
     left to that rule deliberately. */
  .v-card__text.clone-page {
    background-color: #fafafa;
    flex: 1 1 auto;
    /* A flex item's floor is its content unless it is told otherwise, and a pane that cannot be
       shorter than the step inside it never scrolls — it pushes the button bar off the screen
       instead. */
    min-height: 0;
    overflow-y: auto;
    padding-top: 24px;
  }

  /* THE DIALOG IS THE WHOLE SCREEN AND THE CARD IS THE WHOLE DIALOG: a column of three, with the
     black bar and the step bar fixed at its ends and only the page between them scrolling. The page
     used to be the scroller of the dialog itself and as tall as it needed to be; a wizard whose Next
     button is off the bottom of a long step is not a wizard. */
  .compose-shell {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  /* THE BLACK BAR IS ALWAYS THE SAME HEIGHT. It is a flex item now, and a flex item's height is
     negotiable: on a long step the column would take the difference out of whatever could give, and
     the toolbar giving a few pixels is a bar that changes size as the user walks the wizard. It
     gives nothing — the page between the bars is the only thing that stretches and the only thing
     that scrolls. */
  .compose-shell > .v-toolbar {
    flex: 0 0 auto;
  }
  /* What is wrong with the whole thing, on the page's own grey and aligned to the same corridor its
     content is, so an alert reads as part of the page rather than as a band across the dialog. */
  .compose-alerts {
    flex-shrink: 0;
    background-color: #fafafa;
    padding: 16px 24px 0;
  }
  .compose-alerts__inner {
    max-width: 1280px;
    margin: 0 auto;
  }
  /* WHAT IS ALREADY SETTLED, over the step bar. The same dress the metric boxes wear — a white card
     on the page's grey, a small uppercase label with the figure beside it — laid out on one wrapping
     row so a narrow screen stacks them rather than shrinking them. */
  .compose-recap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }
  .compose-recap__item {
    display: flex;
    align-items: baseline;
    gap: 8px;
    min-width: 0;
    padding: 6px 12px;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
  .compose-recap__label {
    flex-shrink: 0;
    font-size: 0.7rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.55);
  }
  .compose-recap__value {
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .compose-actions {
    flex-shrink: 0;
    background-color: #ffffff;
    padding: 12px 24px;
  }
  /* The question above the tiles, in the same small uppercase the boxes below label their fields
     with: it names what is being answered, and the two tiles under it are the answer. */
  .compose-ask {
    font-size: 0.7rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.55);
    margin-bottom: 8px;
  }
  /* The first question, as two cards side by side. They fall to one per row on a narrow screen the
     way the metric boxes below them do, and each is a real <button>, so it lands in the tab order
     and answers Enter and Space without being told to. */
  .compose-source {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  /* The icon to the left of the words rather than over them: the two tiles are read as a pair and
     what is compared is the sentence in each, so the sentences start on the same line. The room on
     the right is the tick's, kept whether or not the tile is the chosen one, so choosing does not
     reflow the words. */
  .compose-source__tile {
    position: relative;
    display: flex;
    flex: 1 1 260px;
    align-items: flex-start;
    gap: 12px;
    min-width: 0;
    padding: 16px 44px 16px 16px;
    text-align: left;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  .compose-source__tile:hover {
    border-color: rgba(0, 0, 0, 0.32);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  /* The one that is chosen wears the page's own primary, and wears it four times over — the border,
     the ring, the icon and the tick — because a single hairline at this size is not the difference
     between two cards. */
  .compose-source__tile--on {
    border-color: var(--v-primary-base, #1976d2);
    box-shadow: inset 0 0 0 1px var(--v-primary-base, #1976d2);
  }
  .compose-source__icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.05);
    flex: none;
  }
  /* The tenant's colour at a tenth, which is a wash no rgba() written here could be: the theme hands
     over one hex per hostname, so the tint is that hex on a layer of its own with the opacity on the
     layer instead of in the colour. */
  .compose-source__tile--on .compose-source__icon {
    background-color: transparent;
  }
  .compose-source__tile--on .compose-source__icon::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    background-color: var(--v-primary-base, #1976d2);
    opacity: 0.12;
  }
  .compose-source__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }
  .compose-source__check {
    position: absolute;
    top: 14px;
    right: 14px;
  }
  .compose-source__name {
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }
  .compose-source__note {
    font-size: 0.75rem;
    line-height: 1.35;
    color: rgba(0, 0, 0, 0.55);
    white-space: normal;
  }
  .compose-copy {
    padding: 16px;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
  .compose-copy__wait {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
  }
  .compose-copy__note {
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.55);
  }
  .compose-copy__model {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background-color: #ffffff;
  }
  .compose-copy__model-icon {
    flex: none;
  }
  .compose-copy__model-body {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .compose-copy__model-name {
    font-size: 0.9rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }
  .compose-copy__model-name--empty {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
  }
  /* The stepper carries no chrome of its own: the header sits on the page's grey like everything
     else, and the content pane gives its padding back so the cards inside a step line up with the
     corridor rather than being inset by Vuetify's own 24px. */
  .compose-stepper {
    background-color: transparent !important;
    box-shadow: none !important;
  }
  .compose-stepper__header {
    box-shadow: none;
    height: auto;
    margin-bottom: 8px;
  }
  /* An answered step: its number kept, drawn as an outline rather than a filled disc, so the row
     reads as three states at a glance — filled for where the reader is, outlined for what is behind
     them, and Vuetify's flat grey for what is still ahead. */
  .compose-stepper >>> .compose-stepper__step--done .v-stepper__step__step {
    background: transparent !important;
    border: 2px solid var(--v-primary-base);
    color: var(--v-primary-base) !important;
  }
  .compose-stepper >>> .v-stepper__content {
    padding: 16px 0 0;
  }
  .compose-stepper >>> .v-stepper__wrapper {
    overflow: visible;
  }
  /* The line under each of the two ways in. It says what the choice IS rather than repeating the
     verb, so it is read once and then never again — hence the smaller, quieter type. */
  .clone-add-menu__note {
    font-size: 11px;
  }
  .clone-page__inner {
    max-width: 1280px;
    margin: 0 auto;
  }

  /* Boxes about the whole model, each taking half the row and wrapping rather than shrinking on
     a narrow screen; both stretch to a common height, and each one's footer is pushed to the bottom
     so the averages line up. */
  .clone-metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  /* One box per row instead. The pair of levels — the revenue and the spend it pays for — read down
     the page rather than across it: they are decided in that order, not weighed against each other,
     and each one's own contents (the twelve months, the two figures and the trade-off plot beside
     them) have the whole width to be drawn and grabbed in. */
  .clone-metrics--stacked > .clone-metric {
    flex-basis: 100%;
  }
  /* How wide a box is and how it wraps: a statement about the row, so it stays here, on the
     child's own root, where a parent's scoped style is allowed to reach. The chrome inside — the
     border, the padding, the column — belongs to each card and travels with it. */
  .clone-metric {
    flex: 1 1 320px;
    /* A FLEX ITEM IS AS WIDE AS ITS WIDEST CONTENT UNLESS IT IS TOLD OTHERWISE: min-width defaults
       to auto, so a box holding something that cannot shrink — the spend grid, which is one column
       per month and as wide as it needs to be — grows past its own basis and takes the row with it.
       Zero is what makes the declared basis binding, and it is what lets the grid's own scroller
       (see Spreadsheet.vue, where being handed a width is what makes .jexcel_content the one
       horizontal scrollbar) be the thing that gives way instead of the card. */
    min-width: 0;
  }
  /* The unit the chart's own header used to carry, in the label instead. Lighter than the title
     beside it: it names the axis rather than the chart. */
  .clone-metric__unit {
    margin-left: 6px;
    color: rgba(0, 0, 0, 0.38);
  }

  /* The two fields the payload cannot be built without, wearing the chrome of every other box on
     this page.

     It is written out here rather than taken from .clone-metric because that class carries only the
     flex on this page: the boxes it is on are child components, each holding its own copy of the
     border and the padding, and a rule of this page's that reached into one would be reaching past
     the boundary the extraction exists to draw. */
  .clone-field {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 12px 16px 10px;
  }
  /* The saturation curves compared under the media cards: the same box, holding a chart rather than
     a field. The chart's own card is flat and transparent so the box is the only frame. */
  .compose-compare >>> .v-card {
    background-color: transparent;
  }
  /* The value under the label, on the same hairline the figures below stand on — but not at their
     1.6rem. A name is not a figure: it is as long as the user makes it, and what puts it in the
     same family as the boxes below is the box, the label and the rule rather than the type size. */
  .clone-field__input {
    margin: 2px 0 0;
    padding: 0;
  }
  .clone-field__input >>> input {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5;
    padding: 0;
    max-height: none;
  }
  /* A select prints what is chosen in a span beside its input rather than in it, and that span
     carries 7px of its own above and below — which would leave the market's box a quarter-inch
     taller than the name's standing next to it. */
  .clone-field__input >>> .v-select__selections {
    min-height: 0;
  }
  .clone-field__input >>> .v-select__selection--comma {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5;
    margin: 0 4px 0 0;
    min-height: 0;
  }
  .clone-field__input >>> .v-input__slot::before {
    border-color: rgba(0, 0, 0, 0.12);
  }
  /* The label names a field here rather than a figure, so it is a real <label> and gets the pointer
     that says so. */
  .clone-field .clone-metric__label {
    cursor: pointer;
  }

  /* The chip that adds a channel. It wears the counter's pill and the app's own primary, which is
     what separates a control from the grey figure standing beside it — the same way primary is used
     everywhere else on this page, as ink rather than as fill. The colour is never written here: it
     is per-tenant, set on the Vuetify theme by hostname, so color="primary" puts it on the text and
     the icon and every rule below takes it from currentColor. Each one has to out-specify a
     .theme--light.v-chip rule, hence the doubled class. */
  /* The empty cell at the end of the grid. Its height is the row's, taken the same way the cards
     take it, so it lines up with them at whatever height the tallest card comes to; the floor is for
     the empty composer, where there is no card beside it to be as tall as. A button carries the
     browser's own font family, which the label inside it would otherwise wear. */
  /* The card that just arrived, for a second and a half. A ring around the cell rather than a change
     to the card, so nothing the card itself draws moves, and in the theme's own primary — the colour
     is per-tenant off the hostname, which Vuetify publishes as a custom property, and the fallback is
     a neutral for the build that does not. `pointer-events: none` on nothing: the ring is a shadow
     and takes no space, so the grid does not reflow when it goes. */
  .clone-card-cell--new {
    border-radius: 6px;
    animation: clone-card-arrive 1.6s ease-out forwards;
  }
  @keyframes clone-card-arrive {
    0% {
      box-shadow: 0 0 0 2px var(--v-primary-base, rgba(0, 0, 0, 0.45));
    }
    70% {
      box-shadow: 0 0 0 2px var(--v-primary-base, rgba(0, 0, 0, 0.45));
    }
    100% {
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0);
    }
  }

  .clone-add-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    height: 100%;
    min-height: 190px;
    padding: 12px 8px;
    border: 1px dashed rgba(0, 0, 0, 0.24);
    border-radius: 4px;
    background-color: transparent;
    font: inherit;
    color: rgba(0, 0, 0, 0.55);
    transition: border-color 0.2s, background-color 0.2s, color 0.2s;
  }
  /* Vuetify sets an icon's colour rather than letting it inherit, so the plus would hold its grey
     while the border and the word around it darken. */
  .clone-add-card .v-icon {
    color: inherit;
  }
  .clone-add-card:hover {
    border-color: rgba(0, 0, 0, 0.42);
    background-color: rgba(0, 0, 0, 0.03);
    color: rgba(0, 0, 0, 0.8);
  }
  /* Written apart from the hover rule rather than beside it: a browser that does not know
     :focus-visible drops the whole selector list it appears in, and the hover would go with it. A
     ring outside the tile, so nothing in the row moves by a pixel when it is focused. */
  .clone-add-card:focus-visible {
    outline: 1px solid rgba(0, 0, 0, 0.42);
    outline-offset: 2px;
  }
  .clone-add-card__label {
    font-size: 0.72rem;
    letter-spacing: 0.04em;
    line-height: 1.3;
    text-align: center;
    text-transform: uppercase;
  }

  .clone-empty {
    text-align: center;
    padding: 64px 0;
  }
  li {
    margin-top: 4px;
  }

  /* The label and its dot are also worn by the two chart boxes below the cards, which are this
     page's own markup rather than a shared component's. The cards carry their own copy: scoped
     styles cannot be handed to a child, and a rule that reached into one would be reaching past the
     boundary the extraction exists to draw. */
  .clone-metric__label {
    display: flex;
    align-items: center;
    font-size: 0.7rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.55);
  }
  .clone-metric__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 7px;
    flex: none;
  }

  /* THE SECOND QUESTION ABOUT THE YEAR, inside the revenue card and under the columns it is about.
     A rule across the card and nothing else: it is a section of that card and not a card of its own,
     so it takes no border of its own, no ground and no radius — a box drawn inside another box would
     say the year above and the season below were two different years, which is the exact thing
     moving this in here was meant to stop saying. */
  .clone-season {
    /* The fold carries a grid of its own now, and a grid that may not shrink is one the card has to
       grow for. Same reason as .clone-metric and .compose-sheet. */
    min-width: 0;
    margin-top: 14px;
    padding-top: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.09);
  }
  .clone-season__head {
    margin-bottom: 2px;
  }
  /* THE HEADING IS THE CONTROL. It carries the label's own type — the row it sits in is the label —
     so a section that folds looks like the sections that do not, and the caret is the whole of the
     difference. */
  .clone-season__toggle {
    display: inline-flex;
    align-items: center;
    padding: 2px 4px;
    margin-left: -4px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    font: inherit;
    letter-spacing: inherit;
    text-transform: inherit;
    color: inherit;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
  }
  .clone-season__toggle:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.85);
  }
  .clone-season__toggle:focus-visible {
    outline: 2px solid rgba(0, 0, 0, 0.35);
    outline-offset: 1px;
  }
  .clone-season__caret {
    margin-left: 4px;
    color: rgba(0, 0, 0, 0.45);
  }
  /* What is behind the fold, said on the line that opens it — and it says the section is OPTIONAL
     rather than unfinished, which is the one thing a closed block on a wizard cannot leave ambiguous.
     Lighter than the heading and in ordinary case: it is a note about the control, not a second
     heading. */
  .clone-season__closed {
    margin-left: 8px;
    font-size: 0.7rem;
    letter-spacing: 0;
    text-transform: none;
    color: rgba(0, 0, 0, 0.38);
  }
  /* WHAT MAY BE TYPED IN A MONTH, in the small grey every hint on this page is written in: a note
     about the two editors under it and not a heading of its own. It replaced a meter — see the
     markup, which says why the pot it drew no longer exists — and a rule that is one sentence long
     has no business being a picture. */
  .clone-season__rule {
    margin: 0 0 12px;
    font-size: 0.7rem;
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.5);
  }
  /* The section's three verbs, over the right-hand end of the plot they act on — the same corner
     the Sales card puts its own row of buttons in. */
  .clone-season__tools {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
    margin-bottom: 2px;
  }
  /* Sized to the label's own line so the row does not grow a button's worth of height. */
  .clone-season__info {
    margin: -4px 0 -4px 2px;
  }
  /* The channel editor. One screen for one channel: the response on the left, what places it on the
     right, and what it does to the plan under both. */
  .v-card__title.clone-editor__title {
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    flex: none;
    word-break: normal;
  }
  .clone-editor__heading {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 340px;
  }
  /* The name, which is also the title. It carries the heading's own type and no chrome at all until
     it is pointed at, so the bar reads as a title bar and still says, on the first hover, that the
     one thing on it a channel owns can be typed over. */
  .clone-editor__name-wrap {
    display: flex;
    align-items: center;
    margin-left: -4px;
    padding: 1px 4px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.24);
    cursor: text;
    transition: background-color 0.15s ease, border-color 0.15s ease;
  }
  .clone-editor__name-wrap:hover {
    background: rgba(0, 0, 0, 0.05);
    border-bottom-color: rgba(0, 0, 0, 0.5);
  }
  .clone-editor__name-wrap:focus-within {
    background: rgba(0, 0, 0, 0.05);
    border-bottom: 1px solid #1976d2;
  }
  .clone-editor__name-wrap:focus-within .clone-editor__name-pen,
  .clone-editor__name-wrap:hover .clone-editor__name-pen {
    color: rgba(0, 0, 0, 0.6);
  }
  .clone-editor__name-wrap:focus-within .clone-editor__name-pen {
    color: #1976d2;
  }
  .clone-editor__name-wrap--error,
  .clone-editor__name-wrap--error:hover,
  .clone-editor__name-wrap--error:focus-within {
    border-bottom: 1px solid #c62828;
  }
  .clone-editor__name-wrap--error .clone-editor__name,
  .clone-editor__name-wrap--error .clone-editor__name-pen {
    color: #c62828;
  }
  .clone-editor__name {
    flex: 1 1 auto;
    min-width: 0;
    padding: 0;
    border: none;
    outline: none;
    background: transparent;
    color: inherit;
    text-overflow: ellipsis;
  }
  .clone-editor__name-pen {
    flex: none;
    margin-left: 6px;
    color: rgba(0, 0, 0, 0.3);
    transition: color 0.15s ease;
  }
  .clone-editor__origin {
    max-width: 340px;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0;
    color: rgba(0, 0, 0, 0.55);
  }
  /* Why the name cannot be used, in the source line's own place rather than under the field: the
     title bar holds its height while a name is being refused, and the refusal is one line either
     way — the name goes back to the channel's own on blur. */
  .clone-editor__error {
    max-width: 340px;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #c62828;
  }
  /* The way around the model, as one control: two arrows with the position between them, so the
     count is read as part of the walk rather than as a fact about the channel. */
  .clone-editor__walk {
    display: flex;
    align-items: center;
    margin-right: 4px;
  }
  .clone-editor__count {
    min-width: 56px;
    text-align: center;
    font-size: 0.72rem;
    letter-spacing: 0.04em;
    color: rgba(0, 0, 0, 0.5);
  }
  .v-card__text.clone-editor__body {
    padding: 16px;
  }
  /* ONE FRAME AND ONE HEADING, FOUR TIMES. The response, the point that places it, where its zones
     fall and the shape between them are four statements about one channel, and a screen that draws
     them as four runs of markup down two columns leaves the reader deciding which heading owns
     which control. Each stands in the same card under the same small-capitals heading: what belongs
     to what is then a fact about the drawing rather than something to be worked out. Cards stacked
     in a column space themselves. */
  .clone-editor__card {
    padding: 12px 14px;
    border: 1px solid rgba(0, 0, 0, 0.14);
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.015);
  }
  .clone-editor__card + .clone-editor__card {
    margin-top: 12px;
  }
  /* THE TWO COLUMNS END ON THE SAME LINE.
     The left is a 350px chart and a bar under it, both of which are the size they are; the right is
     a run of cards that comes to whatever its contents come to, and the two agreed only by accident
     — the dialog closed on a ragged edge, with one column's last card floating clear of the other's.
     So the columns are flex columns and exactly one card may take up the slack: the decay card. Its
     bars are normalised against their own tallest and read as a SHAPE, which makes it the one thing
     on this screen that can be given fifty pixels or go without them and still say exactly what it
     said before — a chart cannot, and neither can a run of figures.

     IT GROWS AND DOES NOT SHRINK, which is the one place this stops short of levelling everything.
     With the saturation point's panel open the levers arrive above it and the right column is the
     taller of the two; a card allowed to shrink there would take its own contents past its edge,
     and a scroll is the honest answer to a column with more in it than the one beside it. The
     alignment is exact with both panels closed, which is how this editor opens.

     Only from the breakpoint the columns stand side by side at. Stacked, there is no other column
     for anything to be aligned with. */
  @media (min-width: 960px) {
    .clone-editor__col {
      display: flex;
      flex-direction: column;
    }
    .clone-editor__col > .clone-editor__card--fill {
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
    }
  }
  .clone-editor__card-title {
    display: flex;
    align-items: center;
    font-size: 0.68rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.55);
  }
  /* THE SATURATION POINT, AS ONE CONTROL. The two numbers it takes with an arrow between them
     saying which way to read the pair: this much money, and this much back. Each number is a field
     and is drawn as one — a rule under it that darkens on hover and turns blue as it is typed into
     — and the two rules are the only borders inside the card, because a box around each half would
     be two controls again.

     UNSTATED, THE FRAME IS DASHED. It is the same statement the chart makes by dropping its axis
     figures and marking the point with a question: the shape is real, the magnitudes have not been
     given, and a solid frame around two em dashes would look like a control that had failed rather
     than one that is waiting. */
  .clone-editor__point--unstated {
    border-style: dashed;
    border-color: rgba(0, 0, 0, 0.28);
  }
  .clone-editor__point-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 7px;
    flex: none;
  }
  .clone-editor__point-dot--unstated {
    background: transparent;
    border: 1px dashed rgba(0, 0, 0, 0.45);
  }
  .clone-editor__point-pair {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
  }
  .clone-editor__point-half {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1 0;
    min-width: 0;
  }
  .clone-editor__point-arrow {
    flex: none;
    margin: 0 8px 18px;
    color: rgba(0, 0, 0, 0.3);
  }
  .clone-editor__point-label {
    font-size: 0.66rem;
    letter-spacing: 0.04em;
    line-height: 1.3;
    text-align: center;
    color: rgba(0, 0, 0, 0.6);
  }
  .clone-editor__point-value {
    width: 100%;
    min-width: 0;
    margin-top: 4px;
    padding: 0 2px 2px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    border-radius: 0;
    outline: none;
    background: transparent;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: -0.01em;
    color: rgba(0, 0, 0, 0.87);
    transition: border-color 0.15s ease;
  }
  .clone-editor__point-value:hover {
    border-bottom-color: rgba(0, 0, 0, 0.42);
  }
  .clone-editor__point-value:focus {
    border-bottom: 1px solid #1976d2;
  }
  .clone-editor__point-value::placeholder {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.32);
  }
  .clone-editor__point-unit {
    margin-top: 3px;
    font-size: 0.63rem;
    letter-spacing: 0.04em;
    text-align: center;
    color: rgba(0, 0, 0, 0.42);
  }
  /* The chart's own component wraps its plot in a container of Vuetify's, whose padding would
     inset the plot from the top of the column and leave it starting below the card across the row.
     The same rule the two charts under the grid follow, and for the same reason. */
  .clone-editor__chart >>> .container {
    padding: 0;
  }
  .clone-editor__noshape {
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.35);
  }
  .clone-editor__note {
    margin: 10px 0 0;
    font-size: 0.75rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.6);
  }
  /* The heading over the zone bar. The bar and its five cells are SaturationZones' own; what is
     left here is the line that says what the figures under it are, carrying the unit once the way
     the two fields beside the chart do rather than repeating a suffix five times. */
  /* The bar and its five cells are SaturationZones' own; what is left here is the card's heading
     line, which carries the unit once — the way the pair above the chart does — and the disclosure
     that opens the bar's controls. It wraps: on a narrow dialog the disclosure drops under the name
     rather than pushing it out of the card. */
  .clone-editor__zones-head {
    flex-wrap: wrap;
    margin-bottom: 8px;
  }
  .clone-editor__zones-unit {
    margin-left: 6px;
    text-transform: none;
    letter-spacing: 0;
    font-size: 0.68rem;
    color: rgba(0, 0, 0, 0.32);
  }
  /* THE SWITCH, AS ONE SEGMENTED RUN on its own row over the bar: a tray with the five settings
     inside it and the one that is on drawn as a raised pill. One border around the whole control
     rather than one around each button, because this is one answer with five settings and not five
     things that could each be on. It arrives with the grips it governs, so it is read immediately
     before the first drag rather than found afterwards. */
  .clone-editor__zones-hold {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;
    font-size: 0.68rem;
    text-transform: none;
    letter-spacing: 0;
  }
  .clone-editor__zones-holds {
    margin-right: 7px;
    font-size: 0.68rem;
    color: rgba(0, 0, 0, 0.32);
  }
  .clone-editor__zones-run {
    display: inline-flex;
    align-items: center;
    padding: 2px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.04);
  }
  /* The tooltip's activator, and therefore what the pointer has to be over for the name to appear:
     a wrapper AROUND the button rather than the button itself, so a disabled switch still explains
     what each of its settings would have done. */
  .clone-editor__zones-slot {
    display: inline-flex;
  }
  /* All that is left of the two groups this used to be: a hairline before the boundaries, which are
     places on the bar below, and none before the two conventions, which are not. */
  .clone-editor__zones-slot--cut {
    margin-left: 4px;
    padding-left: 4px;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }
  .clone-editor__zones-pick {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 22px;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: rgba(0, 0, 0, 0.42);
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
  }
  /* The glyph takes the button's own colour rather than Vuetify's default ink, so the lit setting,
     the hovered one and the greyed run are each one rule and not two. */
  .clone-editor__zones-pick .v-icon {
    font-size: 15px;
    color: inherit;
  }
  .clone-editor__zones-pick:hover:not(:disabled):not(.clone-editor__zones-pick--on) {
    background: rgba(0, 0, 0, 0.06);
    color: rgba(0, 0, 0, 0.7);
  }
  .clone-editor__zones-pick--on {
    color: #1976D2;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
  }
  .clone-editor__zones-pick:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.35);
  }
  .clone-editor__zones-pick--on:focus {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18), 0 0 0 2px rgba(25, 118, 210, 0.35);
  }
  .clone-editor__zones-pick:disabled {
    opacity: 0.55;
    cursor: default;
  }
  .v-card__actions.clone-editor__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    padding: 8px 12px;
  }
  /* THE WAY INTO A SECTION'S OWN CONTROLS, at the far end of the heading line it belongs to. Two
     glyphs and no words: what the panel holds, and a caret saying whether it is open. It is drawn
     with no frame and no fill — a framed control on a heading line reads as the section's title
     having grown a second half — and what says it is pressable is the pointer, the caret and the
     name the tooltip gives it.

     Lit blue while its panel is open, so a run of cards down the column says at a glance which of
     them are showing controls and which are showing readings. Greyed where there is nothing behind
     it to open. */
  .clone-editor__more-slot {
    display: inline-flex;
    margin-left: auto;
  }
  .clone-editor__more {
    display: inline-flex;
    align-items: center;
    padding: 1px 2px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    transition: color 0.15s ease, background-color 0.15s ease;
  }
  .clone-editor__more .v-icon {
    font-size: 16px;
    color: inherit;
  }
  /* Tight against the glyph it qualifies and a size down from it: the caret is punctuation on the
     icon, not a second thing on the line. */
  .clone-editor__more .v-icon.clone-editor__more-caret {
    font-size: 13px;
    margin-left: -1px;
  }
  .clone-editor__more:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.72);
  }
  .clone-editor__more--on {
    color: #1976D2;
  }
  .clone-editor__more:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.35);
  }
  .clone-editor__more:disabled {
    opacity: 0.45;
    cursor: default;
  }
  /* What a disclosure opens, inside the card that opened it: a hairline across the card and then
     the controls. The rule is what says these are a second thing and not more of the first — the
     pair above it is what the channel IS, and everything under it is how the curve gets there. */
  .clone-editor__panel {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  /* What the borrowed year is about to be, beside the button that applies it in the importer's
     footer. It shares the row with two buttons, so it takes what is left and truncates. */
  .clone-picker__summary {
    min-width: 0;
    font-size: 0.78rem;
    color: rgba(0, 0, 0, 0.6);
    padding-left: 4px;
  }

  /* Nothing chosen yet, or the report still being read. The dashed box the grid uses for a cell it
     is holding open, at the size of a few rows so the dialog does not change height the moment a
     model is picked. */
  .clone-pick-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 240px;
    margin-top: 12px;
    padding: 24px;
    text-align: center;
    border: 1px dashed rgba(0, 0, 0, 0.18);
    border-radius: 4px;
  }
  .clone-pick-empty__text {
    max-width: 340px;
    font-size: 0.8rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.5);
  }

  /* THE GRID UNDER THE BANDS, and the line that opens it. A text link rather than a button with a
     border: the card already has three things in it that look like controls — two fields and a
     chart with levels on it — and a fourth box would read as a fourth figure. It sits at the hint's
     own weight and colour, which is what the row above it uses for the one thing it says about
     itself that is not a number. */
  .compose-sheet {
    margin-top: 10px;
    /* The same reason as .clone-metric above, one level down: this is an item of the card's own
       column flex, and an item that may not shrink is one the card has to grow for. */
    min-width: 0;
  }
  .compose-sheet__toggle {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 0;
    font-size: 0.7rem;
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.5);
    background: none;
    border: none;
    cursor: pointer;
  }
  .compose-sheet__toggle:hover {
    color: rgba(0, 0, 0, 0.8);
  }
  .compose-sheet__toggle >>> .v-icon {
    color: inherit;
  }
  /* The grid brings its own scrollbar — see Spreadsheet.vue, where being handed a width is what
     makes .jexcel_content the one horizontal scroller — so all this owes it is the room to stand
     in and no second box around it. */
  .compose-sheet__grid {
    margin-top: 6px;
    min-width: 0;
    max-width: 100%;
  }
  /* THE YEAR BORROWED OFF ANOTHER MODEL: the importer's second step, drawn here through its
     `details` slot — the questions, and twelve columns of a year nobody has accepted yet. */
  .shape-pick__asks {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
  }
  .shape-pick__asks > * {
    flex: 1 1 0;
    min-width: 0;
  }
  /* The columns stand on one baseline and share the height evenly, which is what makes the row read
     as one year rather than as twelve readings: the heights are the shape and the widths are not
     saying anything. */
  /* Over the right-hand end of the columns, which is where the card behind this puts its own row
     of verbs. */
  .shape-pick__tools {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    margin-bottom: 4px;
  }
  .shape-pick__shift {
    margin-right: 4px;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.55);
  }
  .shape-pick__plot {
    display: flex;
    align-items: flex-end;
    gap: 6px;
    height: 140px;
  }
  .shape-pick__col {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
  }
  .shape-pick__track {
    flex: 1 1 auto;
    display: flex;
    align-items: flex-end;
    background: rgba(67, 160, 71, 0.10);
    border-radius: 3px 3px 0 0;
  }
  .shape-pick__bar {
    width: 100%;
    background: #43A047;
    border-radius: 3px 3px 0 0;
  }
  /* The line a season is read against: the two halves of the box meet on it, and it is the zero
     the section's own plot draws. */
  .shape-pick__line {
    height: 1px;
    background: rgba(0, 0, 0, 0.28);
  }
  .shape-pick__track--down {
    align-items: flex-start;
    border-radius: 0 0 3px 3px;
  }
  .shape-pick__bar--down {
    border-radius: 0 0 3px 3px;
  }
  .shape-pick__note--held {
    margin-top: 6px;
    color: rgba(0, 0, 0, 0.7);
  }
  .shape-pick__month {
    margin-top: 6px;
    text-align: center;
    font-size: 10px;
    line-height: 1.2;
    color: rgba(0, 0, 0, 0.55);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .shape-pick__note {
    margin: 14px 0 0;
    font-size: 12px;
    line-height: 1.45;
    color: rgba(0, 0, 0, 0.55);
  }
</style>
